// Translations for Destine App
// Languages: en, es, fr, ar, pt, de, ru, zh

export const translations = {
  // English
  en: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Events & concerts',
      seeAll: 'See all',
      upcoming: 'Upcoming',
      empty: 'No events yet.',
      buy: 'Buy',
      book: 'Book',
      soldOut: 'Sold out',
      ticketsWord: 'tickets',
      share: 'Share',
      report: 'Report',
      myTickets: 'My MyMouv tickets',
      discover: 'Discover events',
    },
    vocaux: 'Voicemails',
    // Navigation
    nav: {
      home: 'Home',
      explorer: 'Explorer',
      discover: 'Discover',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'Profile',
      admin: 'Admin'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      share: 'Share',
      report: 'Report',
      search: 'Search',
      new: 'New',
      publish: 'Publish',
      send: 'Send',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      copy_link: "Copy link",
      link_copied: "Link copied"
    },
    // Auth
    auth: {
      login: 'Login',
      logout: 'Logout',
      register: 'Sign Up',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      resetPassword: 'Reset Password',
      newPassword: 'New Password',
      age: 'Age',
      siret: 'SIRET Number',
      joinDestine: 'Join Destine',
      accountType: 'Account type',
      accountID: 'ID Account',
      accountPRO: 'PRO Account',
      appLanguage: 'App language',
      fullName: 'Full name',
      yourName: 'Your name',
      birthDate: 'Date of birth',
      optional: 'optional',
      alreadyAccount: 'Already have an account? Log in',
      noAccount: 'No account? Sign up',
      signIn: 'Sign in',
      signUp: 'Sign up',
      verification: 'Verification'
    },
    // Explorer
    explorer: {
      title: 'Explorer',
      subtitle: 'Podcasts, films, articles and more',
      searchPlaceholder: 'Search content, users, Gim Tolis...',
      podcasts: 'Podcasts',
      freeFilms: 'Public Domain Films',
      news: 'News',
      shortFilms: 'Short Films',
      watchNow: 'Watch Now',
      noContent: 'No content available',
      qualityWarning: 'Only the best short films will be kept. Low quality videos may be removed by administrators.',

      whereToWatch: 'Where to watch?',

      whereToWatchSubtitle: 'Streaming platforms in your country'

    },
    discover: {
      title: 'Discover',
      subtitle: 'Movies, series, news, AI and MyMouv',
      tabCinema: 'Cinema',
      tabStudio: 'Studio',
      upcomingReleases: 'Upcoming releases',
      popCulture: 'Pop culture, manga, theater',
      bestFilms: 'Best movies and series',
      boxOffice: 'Box Office',
      learnMore: 'Learn more'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'Emotionally intelligent voice AI',
      greeting: 'Hello!',
      greetingText: 'I am Déesse, your emotionally intelligent voice AI.',
      suggestions: ['Tell me today\'s news', 'What are the latest news?', 'Recommend a good movie', 'What are the 2024 Oscars?', 'Most anticipated movies this year', 'Explain French cinema to me'],
      newConversation: 'New conversation',

      movieGameTitle: '🎬 Mini-game: Guess the movie',

      movieGameSubtitle: 'Test your cinema knowledge — answer by voice and score points',

      movieGameReady: 'Ready to shine?',

      movieGameDescription: 'Guess a movie from a hidden synopsis. Answer by voice or text. Max score: 100 pts on the first try.',

      movieGameStart: '🎬 Start',

      movieGameAnswerPlaceholder: 'Your answer...',

      movieGameSubmit: 'Submit',

      movieGameOrVoice: 'or by voice',

      movieGameVoiceAnswer: 'Answer by voice',

      movieGameStop: 'Stop',

      movieGameBravo: 'Bravo!',

      movieGameTryAgain: 'Not this time...',

      movieGameCorrectAnswer: 'The answer was:',

      movieGameReplay: 'Play again',

      movieGameAttempt: 'Attempt',

      movieGameImageMode: '🎨 Image mode active: your next voice will generate an image',

      movieGameImageLimit: 'Daily limit reached (5/day)',
      regionalLangTitle: 'Answer in a regional language of French Guiana',
      regionalLangSubtitle: 'The IA will answer in the chosen language using the corpus built by the community.',
      regionalLangOff: 'None (main language)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'Search users...',
      conversations: 'MyTalk',
      invitations: 'Invitations',
      noMessages: 'No messages',
      typeMessage: 'Type a message...',
      learnMore: 'Learn more',
      record: 'Record',
      publish: 'Publish',
      titleField: 'Title',
      descriptionField: 'Description'
    },
    // Profile
    profile: {
      title: 'Profile',
      followers: 'Followers',
      following: 'Following',
      posts: 'Posts',
      editProfile: 'Edit Profile',
      settings: 'Settings',
      gimToli: 'Gim Toli',
      podcasts: 'Podcasts',
      news: 'News',
      videos: 'Videos',
      saved: 'Saved',

      bioAudio: 'Voice intro'

    },
    // Settings
    settings: {
      backToProfile: 'Back to profile',
      title: 'Settings',
      accountInfo: 'Account Information',
      notifications: 'Notifications',
      notifStatusGranted: '✅ Enabled — tap to manage in iPhone Settings',
      notifStatusDenied: '❌ Disabled — tap to open iPhone Settings',
      notifStatusWeb: 'Available on the mobile app only',
      notifStatusEnable: 'Tap to enable notifications',
      privacy: 'Privacy',
      language: 'Language',
      changePassword: 'Change Password',
      deleteAccount: 'Delete Account',
      proSpace: 'PRO Space',
      helpSupport: 'Help & Support',
      about: 'About',
      selectLanguage: 'Select Language',

      aboutIATitle: 'About Destine AI',

      aboutIAIntro: 'Destine AI is the smart assistant built into your app. It helps you every day, without ever accessing your private messages.',

      aboutIACanDo: 'What it can do:',

      aboutIAPrivacy: 'Privacy:',

      aboutIAFeatures: 'Chat with you (text or voice via Whisper);Give you the latest news;Talk movies, series, releases;Analyze the emotion of your Gim Tolis (joy, calm, energy...);Transcribe your voice messages automatically',

      aboutIAPrivacyPoints: 'Your private chats are never read by the AI;Emotional analysis is only on public Gim Tolis;No sensitive data is shared with third parties',

      openIA: 'Open Destine AI',

      countryForWatch: 'Country for "Where to watch?"',

      countryForWatchSubtitle: 'Determines the streaming platforms shown in Explorer',

      updatedToast: 'Country updated ✓',
      titleHero: 'Settings',
      subtitleHero: 'Manage your account and preferences',
      appearance: 'Appearance',
      darkMode: 'Dark Mode',
      lightMode: 'Light — Rose',
      whiteMode: 'Light — White',
      active: 'Active',
      changePasswordSub: 'Change your password',
      phoneInChats: 'Phone number in chats',
      phoneInChatsHidden: 'Your number is hidden in chats',
      phoneInChatsShown: 'Your number is shown to chat partners',
      location: 'Location',
      locationOn: 'Location enabled — you can share your position in chats',
      locationOff: 'Location disabled — tap to open settings',
      locationActivated: 'Location activated',
      myComments: 'My comments',
      viewMyComments: 'View my comments',
      viewMyCommentsSub: 'Manage all comments you left on Gim Tolis and Podcasts',
      pushNotifications: 'Push notifications',
      weeklyCinemaDigest: 'Weekly cinema releases',
      weeklyCinemaDigestSub: 'Get a weekly email + notification about upcoming movie releases.',
      pushNotifMobileOnly: 'Available on mobile app only',
      reportsTitle: 'Reports',
      makeReport: 'Make a report',
      makeReportSub: 'Report a problem or contact support',
      blockedUsers: 'Blocked users',
      blockedUsersDesc: 'Block users whose content you no longer want to see. They will no longer be able to contact you or view your profile.',
      searchUserToBlock: 'Search a user to block...',
      blockedUsersCount: 'Blocked users',
      noBlockedUser: 'No blocked user',
      legalDocs: 'Legal documents',
      legalDocsSub: 'Terms, privacy policy, community rules',
      security: 'Security',
      logout: 'Log out',
      dangerZone: 'Danger zone',
      phoneTitle: 'Phone number',
      noPhone: 'No phone number',
      statisticsTitle: "Statistics & monetization",
      statisticsOpen: "View my statistics",
      statisticsSub: "Likes, comments, shares, plays, followers",
    },
    // Content creation
    create: {
      selectLanguage: 'Content Language',
      languageHint: 'Select the language of your content',
      title: 'Title',
      description: 'Description',
      content: 'Content',
      coverImage: 'Cover Image',
      audio: 'Audio',
      video: 'Video'
    },
    // Languages
    languages: {
      en: 'English',
      es: 'Spanish',
      fr: 'French',
      ar: 'Arabic',
      pt: 'Portuguese',
      de: 'German',
      ru: 'Russian',
      zh: 'Chinese',
      ja: 'Japanese',
      hi: 'Hindi',
      nl: 'Dutch',
      sw: 'Swahili'
    },
    // Tooltips
    tooltips: {
      ageInfo: 'Enter your age to enhance your account security',
      siretInfo: 'Your SIRET will be used to verify your account and enhance security'
    },
    statistics: {
      title: "Statistics & monetization",
      subtitle: "Track your content's reach and your audience's engagement.",
      memberSince: "Member since",
      global: "Overview",
      audience: "Audience",
      gimToli: "Gim Toli",
      shortFilms: "Short Films",
      podcasts: "Podcasts",
      totalLikes: "Likes received",
      totalComments: "Comments",
      totalShares: "Shares",
      totalPlays: "Plays / Views",
      followers: "Followers",
      following: "Following",
      saved: "Saved",
      activeStories: "Active stories",
      posts: "Posts",
      likes: "Likes",
      comments: "Comments",
      shares: "Shares",
      plays: "Plays",
      views: "Views",
    },
    monetization: {
      title: "Monetization",
      payouts: "Payments received",
      noPayouts: "No payment received yet.",
      eligibility: "Monetization on Destine",
      unlocked: "You can add a sponsor to your Gim Toli, podcasts and short films.",
      locked: "Unlock monetization at {threshold} followers.",
      followersOf: "followers",
      policy: "Monetization policy",
      iban: "Bank details (IBAN)",
      ibanHelp: "Visible only to PRO accounts that have accepted a sponsorship.",
      iban_save: "Save",
      iban_saved: "IBAN saved",
      requests: "My sponsorship requests",
      noRequests: "No request sent yet.",
      clicks: "sponsor link clicks",
      partnerWith: "Partner with sponsor",
      shareWithSponsor: "Share with sponsor",
      lockedShort: "Locked",
      info_title: "Monetization",
      info_body: "From 5,000 followers, you can attach a sponsor to your content and receive direct payments in 15+ currencies.",
      info_cta: "Learn more",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Pay the creator",
      payHint: "Stripe fees covered by you (~2.9% + €0.30) — creator receives the exact amount.",
      paid: "Payment complete",
      subtitle: "Manage your ads and track your performance",
      createAd: "Create an ad",
      myAds: "My Ads",
      analytics: "Analytics",
      sponsorshipRequests: "Sponsorship requests",
      myOffers: "My offers",
      // Header / KPIs
      activeAds: "Active ads",
      totalImpressions: "Total impressions",
      totalClicks: "Total clicks",
      ctr: "Click-through rate (CTR)",
      avgCtr: "Average CTR",
      conversionRate: "Conversion rate",
      adsCreated: "Ads created",
      activeShort: "active",
      performanceSummary: "Performance summary",
      details: "Details",
      perAdPerformance: "Performance per ad",
      // MyShop shortcut
      myShop: "My MyShop",
      sellYourProductsServices: "Sell your products & services",
      // Payout info
      payoutTitle: "Bank details (MyShop)",
      payoutModify: "Edit",
      payoutFill: "Fill in",
      payoutHint: "These details are required to receive your sales payouts (Destine fee: 5%). Visible only to you and the admin team.",
      companyName: "Company name",
      iban: "IBAN",
      bic: "BIC",
      companyPlaceholder: "Company name (e.g. SARL Boutique XYZ)",
      bicPlaceholder: "BIC / SWIFT",
      save: "Save",
      saving: "Saving…",
      cancel: "Cancel",
      saved: "Details saved",
      genericError: "Error",
      // Empty states
      noAdsYet: "No ads yet",
      noAdsHint: "Create your first ad to get started",
      // Card statuses
      statusPendingPayment: "Awaiting payment",
      statusApproved: "Approved",
      statusActive: "Active",
      statusExpired: "Expired",
      statusPending: "Pending",
      // Ad card
      adVideo: "Video",
      adImage: "Image",
      adAudio: "Audio",
      duration: "Duration",
      days: "days",
      broadcastZones: "Broadcast zones:",
      impressions: "Impressions",
      clicks: "Clicks",
      delete: "Delete",
      pay: "Pay",
      checkPayment: "Check payment",
      checking: "Checking…",
      // Create modal
      createModalTitle: "Create an ad",
      adTypeLabel: "Ad type",
      videoMax: "Max 30s, 30 MB",
      imageMax: "Max 5 MB",
      audioMax: "Max 30s, MP3",
      file: "File",
      maxDuration: "Maximum duration: 30 seconds",
      broadcastDuration: "Broadcast duration",
      sevenDays: "7 days",
      externalLinkOptional: "External link (optional)",
      sitePlaceholder: "https://your-site.com",
      externalLinkHint: "URL to your site, product or service",
      feedGimToli: "Feed (Gim Toli)",
      podcasts: "Podcasts",
      stories: "Stories",
      adPrice: "Ad price",
      videoPriceLabel: "€100 for 7 days (video)",
      audioPriceLabel: "€50 for 7 days (audio)",
      imagePriceLabel: "€50 for 7 days (image)",
      creating: "Creating…",
      createAndPay: "Create and pay",
      selectFile: "Please select a file",
      selectAtLeastOneZone: "Select at least one broadcast zone",
      adCreated: "Ad created! Proceed to payment.",
      createError: "Error while creating",
      // Offers
      myOffersPanel: "My sponsorship offers",
      newOffer: "New offer",
      noOffersYet: "No offer published. Create one so creators see it when sharing.",
      offerTitleLabel: "Title",
      offerTitlePlaceholder: "Ex: Launch of our new perfume",
      offerDescLabel: "Description (what should the creator say?)",
      offerDescPlaceholder: "Describe the product or service the creator should mention…",
      offerKindsLabel: "Accepted content types",
      offerKindGimToli: "Gim Toli",
      offerKindPodcast: "Podcast",
      offerAmountPlaceholder: "Amount",
      offerCurrencyEUR: "EUR",
      offerRule: "The creator must talk about the sponsor for at least 10 seconds in their Gim Toli or podcast (or simple mention on a short film). This rule is set by Destine.",
      publishOffer: "Publish offer",
      offerTitleRequired: "Title required",
      offerDescRequired: "Description required",
      offerAmountInvalid: "Invalid amount",
      offerPublished: "Offer published",
      offerDeleted: "Offer deleted",
      // Sponsorship inbox
      filterAll: "All",
      filterPending: "Pending",
      filterAccepted: "Accepted",
      filterRejected: "Rejected",
      noSponsorshipRequests: "No sponsorship requests.",
      kindGimToli: "Gim Toli",
      kindPodcast: "Podcast",
      kindShortFilm: "Short film",
      // Service callbacks
      noCallbacks: "No callback requests yet.",
      noCallbacksHint: "Buyers' callback requests on your services will appear here.",
      client: "Client",
      markCalled: "Mark as called back",
      archive: "Archive",
      updated: "Updated",
      // Accounting snapshot
      shopAccounting: "MyShop accounting",
      detailsBtn: "Details",
      gross: "Gross",
      commissionPct: "Commission",
      netReceive: "Net payout",
      salesCount: "sale(s)",
      shopsCount: "shop(s)",
      netExplain: "Net = revenue minus Destine's commission.",
      // Misc
      back: "Back",
      proOnly: "PRO accounts only",
      loading: "Loading…",
      paymentChecking: "Checking payment…",
      paymentConfirmed: "Payment confirmed!",
      paymentProcessing: "Payment in progress…",
      paymentCheckError: "Verification error",
      paymentCreateError: "Error creating payment",
      notifications: "Notifications",
      paymentCanceled: "Payment cancelled",
      confirmDelete: "Do you really want to delete this ad?",
      adDeleted: "Ad deleted",
      deleteError: "Error while deleting",
      acceptedTypes: "Accepted types",
      minTalk: "Minimum talk time",
      confirmDeleteOffer: "Delete this offer?",
      followers: "Followers",
      likes: "Likes",
      plays: "Plays",
      accept: "Accept",
      reject: "Reject",
      sponsorAccepted: "Sponsorship accepted",
      sponsorRejected: "Request rejected",
      payoutCoords: "Payment details",
      holder: "Holder",
      sponsorLinkClicks: "Clicks on sponsor link",
      publishing: "Publishing…",
      chooseAtLeastOneKind: "Choose at least one content type",
    },

    groups: {
      tab: "Groups",
      create: "Create a group",
      name: "Group name",
      theme: "Theme",
      rules: "Rules",
      profile_image: "Profile photo",
      request_join: "Request to join",
      pending: "Request pending",
      member: "Member",
      creator: "Creator",
      encryptedStorage: "Encrypted storage",
      reportGroup: "Report this group",
      admin: "Admin",
      members: "Members",
      leave: "Leave group",
      delete: "Delete group",
      no_groups: "No groups yet",
      search_groups: "Search groups…",
      info: "Group information",
      invitations: "Group requests",
      accept: "Accept",
      reject: "Decline",
      created_by: "Created by",
      placeholder_message: "Message…",
      send: "Send",
      unread_messages: "New messages"
    },
    regional: {
      helpTitle: "Help Destine IA understand the regional languages of French Guiana.",
      activeLang: "Active language:",
      formatTitle: "Format",
      formatHint: "Write in French / English / Dutch, add « = » then the translation.",
      example: "E.g.: Can you make me an image of a red car? = Yu sa méké wang photo fou wang lébi wagi gim?",
      pickerLabel: "Language:",
      restrictions: "Text and voice messages only (no photos or videos). Non-profit goal.",
      leave: "Leave",
      confirmLeave: "Leave the group? You can rejoin at any time.",
      left: "You left the group",
      noMedia: "Not available in this group",
      ackPrefix: "Translation integrated in",
      ackThanks: "Thanks for your contribution!",
      ackPairs: "pairs in",
      groupName: "Destine IA — Regional languages 🇬🇫",
      groupTheme: "Help the IA learn ndjuka, saramaka, Guianese Creole, hmong, kali'na, palikur, teko, wayana and wayampi.",
      groupRules: "Non-profit goal: train Destine IA to understand and answer in the regional languages of French Guiana.\n\nContribution format:\n  <sentence in French / English / Dutch> = <translation in the chosen language>\n\nExample (djuka): Can you make me an image of a red car? = Yu sa méké wang photo fou wang lébi wagi gim?\n\nPlease be respectful — any inappropriate message can be reported."
    },
    calls: {
      dnd_title: "Do Not Disturb",
      dnd_desc: "When enabled, you will not receive any in-app voice calls.",
      peer_dnd: "This user has activated Do Not Disturb",
      connecting: "Connecting…",
      ringing: "Ringing…",
      in_call: "In call",
      ended: "Ended",
      error: "Error",
      preparing: "Preparing the call…",
      waiting: "Waiting for an answer…",
      daily_left: "Left today",
      quota_exceeded: "You've reached your 30-minute daily call quota.",
      not_configured: "Voice calls are not enabled on this server.",
      quota_reached: "Daily quota reached"
    },
    screenshot: {
      taken: "{name} took a screenshot of this conversation",
      i_took: "You took a screenshot of this conversation"
    },
    eshop: {
      title: "MyShop",
      see_all: "See all",
      search_placeholder: "Search a shop or product…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "My shop",
      my_shops: "My shops",
      delivery_days_label: "Completion time (days) *",
      delivery_days_hint: "Beyond this delay, the order is auto-validated if the buyer hasn't confirmed.",
      delivery_days_invalid: "Invalid completion time (1 to 60 days)",
      contact_address: "Address / contact details",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Create a shop",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Products",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "Catalog",
      no_products: "No products yet",
      buy: "Buy",
      checkout: "Checkout",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "Pay",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "Reviews",
      no_reviews: "No reviews yet",
      write_review: "Write a review",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "All",
      cat_fashion: "Fashion",
      cat_beauty: "Beauty",
      cat_food: "Food",
      cat_myfood: "MyFood",
      cat_art: "Art",
      cat_music: "Music",
      cat_books: "Books",
      cat_electronics: "Electronics",
      cat_home: "Home",
      cat_handcraft: "Handcraft",
      cat_wellness: "Wellness",
      cat_services: "Services",
      cat_education: "Education",
      cat_kids: "Kids",
      cat_sport: "Sport",
      cat_jewelry: "Jewelry",
      cat_other: "Other",
      report_shop: "Report shop",
      report_help: "Help us moderate Destine. Reports are reviewed by our team.",
      report_reason_scam: "Scam / fraud",
      report_reason_fake_product: "Counterfeit products",
      report_reason_inappropriate: "Inappropriate content",
      report_reason_illegal: "Illegal activity",
      report_reason_other: "Other",
      report_details: "Additional details (optional)",
      send_report: "Send report",
      report_sent: "Report sent. Thank you.",
      report_pick_reason: "Pick a reason",
      rate_help: "1 to 5 stars + comment",
      reviews_count: "reviews",
      review_one: "review",
      no_reviews_short: "No reviews",
      payout_in_ads: "Your bank details (IBAN, BIC, company name) are entered in Destine Ads.",
      video_60s: "Video (max 60s, optional)",
      // === Service callback flow + product form (v48.2) ===
      product_title_label: "Product / service title *",
      product_price_label: "Price",
      availability_label: "Availability",
      available: "Available",
      unavailable: "Unavailable",
      contact: "Contact",
      call_seller: "Call",
      request_callback: "Request a callback",
      request_callback_help: "Leave your number, the seller will call you back",
      callback_message: "Message (optional)",
      send_callback_request: "Send request",
      callback_sent: "Your request has been sent",
      service_intro: "This service is not paid online. Choose how to contact the seller to discuss the project and get a quote.",
      service_no_stripe: "For services, no payment is processed by Destine.",
      no_phone_provided: "Phone number not provided",
      invalid_phone: "Invalid phone number",
      title_required: "Product / service title is required",
      price_required: "Price is required (in euros, e.g. 300)",
      cover_dim_hint: "💡 Recommended size: 1600 × 600 px (landscape 8:3), JPG or PNG, under 3 MB. Avoid important elements near the corners (mobile auto-crop)."
    },
    },

  // Spanish
  es: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Eventos y conciertos',
      seeAll: 'Ver todo',
      upcoming: 'Próximos',
      empty: 'Aún no hay eventos.',
      buy: 'Comprar',
      book: 'Reservar',
      soldOut: 'Agotado',
      ticketsWord: 'entradas',
      share: 'Compartir',
      report: 'Reportar',
      myTickets: 'Mis entradas MyMouv',
      discover: 'Descubrir eventos',
    },
    vocaux: 'Vocales',
    nav: {
      home: 'Inicio',
      explorer: 'Explorar',
      discover: 'Descubrir',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'Perfil',
      admin: 'Admin'
    },
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      cancel: 'Cancelar',
      save: 'Guardar',
      saved: 'Guardado',
      delete: 'Eliminar',
      edit: 'Editar',
      share: 'Compartir',
      report: 'Reportar',
      search: 'Buscar',
      new: 'Nuevo',
      publish: 'Publicar',
      send: 'Enviar',
      close: 'Cerrar',
      back: 'Atrás',
      next: 'Siguiente',
      confirm: 'Confirmar',
      yes: 'Sí',
      no: 'No',
      copy_link: "Copiar enlace",
      link_copied: "Enlace copiado"
    },
    auth: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      register: 'Registrarse',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      resetPassword: 'Restablecer contraseña',
      newPassword: 'Nueva contraseña',
      age: 'Edad',
      siret: 'Número SIRET',
      joinDestine: 'Únete a Destine',
      accountType: 'Tipo de cuenta',
      accountID: 'Cuenta ID',
      accountPRO: 'Cuenta PRO',
      appLanguage: 'Idioma de la aplicación',
      fullName: 'Nombre completo',
      yourName: 'Tu nombre',
      birthDate: 'Fecha de nacimiento',
      optional: 'opcional',
      alreadyAccount: '¿Ya tienes cuenta? Iniciar sesión',
      noAccount: '¿Sin cuenta? Registrarse',
      signIn: 'Iniciar sesión',
      signUp: 'Registrarse',
      verification: 'Verificación'
    },
    explorer: {
      title: 'Explorar',
      subtitle: 'Podcasts, películas, artículos y más',
      searchPlaceholder: 'Buscar contenido, usuarios, Gim Tolis...',
      podcasts: 'Podcasts',
      freeFilms: 'Películas de dominio público',
      news: 'Noticias',
      shortFilms: 'Cortometrajes',
      watchNow: 'Ver ahora',
      noContent: 'No hay contenido disponible',
      qualityWarning: 'Solo se conservarán los mejores cortometrajes. Los videos de baja calidad pueden ser eliminados por los administradores.',

      whereToWatch: '¿Dónde ver?',

      whereToWatchSubtitle: 'Plataformas de streaming en tu país'

    },
    discover: {
      title: 'Descubrir',
      subtitle: 'Películas, series, noticias, IA y MyMouv',
      tabCinema: 'Cine',
      tabStudio: 'Studio',
      upcomingReleases: 'Próximos estrenos',
      popCulture: 'Cultura pop, manga, teatro',
      bestFilms: 'Mejores películas y series',
      boxOffice: 'Taquilla',
      learnMore: 'Más información'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'IA de voz emocionalmente inteligente',
      greeting: '¡Hola!',
      greetingText: 'Soy Déesse, tu IA de voz emocionalmente inteligente.',
      suggestions: ['Cuéntame las noticias del día', '¿Cuáles son las últimas novedades?', 'Recomiéndame una buena película', '¿Cuáles son los Oscar 2024?', 'Películas más esperadas este año', 'Explícame el cine francés'],
      newConversation: 'Nueva conversación',

      movieGameTitle: '🎬 Minijuego: Adivina la película',

      movieGameSubtitle: 'Pon a prueba tu cultura cinematográfica',

      movieGameReady: '¿Listo para brillar?',

      movieGameDescription: 'Adivina una película desde una sinopsis oculta. Responde por voz o texto.',

      movieGameStart: '🎬 Empezar',

      movieGameAnswerPlaceholder: 'Tu respuesta...',

      movieGameSubmit: 'Enviar',

      movieGameOrVoice: 'o por voz',

      movieGameVoiceAnswer: 'Responder por voz',

      movieGameStop: 'Parar',

      movieGameBravo: '¡Bravo!',

      movieGameTryAgain: 'Esta vez no...',

      movieGameCorrectAnswer: 'La respuesta era:',

      movieGameReplay: 'Volver a jugar',

      movieGameAttempt: 'Intento',

      movieGameImageMode: '🎨 Modo imagen activado',

      movieGameImageLimit: 'Límite diario alcanzado (5/día)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'Buscar usuarios...',
      conversations: 'MyTalk',
      invitations: 'Invitaciones',
      noMessages: 'Sin mensajes',
      typeMessage: 'Escribe un mensaje...',
      learnMore: 'Más información',
      record: 'Grabar',
      publish: 'Publicar',
      titleField: 'Título',
      descriptionField: 'Descripción'
    },
    profile: {
      title: 'Perfil',
      followers: 'Seguidores',
      following: 'Siguiendo',
      posts: 'Publicaciones',
      editProfile: 'Editar perfil',
      settings: 'Configuración',
      gimToli: 'Gim Toli',
      podcasts: 'Podcasts',
      news: 'Noticias',
      videos: 'Videos',
      saved: 'Guardados',

      bioAudio: 'Audio de presentación'

    },
    settings: {
      backToProfile: 'Volver al perfil',
      title: 'Configuración',
      accountInfo: 'Información de la cuenta',
      notifications: 'Notificaciones',
      notifStatusGranted: '✅ Activadas — pulsa para gestionar en Ajustes de iPhone',
      notifStatusDenied: '❌ Desactivadas — pulsa para abrir Ajustes de iPhone',
      notifStatusWeb: 'Disponible solo en la app móvil',
      notifStatusEnable: 'Pulsa para activar las notificaciones',
      privacy: 'Privacidad',
      language: 'Idioma',
      changePassword: 'Cambiar contraseña',
      deleteAccount: 'Eliminar cuenta',
      proSpace: 'Espacio PRO',
      helpSupport: 'Ayuda y soporte',
      about: 'Acerca de',
      selectLanguage: 'Seleccionar idioma',

      aboutIATitle: 'Acerca de Destine IA',

      aboutIAIntro: 'Destine IA es el asistente inteligente integrado en tu aplicación. Te ayuda a diario sin acceder a tus mensajes privados.',

      aboutIACanDo: 'Lo que puede hacer:',

      aboutIAPrivacy: 'Privacidad:',

      aboutIAFeatures: 'Chatear contigo (texto o voz con Whisper);Darte las últimas noticias;Hablar de cine, series, estrenos;Analizar la emoción de tus Gim Tolis;Transcribir tus mensajes de voz',

      aboutIAPrivacyPoints: 'La IA nunca lee tus chats privados;El análisis emocional solo se hace en Gim Tolis públicos;No se comparten datos sensibles con terceros',

      openIA: 'Abrir Destine IA',

      countryForWatch: 'País para "¿Dónde ver?"',

      countryForWatchSubtitle: 'Determina las plataformas mostradas en Explorer',

      updatedToast: 'País actualizado ✓',
      titleHero: 'Ajustes',
      subtitleHero: 'Gestiona tu cuenta y preferencias',
      appearance: 'Apariencia',
      darkMode: 'Modo oscuro',
      lightMode: 'Claro — Rosa',
      whiteMode: 'Claro — Blanco',
      active: 'Activo',
      changePasswordSub: 'Modifica tu contraseña',
      phoneInChats: 'Teléfono en chats',
      phoneInChatsHidden: 'Tu número está oculto en chats',
      phoneInChatsShown: 'Tu número se muestra a tus contactos',
      location: 'Ubicación',
      locationOn: 'Ubicación activada — puedes compartir tu posición',
      locationOff: 'Ubicación desactivada — toca para abrir ajustes',
      locationActivated: 'Ubicación activada',
      myComments: 'Mis comentarios',
      viewMyComments: 'Ver mis comentarios',
      viewMyCommentsSub: 'Gestiona todos los comentarios que dejaste en Gim Tolis y Podcasts',
      pushNotifications: 'Notificaciones push',
      weeklyCinemaDigest: 'Estrenos de cine semanales',
      weeklyCinemaDigestSub: 'Recibe un email + notificación semanal sobre los próximos estrenos.',
      pushNotifMobileOnly: 'Solo disponible en la app móvil',
      reportsTitle: 'Reclamaciones',
      makeReport: 'Hacer una reclamación',
      makeReportSub: 'Reportar un problema o contactar soporte',
      blockedUsers: 'Usuarios bloqueados',
      blockedUsersDesc: 'Bloquea usuarios cuyo contenido ya no quieras ver. No podrán contactarte ni ver tu perfil.',
      searchUserToBlock: 'Buscar un usuario a bloquear...',
      blockedUsersCount: 'Usuarios bloqueados',
      noBlockedUser: 'Ningún usuario bloqueado',
      legalDocs: 'Documentos legales',
      legalDocsSub: 'Términos, privacidad, reglas',
      security: 'Seguridad',
      logout: 'Cerrar sesión',
      dangerZone: 'Zona peligrosa',
      phoneTitle: 'Número de teléfono',
      noPhone: 'Sin número',
      statisticsTitle: "Estadísticas y monetización",
      statisticsOpen: "Ver mis estadísticas",
      statisticsSub: "Me gusta, comentarios, compartidos, reproducciones, seguidores",
    },
    create: {
      selectLanguage: 'Idioma del contenido',
      languageHint: 'Selecciona el idioma de tu contenido',
      title: 'Título',
      description: 'Descripción',
      content: 'Contenido',
      coverImage: 'Imagen de portada',
      audio: 'Audio',
      video: 'Video'
    },
    languages: {
      en: 'Inglés',
      es: 'Español',
      fr: 'Francés',
      ar: 'Árabe',
      pt: 'Portugués',
      de: 'Alemán',
      ru: 'Ruso',
      zh: 'Chino'
    },
    tooltips: {
      ageInfo: 'Ingresa tu edad para mejorar la seguridad de tu cuenta',
      siretInfo: 'Tu SIRET se utilizará para verificar tu cuenta y mejorar la seguridad'
    },
    statistics: {
      title: "Estadísticas y monetización",
      subtitle: "Sigue el alcance de tu contenido y la interacción de tu audiencia.",
      memberSince: "Miembro desde",
      global: "Resumen",
      audience: "Audiencia",
      gimToli: "Gim Toli",
      shortFilms: "Cortometrajes",
      podcasts: "Podcasts",
      totalLikes: "Me gusta recibidos",
      totalComments: "Comentarios",
      totalShares: "Compartidos",
      totalPlays: "Reproducciones / Vistas",
      followers: "Seguidores",
      following: "Siguiendo",
      saved: "Guardados",
      activeStories: "Historias activas",
      posts: "Publicaciones",
      likes: "Me gusta",
      comments: "Comentarios",
      shares: "Compartidos",
      plays: "Reproducciones",
      views: "Vistas",
    },
    monetization: {
      title: "Monetización",
      payouts: "Pagos recibidos",
      noPayouts: "Ningún pago recibido por el momento.",
      eligibility: "Monetización en Destine",
      unlocked: "Puedes añadir un patrocinador a tus Gim Toli, podcasts y cortos.",
      locked: "Desbloquea la monetización con {threshold} seguidores.",
      followersOf: "seguidores",
      policy: "Política de monetización",
      iban: "Datos bancarios (IBAN)",
      ibanHelp: "Visible solo para cuentas PRO que aceptaron un patrocinio.",
      iban_save: "Guardar",
      iban_saved: "IBAN guardado",
      requests: "Mis solicitudes de patrocinio",
      noRequests: "Aún no hay solicitudes enviadas.",
      clicks: "clics en enlace patrocinador",
      partnerWith: "Asociar con patrocinador",
      shareWithSponsor: "Compartir con patrocinador",
      lockedShort: "Bloqueado",
      info_title: "Monetización",
      info_body: "A partir de 5.000 seguidores, puedes adjuntar un patrocinador a tu contenido y recibir pagos directos en más de 15 monedas.",
      info_cta: "Más información",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Pagar al creador",
      payHint: "Comisiones de Stripe a tu cargo (~2,9 % + 0,30 €) — el creador recibe el importe exacto.",
      paid: "Pago realizado",
      myAds: "Mis anuncios",
      analytics: "Analítica",
      sponsorshipRequests: "Solicitudes de patrocinio",
      myOffers: "Mis ofertas",
    },

    groups: {
      tab: "Grupos",
      create: "Crear un grupo",
      name: "Nombre del grupo",
      theme: "Tema",
      rules: "Reglas",
      profile_image: "Foto de perfil",
      request_join: "Solicitar unirse",
      pending: "Solicitud pendiente",
      member: "Miembro",
      creator: "Creador",
      admin: "Administrador",
      members: "Miembros",
      leave: "Salir del grupo",
      delete: "Eliminar grupo",
      no_groups: "Aún no hay grupos",
      search_groups: "Buscar grupos…",
      info: "Información del grupo",
      invitations: "Solicitudes del grupo",
      accept: "Aceptar",
      reject: "Rechazar",
      created_by: "Creado por",
      placeholder_message: "Mensaje…",
      send: "Enviar",
      unread_messages: "Nuevos mensajes"
    },
    calls: {
      dnd_title: "No molestar",
      dnd_desc: "Cuando esté activado, no recibirás llamadas de voz en la app.",
      peer_dnd: "Este usuario ha activado No molestar",
      connecting: "Conectando…",
      ringing: "Llamando…",
      in_call: "En llamada",
      ended: "Finalizada",
      error: "Error",
      preparing: "Preparando la llamada…",
      waiting: "Esperando respuesta…",
      daily_left: "Queda hoy",
      quota_exceeded: "Has alcanzado tu cuota diaria de 30 minutos de llamada.",
      not_configured: "Las llamadas de voz no están activadas en este servidor.",
      quota_reached: "Cuota diaria alcanzada"
    },
    screenshot: {
      taken: "{name} hizo una captura de pantalla de esta conversación",
      i_took: "Hiciste una captura de pantalla de esta conversación"
    },
    eshop: {
      title: "MyShop",
      see_all: "Ver todo",
      search_placeholder: "Buscar tienda o producto…",
      empty: "Aún no hay tiendas",
      load_more: "Cargar más",
      my_shop: "Mi tienda",
      my_shops: "Mis tiendas",
      no_shop_yet: "Aún no tienes tienda",
      create_first: "Crear mi tienda",
      create_shop: "Crear una tienda",
      edit_shop: "Editar tienda",
      shop_created: "Tienda creada",
      shop_deleted: "Tienda eliminada",
      confirm_delete_shop: "¿Eliminar definitivamente esta tienda?",
      delete_shop: "Eliminar tienda",
      name: "Nombre de la tienda",
      category: "Categoría",
      country: "País (ISO)",
      currency: "Moneda",
      description: "Descripción de la actividad",
      upload_cover: "Foto de portada",
      address_full: "Dirección postal",
      phone: "Teléfono",
      website: "Sitio web (opcional)",
      shipping: "Envío",
      shipping_fee: "Costo",
      shipping_fee_cents: "Costo (céntimos)",
      shipping_terms_short: "Condiciones",
      company_date: "Fecha de creación de la empresa",
      payout_info: "Datos bancarios (para pagos)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "Nueva",
      fill_required: "Faltan campos obligatorios",
      fill_all: "Por favor complete todos los campos",
      products: "Productos",
      add_product: "Nuevo producto / servicio",
      edit_product: "Editar producto",
      kind: "Tipo",
      kind_product: "Producto",
      kind_service: "Servicio",
      title_field: "Título",
      price_cents: "Precio (céntimos)",
      photos: "Fotos",
      video_url: "Vídeo (URL, <60s)",
      stock: "Stock (vacío = ilimitado)",
      catalog: "Catálogo",
      no_products: "Aún no hay productos",
      buy: "Comprar",
      checkout: "Pago",
      fullname: "Nombre completo",
      address: "Dirección de envío",
      quantity: "Cantidad",
      subtotal: "Subtotal",
      pay: "Pagar",
      accept_cgv: "Acepto las",
      cgv: "Condiciones",
      must_accept_cgv: "Debe aceptar las condiciones",
      cgv_link: "Condiciones generales de venta",
      order_placed: "Pedido realizado",
      reviews: "Reseñas",
      no_reviews: "Aún no hay reseñas",
      write_review: "Escribir una reseña",
      publish_review: "Publicar",
      review_thanks: "Gracias por su reseña",
      review_placeholder: "Su comentario (opcional)",
      orders: "Pedidos",
      my_orders: "Mis pedidos",
      no_orders: "Sin pedidos",
      tracking_number: "Nº de seguimiento",
      tracking_required: "Nº de seguimiento requerido",
      marked_shipped: "Marcado como enviado",
      claims: "Reclamaciones",
      no_claims: "Sin reclamaciones",
      respond: "Responder",
      your_response: "Su respuesta",
      your_response_placeholder: "Su respuesta…",
      analytics: "Ventas",
      today: "Hoy",
      this_week: "Esta semana",
      this_month: "Este mes",
      this_year: "Este año",
      total_net: "Total neto",
      sales: "ventas",
      after_commission: "Después de la comisión del 5% de Destine",
      settings: "Ajustes",
      no_description: "Sin descripción",
      cat_mymap: "MyMap",
      cat_all: "Todo",
      cat_fashion: "Moda",
      cat_beauty: "Belleza",
      cat_food: "Alimentación",
      cat_myfood: "MyFood",
      cat_art: "Arte",
      cat_music: "Música",
      cat_books: "Libros",
      cat_electronics: "Electrónica",
      cat_home: "Hogar",
      cat_handcraft: "Artesanía",
      cat_wellness: "Bienestar",
      cat_services: "Servicios",
      cat_education: "Educación",
      cat_kids: "Niños",
      cat_sport: "Deporte",
      cat_jewelry: "Joyería",
      cat_other: "Otro",
      payout_in_ads: "Sus datos bancarios (IBAN, BIC, razón social) se introducen en Destine Ads.",
      rate_help: "1 a 5 estrellas + comentario",
      reviews_count: "reseñas",
      review_one: "reseña",
      no_reviews_short: "Sin reseñas",
      report_shop: "Reportar la tienda",
      report_help: "Ayúdenos a moderar Destine.",
      report_reason_scam: "Estafa / fraude",
      report_reason_fake_product: "Productos falsificados",
      report_reason_inappropriate: "Contenido inapropiado",
      report_reason_illegal: "Actividad ilegal",
      report_reason_other: "Otro",
      report_details: "Detalles adicionales (opcional)",
      send_report: "Enviar reporte",
      report_sent: "Reporte enviado. Gracias.",
      report_pick_reason: "Seleccione un motivo"
    },
    },

  // French
  fr: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Événements & concerts',
      seeAll: 'Voir tout',
      upcoming: 'À venir',
      empty: "Aucun événement pour l'instant.",
      buy: 'Acheter',
      book: 'Réserver',
      soldOut: 'Complet',
      ticketsWord: 'billets',
      share: 'Partager',
      report: 'Signaler',
      myTickets: 'Mes billets MyMouv',
      discover: 'Découvrir des événements',
    },
    vocaux: 'Vocaux',
    nav: {
      home: 'Accueil',
      explorer: 'Explorer',
      discover: 'Découvrir',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'Profil',
      admin: 'Admin'
    },
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saved: 'Enregistré',
      delete: 'Supprimer',
      edit: 'Modifier',
      share: 'Partager',
      report: 'Signaler',
      search: 'Rechercher',
      new: 'Nouveau',
      publish: 'Publier',
      send: 'Envoyer',
      close: 'Fermer',
      back: 'Retour',
      next: 'Suivant',
      confirm: 'Confirmer',
      yes: 'Oui',
      no: 'Non',
      copy_link: "Copier le lien",
      link_copied: "Lien copié"
    },
    auth: {
      login: 'Connexion',
      logout: 'Déconnexion',
      register: 'Inscription',
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      resetPassword: 'Réinitialiser le mot de passe',
      newPassword: 'Nouveau mot de passe',
      age: 'Âge',
      siret: 'Numéro SIRET',
      joinDestine: 'Rejoignez Destine',
      accountType: 'Type de compte',
      accountID: 'Compte ID',
      accountPRO: 'Compte PRO',
      appLanguage: 'Langue de l\'application',
      fullName: 'Nom complet',
      yourName: 'Votre nom',
      birthDate: 'Date de naissance',
      optional: 'optionnel',
      alreadyAccount: 'Déjà un compte ? Se connecter',
      noAccount: 'Pas de compte ? S\'inscrire',
      signIn: 'Se connecter',
      signUp: 'S\'inscrire',
      verification: 'Vérification'
    },
    explorer: {
      title: 'Explorer',
      subtitle: 'Podcasts, films, articles et plus',
      searchPlaceholder: 'Rechercher des contenus, utilisateurs, Gim Tolis...',
      podcasts: 'Podcasts',
      freeFilms: 'Films libres de droit',
      news: 'Actus',
      shortFilms: 'Films courts',
      watchNow: 'Regardez maintenant',
      noContent: 'Aucun contenu disponible',
      qualityWarning: 'Seuls les meilleurs courts métrages seront retenus. Les vidéos de mauvaise qualité pourront être supprimées par les administrateurs.',

      whereToWatch: 'Où regarder ?',

      whereToWatchSubtitle: 'Plateformes de streaming dans votre pays'

    },
    discover: {
      title: 'Découvrir',
      subtitle: 'Films, séries, actus, IA et MyMouv',
      tabCinema: 'Cinéma',
      tabStudio: 'Studio',
      upcomingReleases: 'Prochaines sorties cinéma',
      popCulture: 'Pop culture, mangas, théâtre',
      bestFilms: 'Meilleurs films et séries',
      boxOffice: 'Box Office',
      learnMore: 'En savoir plus'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'IA vocale émotionnellement intelligente',
      greeting: 'Bonjour !',
      greetingText: 'Je suis Déesse, votre IA vocale émotionnellement intelligente.',
      suggestions: ['Raconte-moi les actualités du jour', 'Quelles sont les dernières nouvelles ?', 'Recommande-moi un bon film', 'Quels sont les Oscars 2024 ?', 'Films les plus attendus cette année', 'Explique-moi le cinéma français'],
      newConversation: 'Nouvelle conversation',

      movieGameTitle: '🎬 Mini-jeu : Devine le film',

      movieGameSubtitle: 'Teste ta culture cinéma — réponds en vocal et marque des points',

      movieGameReady: 'Prêt(e) à briller ?',

      movieGameDescription: 'Devine un film à partir d\'un synopsis caché. Réponds en vocal ou par écrit. Score max : 100 pts du premier coup.',

      movieGameStart: '🎬 Démarrer',

      movieGameAnswerPlaceholder: 'Ta réponse...',

      movieGameSubmit: 'Envoyer',

      movieGameOrVoice: 'ou en vocal',

      movieGameVoiceAnswer: 'Répondre en vocal',

      movieGameStop: 'Arrêter',

      movieGameBravo: 'Bravo !',

      movieGameTryAgain: 'Pas cette fois...',

      movieGameCorrectAnswer: 'La réponse était :',

      movieGameReplay: 'Rejouer',

      movieGameAttempt: 'Essai',

      movieGameImageMode: '🎨 Mode image activé : ton prochain vocal génèrera une image',

      movieGameImageLimit: 'Limite quotidienne atteinte (5/jour)',
      regionalLangTitle: 'Réponse en langue régionale de Guyane',
      regionalLangSubtitle: "L'IA répondra dans la langue choisie en s'appuyant sur le corpus contribué par la communauté.",
      regionalLangOff: 'Aucune (langue principale)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'Rechercher des utilisateurs...',
      conversations: 'MyTalk',
      invitations: 'Invitations',
      noMessages: 'Aucun message',
      typeMessage: 'Écrivez un message...',
      learnMore: 'En savoir plus',
      record: 'Enregistrer',
      publish: 'Publier',
      titleField: 'Titre',
      descriptionField: 'Description'
    },
    profile: {
      title: 'Profil',
      followers: 'Abonnés',
      following: 'Abonnements',
      posts: 'Publications',
      editProfile: 'Modifier le profil',
      settings: 'Réglages',
      gimToli: 'Gim Toli',
      podcasts: 'Podcasts',
      news: 'Actus',
      videos: 'Vidéos',
      saved: 'Enregistrements',

      bioAudio: 'Audio de présentation'

    },
    settings: {
      backToProfile: 'Retour au profil',
      title: 'Réglages',
      accountInfo: 'Informations du compte',
      notifications: 'Notifications',
      notifStatusGranted: '✅ Activées — appuyez pour gérer dans Réglages iPhone',
      notifStatusDenied: '❌ Désactivées — appuyez pour ouvrir les Réglages iPhone',
      notifStatusWeb: 'Disponible sur l\'app mobile uniquement',
      notifStatusEnable: 'Appuyez pour activer les notifications',
      privacy: 'Confidentialité',
      language: 'Langue',
      changePassword: 'Changer le mot de passe',
      deleteAccount: 'Supprimer mon compte',
      proSpace: 'Espace PRO',
      helpSupport: 'Aide et support',
      about: 'À propos',
      selectLanguage: 'Sélectionner la langue',

      aboutIATitle: 'À propos de Destine IA',

      aboutIAIntro: 'Destine IA est l\'assistant intelligent intégré à votre application. Il vous aide au quotidien, sans jamais accéder à vos messages privés.',

      aboutIACanDo: 'Ce qu\'il peut faire :',

      aboutIAPrivacy: 'Confidentialité :',

      aboutIAFeatures: 'Discuter avec vous (texte ou voix grâce à Whisper);Vous donner les actualités du moment;Vous parler cinéma, séries, sorties;Analyser l\'émotion de vos Gim Toli (joie, calme, énergie...);Vous transcrire vos vocaux automatiquement',

      aboutIAPrivacyPoints: 'Vos discussions privées ne sont jamais lues par l\'IA;L\'analyse émotionnelle se fait uniquement sur les Gim Toli publics;Aucune donnée sensible n\'est partagée avec des tiers',

      openIA: 'Ouvrir Destine IA',

      countryForWatch: 'Pays pour « Où regarder ? »',

      countryForWatchSubtitle: 'Détermine les plateformes affichées dans Explorer',

      updatedToast: 'Pays mis à jour ✓',
      titleHero: 'Paramètres',
      subtitleHero: 'Gérez votre compte et vos préférences',
      appearance: 'Apparence',
      darkMode: 'Mode Sombre',
      lightMode: 'Clair — Rose',
      whiteMode: 'Clair — Blanc',
      active: 'Actif',
      changePasswordSub: 'Modifier votre mot de passe',
      phoneInChats: 'Numéro de téléphone dans les discussions',
      phoneInChatsHidden: 'Votre numéro est masqué dans les discussions',
      phoneInChatsShown: 'Votre numéro est visible par vos correspondants',
      location: 'Localisation',
      locationOn: 'Localisation activée — vous pouvez partager votre position dans les discussions',
      locationOff: 'Localisation désactivée — appuyez pour ouvrir les réglages',
      locationActivated: 'Localisation activée',
      myComments: 'Mes commentaires',
      viewMyComments: 'Voir mes commentaires',
      viewMyCommentsSub: 'Gérez tous les commentaires que vous avez laissés sur les Gim Toli et Podcasts',
      pushNotifications: 'Notifications push',
      weeklyCinemaDigest: 'Prochaines sorties ciné (hebdo)',
      weeklyCinemaDigestSub: 'Recevez chaque semaine une notification + un email avec les nouvelles sorties.',
      pushNotifMobileOnly: 'Disponible sur l\'app mobile uniquement',
      reportsTitle: 'Réclamations',
      makeReport: 'Faire une réclamation',
      makeReportSub: 'Signaler un problème ou contacter le support',
      blockedUsers: 'Utilisateurs bloqués',
      blockedUsersDesc: 'Bloquez les utilisateurs dont vous ne souhaitez plus voir le contenu. Ils ne pourront plus vous contacter ni voir votre profil.',
      searchUserToBlock: 'Rechercher un utilisateur à bloquer...',
      blockedUsersCount: 'Utilisateurs bloqués',
      noBlockedUser: 'Aucun utilisateur bloqué',
      legalDocs: 'Documents juridiques',
      legalDocsSub: 'CGU, politique de confidentialité, règles communautaires',
      security: 'Sécurité',
      logout: 'Se déconnecter',
      dangerZone: 'Zone dangereuse',
      phoneTitle: 'Numéro de téléphone',
      noPhone: 'Aucun numéro',
      statisticsTitle: "Statistiques et monétisation",
      statisticsOpen: "Voir mes statistiques",
      statisticsSub: "Likes, commentaires, partages, lectures, abonnés",
    },
    create: {
      selectLanguage: 'Langue du contenu',
      languageHint: 'Sélectionnez la langue de votre contenu',
      title: 'Titre',
      description: 'Description',
      content: 'Contenu',
      coverImage: 'Image de couverture',
      audio: 'Audio',
      video: 'Vidéo'
    },
    languages: {
      en: 'Anglais',
      es: 'Espagnol',
      fr: 'Français',
      ar: 'Arabe',
      pt: 'Portugais',
      de: 'Allemand',
      ru: 'Russe',
      zh: 'Chinois',
      ja: 'Japonais',
      hi: 'Hindi',
      nl: 'Néerlandais',
      sw: 'Swahili'
    },
    tooltips: {
      ageInfo: 'Renseignez votre âge pour renforcer la sécurité de votre compte',
      siretInfo: 'Votre SIRET servira à vérifier votre compte et renforcer sa sécurité'
    },
    statistics: {
      title: "Statistiques et monétisation",
      subtitle: "Suivez la portée de votre contenu et l'engagement de votre audience.",
      memberSince: "Membre depuis",
      global: "Vue d'ensemble",
      audience: "Audience",
      gimToli: "Gim Toli",
      shortFilms: "Films courts",
      podcasts: "Podcasts",
      totalLikes: "J'aime reçus",
      totalComments: "Commentaires",
      totalShares: "Partages",
      totalPlays: "Lectures / Vues",
      followers: "Abonnés",
      following: "Abonnements",
      saved: "Enregistrés",
      activeStories: "Stories actives",
      posts: "Publications",
      likes: "J'aime",
      comments: "Commentaires",
      shares: "Partages",
      plays: "Lectures",
      views: "Vues",
    },
    monetization: {
      title: "Monétisation",
      payouts: "Paiements reçus",
      noPayouts: "Aucun paiement reçu pour le moment.",
      eligibility: "Monétisation Destine",
      unlocked: "Tu peux ajouter un sponsor sur tes Gim Toli, podcasts et films courts.",
      locked: "Débloque la monétisation à {threshold} abonnés.",
      followersOf: "abonnés",
      policy: "Politique de monétisation",
      iban: "Coordonnées bancaires (IBAN)",
      ibanHelp: "Visible uniquement par les comptes PRO ayant accepté un sponsoring.",
      iban_save: "Enregistrer",
      iban_saved: "IBAN enregistré",
      requests: "Mes demandes de sponsoring",
      noRequests: "Aucune demande envoyée pour le moment.",
      clicks: "clics sur le lien sponsor",
      partnerWith: "Partager avec sponsor",
      shareWithSponsor: "Partager avec sponsor",
      lockedShort: "Verrouillé",
      info_title: "Monétisation",
      info_body: "À partir de 5 000 abonnés, vous pouvez attacher un sponsor à vos contenus et recevoir des paiements directs en plus de 15 devises.",
      info_cta: "En savoir plus",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Payer le créateur",
      payHint: "Frais Stripe couverts par vous (~2,9 % + 0,30 €) — le créateur reçoit le montant exact.",
      paid: "Paiement effectué",
      subtitle: "Gérez vos publicités et suivez vos performances",
      createAd: "Créer une publicité",
      myAds: "Mes publicités",
      analytics: "Analytics",
      sponsorshipRequests: "Demandes de sponsoring",
      myOffers: "Mes offres",
      activeAds: "Publicités actives",
      totalImpressions: "Impressions totales",
      totalClicks: "Clics totaux",
      ctr: "Taux de clic (CTR)",
      avgCtr: "Taux de clic moyen",
      conversionRate: "Taux de conversion",
      adsCreated: "Publicités créées",
      activeShort: "actives",
      performanceSummary: "Résumé des performances",
      details: "Détails",
      perAdPerformance: "Performance par publicité",
      myShop: "Ma MyShop",
      sellYourProductsServices: "Vendez vos produits & services",
      payoutTitle: "Coordonnées bancaires (MyShop)",
      payoutModify: "Modifier",
      payoutFill: "Renseigner",
      payoutHint: "Ces informations sont nécessaires pour recevoir les paiements de vos ventes (commission Destine : 5 %). Elles ne sont visibles que par vous et l'équipe admin.",
      companyName: "Raison sociale",
      iban: "IBAN",
      bic: "BIC",
      companyPlaceholder: "Raison sociale (ex. SARL Boutique XYZ)",
      bicPlaceholder: "BIC / SWIFT",
      save: "Enregistrer",
      saving: "Enregistrement…",
      cancel: "Annuler",
      saved: "Coordonnées enregistrées",
      genericError: "Erreur",
      noAdsYet: "Aucune publicité",
      noAdsHint: "Créez votre première publicité pour commencer",
      statusPendingPayment: "En attente de paiement",
      statusApproved: "Approuvée",
      statusActive: "Active",
      statusExpired: "Expirée",
      statusPending: "En attente",
      adVideo: "Vidéo",
      adImage: "Image",
      adAudio: "Audio",
      duration: "Durée",
      days: "jours",
      broadcastZones: "Zones de diffusion :",
      impressions: "Impressions",
      clicks: "Clics",
      delete: "Supprimer",
      pay: "Payer",
      checkPayment: "Vérifier paiement",
      checking: "Vérification…",
      createModalTitle: "Créer une publicité",
      adTypeLabel: "Type de publicité",
      videoMax: "Max 30s, 30 MB",
      imageMax: "Max 5 MB",
      audioMax: "Max 30s, MP3",
      file: "Fichier",
      maxDuration: "Durée maximale : 30 secondes",
      broadcastDuration: "Durée de diffusion",
      sevenDays: "7 jours",
      externalLinkOptional: "Lien externe (optionnel)",
      sitePlaceholder: "https://votre-site.com",
      externalLinkHint: "URL vers votre site, produit ou service",
      feedGimToli: "Feed (Gim Toli)",
      podcasts: "Podcasts",
      stories: "Stories",
      adPrice: "Prix de la publicité",
      videoPriceLabel: "100€ pour 7 jours (vidéo)",
      audioPriceLabel: "50€ pour 7 jours (audio)",
      imagePriceLabel: "50€ pour 7 jours (image)",
      creating: "Création…",
      createAndPay: "Créer et payer",
      selectFile: "Veuillez sélectionner un fichier",
      selectAtLeastOneZone: "Sélectionnez au moins une zone de diffusion",
      adCreated: "Publicité créée ! Procédez au paiement.",
      createError: "Erreur lors de la création",
      myOffersPanel: "Mes offres de sponsoring",
      newOffer: "Nouvelle offre",
      noOffersYet: "Aucune offre publiée. Crée-en une pour qu'elle apparaisse aux créateurs lors du partage.",
      offerTitleLabel: "Titre",
      offerTitlePlaceholder: "Ex : Lancement de notre nouveau parfum",
      offerDescLabel: "Description (que doit dire le créateur ?)",
      offerDescPlaceholder: "Décris le produit ou service que le créateur doit mentionner…",
      offerKindsLabel: "Types de contenu acceptés",
      offerKindGimToli: "Gim Toli",
      offerKindPodcast: "Podcast",
      offerAmountPlaceholder: "Montant",
      offerCurrencyEUR: "EUR",
      offerRule: "Le créateur doit parler du sponsor pendant 10 secondes minimum dans son Gim Toli ou podcast (ou simple mention sur film court). Cette règle est imposée par Destine.",
      publishOffer: "Publier l'offre",
      offerTitleRequired: "Titre requis",
      offerDescRequired: "Description requise",
      offerAmountInvalid: "Montant invalide",
      offerPublished: "Offre publiée",
      offerDeleted: "Offre supprimée",
      filterAll: "Tout",
      filterPending: "En attente",
      filterAccepted: "Acceptées",
      filterRejected: "Refusées",
      noSponsorshipRequests: "Aucune demande de sponsoring.",
      kindGimToli: "Gim Toli",
      kindPodcast: "Podcast",
      kindShortFilm: "Film court",
      noCallbacks: "Aucune demande de rappel pour le moment.",
      noCallbacksHint: "Les demandes envoyées par les acheteurs sur vos services apparaîtront ici.",
      client: "Client",
      markCalled: "Marquer comme rappelé",
      archive: "Archiver",
      updated: "Mis à jour",
      shopAccounting: "Comptabilité MyShop",
      detailsBtn: "Détails",
      gross: "Brut",
      commissionPct: "Commission",
      netReceive: "Net à recevoir",
      salesCount: "vente(s)",
      shopsCount: "boutique(s)",
      netExplain: "Net = chiffre d'affaires moins la commission Destine.",
      back: "Retour",
      proOnly: "Accès réservé aux comptes PRO",
      loading: "Chargement…",
      paymentChecking: "Vérification du paiement en cours…",
      paymentConfirmed: "Paiement confirmé !",
      paymentProcessing: "Paiement en cours de traitement…",
      paymentCheckError: "Erreur de vérification",
      paymentCreateError: "Erreur lors de la création du paiement",
      notifications: "Notifications",
      paymentCanceled: "Paiement annulé",
      confirmDelete: "Voulez-vous vraiment supprimer cette publicité ?",
      adDeleted: "Publicité supprimée",
      deleteError: "Erreur lors de la suppression",
      acceptedTypes: "Types acceptés",
      minTalk: "Durée parlée minimum",
      confirmDeleteOffer: "Supprimer cette offre ?",
      followers: "Abonnés",
      likes: "Likes",
      plays: "Lectures",
      accept: "Accepter",
      reject: "Refuser",
      sponsorAccepted: "Sponsoring accepté",
      sponsorRejected: "Demande refusée",
      payoutCoords: "Coordonnées de paiement",
      holder: "Titulaire",
      sponsorLinkClicks: "Clics sur lien sponsor",
      publishing: "Publication…",
      chooseAtLeastOneKind: "Choisis au moins un type de contenu",
    },

    groups: {
      tab: "Groupes",
      create: "Créer un groupe",
      name: "Nom du groupe",
      theme: "Thématique",
      rules: "Règles",
      profile_image: "Photo de profil",
      request_join: "Demander à rejoindre",
      pending: "Demande en attente",
      member: "Membre",
      encryptedStorage: "Conversation chiffrée au stockage",
      reportGroup: "Signaler le groupe",
      creator: "Créateur",
      admin: "Administrateur",
      members: "Membres",
      leave: "Quitter le groupe",
      delete: "Supprimer le groupe",
      no_groups: "Aucun groupe pour le moment",
      search_groups: "Rechercher des groupes…",
      info: "Informations du groupe",
      invitations: "Demandes de groupe",
      accept: "Accepter",
      reject: "Refuser",
      created_by: "Créé par",
      placeholder_message: "Message…",
      send: "Envoyer",
      unread_messages: "Nouveaux messages"
    },
    regional: {
      helpTitle: "Aide Destine IA à comprendre les langues régionales de Guyane.",
      activeLang: "Langue active :",
      formatTitle: "Format",
      formatHint: "Écris en français / anglais / néerlandais, ajoute « = » puis la traduction.",
      example: "Ex : Peux-tu me faire l'image d'une voiture rouge ? = Yu sa méké wang photo fou wang lébi wagi gim ?",
      pickerLabel: "Langue :",
      restrictions: "Texte et vocaux uniquement (pas de photos ni vidéos). But non lucratif.",
      leave: "Quitter",
      confirmLeave: "Quitter le groupe ? Tu pourras le rejoindre à tout moment.",
      left: "Tu as quitté le groupe",
      noMedia: "Indisponible dans ce groupe",
      ackPrefix: "Traduction intégrée en",
      ackThanks: "Merci pour ta contribution !",
      ackPairs: "paires en",
      groupName: "Destine IA — Langues régionales 🇬🇫",
      groupTheme: "Aidez l'IA à apprendre le ndjuka, saramaka, créole guyanais, hmong, kali'na, palikur, teko, wayana et wayampi.",
      groupRules: "But non lucratif : entraîner Destine IA à comprendre et répondre dans les langues régionales de Guyane française.\n\nFormat des contributions :\n  <phrase en français / anglais / néerlandais> = <traduction dans la langue choisie>\n\nExemple (djuka) : Peux-tu me faire l'image d'une voiture rouge ? = Yu sa méké wang photo fou wang lébi wagi gim ?\n\nSoyez respectueux — tout message inapproprié peut être signalé."
    },
    calls: {
      dnd_title: "Ne pas déranger",
      dnd_desc: "Lorsqu'il est activé, vous ne recevez plus d'appels vocaux dans l'app.",
      peer_dnd: "Cet utilisateur a activé Ne pas déranger",
      connecting: "Connexion…",
      ringing: "Sonnerie…",
      in_call: "En appel",
      ended: "Appel terminé",
      error: "Erreur",
      preparing: "Préparation de l'appel…",
      waiting: "En attente de la réponse…",
      daily_left: "Reste aujourd'hui",
      quota_exceeded: "Vous avez atteint votre quota de 30 minutes d'appel pour aujourd'hui.",
      not_configured: "Les appels vocaux ne sont pas activés sur ce serveur.",
      quota_reached: "Quota quotidien atteint"
    },
    screenshot: {
      taken: "{name} a fait une capture d'écran de cette discussion",
      i_took: "Vous avez fait une capture d'écran de cette discussion"
    },
    eshop: {
      title: "MyShop",
      see_all: "Tout voir",
      search_placeholder: "Rechercher une boutique ou un produit…",
      empty: "Aucune boutique pour le moment",
      load_more: "Voir plus",
      my_shop: "Ma boutique",
      my_shops: "Mes boutiques",
      delivery_days_label: "Délai de réalisation (en jours) *",
      delivery_days_hint: "Au-delà de ce délai, la commande est automatiquement validée si l'acheteur n'a pas confirmé.",
      delivery_days_invalid: "Délai de réalisation invalide (1 à 60 jours)",
      contact_address: "Adresse / coordonnées",
      no_shop_yet: "Vous n'avez pas encore de boutique",
      create_first: "Créer ma boutique",
      create_shop: "Créer une boutique",
      edit_shop: "Modifier la boutique",
      shop_created: "Boutique créée",
      shop_deleted: "Boutique supprimée",
      confirm_delete_shop: "Supprimer définitivement la boutique ?",
      delete_shop: "Supprimer la boutique",
      name: "Nom de la boutique",
      category: "Catégorie",
      country: "Pays (ISO)",
      currency: "Devise",
      description: "Description de l'activité",
      upload_cover: "Photo de couverture",
      address_full: "Adresse postale",
      phone: "Téléphone",
      website: "Site web (facultatif)",
      shipping: "Livraison",
      shipping_fee: "Frais",
      shipping_fee_cents: "Frais (centimes)",
      shipping_terms_short: "Modalités",
      company_date: "Date de création de l'entreprise",
      payout_info: "Coordonnées bancaires (pour vos virements)",
      pay_extra_now: "Payer 500 € maintenant pour une boutique supplémentaire ?",
      pro_required: "Compte PRO requis",
      pro_required_desc: "Seuls les comptes PRO peuvent créer une boutique sur Destine.",
      new: "Nouvelle",
      fill_required: "Champs obligatoires manquants",
      fill_all: "Veuillez compléter tous les champs",
      products: "Produits",
      add_product: "Nouveau produit / service",
      edit_product: "Modifier le produit",
      kind: "Type",
      kind_product: "Produit",
      kind_service: "Service",
      title_field: "Titre",
      price_cents: "Prix (centimes)",
      photos: "Photos",
      video_url: "Vidéo (URL, <60s)",
      stock: "Stock (vide = illimité)",
      catalog: "Catalogue",
      no_products: "Aucun produit pour le moment",
      buy: "Acheter",
      checkout: "Paiement",
      fullname: "Nom complet",
      address: "Adresse de livraison",
      quantity: "Quantité",
      subtotal: "Sous-total",
      pay: "Payer",
      accept_cgv: "J'accepte les",
      cgv: "CGV",
      must_accept_cgv: "Vous devez accepter les CGV",
      cgv_link: "Conditions générales de vente",
      order_placed: "Commande passée",
      reviews: "Avis",
      no_reviews: "Aucun avis pour le moment",
      write_review: "Donner un avis",
      publish_review: "Publier",
      review_thanks: "Merci pour votre avis",
      review_placeholder: "Votre commentaire (facultatif)",
      // === Service callback flow + product form (v48.2) ===
      product_title_label: "Titre du produit / service *",
      product_price_label: "Prix",
      availability_label: "Disponibilité",
      available: "Disponible",
      unavailable: "Indisponible",
      contact: "Contacter",
      call_seller: "Appeler",
      request_callback: "Demander un rappel",
      request_callback_help: "Laissez votre numéro, le vendeur vous rappellera",
      callback_message: "Message (facultatif)",
      send_callback_request: "Envoyer la demande",
      callback_sent: "Votre demande a été envoyée",
      service_intro: "Ce service ne se paie pas en ligne. Choisissez comment contacter le prestataire pour discuter du projet et obtenir un devis.",
      service_no_stripe: "Pour les services, aucun paiement n'est traité par Destine.",
      no_phone_provided: "Numéro non renseigné",
      invalid_phone: "Numéro de téléphone invalide",
      title_required: "Le titre du produit / service est obligatoire",
      price_required: "Le prix est obligatoire (en euros, ex : 300)",
      cover_dim_hint: "💡 Format recommandé : 1600 × 600 px (ratio paysage 8:3), JPG ou PNG, moins de 3 Mo. Évitez les éléments importants dans les coins (recadrage automatique sur mobile).",
      orders: "Commandes",
      my_orders: "Mes commandes",
      no_orders: "Aucune commande",
      tracking_number: "N° de suivi",
      tracking_required: "N° de suivi requis",
      marked_shipped: "Marquée comme expédiée",
      claims: "Réclamations",
      no_claims: "Aucune réclamation",
      respond: "Répondre",
      your_response: "Votre réponse",
      your_response_placeholder: "Votre réponse…",
      analytics: "Ventes",
      today: "Aujourd'hui",
      this_week: "Cette semaine",
      this_month: "Ce mois",
      this_year: "Cette année",
      total_net: "Total net",
      sales: "ventes",
      after_commission: "Après commission Destine 5%",
      settings: "Réglages",
      no_description: "Pas de description",
      cat_mymap: "MyMap",
      cat_all: "Tout",
      cat_fashion: "Mode",
      cat_beauty: "Beauté",
      cat_food: "Alimentation",
      cat_myfood: "MyFood",
      cat_art: "Art",
      cat_music: "Musique",
      cat_books: "Livres",
      cat_electronics: "Électronique",
      cat_home: "Maison",
      cat_handcraft: "Artisanat",
      cat_wellness: "Bien-être",
      cat_services: "Services",
      cat_education: "Éducation",
      cat_kids: "Enfants",
      cat_sport: "Sport",
      cat_jewelry: "Bijoux",
      cat_other: "Autre",
      report_shop: "Signaler la boutique",
      report_help: "Aidez-nous à modérer Destine. Les signalements sont examinés par notre équipe.",
      report_reason_scam: "Arnaque / fraude",
      report_reason_fake_product: "Produits contrefaits",
      report_reason_inappropriate: "Contenu inapproprié",
      report_reason_illegal: "Activité illégale",
      report_reason_other: "Autre",
      report_details: "Détails complémentaires (facultatif)",
      send_report: "Envoyer le signalement",
      report_sent: "Signalement envoyé. Merci.",
      report_pick_reason: "Sélectionnez un motif",
      rate_help: "1 à 5 étoiles + commentaire",
      reviews_count: "avis",
      review_one: "avis",
      no_reviews_short: "Pas d'avis",
      payout_in_ads: "Vos coordonnées bancaires (IBAN, BIC, raison sociale) se renseignent dans Destine Ads.",
      video_60s: "Vidéo (max 60 s, optionnelle)"
    },
    },

  // Arabic
  ar: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'الفعاليات والحفلات',
      seeAll: 'عرض الكل',
      upcoming: 'قادم',
      empty: 'لا توجد فعاليات بعد.',
      buy: 'شراء',
      book: 'حجز',
      soldOut: 'نفدت',
      ticketsWord: 'تذاكر',
      share: 'مشاركة',
      report: 'إبلاغ',
      myTickets: 'تذاكري في MyMouv',
      discover: 'اكتشف الفعاليات',
    },
    vocaux: 'صوتيات',
    nav: {
      home: 'الرئيسية',
      explorer: 'استكشاف',
      discover: 'اكتشف',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'الملف الشخصي',
      admin: 'الإدارة'
    },
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      success: 'نجاح',
      cancel: 'إلغاء',
      save: 'حفظ',
      saved: 'تم الحفظ',
      delete: 'حذف',
      edit: 'تعديل',
      share: 'مشاركة',
      report: 'إبلاغ',
      search: 'بحث',
      new: 'جديد',
      publish: 'نشر',
      send: 'إرسال',
      close: 'إغلاق',
      back: 'رجوع',
      next: 'التالي',
      confirm: 'تأكيد',
      yes: 'نعم',
      no: 'لا',
      copy_link: "نسخ الرابط",
      link_copied: "تم النسخ"
    },
    auth: {
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      register: 'إنشاء حساب',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور؟',
      resetPassword: 'إعادة تعيين كلمة المرور',
      newPassword: 'كلمة مرور جديدة',
      age: 'العمر',
      siret: 'رقم SIRET',
      joinDestine: 'انضم إلى Destine',
      accountType: 'نوع الحساب',
      accountID: 'حساب ID',
      accountPRO: 'حساب PRO',
      appLanguage: 'لغة التطبيق',
      fullName: 'الاسم الكامل',
      yourName: 'اسمك',
      birthDate: 'تاريخ الميلاد',
      optional: 'اختياري',
      alreadyAccount: 'لديك حساب؟ تسجيل الدخول',
      noAccount: 'ليس لديك حساب؟ التسجيل',
      signIn: 'تسجيل الدخول',
      signUp: 'التسجيل',
      verification: 'التحقق'
    },
    explorer: {
      title: 'استكشاف',
      subtitle: 'بودكاست، أفلام، مقالات والمزيد',
      searchPlaceholder: 'البحث عن محتوى، مستخدمين، Gim Tolis...',
      podcasts: 'بودكاست',
      freeFilms: 'أفلام المجال العام',
      news: 'أخبار',
      shortFilms: 'أفلام قصيرة',
      watchNow: 'شاهد الآن',
      noContent: 'لا يوجد محتوى متاح',
      qualityWarning: 'سيتم الاحتفاظ بأفضل الأفلام القصيرة فقط. قد يتم حذف مقاطع الفيديو منخفضة الجودة من قبل المسؤولين.',

      whereToWatch: 'أين تشاهد؟',

      whereToWatchSubtitle: 'منصات البث في بلدك'

    },
    discover: {
      title: 'اكتشف',
      subtitle: 'أفلام، مسلسلات، أخبار، ذكاء اصطناعي و MyMouv',
      tabCinema: 'سينما',
      tabStudio: 'Studio',
      upcomingReleases: 'إصدارات قادمة',
      popCulture: 'ثقافة شعبية، مانغا، مسرح',
      bestFilms: 'أفضل الأفلام والمسلسلات',
      boxOffice: 'شباك التذاكر',
      learnMore: 'اعرف أكثر'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'ذكاء اصطناعي صوتي ذكي عاطفيًا',
      greeting: 'مرحباً!',
      greetingText: 'أنا Déesse، ذكاؤك الاصطناعي الصوتي الذكي عاطفيًا.',
      suggestions: ['أخبرني بأخبار اليوم', 'ما هي آخر الأخبار؟', 'أوصني بفيلم جيد', 'ما هي جوائز أوسكار 2024؟', 'أكثر الأفلام المنتظرة هذا العام', 'اشرح لي السينما الفرنسية'],
      newConversation: 'محادثة جديدة',

      movieGameTitle: '🎬 لعبة: خمن الفيلم',

      movieGameSubtitle: 'اختبر ثقافتك السينمائية',

      movieGameReady: 'مستعد؟',

      movieGameDescription: 'خمّن فيلمًا من ملخص مخفي.',

      movieGameStart: '🎬 ابدأ',

      movieGameAnswerPlaceholder: 'إجابتك...',

      movieGameSubmit: 'إرسال',

      movieGameOrVoice: 'أو بالصوت',

      movieGameVoiceAnswer: 'الإجابة بالصوت',

      movieGameStop: 'إيقاف',

      movieGameBravo: 'أحسنت!',

      movieGameTryAgain: 'ليس هذه المرة...',

      movieGameCorrectAnswer: 'الإجابة كانت:',

      movieGameReplay: 'العب مجددًا',

      movieGameAttempt: 'محاولة',

      movieGameImageMode: '🎨 وضع الصورة مفعل',

      movieGameImageLimit: 'تم بلوغ الحد اليومي (5/يوم)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'البحث عن مستخدمين...',
      conversations: 'MyTalk',
      invitations: 'الدعوات',
      noMessages: 'لا توجد رسائل',
      typeMessage: 'اكتب رسالة...',
      learnMore: 'اعرف أكثر',
      record: 'تسجيل',
      publish: 'نشر',
      titleField: 'العنوان',
      descriptionField: 'الوصف'
    },
    profile: {
      title: 'الملف الشخصي',
      followers: 'المتابعون',
      following: 'يتابع',
      posts: 'المنشورات',
      editProfile: 'تعديل الملف الشخصي',
      settings: 'الإعدادات',
      gimToli: 'Gim Toli',
      podcasts: 'بودكاست',
      news: 'أخبار',
      videos: 'فيديوهات',
      saved: 'المحفوظات',

      bioAudio: 'تقديم صوتي'

    },
    settings: {
      backToProfile: 'العودة إلى الملف الشخصي',
      title: 'الإعدادات',
      accountInfo: 'معلومات الحساب',
      notifications: 'الإشعارات',
      notifStatusGranted: '✅ مفعّلة — اضغط للإدارة في إعدادات iPhone',
      notifStatusDenied: '❌ معطّلة — اضغط لفتح إعدادات iPhone',
      notifStatusWeb: 'متاح على تطبيق الجوّال فقط',
      notifStatusEnable: 'اضغط لتفعيل الإشعارات',
      privacy: 'الخصوصية',
      language: 'اللغة',
      changePassword: 'تغيير كلمة المرور',
      deleteAccount: 'حذف الحساب',
      proSpace: 'مساحة PRO',
      helpSupport: 'المساعدة والدعم',
      about: 'حول',
      selectLanguage: 'اختر اللغة',

      aboutIATitle: 'حول Destine AI',

      aboutIAIntro: 'Destine AI هو المساعد الذكي المدمج في تطبيقك. يساعدك يوميًا دون الوصول إلى رسائلك الخاصة.',

      aboutIACanDo: 'ما يمكنه فعله:',

      aboutIAPrivacy: 'الخصوصية:',

      aboutIAFeatures: 'الدردشة معك (نص أو صوت);إعطاؤك آخر الأخبار;التحدث عن السينما والمسلسلات;تحليل مشاعر Gim Tolis;نسخ رسائلك الصوتية',

      aboutIAPrivacyPoints: 'لا تُقرأ محادثاتك الخاصة أبدًا;التحليل العاطفي للمحتوى العام فقط;لا تتم مشاركة البيانات الحساسة',

      openIA: 'افتح Destine AI',

      countryForWatch: 'البلد لـ "أين تشاهد؟"',

      countryForWatchSubtitle: 'يحدد المنصات في Explorer',

      updatedToast: 'تم تحديث البلد ✓',
      titleHero: 'الإعدادات',
      subtitleHero: 'إدارة حسابك وتفضيلاتك',
      appearance: 'المظهر',
      darkMode: 'الوضع الداكن',
      lightMode: 'فاتح — وردي',
      whiteMode: 'فاتح — أبيض',
      active: 'نشط',
      changePasswordSub: 'تعديل كلمة المرور',
      phoneInChats: 'الهاتف في المحادثات',
      phoneInChatsHidden: 'رقمك مخفي',
      phoneInChatsShown: 'رقمك مرئي',
      location: 'الموقع',
      locationOn: 'الموقع مفعل',
      locationOff: 'الموقع معطل',
      locationActivated: 'تم تفعيل الموقع',
      myComments: 'تعليقاتي',
      viewMyComments: 'عرض تعليقاتي',
      viewMyCommentsSub: 'إدارة جميع تعليقاتك',
      pushNotifications: 'إشعارات الدفع',
      weeklyCinemaDigest: 'إصدارات سينمائية أسبوعية',
      weeklyCinemaDigestSub: 'احصل على بريد إلكتروني + إشعار أسبوعي حول الإصدارات القادمة.',
      pushNotifMobileOnly: 'متاح فقط في التطبيق المحمول',
      reportsTitle: 'الشكاوى',
      makeReport: 'تقديم شكوى',
      makeReportSub: 'الإبلاغ عن مشكلة أو الاتصال بالدعم',
      blockedUsers: 'المستخدمون المحظورون',
      blockedUsersDesc: 'احظر المستخدمين الذين لا تريد رؤية محتواهم.',
      searchUserToBlock: 'ابحث عن مستخدم لحظره...',
      blockedUsersCount: 'المستخدمون المحظورون',
      noBlockedUser: 'لا يوجد مستخدم محظور',
      legalDocs: 'الوثائق القانونية',
      legalDocsSub: 'الشروط والخصوصية والقواعد',
      security: 'الأمان',
      logout: 'تسجيل الخروج',
      dangerZone: 'منطقة الخطر',
      phoneTitle: 'رقم الهاتف',
      noPhone: 'لا يوجد رقم',
      statisticsTitle: "الإحصائيات وتحقيق الدخل",
      statisticsOpen: "عرض إحصائياتي",
      statisticsSub: "الإعجابات، التعليقات، المشاركات، التشغيلات، المتابعون",
    },
    create: {
      selectLanguage: 'لغة المحتوى',
      languageHint: 'اختر لغة المحتوى الخاص بك',
      title: 'العنوان',
      description: 'الوصف',
      content: 'المحتوى',
      coverImage: 'صورة الغلاف',
      audio: 'صوت',
      video: 'فيديو'
    },
    languages: {
      en: 'الإنجليزية',
      es: 'الإسبانية',
      fr: 'الفرنسية',
      ar: 'العربية',
      pt: 'البرتغالية',
      de: 'الألمانية',
      ru: 'الروسية',
      zh: 'الصينية'
    },
    tooltips: {
      ageInfo: 'أدخل عمرك لتعزيز أمان حسابك',
      siretInfo: 'سيتم استخدام رقم SIRET للتحقق من حسابك وتعزيز الأمان'
    },
    statistics: {
      title: "الإحصائيات وتحقيق الدخل",
      subtitle: "تتبع مدى وصول محتواك وتفاعل جمهورك.",
      memberSince: "عضو منذ",
      global: "نظرة عامة",
      audience: "الجمهور",
      gimToli: "جيم تولي",
      shortFilms: "أفلام قصيرة",
      podcasts: "البودكاست",
      totalLikes: "الإعجابات المستلمة",
      totalComments: "التعليقات",
      totalShares: "المشاركات",
      totalPlays: "المشاهدات / التشغيلات",
      followers: "المتابعون",
      following: "تتابع",
      saved: "المحفوظات",
      activeStories: "قصص نشطة",
      posts: "المنشورات",
      likes: "إعجابات",
      comments: "تعليقات",
      shares: "مشاركات",
      plays: "تشغيلات",
      views: "مشاهدات",
    },
    monetization: {
      title: "تحقيق الدخل",
      payouts: "المدفوعات المستلمة",
      noPayouts: "لم يتم استلام أي دفعة بعد.",
      eligibility: "تحقيق الدخل على Destine",
      unlocked: "يمكنك إضافة راعٍ إلى Gim Toli والبودكاست والأفلام القصيرة.",
      locked: "افتح تحقيق الدخل عند {threshold} متابع.",
      followersOf: "متابعون",
      policy: "سياسة تحقيق الدخل",
      iban: "تفاصيل المصرف (IBAN)",
      ibanHelp: "مرئية فقط لحسابات PRO التي قبلت رعاية.",
      iban_save: "حفظ",
      iban_saved: "تم حفظ IBAN",
      requests: "طلبات الرعاية",
      noRequests: "لا توجد طلبات مرسلة بعد.",
      clicks: "نقرات على رابط الراعي",
      partnerWith: "الشراكة مع راعٍ",
      shareWithSponsor: "مشاركة مع راعٍ",
      lockedShort: "مقفل",
      info_title: "تحقيق الدخل",
      info_body: "بدءًا من 5000 متابع، يمكنك إرفاق راعٍ بمحتواك وتلقي مدفوعات مباشرة بأكثر من 15 عملة.",
      info_cta: "اعرف المزيد",
    },
    ads: {
      title: "Destine Ads",
      payNow: "ادفع للمُنشئ",
      payHint: "رسوم Stripe يتحمّلها المُعلن (~2.9% + 0.30€) — يستلم المُنشئ المبلغ بالضبط.",
      paid: "تم الدفع",
      myAds: "إعلاناتي",
      analytics: "تحليلات",
      sponsorshipRequests: "طلبات الرعاية",
      myOffers: "عروضي",
    },

    groups: {
      tab: "المجموعات",
      create: "إنشاء مجموعة",
      name: "اسم المجموعة",
      theme: "الموضوع",
      rules: "القواعد",
      profile_image: "صورة الملف الشخصي",
      request_join: "طلب الانضمام",
      pending: "الطلب قيد الانتظار",
      member: "عضو",
      creator: "المنشئ",
      admin: "مسؤول",
      members: "الأعضاء",
      leave: "مغادرة المجموعة",
      delete: "حذف المجموعة",
      no_groups: "لا توجد مجموعات بعد",
      search_groups: "البحث عن المجموعات…",
      info: "معلومات المجموعة",
      invitations: "طلبات المجموعة",
      accept: "قبول",
      reject: "رفض",
      created_by: "أنشأها",
      placeholder_message: "رسالة…",
      send: "إرسال",
      unread_messages: "رسائل جديدة"
    },
    calls: {
      dnd_title: "عدم الإزعاج",
      dnd_desc: "عند التفعيل، لن تتلقى مكالمات صوتية في التطبيق.",
      peer_dnd: "فعّل هذا المستخدم عدم الإزعاج",
      connecting: "جارٍ الاتصال…",
      ringing: "رنين…",
      in_call: "في مكالمة",
      ended: "انتهت",
      error: "خطأ",
      preparing: "تجهيز المكالمة…",
      waiting: "في انتظار الرد…",
      daily_left: "المتبقي اليوم",
      quota_exceeded: "لقد وصلت إلى الحد اليومي البالغ 30 دقائق.",
      not_configured: "المكالمات الصوتية غير مفعّلة على هذا الخادم.",
      quota_reached: "تم بلوغ الحصة اليومية"
    },
    screenshot: {
      taken: "{name} التقط لقطة شاشة لهذه المحادثة",
      i_took: "قمت بالتقاط لقطة شاشة لهذه المحادثة"
    },
    eshop: {
      title: "MyShop",
      see_all: "عرض الكل",
      search_placeholder: "ابحث عن متجر أو منتج…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "متجري",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "إنشاء متجر",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "المنتجات",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "الكتالوج",
      no_products: "No products yet",
      buy: "شراء",
      checkout: "الدفع",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "ادفع",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "التقييمات",
      no_reviews: "No reviews yet",
      write_review: "اكتب تقييماً",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "الكل",
      cat_fashion: "الأزياء",
      cat_beauty: "الجمال",
      cat_food: "الطعام",
      cat_myfood: "MyFood",
      cat_art: "الفن",
      cat_music: "الموسيقى",
      cat_books: "الكتب",
      cat_electronics: "الإلكترونيات",
      cat_home: "المنزل",
      cat_handcraft: "الحرف اليدوية",
      cat_wellness: "العافية",
      cat_services: "الخدمات",
      cat_education: "التعليم",
      cat_kids: "الأطفال",
      cat_sport: "الرياضة",
      cat_jewelry: "المجوهرات",
      cat_other: "أخرى",
      rate_help: "من 1 إلى 5 نجوم + تعليق",
      report_shop: "بلّغ عن المتجر",
      reviews_count: "تقييمات",
      review_one: "تقييم",
      no_reviews_short: "لا توجد تقييمات"
    },
    },

  // Portuguese
  pt: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Eventos e concertos',
      seeAll: 'Ver tudo',
      upcoming: 'Próximos',
      empty: 'Ainda não há eventos.',
      buy: 'Comprar',
      book: 'Reservar',
      soldOut: 'Esgotado',
      ticketsWord: 'ingressos',
      share: 'Compartilhar',
      report: 'Denunciar',
      myTickets: 'Meus ingressos MyMouv',
      discover: 'Descobrir eventos',
    },
    vocaux: 'Áudios',
    nav: {
      home: 'Início',
      explorer: 'Explorar',
      discover: 'Descobrir',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'Perfil',
      admin: 'Admin'
    },
    common: {
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      cancel: 'Cancelar',
      save: 'Salvar',
      saved: 'Salvo',
      delete: 'Excluir',
      edit: 'Editar',
      share: 'Compartilhar',
      report: 'Denunciar',
      search: 'Pesquisar',
      new: 'Novo',
      publish: 'Publicar',
      send: 'Enviar',
      close: 'Fechar',
      back: 'Voltar',
      next: 'Próximo',
      confirm: 'Confirmar',
      yes: 'Sim',
      no: 'Não',
      copy_link: "Copiar link",
      link_copied: "Link copiado"
    },
    auth: {
      login: 'Entrar',
      logout: 'Sair',
      register: 'Cadastrar',
      email: 'Email',
      password: 'Senha',
      confirmPassword: 'Confirmar senha',
      forgotPassword: 'Esqueceu a senha?',
      resetPassword: 'Redefinir senha',
      newPassword: 'Nova senha',
      age: 'Idade',
      siret: 'Número SIRET',
      joinDestine: 'Junte-se ao Destine',
      accountType: 'Tipo de conta',
      accountID: 'Conta ID',
      accountPRO: 'Conta PRO',
      appLanguage: 'Idioma do aplicativo',
      fullName: 'Nome completo',
      yourName: 'Seu nome',
      birthDate: 'Data de nascimento',
      optional: 'opcional',
      alreadyAccount: 'Já tem conta? Entrar',
      noAccount: 'Sem conta? Cadastrar-se',
      signIn: 'Entrar',
      signUp: 'Cadastrar-se',
      verification: 'Verificação'
    },
    explorer: {
      title: 'Explorar',
      subtitle: 'Podcasts, filmes, artigos e mais',
      searchPlaceholder: 'Pesquisar conteúdo, usuários, Gim Tolis...',
      podcasts: 'Podcasts',
      freeFilms: 'Filmes de domínio público',
      news: 'Notícias',
      shortFilms: 'Curtas-metragens',
      watchNow: 'Assistir agora',
      noContent: 'Nenhum conteúdo disponível',
      qualityWarning: 'Apenas os melhores curtas serão mantidos. Vídeos de baixa qualidade podem ser removidos pelos administradores.',

      whereToWatch: 'Onde assistir?',

      whereToWatchSubtitle: 'Plataformas de streaming no seu país'

    },
    discover: {
      title: 'Descobrir',
      subtitle: 'Filmes, séries, notícias, IA e MyMouv',
      tabCinema: 'Cinema',
      tabStudio: 'Studio',
      upcomingReleases: 'Próximos lançamentos',
      popCulture: 'Cultura pop, mangá, teatro',
      bestFilms: 'Melhores filmes e séries',
      boxOffice: 'Bilheteria',
      learnMore: 'Saiba mais'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'IA de voz emocionalmente inteligente',
      greeting: 'Olá!',
      greetingText: 'Sou a Déesse, a sua IA de voz emocionalmente inteligente.',
      suggestions: ['Conte-me as notícias do dia', 'Quais são as últimas novidades?', 'Recomende-me um bom filme', 'Quais são os Oscars 2024?', 'Filmes mais esperados este ano', 'Explique-me o cinema francês'],
      newConversation: 'Nova conversa',

      movieGameTitle: '🎬 Mini-jogo: Adivinhe o filme',

      movieGameSubtitle: 'Teste sua cultura cinematográfica',

      movieGameReady: 'Pronto para brilhar?',

      movieGameDescription: 'Adivinhe um filme pela sinopse oculta.',

      movieGameStart: '🎬 Começar',

      movieGameAnswerPlaceholder: 'Sua resposta...',

      movieGameSubmit: 'Enviar',

      movieGameOrVoice: 'ou por voz',

      movieGameVoiceAnswer: 'Responder por voz',

      movieGameStop: 'Parar',

      movieGameBravo: 'Bravo!',

      movieGameTryAgain: 'Desta vez não...',

      movieGameCorrectAnswer: 'A resposta era:',

      movieGameReplay: 'Jogar de novo',

      movieGameAttempt: 'Tentativa',

      movieGameImageMode: '🎨 Modo imagem ativo',

      movieGameImageLimit: 'Limite diário atingido (5/dia)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'Buscar usuários...',
      conversations: 'MyTalk',
      invitations: 'Convites',
      noMessages: 'Sem mensagens',
      typeMessage: 'Digite uma mensagem...',
      learnMore: 'Saiba mais',
      record: 'Gravar',
      publish: 'Publicar',
      titleField: 'Título',
      descriptionField: 'Descrição'
    },
    profile: {
      title: 'Perfil',
      followers: 'Seguidores',
      following: 'Seguindo',
      posts: 'Publicações',
      editProfile: 'Editar perfil',
      settings: 'Configurações',
      gimToli: 'Gim Toli',
      podcasts: 'Podcasts',
      news: 'Notícias',
      videos: 'Vídeos',
      saved: 'Salvos',

      bioAudio: 'Áudio de apresentação'

    },
    settings: {
      backToProfile: 'Voltar ao perfil',
      title: 'Configurações',
      accountInfo: 'Informações da conta',
      notifications: 'Notificações',
      notifStatusGranted: '✅ Ativadas — toque para gerir em Ajustes do iPhone',
      notifStatusDenied: '❌ Desativadas — toque para abrir Ajustes do iPhone',
      notifStatusWeb: 'Disponível apenas na app móvel',
      notifStatusEnable: 'Toque para ativar as notificações',
      privacy: 'Privacidade',
      language: 'Idioma',
      changePassword: 'Alterar senha',
      deleteAccount: 'Excluir conta',
      proSpace: 'Espaço PRO',
      helpSupport: 'Ajuda e suporte',
      about: 'Sobre',
      selectLanguage: 'Selecionar idioma',

      aboutIATitle: 'Sobre o Destine IA',

      aboutIAIntro: 'O Destine IA é o assistente inteligente do seu app. Ele ajuda você sem acessar suas mensagens privadas.',

      aboutIACanDo: 'O que ele pode fazer:',

      aboutIAPrivacy: 'Privacidade:',

      aboutIAFeatures: 'Conversar (texto ou voz via Whisper);Dar notícias atuais;Falar sobre cinema, séries;Analisar a emoção dos Gim Tolis;Transcrever mensagens de voz',

      aboutIAPrivacyPoints: 'Suas conversas privadas nunca são lidas;A análise emocional é só nos Gim Tolis públicos;Nenhum dado sensível é compartilhado',

      openIA: 'Abrir Destine IA',

      countryForWatch: 'País para "Onde assistir?"',

      countryForWatchSubtitle: 'Define as plataformas mostradas no Explorer',

      updatedToast: 'País atualizado ✓',
      titleHero: 'Configurações',
      subtitleHero: 'Gerencie sua conta e preferências',
      appearance: 'Aparência',
      darkMode: 'Modo escuro',
      lightMode: 'Claro — Rosa',
      whiteMode: 'Claro — Branco',
      active: 'Ativo',
      changePasswordSub: 'Modifique sua senha',
      phoneInChats: 'Telefone em chats',
      phoneInChatsHidden: 'Seu número está oculto',
      phoneInChatsShown: 'Seu número é visível',
      location: 'Localização',
      locationOn: 'Localização ativada',
      locationOff: 'Localização desativada — toque para abrir ajustes',
      locationActivated: 'Localização ativada',
      myComments: 'Meus comentários',
      viewMyComments: 'Ver meus comentários',
      viewMyCommentsSub: 'Gerencie todos os comentários',
      pushNotifications: 'Notificações push',
      weeklyCinemaDigest: 'Estreias semanais no cinema',
      weeklyCinemaDigestSub: 'Receba um email + notificação semanal sobre próximos lançamentos.',
      pushNotifMobileOnly: 'Disponível apenas no app móvel',
      reportsTitle: 'Reclamações',
      makeReport: 'Fazer uma reclamação',
      makeReportSub: 'Reportar um problema ou contatar suporte',
      blockedUsers: 'Usuários bloqueados',
      blockedUsersDesc: 'Bloqueie usuários cujo conteúdo você não quer mais ver.',
      searchUserToBlock: 'Pesquisar usuário para bloquear...',
      blockedUsersCount: 'Usuários bloqueados',
      noBlockedUser: 'Nenhum usuário bloqueado',
      legalDocs: 'Documentos legais',
      legalDocsSub: 'Termos, privacidade, regras',
      security: 'Segurança',
      logout: 'Sair',
      dangerZone: 'Zona perigosa',
      phoneTitle: 'Número de telefone',
      noPhone: 'Sem número',
      statisticsTitle: "Estatísticas e monetização",
      statisticsOpen: "Ver minhas estatísticas",
      statisticsSub: "Curtidas, comentários, compartilhamentos, reproduções, seguidores",
    },
    create: {
      selectLanguage: 'Idioma do conteúdo',
      languageHint: 'Selecione o idioma do seu conteúdo',
      title: 'Título',
      description: 'Descrição',
      content: 'Conteúdo',
      coverImage: 'Imagem de capa',
      audio: 'Áudio',
      video: 'Vídeo'
    },
    languages: {
      en: 'Inglês',
      es: 'Espanhol',
      fr: 'Francês',
      ar: 'Árabe',
      pt: 'Português',
      de: 'Alemão',
      ru: 'Russo',
      zh: 'Chinês'
    },
    tooltips: {
      ageInfo: 'Insira sua idade para aumentar a segurança da sua conta',
      siretInfo: 'Seu SIRET será usado para verificar sua conta e aumentar a segurança'
    },
    statistics: {
      title: "Estatísticas e monetização",
      subtitle: "Acompanhe o alcance do seu conteúdo e o engajamento do público.",
      memberSince: "Membro desde",
      global: "Visão geral",
      audience: "Audiência",
      gimToli: "Gim Toli",
      shortFilms: "Curtas",
      podcasts: "Podcasts",
      totalLikes: "Curtidas recebidas",
      totalComments: "Comentários",
      totalShares: "Compartilhamentos",
      totalPlays: "Reproduções / Vistas",
      followers: "Seguidores",
      following: "Seguindo",
      saved: "Salvos",
      activeStories: "Stories ativos",
      posts: "Publicações",
      likes: "Curtidas",
      comments: "Comentários",
      shares: "Compartilhamentos",
      plays: "Reproduções",
      views: "Visualizações",
    },
    monetization: {
      title: "Monetização",
      payouts: "Pagamentos recebidos",
      noPayouts: "Nenhum pagamento recebido no momento.",
      eligibility: "Monetização no Destine",
      unlocked: "Você pode adicionar um patrocinador aos seus Gim Toli, podcasts e curtas.",
      locked: "Desbloqueie a monetização com {threshold} seguidores.",
      followersOf: "seguidores",
      policy: "Política de monetização",
      iban: "Dados bancários (IBAN)",
      ibanHelp: "Visível apenas para contas PRO que aceitaram um patrocínio.",
      iban_save: "Salvar",
      iban_saved: "IBAN salvo",
      requests: "Minhas solicitações de patrocínio",
      noRequests: "Nenhuma solicitação enviada ainda.",
      clicks: "cliques no link do patrocinador",
      partnerWith: "Compartilhar com patrocinador",
      shareWithSponsor: "Compartilhar com patrocinador",
      lockedShort: "Bloqueado",
      info_title: "Monetização",
      info_body: "A partir de 5.000 seguidores, você pode anexar um patrocinador ao seu conteúdo e receber pagamentos diretos em mais de 15 moedas.",
      info_cta: "Saiba mais",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Pagar ao criador",
      payHint: "Taxas Stripe pagas por você (~2,9 % + € 0,30) — o criador recebe o valor exato.",
      paid: "Pagamento efetuado",
      myAds: "Meus anúncios",
      analytics: "Analytics",
      sponsorshipRequests: "Solicitações de patrocínio",
      myOffers: "Minhas ofertas",
    },

    groups: {
      tab: "Grupos",
      create: "Criar um grupo",
      name: "Nome do grupo",
      theme: "Tema",
      rules: "Regras",
      profile_image: "Foto de perfil",
      request_join: "Pedir para entrar",
      pending: "Pedido pendente",
      member: "Membro",
      creator: "Criador",
      admin: "Administrador",
      members: "Membros",
      leave: "Sair do grupo",
      delete: "Excluir grupo",
      no_groups: "Ainda não há grupos",
      search_groups: "Pesquisar grupos…",
      info: "Informações do grupo",
      invitations: "Solicitações de grupo",
      accept: "Aceitar",
      reject: "Recusar",
      created_by: "Criado por",
      placeholder_message: "Mensagem…",
      send: "Enviar",
      unread_messages: "Novas mensagens"
    },
    calls: {
      dnd_title: "Não perturbe",
      dnd_desc: "Quando ativado, você não receberá chamadas de voz no aplicativo.",
      peer_dnd: "Este usuário ativou Não perturbe",
      connecting: "Conectando…",
      ringing: "Chamando…",
      in_call: "Em chamada",
      ended: "Encerrada",
      error: "Erro",
      preparing: "Preparando a chamada…",
      waiting: "Aguardando resposta…",
      daily_left: "Resta hoje",
      quota_exceeded: "Você atingiu sua cota diária de 30 minutos.",
      not_configured: "As chamadas de voz não estão ativadas neste servidor.",
      quota_reached: "Cota diária atingida"
    },
    screenshot: {
      taken: "{name} fez uma captura de tela desta conversa",
      i_took: "Você fez uma captura de tela desta conversa"
    },
    eshop: {
      title: "MyShop",
      see_all: "Ver tudo",
      search_placeholder: "Pesquisar loja ou produto…",
      empty: "Ainda não há lojas",
      load_more: "Carregar mais",
      my_shop: "Minha loja",
      my_shops: "Minhas lojas",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Criar uma loja",
      edit_shop: "Editar loja",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Nome da loja",
      category: "Categoria",
      country: "País (ISO)",
      currency: "Moeda",
      description: "Descrição da atividade",
      upload_cover: "Foto de capa",
      address_full: "Endereço postal",
      phone: "Telefone",
      website: "Site (opcional)",
      shipping: "Entrega",
      shipping_fee: "Taxa",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Data de criação da empresa",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Produtos",
      add_product: "Novo produto / serviço",
      edit_product: "Editar produto",
      kind: "Tipo",
      kind_product: "Produto",
      kind_service: "Serviço",
      title_field: "Title",
      price_cents: "Preço (cêntimos)",
      photos: "Fotos",
      video_url: "Video (URL, <60s)",
      stock: "Estoque (vazio = ilimitado)",
      catalog: "Catálogo",
      no_products: "Ainda não há produtos",
      buy: "Comprar",
      checkout: "Pagamento",
      fullname: "Nome completo",
      address: "Endereço de entrega",
      quantity: "Quantidade",
      subtotal: "Subtotal",
      pay: "Pagar",
      accept_cgv: "Aceito os",
      cgv: "Termos",
      must_accept_cgv: "Você deve aceitar os termos",
      cgv_link: "Termos gerais de venda",
      order_placed: "Pedido realizado",
      reviews: "Avaliações",
      no_reviews: "Ainda não há avaliações",
      write_review: "Deixar avaliação",
      publish_review: "Publicar",
      review_thanks: "Obrigado pela avaliação",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Hoje",
      this_week: "Esta semana",
      this_month: "Este mês",
      this_year: "Este ano",
      total_net: "Total líquido",
      sales: "vendas",
      after_commission: "Após comissão de 5% Destine",
      settings: "Ajustes",
      no_description: "Sem descrição",
      cat_mymap: "MyMap",
      cat_all: "Tudo",
      cat_fashion: "Moda",
      cat_beauty: "Beleza",
      cat_food: "Alimentação",
      cat_myfood: "MyFood",
      cat_art: "Arte",
      cat_music: "Música",
      cat_books: "Livros",
      cat_electronics: "Eletrônica",
      cat_home: "Casa",
      cat_handcraft: "Artesanato",
      cat_wellness: "Bem-estar",
      cat_services: "Serviços",
      cat_education: "Educação",
      cat_kids: "Crianças",
      cat_sport: "Esporte",
      cat_jewelry: "Joias",
      cat_other: "Outro",
      rate_help: "1 a 5 estrelas + comentário",
      reviews_count: "avaliações",
      review_one: "avaliação",
      no_reviews_short: "Sem avaliações",
      report_shop: "Reportar loja",
      send_report: "Enviar reporte",
      report_sent: "Reporte enviado."
    },
    },

  // German
  de: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Events & Konzerte',
      seeAll: 'Alle ansehen',
      upcoming: 'Kommende',
      empty: 'Noch keine Events.',
      buy: 'Kaufen',
      book: 'Buchen',
      soldOut: 'Ausverkauft',
      ticketsWord: 'Tickets',
      share: 'Teilen',
      report: 'Melden',
      myTickets: 'Meine MyMouv-Tickets',
      discover: 'Events entdecken',
    },
    vocaux: 'Sprachnachrichten',
    nav: {
      home: 'Startseite',
      explorer: 'Entdecken',
      discover: 'Entdecken',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'Profil',
      admin: 'Admin'
    },
    common: {
      loading: 'Laden...',
      error: 'Fehler',
      success: 'Erfolg',
      cancel: 'Abbrechen',
      save: 'Speichern',
      saved: 'Gespeichert',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      share: 'Teilen',
      report: 'Melden',
      search: 'Suchen',
      new: 'Neu',
      publish: 'Veröffentlichen',
      send: 'Senden',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      confirm: 'Bestätigen',
      yes: 'Ja',
      no: 'Nein',
      copy_link: "Link kopieren",
      link_copied: "Link kopiert"
    },
    auth: {
      login: 'Anmelden',
      logout: 'Abmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      forgotPassword: 'Passwort vergessen?',
      resetPassword: 'Passwort zurücksetzen',
      newPassword: 'Neues Passwort',
      age: 'Alter',
      siret: 'SIRET-Nummer',
      joinDestine: 'Treten Sie Destine bei',
      accountType: 'Kontotyp',
      accountID: 'ID-Konto',
      accountPRO: 'PRO-Konto',
      appLanguage: 'App-Sprache',
      fullName: 'Vollständiger Name',
      yourName: 'Ihr Name',
      birthDate: 'Geburtsdatum',
      optional: 'optional',
      alreadyAccount: 'Bereits ein Konto? Anmelden',
      noAccount: 'Kein Konto? Registrieren',
      signIn: 'Anmelden',
      signUp: 'Registrieren',
      verification: 'Überprüfung'
    },
    explorer: {
      title: 'Entdecken',
      subtitle: 'Podcasts, Filme, Artikel und mehr',
      searchPlaceholder: 'Inhalte, Benutzer, Gim Tolis suchen...',
      podcasts: 'Podcasts',
      freeFilms: 'Gemeinfreie Filme',
      news: 'Nachrichten',
      shortFilms: 'Kurzfilme',
      watchNow: 'Jetzt ansehen',
      noContent: 'Kein Inhalt verfügbar',
      qualityWarning: 'Nur die besten Kurzfilme werden behalten. Videos mit niedriger Qualität können von Administratoren entfernt werden.',

      whereToWatch: 'Wo ansehen?',

      whereToWatchSubtitle: 'Streaming-Plattformen in deinem Land'

    },
    discover: {
      title: 'Entdecken',
      subtitle: 'Filme, Serien, Nachrichten, KI und MyMouv',
      tabCinema: 'Kino',
      tabStudio: 'Studio',
      upcomingReleases: 'Kommende Veröffentlichungen',
      popCulture: 'Popkultur, Manga, Theater',
      bestFilms: 'Beste Filme und Serien',
      boxOffice: 'Kassenrekorde',
      learnMore: 'Mehr erfahren'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'Emotional intelligente Sprach-KI',
      greeting: 'Hallo!',
      greetingText: 'Ich bin Déesse, deine emotional intelligente Sprach-KI.',
      suggestions: ['Erzähl mir die Nachrichten des Tages', 'Was sind die neuesten Nachrichten?', 'Empfiehl mir einen guten Film', 'Was sind die Oscars 2024?', 'Die meisterwarteten Filme dieses Jahres', 'Erkläre mir das französische Kino'],
      newConversation: 'Neues Gespräch',

      movieGameTitle: '🎬 Mini-Spiel: Errate den Film',

      movieGameSubtitle: 'Teste dein Filmwissen',

      movieGameReady: 'Bereit?',

      movieGameDescription: 'Errate einen Film aus einer versteckten Inhaltsangabe.',

      movieGameStart: '🎬 Starten',

      movieGameAnswerPlaceholder: 'Deine Antwort...',

      movieGameSubmit: 'Senden',

      movieGameOrVoice: 'oder per Sprache',

      movieGameVoiceAnswer: 'Per Sprache antworten',

      movieGameStop: 'Stopp',

      movieGameBravo: 'Bravo!',

      movieGameTryAgain: 'Nicht dieses Mal...',

      movieGameCorrectAnswer: 'Die Antwort war:',

      movieGameReplay: 'Nochmal spielen',

      movieGameAttempt: 'Versuch',

      movieGameImageMode: '🎨 Bildmodus aktiv',

      movieGameImageLimit: 'Tageslimit erreicht (5/Tag)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'Benutzer suchen...',
      conversations: 'MyTalk',
      invitations: 'Einladungen',
      noMessages: 'Keine Nachrichten',
      typeMessage: 'Nachricht eingeben...',
      learnMore: 'Mehr erfahren',
      record: 'Aufnehmen',
      publish: 'Veröffentlichen',
      titleField: 'Titel',
      descriptionField: 'Beschreibung'
    },
    profile: {
      title: 'Profil',
      followers: 'Follower',
      following: 'Folgt',
      posts: 'Beiträge',
      editProfile: 'Profil bearbeiten',
      settings: 'Einstellungen',
      gimToli: 'Gim Toli',
      podcasts: 'Podcasts',
      news: 'Nachrichten',
      videos: 'Videos',
      saved: 'Gespeichert',

      bioAudio: 'Vorstellungs-Audio'

    },
    settings: {
      backToProfile: 'Zurück zum Profil',
      title: 'Einstellungen',
      accountInfo: 'Kontoinformationen',
      notifications: 'Benachrichtigungen',
      notifStatusGranted: '✅ Aktiviert — tippe zum Verwalten in iPhone-Einstellungen',
      notifStatusDenied: '❌ Deaktiviert — tippe zum Öffnen der iPhone-Einstellungen',
      notifStatusWeb: 'Nur in der mobilen App verfügbar',
      notifStatusEnable: 'Tippe, um Benachrichtigungen zu aktivieren',
      privacy: 'Datenschutz',
      language: 'Sprache',
      changePassword: 'Passwort ändern',
      deleteAccount: 'Konto löschen',
      proSpace: 'PRO-Bereich',
      helpSupport: 'Hilfe & Support',
      about: 'Über',
      selectLanguage: 'Sprache wählen',

      aboutIATitle: 'Über Destine AI',

      aboutIAIntro: 'Destine AI ist der intelligente Assistent in deiner App. Er hilft täglich, ohne private Nachrichten zu lesen.',

      aboutIACanDo: 'Was er kann:',

      aboutIAPrivacy: 'Datenschutz:',

      aboutIAFeatures: 'Mit dir chatten (Text oder Sprache mit Whisper);Aktuelle Nachrichten geben;Über Filme, Serien sprechen;Emotionen deiner Gim Tolis analysieren;Sprachnachrichten transkribieren',

      aboutIAPrivacyPoints: 'Private Chats werden nie gelesen;Emotionsanalyse nur auf öffentlichen Gim Tolis;Keine sensiblen Daten geteilt',

      openIA: 'Destine AI öffnen',

      countryForWatch: 'Land für "Wo ansehen?"',

      countryForWatchSubtitle: 'Bestimmt die Plattformen in Explorer',

      updatedToast: 'Land aktualisiert ✓',
      titleHero: 'Einstellungen',
      subtitleHero: 'Verwalte dein Konto und deine Einstellungen',
      appearance: 'Aussehen',
      darkMode: 'Dunkelmodus',
      lightMode: 'Hell — Rosé',
      whiteMode: 'Hell — Weiß',
      active: 'Aktiv',
      changePasswordSub: 'Passwort ändern',
      phoneInChats: 'Telefonnummer in Chats',
      phoneInChatsHidden: 'Deine Nummer ist verborgen',
      phoneInChatsShown: 'Deine Nummer ist sichtbar',
      location: 'Standort',
      locationOn: 'Standort aktiviert',
      locationOff: 'Standort deaktiviert',
      locationActivated: 'Standort aktiviert',
      myComments: 'Meine Kommentare',
      viewMyComments: 'Meine Kommentare ansehen',
      viewMyCommentsSub: 'Verwalte alle Kommentare',
      pushNotifications: 'Push-Benachrichtigungen',
      weeklyCinemaDigest: 'Wöchentliche Kinostarts',
      weeklyCinemaDigestSub: 'Erhalte eine wöchentliche E-Mail + Benachrichtigung zu neuen Kinostarts.',
      pushNotifMobileOnly: 'Nur in der mobilen App',
      reportsTitle: 'Beschwerden',
      makeReport: 'Beschwerde einreichen',
      makeReportSub: 'Problem melden oder Support kontaktieren',
      blockedUsers: 'Blockierte Nutzer',
      blockedUsersDesc: 'Blockiere Nutzer, deren Inhalte du nicht mehr sehen willst.',
      searchUserToBlock: 'Nutzer zum Blockieren suchen...',
      blockedUsersCount: 'Blockierte Nutzer',
      noBlockedUser: 'Kein blockierter Nutzer',
      legalDocs: 'Rechtliche Dokumente',
      legalDocsSub: 'AGB, Datenschutz, Regeln',
      security: 'Sicherheit',
      logout: 'Abmelden',
      dangerZone: 'Gefahrenzone',
      phoneTitle: 'Telefonnummer',
      noPhone: 'Keine Nummer',
      statisticsTitle: "Statistiken & Monetarisierung",
      statisticsOpen: "Meine Statistiken ansehen",
      statisticsSub: "Likes, Kommentare, geteilt, Wiedergaben, Follower",
    },
    create: {
      selectLanguage: 'Inhaltssprache',
      languageHint: 'Wählen Sie die Sprache Ihres Inhalts',
      title: 'Titel',
      description: 'Beschreibung',
      content: 'Inhalt',
      coverImage: 'Titelbild',
      audio: 'Audio',
      video: 'Video'
    },
    languages: {
      en: 'Englisch',
      es: 'Spanisch',
      fr: 'Französisch',
      ar: 'Arabisch',
      pt: 'Portugiesisch',
      de: 'Deutsch',
      ru: 'Russisch',
      zh: 'Chinesisch'
    },
    tooltips: {
      ageInfo: 'Geben Sie Ihr Alter ein, um die Sicherheit Ihres Kontos zu erhöhen',
      siretInfo: 'Ihre SIRET wird zur Verifizierung Ihres Kontos und zur Erhöhung der Sicherheit verwendet'
    },
    statistics: {
      title: "Statistiken & Monetarisierung",
      subtitle: "Verfolge die Reichweite deines Inhalts und das Engagement deines Publikums.",
      memberSince: "Mitglied seit",
      global: "Übersicht",
      audience: "Publikum",
      gimToli: "Gim Toli",
      shortFilms: "Kurzfilme",
      podcasts: "Podcasts",
      totalLikes: "Erhaltene Likes",
      totalComments: "Kommentare",
      totalShares: "Geteilt",
      totalPlays: "Wiedergaben / Aufrufe",
      followers: "Follower",
      following: "Folgt",
      saved: "Gespeichert",
      activeStories: "Aktive Stories",
      posts: "Beiträge",
      likes: "Likes",
      comments: "Kommentare",
      shares: "Geteilt",
      plays: "Wiedergaben",
      views: "Aufrufe",
    },
    monetization: {
      title: "Monetarisierung",
      payouts: "Erhaltene Zahlungen",
      noPayouts: "Noch keine Zahlung erhalten.",
      eligibility: "Monetarisierung auf Destine",
      unlocked: "Du kannst Sponsoren zu deinen Gim Toli, Podcasts und Kurzfilmen hinzufügen.",
      locked: "Schalte die Monetarisierung mit {threshold} Followern frei.",
      followersOf: "Follower",
      policy: "Monetarisierungsrichtlinie",
      iban: "Bankdaten (IBAN)",
      ibanHelp: "Nur für PRO-Konten sichtbar, die ein Sponsoring akzeptiert haben.",
      iban_save: "Speichern",
      iban_saved: "IBAN gespeichert",
      requests: "Meine Sponsoringanfragen",
      noRequests: "Noch keine Anfrage gesendet.",
      clicks: "Klicks auf Sponsor-Link",
      partnerWith: "Mit Sponsor teilen",
      shareWithSponsor: "Mit Sponsor teilen",
      lockedShort: "Gesperrt",
      info_title: "Monetarisierung",
      info_body: "Ab 5.000 Followern können Sie einen Sponsor an Ihre Inhalte anhängen und Direktzahlungen in über 15 Währungen erhalten.",
      info_cta: "Mehr erfahren",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Creator bezahlen",
      payHint: "Stripe-Gebühren übernimmst du (~2,9 % + 0,30 €) — der Creator erhält den exakten Betrag.",
      paid: "Zahlung abgeschlossen",
      myAds: "Meine Anzeigen",
      analytics: "Analytics",
      sponsorshipRequests: "Sponsoringanfragen",
      myOffers: "Meine Angebote",
    },

    groups: {
      tab: "Gruppen",
      create: "Gruppe erstellen",
      name: "Gruppenname",
      theme: "Thema",
      rules: "Regeln",
      profile_image: "Profilfoto",
      request_join: "Beitritt anfragen",
      pending: "Anfrage ausstehend",
      member: "Mitglied",
      creator: "Ersteller",
      admin: "Administrator",
      members: "Mitglieder",
      leave: "Gruppe verlassen",
      delete: "Gruppe löschen",
      no_groups: "Noch keine Gruppen",
      search_groups: "Gruppen suchen…",
      info: "Gruppeninformationen",
      invitations: "Gruppenanfragen",
      accept: "Annehmen",
      reject: "Ablehnen",
      created_by: "Erstellt von",
      placeholder_message: "Nachricht…",
      send: "Senden",
      unread_messages: "Neue Nachrichten"
    },
    calls: {
      dnd_title: "Nicht stören",
      dnd_desc: "Wenn aktiviert, erhalten Sie keine Sprachanrufe in der App.",
      peer_dnd: "Dieser Nutzer hat „Nicht stören\" aktiviert",
      connecting: "Verbinden…",
      ringing: "Klingelt…",
      in_call: "Im Gespräch",
      ended: "Beendet",
      error: "Fehler",
      preparing: "Anruf wird vorbereitet…",
      waiting: "Warten auf Antwort…",
      daily_left: "Heute übrig",
      quota_exceeded: "Sie haben Ihr tägliches Anrufkontingent von 30 Minuten erreicht.",
      not_configured: "Sprachanrufe sind auf diesem Server nicht aktiviert.",
      quota_reached: "Tägliches Kontingent erreicht"
    },
    screenshot: {
      taken: "{name} hat einen Screenshot dieser Unterhaltung gemacht",
      i_took: "Sie haben einen Screenshot dieser Unterhaltung gemacht"
    },
    eshop: {
      title: "MyShop",
      see_all: "Alle anzeigen",
      search_placeholder: "Shop oder Produkt suchen…",
      empty: "Noch keine Shops",
      load_more: "Mehr laden",
      my_shop: "Mein Shop",
      my_shops: "Meine Shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Shop erstellen",
      edit_shop: "Shop bearbeiten",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shopname",
      category: "Kategorie",
      country: "Land (ISO)",
      currency: "Währung",
      description: "Beschreibung der Tätigkeit",
      upload_cover: "Titelbild",
      address_full: "Postadresse",
      phone: "Telefon",
      website: "Website (optional)",
      shipping: "Versand",
      shipping_fee: "Gebühr",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Gründungsdatum",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Produkte",
      add_product: "Neues Produkt / Dienst",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "Katalog",
      no_products: "Noch keine Produkte",
      buy: "Kaufen",
      checkout: "Zahlung",
      fullname: "Vollständiger Name",
      address: "Lieferadresse",
      quantity: "Menge",
      subtotal: "Zwischensumme",
      pay: "Bezahlen",
      accept_cgv: "Ich akzeptiere die",
      cgv: "AGB",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Allgemeine Geschäftsbedingungen",
      order_placed: "Bestellung aufgegeben",
      reviews: "Bewertungen",
      no_reviews: "Noch keine Bewertungen",
      write_review: "Bewertung abgeben",
      publish_review: "Veröffentlichen",
      review_thanks: "Danke für die Bewertung",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Heute",
      this_week: "Diese Woche",
      this_month: "Diesen Monat",
      this_year: "Dieses Jahr",
      total_net: "Netto-Total",
      sales: "Verkäufe",
      after_commission: "Nach 5% Destine Provision",
      settings: "Einstellungen",
      no_description: "Keine Beschreibung",
      cat_mymap: "MyMap",
      cat_all: "Alle",
      cat_fashion: "Mode",
      cat_beauty: "Beauty",
      cat_food: "Essen",
      cat_myfood: "MyFood",
      cat_art: "Kunst",
      cat_music: "Musik",
      cat_books: "Bücher",
      cat_electronics: "Elektronik",
      cat_home: "Zuhause",
      cat_handcraft: "Handwerk",
      cat_wellness: "Wellness",
      cat_services: "Dienste",
      cat_education: "Bildung",
      cat_kids: "Kinder",
      cat_sport: "Sport",
      cat_jewelry: "Schmuck",
      cat_other: "Andere",
      rate_help: "1 bis 5 Sterne + Kommentar",
      reviews_count: "Bewertungen",
      review_one: "Bewertung",
      no_reviews_short: "Keine Bewertungen",
      report_shop: "Shop melden",
      send_report: "Meldung senden"
    },
    },

  // Russian
  ru: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'События и концерты',
      seeAll: 'Смотреть все',
      upcoming: 'Предстоящие',
      empty: 'Пока нет событий.',
      buy: 'Купить',
      book: 'Забронировать',
      soldOut: 'Распродано',
      ticketsWord: 'билеты',
      share: 'Поделиться',
      report: 'Пожаловаться',
      myTickets: 'Мои билеты MyMouv',
      discover: 'Найти события',
    },
    vocaux: 'Голосовые',
    nav: {
      home: 'Главная',
      explorer: 'Обзор',
      discover: 'Открытия',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: 'Профиль',
      admin: 'Админ'
    },
    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      success: 'Успешно',
      cancel: 'Отмена',
      save: 'Сохранить',
      saved: 'Сохранено',
      delete: 'Удалить',
      edit: 'Редактировать',
      share: 'Поделиться',
      report: 'Пожаловаться',
      search: 'Поиск',
      new: 'Новый',
      publish: 'Опубликовать',
      send: 'Отправить',
      close: 'Закрыть',
      back: 'Назад',
      next: 'Далее',
      confirm: 'Подтвердить',
      yes: 'Да',
      no: 'Нет',
      copy_link: "Копировать ссылку",
      link_copied: "Ссылка скопирована"
    },
    auth: {
      login: 'Войти',
      logout: 'Выйти',
      register: 'Регистрация',
      email: 'Email',
      password: 'Пароль',
      confirmPassword: 'Подтвердите пароль',
      forgotPassword: 'Забыли пароль?',
      resetPassword: 'Сбросить пароль',
      newPassword: 'Новый пароль',
      age: 'Возраст',
      siret: 'Номер SIRET',
      joinDestine: 'Присоединяйтесь к Destine',
      accountType: 'Тип аккаунта',
      accountID: 'Аккаунт ID',
      accountPRO: 'Аккаунт PRO',
      appLanguage: 'Язык приложения',
      fullName: 'Полное имя',
      yourName: 'Ваше имя',
      birthDate: 'Дата рождения',
      optional: 'необязательно',
      alreadyAccount: 'Уже есть аккаунт? Войти',
      noAccount: 'Нет аккаунта? Зарегистрироваться',
      signIn: 'Войти',
      signUp: 'Зарегистрироваться',
      verification: 'Проверка'
    },
    explorer: {
      title: 'Обзор',
      subtitle: 'Подкасты, фильмы, статьи и многое другое',
      searchPlaceholder: 'Поиск контента, пользователей, Gim Tolis...',
      podcasts: 'Подкасты',
      freeFilms: 'Фильмы общественного достояния',
      news: 'Новости',
      shortFilms: 'Короткометражки',
      watchNow: 'Смотреть сейчас',
      noContent: 'Контент недоступен',
      qualityWarning: 'Будут сохранены только лучшие короткометражки. Видео низкого качества могут быть удалены администраторами.',

      whereToWatch: 'Где смотреть?',

      whereToWatchSubtitle: 'Стриминговые платформы в вашей стране'

    },
    discover: {
      title: 'Открытия',
      subtitle: 'Фильмы, сериалы, новости, ИИ и MyMouv',
      tabCinema: 'Кино',
      tabStudio: 'Studio',
      upcomingReleases: 'Скоро в прокате',
      popCulture: 'Поп-культура, манга, театр',
      bestFilms: 'Лучшие фильмы и сериалы',
      boxOffice: 'Кассовые сборы',
      learnMore: 'Подробнее'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: 'Эмоционально интеллектуальный голосовой ИИ',
      greeting: 'Привет!',
      greetingText: 'Я Déesse, ваш эмоционально интеллектуальный голосовой ИИ.',
      suggestions: ['Расскажи новости дня', 'Какие последние новости?', 'Порекомендуй хороший фильм', 'Какие Оскары 2024?', 'Самые ожидаемые фильмы года', 'Расскажи о французском кино'],
      newConversation: 'Новый разговор',

      movieGameTitle: '🎬 Мини-игра: Угадай фильм',

      movieGameSubtitle: 'Проверь свои знания кино',

      movieGameReady: 'Готов?',

      movieGameDescription: 'Угадай фильм по скрытому синопсису.',

      movieGameStart: '🎬 Старт',

      movieGameAnswerPlaceholder: 'Твой ответ...',

      movieGameSubmit: 'Отправить',

      movieGameOrVoice: 'или голосом',

      movieGameVoiceAnswer: 'Ответить голосом',

      movieGameStop: 'Стоп',

      movieGameBravo: 'Браво!',

      movieGameTryAgain: 'Не в этот раз...',

      movieGameCorrectAnswer: 'Ответ был:',

      movieGameReplay: 'Сыграть снова',

      movieGameAttempt: 'Попытка',

      movieGameImageMode: '🎨 Режим изображения',

      movieGameImageLimit: 'Дневной лимит (5/день)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: 'Поиск пользователей...',
      conversations: 'MyTalk',
      invitations: 'Приглашения',
      noMessages: 'Нет сообщений',
      typeMessage: 'Введите сообщение...',
      learnMore: 'Подробнее',
      record: 'Записать',
      publish: 'Опубликовать',
      titleField: 'Название',
      descriptionField: 'Описание'
    },
    profile: {
      title: 'Профиль',
      followers: 'Подписчики',
      following: 'Подписки',
      posts: 'Публикации',
      editProfile: 'Редактировать профиль',
      settings: 'Настройки',
      gimToli: 'Gim Toli',
      podcasts: 'Подкасты',
      news: 'Новости',
      videos: 'Видео',
      saved: 'Сохранённое',

      bioAudio: 'Аудио-презентация'

    },
    settings: {
      backToProfile: 'Назад к профилю',
      title: 'Настройки',
      accountInfo: 'Информация об аккаунте',
      notifications: 'Уведомления',
      notifStatusGranted: '✅ Включены — нажмите, чтобы управлять в Настройках iPhone',
      notifStatusDenied: '❌ Отключены — нажмите, чтобы открыть Настройки iPhone',
      notifStatusWeb: 'Доступно только в мобильном приложении',
      notifStatusEnable: 'Нажмите, чтобы включить уведомления',
      privacy: 'Конфиденциальность',
      language: 'Язык',
      changePassword: 'Изменить пароль',
      deleteAccount: 'Удалить аккаунт',
      proSpace: 'PRO пространство',
      helpSupport: 'Помощь и поддержка',
      about: 'О приложении',
      selectLanguage: 'Выберите язык',

      aboutIATitle: 'О Destine AI',

      aboutIAIntro: 'Destine AI — умный помощник в вашем приложении. Он помогает ежедневно, не читая личные сообщения.',

      aboutIACanDo: 'Что он умеет:',

      aboutIAPrivacy: 'Конфиденциальность:',

      aboutIAFeatures: 'Общаться (текст или голос);Давать актуальные новости;Говорить о кино и сериалах;Анализировать эмоции Gim Tolis;Транскрибировать голосовые',

      aboutIAPrivacyPoints: 'Личные чаты никогда не читаются;Анализ эмоций только публичных Gim Tolis;Конфиденциальные данные не передаются',

      openIA: 'Открыть Destine AI',

      countryForWatch: 'Страна для "Где смотреть?"',

      countryForWatchSubtitle: 'Определяет платформы в Explorer',

      updatedToast: 'Страна обновлена ✓',
      titleHero: 'Настройки',
      subtitleHero: 'Управление аккаунтом и настройками',
      appearance: 'Внешний вид',
      darkMode: 'Темный режим',
      lightMode: 'Светлый — Розовый',
      whiteMode: 'Светлый — Белый',
      active: 'Активно',
      changePasswordSub: 'Изменить пароль',
      phoneInChats: 'Телефон в чатах',
      phoneInChatsHidden: 'Номер скрыт',
      phoneInChatsShown: 'Номер виден',
      location: 'Местоположение',
      locationOn: 'Включено',
      locationOff: 'Отключено',
      locationActivated: 'Включено',
      myComments: 'Мои комментарии',
      viewMyComments: 'Посмотреть мои комментарии',
      viewMyCommentsSub: 'Управление комментариями',
      pushNotifications: 'Push-уведомления',
      weeklyCinemaDigest: 'Еженедельные премьеры кино',
      weeklyCinemaDigestSub: 'Получайте еженедельно email + уведомление о новых премьерах.',
      pushNotifMobileOnly: 'Только в мобильном приложении',
      reportsTitle: 'Жалобы',
      makeReport: 'Подать жалобу',
      makeReportSub: 'Сообщить о проблеме',
      blockedUsers: 'Заблокированные',
      blockedUsersDesc: 'Заблокируйте пользователей.',
      searchUserToBlock: 'Поиск пользователя...',
      blockedUsersCount: 'Заблокированные',
      noBlockedUser: 'Нет заблокированных',
      legalDocs: 'Юридические документы',
      legalDocsSub: 'Условия, политика, правила',
      security: 'Безопасность',
      logout: 'Выйти',
      dangerZone: 'Опасная зона',
      phoneTitle: 'Номер телефона',
      noPhone: 'Нет номера',
      statisticsTitle: "Статистика и монетизация",
      statisticsOpen: "Моя статистика",
      statisticsSub: "Лайки, комментарии, поделились, прослушивания, подписчики",
    },
    create: {
      selectLanguage: 'Язык контента',
      languageHint: 'Выберите язык вашего контента',
      title: 'Название',
      description: 'Описание',
      content: 'Содержание',
      coverImage: 'Обложка',
      audio: 'Аудио',
      video: 'Видео'
    },
    languages: {
      en: 'Английский',
      es: 'Испанский',
      fr: 'Французский',
      ar: 'Арабский',
      pt: 'Португальский',
      de: 'Немецкий',
      ru: 'Русский',
      zh: 'Китайский'
    },
    tooltips: {
      ageInfo: 'Укажите возраст для повышения безопасности аккаунта',
      siretInfo: 'SIRET будет использоваться для верификации аккаунта и повышения безопасности'
    },
    statistics: {
      title: "Статистика и монетизация",
      subtitle: "Отслеживайте охват вашего контента и вовлечённость аудитории.",
      memberSince: "Участник с",
      global: "Обзор",
      audience: "Аудитория",
      gimToli: "Gim Toli",
      shortFilms: "Короткометражки",
      podcasts: "Подкасты",
      totalLikes: "Полученные лайки",
      totalComments: "Комментарии",
      totalShares: "Поделились",
      totalPlays: "Прослушивания / Просмотры",
      followers: "Подписчики",
      following: "Подписки",
      saved: "Сохранённые",
      activeStories: "Активные истории",
      posts: "Публикации",
      likes: "Лайки",
      comments: "Комментарии",
      shares: "Поделились",
      plays: "Прослушивания",
      views: "Просмотры",
    },
    monetization: {
      title: "Монетизация",
      payouts: "Полученные платежи",
      noPayouts: "Пока нет платежей.",
      eligibility: "Монетизация на Destine",
      unlocked: "Вы можете добавить спонсора к своим Gim Toli, подкастам и короткометражкам.",
      locked: "Откройте монетизацию при {threshold} подписчиках.",
      followersOf: "подписчиков",
      policy: "Политика монетизации",
      iban: "Банковские реквизиты (IBAN)",
      ibanHelp: "Видны только PRO-аккаунтам, принявшим спонсорство.",
      iban_save: "Сохранить",
      iban_saved: "IBAN сохранён",
      requests: "Мои запросы на спонсорство",
      noRequests: "Пока нет отправленных запросов.",
      clicks: "кликов по ссылке спонсора",
      partnerWith: "Поделиться со спонсором",
      shareWithSponsor: "Поделиться со спонсором",
      lockedShort: "Заблокировано",
      info_title: "Монетизация",
      info_body: "С 5 000 подписчиков вы можете прикрепить спонсора к своему контенту и получать прямые платежи в 15+ валютах.",
      info_cta: "Узнать больше",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Оплатить автору",
      payHint: "Комиссию Stripe (~2,9 % + 0,30 €) оплачиваете вы — автор получает точную сумму.",
      paid: "Оплата выполнена",
      myAds: "Моя реклама",
      analytics: "Аналитика",
      sponsorshipRequests: "Запросы на спонсорство",
      myOffers: "Мои предложения",
    },

    groups: {
      tab: "Группы",
      create: "Создать группу",
      name: "Название группы",
      theme: "Тема",
      rules: "Правила",
      profile_image: "Фото профиля",
      request_join: "Запрос на вступление",
      pending: "Запрос на рассмотрении",
      member: "Участник",
      creator: "Создатель",
      admin: "Администратор",
      members: "Участники",
      leave: "Покинуть группу",
      delete: "Удалить группу",
      no_groups: "Пока нет групп",
      search_groups: "Искать группы…",
      info: "Информация о группе",
      invitations: "Запросы в группу",
      accept: "Принять",
      reject: "Отклонить",
      created_by: "Создан",
      placeholder_message: "Сообщение…",
      send: "Отправить",
      unread_messages: "Новые сообщения"
    },
    calls: {
      dnd_title: "Не беспокоить",
      dnd_desc: "Когда включено, вы не будете получать голосовые вызовы в приложении.",
      peer_dnd: "Этот пользователь включил режим «Не беспокоить»",
      connecting: "Подключение…",
      ringing: "Звонок…",
      in_call: "В разговоре",
      ended: "Завершён",
      error: "Ошибка",
      preparing: "Подготовка звонка…",
      waiting: "Ожидание ответа…",
      daily_left: "Осталось сегодня",
      quota_exceeded: "Вы достигли дневного лимита в 30 минут.",
      not_configured: "Голосовые вызовы не включены на этом сервере.",
      quota_reached: "Дневная квота достигнута"
    },
    screenshot: {
      taken: "{name} сделал(а) скриншот этой переписки",
      i_took: "Вы сделали скриншот этой переписки"
    },
    eshop: {
      title: "MyShop",
      see_all: "Смотреть все",
      search_placeholder: "Найти магазин или товар…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "Мой магазин",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Создать магазин",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Товары",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "Каталог",
      no_products: "No products yet",
      buy: "Купить",
      checkout: "Оплата",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "Оплатить",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "Отзывы",
      no_reviews: "No reviews yet",
      write_review: "Оставить отзыв",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "Все",
      cat_fashion: "Мода",
      cat_beauty: "Красота",
      cat_food: "Еда",
      cat_myfood: "MyFood",
      cat_art: "Искусство",
      cat_music: "Музыка",
      cat_books: "Книги",
      cat_electronics: "Электроника",
      cat_home: "Дом",
      cat_handcraft: "Ремесло",
      cat_wellness: "Здоровье",
      cat_services: "Услуги",
      cat_education: "Образование",
      cat_kids: "Дети",
      cat_sport: "Спорт",
      cat_jewelry: "Украшения",
      cat_other: "Другое",
      rate_help: "1–5 звёзд + комментарий",
      report_shop: "Пожаловаться",
      reviews_count: "отзывов",
      review_one: "отзыв",
      no_reviews_short: "Нет отзывов"
    },
    },

  // Chinese (Simplified)
  zh: {
    mymouv: {
      title: 'MyMouv',
      subtitle: '活动和音乐会',
      seeAll: '查看全部',
      upcoming: '即将到来',
      empty: '暂无活动。',
      buy: '购买',
      book: '预订',
      soldOut: '售罄',
      ticketsWord: '张票',
      share: '分享',
      report: '举报',
      myTickets: '我的 MyMouv 票据',
      discover: '发现活动',
    },
    vocaux: '语音',
    nav: {
      home: '首页',
      explorer: '探索',
      discover: '发现',
      messages: 'MyTalk',
      filmAI: 'Déesse',
      profile: '个人资料',
      admin: '管理员'
    },
    common: {
      loading: '加载中...',
      error: '错误',
      success: '成功',
      cancel: '取消',
      save: '保存',
      saved: '已保存',
      delete: '删除',
      edit: '编辑',
      share: '分享',
      report: '举报',
      search: '搜索',
      new: '新建',
      publish: '发布',
      send: '发送',
      close: '关闭',
      back: '返回',
      next: '下一步',
      confirm: '确认',
      yes: '是',
      no: '否',
      copy_link: "复制链接",
      link_copied: "链接已复制"
    },
    auth: {
      login: '登录',
      logout: '退出',
      register: '注册',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      forgotPassword: '忘记密码？',
      resetPassword: '重置密码',
      newPassword: '新密码',
      age: '年龄',
      siret: 'SIRET号码'
    },
    explorer: {
      title: '探索',
      subtitle: '播客、电影、文章等',
      searchPlaceholder: '搜索内容、用户、Gim Tolis...',
      podcasts: '播客',
      freeFilms: '公共领域电影',
      news: '新闻',
      shortFilms: '短片',
      watchNow: '立即观看',
      noContent: '没有可用内容',
      qualityWarning: '只有最好的短片会被保留。低质量视频可能会被管理员删除。',

      whereToWatch: '在哪里观看?',

      whereToWatchSubtitle: '您所在国家的流媒体平台'

    },
    discover: {
      title: '发现',
      subtitle: '电影、电视剧、资讯、AI 与 MyMouv',
      tabCinema: '电影',
      tabStudio: 'Studio',
      upcomingReleases: '即将上映',
      popCulture: '流行文化、漫画、戏剧',
      bestFilms: '最佳电影和电视剧',
      boxOffice: '票房',
      learnMore: '了解更多'
    },
    filmIA: {
      title: 'Destine IA',
      subtitle: '情感智能语音 AI',
      greeting: '你好！',
      greetingText: '我是 Déesse，您的情感智能语音 AI。',
      suggestions: ['告诉我今天的新闻', '最新消息是什么？', '推荐一部好电影', '2024年奥斯卡获奖者是谁？', '今年最受期待的电影', '给我讲讲法国电影'],
      newConversation: '新对话',

      movieGameTitle: '🎬 迷你游戏: 猜电影',

      movieGameSubtitle: '考验你的电影文化',

      movieGameReady: '准备好了吗?',

      movieGameDescription: '从隐藏的摘要中猜电影。',

      movieGameStart: '🎬 开始',

      movieGameAnswerPlaceholder: '你的答案...',

      movieGameSubmit: '提交',

      movieGameOrVoice: '或用语音',

      movieGameVoiceAnswer: '用语音回答',

      movieGameStop: '停止',

      movieGameBravo: '太棒了!',

      movieGameTryAgain: '这次不行...',

      movieGameCorrectAnswer: '答案是:',

      movieGameReplay: '再玩一次',

      movieGameAttempt: '尝试',

      movieGameImageMode: '🎨 图像模式',

      movieGameImageLimit: '每日限额已达 (5/天)'

    },
    messages: {
      title: 'MyTalk',
      searchPlaceholder: '搜索用户...',
      conversations: 'MyTalk',
      invitations: '邀请',
      noMessages: '暂无消息',
      typeMessage: '输入消息...',
      learnMore: '了解更多',
      record: '录制',
      publish: '发布',
      titleField: '标题',
      descriptionField: '描述'
    },
    profile: {
      title: '个人资料',
      followers: '粉丝',
      following: '关注',
      posts: '帖子',
      editProfile: '编辑资料',
      settings: '设置',
      gimToli: 'Gim Toli',
      podcasts: '播客',
      news: '新闻',
      videos: '视频',
      saved: '已保存',

      bioAudio: '介绍音频'

    },
    settings: {
      backToProfile: '返回资料',
      title: '设置',
      accountInfo: '账户信息',
      notifications: '通知',
      notifStatusGranted: '✅ 已启用 — 点按前往 iPhone 设置管理',
      notifStatusDenied: '❌ 已关闭 — 点按打开 iPhone 设置',
      notifStatusWeb: '仅在移动应用中可用',
      notifStatusEnable: '点按以启用通知',
      privacy: '隐私',
      language: '语言',
      changePassword: '更改密码',
      deleteAccount: '删除账户',
      proSpace: 'PRO空间',
      helpSupport: '帮助与支持',
      about: '关于',
      selectLanguage: '选择语言',

      aboutIATitle: '关于 Destine AI',

      aboutIAIntro: 'Destine AI 是您应用中的智能助手。它每天帮助您，但从不读取您的私信。',

      aboutIACanDo: '它可以做的:',

      aboutIAPrivacy: '隐私:',

      aboutIAFeatures: '与您聊天(文字或语音);提供最新新闻;谈论电影和剧集;分析 Gim Tolis 的情感;自动转录语音',

      aboutIAPrivacyPoints: 'AI 从不读取您的私聊;情感分析仅针对公开内容;不与第三方共享敏感数据',

      openIA: '打开 Destine AI',

      countryForWatch: '"在哪里观看?"的国家',

      countryForWatchSubtitle: '决定 Explorer 中显示的平台',

      updatedToast: '国家已更新 ✓',
      titleHero: '设置',
      subtitleHero: '管理您的账户和偏好',
      appearance: '外观',
      darkMode: '深色模式',
      lightMode: '浅色 — 玫瑰',
      whiteMode: '浅色 — 白色',
      active: '已启用',
      changePasswordSub: '修改密码',
      phoneInChats: '聊天中的电话',
      phoneInChatsHidden: '号码已隐藏',
      phoneInChatsShown: '号码可见',
      location: '位置',
      locationOn: '位置已启用',
      locationOff: '位置已禁用',
      locationActivated: '位置已启用',
      myComments: '我的评论',
      viewMyComments: '查看我的评论',
      viewMyCommentsSub: '管理所有评论',
      pushNotifications: '推送通知',
      weeklyCinemaDigest: '每周电影新片',
      weeklyCinemaDigestSub: '每周接收关于即将上映的电影邮件与通知。',
      pushNotifMobileOnly: '仅在移动应用中可用',
      reportsTitle: '投诉',
      makeReport: '提交投诉',
      makeReportSub: '报告问题或联系支持',
      blockedUsers: '已屏蔽用户',
      blockedUsersDesc: '屏蔽您不想看到内容的用户。',
      searchUserToBlock: '搜索要屏蔽的用户...',
      blockedUsersCount: '已屏蔽用户',
      noBlockedUser: '没有屏蔽的用户',
      legalDocs: '法律文件',
      legalDocsSub: '条款、隐私、规则',
      security: '安全',
      logout: '登出',
      dangerZone: '危险区域',
      phoneTitle: '电话号码',
      noPhone: '无号码',
      statisticsTitle: "统计与变现",
      statisticsOpen: "查看我的统计",
      statisticsSub: "点赞、评论、分享、播放、粉丝",
    },
    create: {
      selectLanguage: '内容语言',
      languageHint: '选择您内容的语言',
      title: '标题',
      description: '描述',
      content: '内容',
      coverImage: '封面图片',
      audio: '音频',
      video: '视频'
    },
    languages: {
      en: '英语',
      es: '西班牙语',
      fr: '法语',
      ar: '阿拉伯语',
      pt: '葡萄牙语',
      de: '德语',
      ru: '俄语',
      zh: '中文'
    },
    tooltips: {
      ageInfo: '输入您的年龄以增强账户安全性',
      siretInfo: 'SIRET将用于验证您的账户并增强安全性'
    },
    statistics: {
      title: "统计与变现",
      subtitle: "跟踪您内容的覆盖范围和受众的互动。",
      memberSince: "注册于",
      global: "总览",
      audience: "受众",
      gimToli: "Gim Toli",
      shortFilms: "短片",
      podcasts: "播客",
      totalLikes: "收到的点赞",
      totalComments: "评论",
      totalShares: "分享",
      totalPlays: "播放/观看",
      followers: "粉丝",
      following: "关注",
      saved: "已保存",
      activeStories: "活跃故事",
      posts: "发布",
      likes: "点赞",
      comments: "评论",
      shares: "分享",
      plays: "播放",
      views: "观看",
    },
    monetization: {
      title: "变现",
      payouts: "已收款项",
      noPayouts: "暂时没有收到付款。",
      eligibility: "Destine 变现",
      unlocked: "你可以为 Gim Toli、播客和短片添加赞助商。",
      locked: "在 {threshold} 粉丝时解锁变现。",
      followersOf: "粉丝",
      policy: "变现政策",
      iban: "银行信息 (IBAN)",
      ibanHelp: "仅接受赞助的 PRO 账户可见。",
      iban_save: "保存",
      iban_saved: "已保存 IBAN",
      requests: "我的赞助请求",
      noRequests: "尚未发送任何请求。",
      clicks: "赞助链接点击",
      partnerWith: "与赞助商合作",
      shareWithSponsor: "与赞助商分享",
      lockedShort: "已锁定",
      info_title: "内容变现",
      info_body: "粉丝达到5,000人后，您可以为内容附加赞助商，并以15+种货币接收直接付款。",
      info_cta: "了解更多",
    },
    ads: {
      title: "Destine Ads",
      payNow: "向创作者付款",
      payHint: "Stripe 手续费由您承担（约 2.9% + €0.30）— 创作者收到确切金额。",
      paid: "支付完成",
      myAds: "我的广告",
      analytics: "分析",
      sponsorshipRequests: "赞助请求",
      myOffers: "我的优惠",
    },

    groups: {
      tab: "群组",
      create: "创建群组",
      name: "群组名称",
      theme: "主题",
      rules: "规则",
      profile_image: "头像",
      request_join: "申请加入",
      pending: "申请待审核",
      member: "成员",
      creator: "创建者",
      admin: "管理员",
      members: "成员",
      leave: "退出群组",
      delete: "删除群组",
      no_groups: "暂无群组",
      search_groups: "搜索群组…",
      info: "群组信息",
      invitations: "群组申请",
      accept: "接受",
      reject: "拒绝",
      created_by: "创建者：",
      placeholder_message: "消息…",
      send: "发送",
      unread_messages: "新消息"
    },
    calls: {
      dnd_title: "勿扰模式",
      dnd_desc: "启用后，您将不会收到应用内语音通话。",
      peer_dnd: "该用户已开启勿扰模式",
      connecting: "连接中…",
      ringing: "响铃中…",
      in_call: "通话中",
      ended: "已结束",
      error: "错误",
      preparing: "正在准备通话…",
      waiting: "等待接听…",
      daily_left: "今日剩余",
      quota_exceeded: "您已达到每日30分钟的通话上限。",
      not_configured: "此服务器未启用语音通话。",
      quota_reached: "已达每日上限"
    },
    screenshot: {
      taken: "{name} 对此对话进行了截图",
      i_took: "您对此对话进行了截图"
    },
    eshop: {
      title: "MyShop",
      see_all: "查看全部",
      search_placeholder: "搜索店铺或商品…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "我的店铺",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "创建店铺",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "商品",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "目录",
      no_products: "No products yet",
      buy: "购买",
      checkout: "结账",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "支付",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "评价",
      no_reviews: "No reviews yet",
      write_review: "写评价",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "全部",
      cat_fashion: "时尚",
      cat_beauty: "美容",
      cat_food: "食品",
      cat_myfood: "MyFood",
      cat_art: "艺术",
      cat_music: "音乐",
      cat_books: "书籍",
      cat_electronics: "电子产品",
      cat_home: "家居",
      cat_handcraft: "手工艺",
      cat_wellness: "健康",
      cat_services: "服务",
      cat_education: "教育",
      cat_kids: "儿童",
      cat_sport: "运动",
      cat_jewelry: "珠宝",
      cat_other: "其他",
      rate_help: "1 到 5 星 + 评论",
      report_shop: "举报店铺",
      reviews_count: "条评价",
      review_one: "条评价",
      no_reviews_short: "暂无评价"
    },
    },

  // Japanese
  ja: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'イベントとコンサート',
      seeAll: 'すべて表示',
      upcoming: '今後の予定',
      empty: 'イベントはありません。',
      buy: '購入',
      book: '予約',
      soldOut: '完売',
      ticketsWord: '枚',
      share: '共有',
      report: '報告',
      myTickets: 'MyMouv のチケット',
      discover: 'イベントを発見',
    },
    vocaux: 'ボイス',
    nav: { home: 'ホーム', explorer: 'エクスプローラー', discover: '発見', messages: 'MyTalk', filmAI: 'Déesse', profile: 'プロフィール', admin: '管理者' },
    common: { loading: '読み込み中...', error: 'エラー', success: '成功', cancel: 'キャンセル', save: '保存', saved: '保存しました', delete: '削除', edit: '編集', share: '共有', report: '報告', search: '検索', new: '新規', publish: '公開', send: '送信', close: '閉じる', back: '戻る', next: '次へ', confirm: '確認', yes: 'はい', no: 'いいえ' },
    explorer: { title: 'エクスプローラー', subtitle: 'ポッドキャスト、映画など', searchPlaceholder: 'コンテンツを検索...', podcasts: 'ポッドキャスト', freeFilms: '無料映画', news: 'ニュース', shortFilms: 'ショートフィルム', watchNow: '今すぐ視聴', noContent: 'コンテンツなし', qualityWarning: '高品質なショートフィルムのみが掲載されます。', whereToWatch: 'どこで見る?', whereToWatchSubtitle: 'あなたの国のストリーミングプラットフォーム' },
    profile: { title: 'プロフィール', followers: 'フォロワー', following: 'フォロー中', posts: '投稿', editProfile: 'プロフィール編集', settings: '設定', gimToli: 'Gim Toli', podcasts: 'ポッドキャスト', news: 'ニュース', videos: '動画', saved: '保存済み', bioAudio: '紹介オーディオ' },
    settings: {
      backToProfile: 'プロフィールに戻る', title: '設定', accountInfo: 'アカウント情報', notifications: '通知', privacy: 'プライバシー', language: '言語', changePassword: 'パスワード変更', deleteAccount: 'アカウント削除', proSpace: 'PROスペース', helpSupport: 'ヘルプ', about: 'について', selectLanguage: '言語を選択', aboutIATitle: 'Destine AI について', aboutIAIntro: 'Destine AI はアプリ内のスマートアシスタントです。毎日サポートしますが、プライベートメッセージは読みません。', aboutIACanDo: 'できること:', aboutIAPrivacy: 'プライバシー:', aboutIAFeatures: 'チャット(テキストまたは音声);最新ニュースを伝える;映画やドラマについて話す;Gim Tolis の感情を分析;音声メッセージを文字起こし', aboutIAPrivacyPoints: 'プライベートチャットは読まれません;感情分析は公開 Gim Tolis のみ;機密データは第三者と共有されません', openIA: 'Destine AI を開く', countryForWatch: '「どこで見る?」の国', countryForWatchSubtitle: 'Explorer に表示されるプラットフォームを決定', updatedToast: '国を更新しました ✓',
    notifStatusGranted: '✅ 有効 — iPhone の設定で管理するにはタップ',
    notifStatusDenied: '❌ 無効 — iPhone の設定を開くにはタップ',
    notifStatusWeb: 'モバイル App のみ利用可能',
    notifStatusEnable: 'タップして通知を有効化',
      titleHero: '設定',
      subtitleHero: 'アカウントと設定を管理',
      appearance: '外観',
      darkMode: 'ダークモード',
      lightMode: 'ライト — ローズ',
      whiteMode: 'ライト — ホワイト',
      active: '有効',
      changePasswordSub: 'パスワードを変更',
      phoneInChats: 'チャットの電話',
      phoneInChatsHidden: '番号は非表示',
      phoneInChatsShown: '番号が表示',
      location: '位置情報',
      locationOn: '位置情報オン',
      locationOff: '位置情報オフ',
      locationActivated: '位置情報を有効化',
      myComments: 'マイコメント',
      viewMyComments: 'コメントを見る',
      viewMyCommentsSub: 'すべてのコメントを管理',
      pushNotifications: 'プッシュ通知',
      weeklyCinemaDigest: '週次シネマ新作',
      weeklyCinemaDigestSub: '毎週、公開予定の映画メール＋通知を受け取ります。',
      pushNotifMobileOnly: 'モバイルアプリのみ',
      reportsTitle: '苦情',
      makeReport: '苦情を出す',
      makeReportSub: '問題を報告',
      blockedUsers: 'ブロックユーザー',
      blockedUsersDesc: 'ユーザーをブロックします。',
      searchUserToBlock: 'ブロックするユーザー検索...',
      blockedUsersCount: 'ブロック済み',
      noBlockedUser: 'ブロックなし',
      legalDocs: '法的文書',
      legalDocsSub: '規約、プライバシー、ルール',
      security: 'セキュリティ',
      logout: 'ログアウト',
      dangerZone: '危険ゾーン',
      phoneTitle: '電話番号',
      noPhone: '番号なし',
      statisticsTitle: "統計と収益化",
      statisticsOpen: "私の統計を見る",
      statisticsSub: "いいね、コメント、シェア、再生、フォロワー",
      copy_link: "リンクをコピー",
      link_copied: "コピーしました"
    },
    create: { selectLanguage: 'コンテンツの言語', languageHint: 'コンテンツの言語を選択', title: 'タイトル', description: '説明', content: 'コンテンツ', coverImage: 'カバー画像', audio: 'オーディオ', video: '動画' },
    languages: { en: '英語', es: 'スペイン語', fr: 'フランス語', ar: 'アラビア語', pt: 'ポルトガル語', de: 'ドイツ語', ru: 'ロシア語', zh: '中国語', ja: '日本語', hi: 'ヒンディー語', nl: 'オランダ語', sw: 'スワヒリ語' },
    discover: { title: '発見', subtitle: '映画、ドラマ、ニュース、AIとMyMouv', tabCinema: 'シネマ', tabStudio: 'Studio', upcomingReleases: '近日公開', popCulture: 'ポップカルチャー、マンガ、演劇', bestFilms: 'ベスト映画＆ドラマ', boxOffice: '興行収入', learnMore: '詳しく見る' },
    filmIA: { title: 'Destine IA', subtitle: '感情知能を備えた音声AI', greeting: 'こんにちは！', greetingText: '私は Déesse、あなたの感情知能を備えた音声AIです。', suggestions: ['今日のニュースを教えて', '最新のニュースは？', 'おすすめの映画は？', '2024年のオスカーは？', '今年最も期待される映画', 'フランス映画について教えて'], newConversation: '新しい会話', movieGameTitle: '🎬 ミニゲーム: 映画を当てる', movieGameSubtitle: '映画文化をテスト', movieGameReady: '準備はいい?', movieGameDescription: '隠されたあらすじから映画を当てましょう。', movieGameStart: '🎬 スタート', movieGameAnswerPlaceholder: 'あなたの答え...', movieGameSubmit: '送信', movieGameOrVoice: 'または音声で', movieGameVoiceAnswer: '音声で答える', movieGameStop: '停止', movieGameBravo: 'ブラボー!', movieGameTryAgain: '今回は違います...', movieGameCorrectAnswer: '答えは:', movieGameReplay: 'もう一度プレイ', movieGameAttempt: '試行', movieGameImageMode: '🎨 画像モード', movieGameImageLimit: '1日の上限到達 (5/日)' },
    messages: { title: 'MyTalk', searchPlaceholder: 'ユーザーを検索...', conversations: 'メッセージ', invitations: '招待', noMessages: 'メッセージなし', typeMessage: 'メッセージを入力...', learnMore: '詳しく見る', record: '録音', publish: '投稿', titleField: 'タイトル', descriptionField: '説明' },
    statistics: {
      title: "統計と収益化",
      subtitle: "コンテンツのリーチとオーディエンスのエンゲージメントを追跡しましょう。",
      memberSince: "メンバー登録日",
      global: "概要",
      audience: "オーディエンス",
      gimToli: "Gim Toli",
      shortFilms: "短編映画",
      podcasts: "ポッドキャスト",
      totalLikes: "受け取ったいいね",
      totalComments: "コメント",
      totalShares: "シェア",
      totalPlays: "再生/視聴",
      followers: "フォロワー",
      following: "フォロー中",
      saved: "保存済み",
      activeStories: "アクティブなストーリー",
      posts: "投稿",
      likes: "いいね",
      comments: "コメント",
      shares: "シェア",
      plays: "再生",
      views: "視聴",
    },
    monetization: {
      title: "収益化",
      payouts: "受け取った支払い",
      noPayouts: "まだ支払いはありません。",
      eligibility: "Destine の収益化",
      unlocked: "Gim Toli、ポッドキャスト、短編映画にスポンサーを追加できます。",
      locked: "{threshold}フォロワーで収益化を解放します。",
      followersOf: "フォロワー",
      policy: "収益化ポリシー",
      iban: "銀行情報 (IBAN)",
      ibanHelp: "スポンサー契約を承諾したPROアカウントのみに表示されます。",
      iban_save: "保存",
      iban_saved: "IBANを保存しました",
      requests: "スポンサーシップリクエスト",
      noRequests: "まだリクエストが送信されていません。",
      clicks: "スポンサーリンクのクリック",
      partnerWith: "スポンサーと共有",
      shareWithSponsor: "スポンサーと共有",
      lockedShort: "ロック中",
      info_title: "収益化",
      info_body: "フォロワー5,000人から、コンテンツにスポンサーを付け、15以上の通貨で直接支払いを受け取れます。",
      info_cta: "詳細はこちら",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Pay the creator",
      payHint: "Stripe fees covered by you (~2.9% + €0.30) — creator receives the exact amount.",
      paid: "Payment complete",
      myAds: "広告",
      analytics: "アナリティクス",
      sponsorshipRequests: "スポンサーリクエスト",
      myOffers: "オファー",
    },

    groups: {
      tab: "グループ",
      create: "グループを作成",
      name: "グループ名",
      theme: "テーマ",
      rules: "ルール",
      profile_image: "プロフィール写真",
      request_join: "参加をリクエスト",
      pending: "リクエスト保留中",
      member: "メンバー",
      creator: "作成者",
      admin: "管理者",
      members: "メンバー",
      leave: "グループを退出",
      delete: "グループを削除",
      no_groups: "まだグループがありません",
      search_groups: "グループを検索…",
      info: "グループ情報",
      invitations: "グループリクエスト",
      accept: "承認",
      reject: "拒否",
      created_by: "作成者：",
      placeholder_message: "メッセージ…",
      send: "送信",
      unread_messages: "新着メッセージ"
    },
    calls: {
      dnd_title: "おやすみモード",
      dnd_desc: "有効にすると、アプリ内の音声通話を受信しなくなります。",
      peer_dnd: "このユーザーはおやすみモードを有効にしています",
      connecting: "接続中…",
      ringing: "呼び出し中…",
      in_call: "通話中",
      ended: "終了",
      error: "エラー",
      preparing: "通話を準備中…",
      waiting: "応答を待っています…",
      daily_left: "本日の残り",
      quota_exceeded: "1日30分の通話制限に達しました。",
      not_configured: "このサーバーでは音声通話が有効になっていません。",
      quota_reached: "本日の上限に達しました"
    },
    screenshot: {
      taken: "{name} がこの会話のスクリーンショットを撮りました",
      i_took: "あなたはこの会話のスクリーンショットを撮りました"
    },
    eshop: {
      title: "MyShop",
      see_all: "すべて表示",
      search_placeholder: "ショップや商品を検索…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "マイショップ",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "ショップを作成",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "商品",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "カタログ",
      no_products: "No products yet",
      buy: "購入",
      checkout: "お支払い",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "支払う",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "レビュー",
      no_reviews: "No reviews yet",
      write_review: "レビューを書く",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "すべて",
      cat_fashion: "ファッション",
      cat_beauty: "ビューティー",
      cat_food: "食品",
      cat_myfood: "MyFood",
      cat_art: "アート",
      cat_music: "音楽",
      cat_books: "本",
      cat_electronics: "家電",
      cat_home: "ホーム",
      cat_handcraft: "手芸",
      cat_wellness: "ウェルネス",
      cat_services: "サービス",
      cat_education: "教育",
      cat_kids: "キッズ",
      cat_sport: "スポーツ",
      cat_jewelry: "ジュエリー",
      cat_other: "その他",
      rate_help: "1〜5 星 + コメント",
      report_shop: "ショップを報告",
      reviews_count: "件のレビュー",
      review_one: "件のレビュー",
      no_reviews_short: "レビューなし"
    },
    },

  // Hindi
  hi: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'इवेंट्स और कॉन्सर्ट्स',
      seeAll: 'सभी देखें',
      upcoming: 'आगामी',
      empty: 'अभी कोई इवेंट नहीं।',
      buy: 'खरीदें',
      book: 'बुक',
      soldOut: 'बिक चुके',
      ticketsWord: 'टिकट',
      share: 'शेयर',
      report: 'रिपोर्ट',
      myTickets: 'मेरे MyMouv टिकट',
      discover: 'इवेंट्स खोजें',
    },
    vocaux: 'वॉइस',
    nav: { home: 'होम', explorer: 'एक्सप्लोरर', discover: 'खोजें', messages: 'MyTalk', filmAI: 'Déesse', profile: 'प्रोफ़ाइल', admin: 'एडमिन' },
    common: { loading: 'लोड हो रहा है...', error: 'त्रुटि', success: 'सफल', cancel: 'रद्द करें', save: 'सहेजें', saved: 'सहेजा गया', delete: 'हटाएं', edit: 'संपादित करें', share: 'साझा करें', report: 'रिपोर्ट', search: 'खोजें', new: 'नया', publish: 'प्रकाशित करें', send: 'भेजें', close: 'बंद करें', back: 'वापस', next: 'अगला', confirm: 'पुष्टि करें', yes: 'हाँ', no: 'नहीं' },
    explorer: { title: 'एक्सप्लोरर', subtitle: 'पॉडकास्ट, फिल्में और अधिक', searchPlaceholder: 'सामग्री खोजें...', podcasts: 'पॉडकास्ट', freeFilms: 'मुफ्त फिल्में', news: 'समाचार', shortFilms: 'लघु फिल्में', watchNow: 'अभी देखें', noContent: 'कोई सामग्री नहीं', qualityWarning: 'केवल उच्च गुणवत्ता वाली लघु फिल्में ही स्वीकार की जाएंगी।', whereToWatch: 'कहाँ देखें?', whereToWatchSubtitle: 'आपके देश में स्ट्रीमिंग प्लेटफ़ॉर्म' },
    profile: { title: 'प्रोफ़ाइल', followers: 'फॉलोअर्स', following: 'फॉलोइंग', posts: 'पोस्ट', editProfile: 'प्रोफ़ाइल संपादित करें', settings: 'सेटिंग्स', gimToli: 'Gim Toli', podcasts: 'पॉडकास्ट', news: 'समाचार', videos: 'वीडियो', saved: 'सहेजा गया', bioAudio: 'परिचय ऑडियो' },
    settings: {
      backToProfile: 'प्रोफ़ाइल पर वापस', title: 'सेटिंग्स', accountInfo: 'खाता जानकारी', notifications: 'सूचनाएं', privacy: 'गोपनीयता', language: 'भाषा', changePassword: 'पासवर्ड बदलें', deleteAccount: 'खाता हटाएं', proSpace: 'PRO स्पेस', helpSupport: 'सहायता', about: 'के बारे में', selectLanguage: 'भाषा चुनें', aboutIATitle: 'Destine AI के बारे में', aboutIAIntro: 'Destine AI आपके ऐप में स्मार्ट सहायक है। यह आपकी मदद करता है लेकिन निजी संदेश नहीं पढ़ता।', aboutIACanDo: 'यह क्या कर सकता है:', aboutIAPrivacy: 'गोपनीयता:', aboutIAFeatures: 'आपसे चैट करना;ताज़ा समाचार देना;फिल्मों के बारे में बात करना;Gim Tolis की भावना विश्लेषण;वॉइस मैसेज ट्रांसक्राइब करना', aboutIAPrivacyPoints: 'निजी चैट नहीं पढ़ी जाती;भावना विश्लेषण केवल सार्वजनिक Gim Tolis पर;संवेदनशील डेटा साझा नहीं', openIA: 'Destine AI खोलें', countryForWatch: '"कहाँ देखें?" के लिए देश', countryForWatchSubtitle: 'Explorer में दिखाए जाने वाले प्लेटफ़ॉर्म', updatedToast: 'देश अपडेट किया गया ✓',
    notifStatusGranted: '✅ सक्षम — प्रबंधित करने के लिए iPhone सेटिंग्स में जाएँ',
    notifStatusDenied: '❌ अक्षम — iPhone सेटिंग्स खोलने के लिए टैप करें',
    notifStatusWeb: 'केवल मोबाइल ऐप में उपलब्ध',
    notifStatusEnable: 'सूचनाएँ सक्षम करने के लिए टैप करें',
      titleHero: 'सेटिंग्स',
      subtitleHero: 'खाता और प्राथमिकताएं प्रबंधित करें',
      appearance: 'दिखावट',
      darkMode: 'डार्क मोड',
      lightMode: 'लाइट — गुलाबी',
      whiteMode: 'लाइट — सफ़ेद',
      active: 'सक्रिय',
      changePasswordSub: 'पासवर्ड बदलें',
      phoneInChats: 'चैट में फ़ोन',
      phoneInChatsHidden: 'नंबर छुपा',
      phoneInChatsShown: 'नंबर दिख रहा',
      location: 'स्थान',
      locationOn: 'स्थान चालू',
      locationOff: 'स्थान बंद',
      locationActivated: 'स्थान सक्रिय',
      myComments: 'मेरी टिप्पणियां',
      viewMyComments: 'मेरी टिप्पणियां देखें',
      viewMyCommentsSub: 'सभी टिप्पणियां प्रबंधित करें',
      pushNotifications: 'पुश सूचनाएं',
      weeklyCinemaDigest: 'साप्ताहिक सिनेमा रिलीज़',
      weeklyCinemaDigestSub: 'आगामी सिनेमा रिलीज़ के बारे में साप्ताहिक ईमेल + सूचना पाएं।',
      pushNotifMobileOnly: 'केवल मोबाइल ऐप पर',
      reportsTitle: 'शिकायतें',
      makeReport: 'शिकायत करें',
      makeReportSub: 'समस्या रिपोर्ट करें',
      blockedUsers: 'ब्लॉक उपयोगकर्ता',
      blockedUsersDesc: 'उपयोगकर्ताओं को ब्लॉक करें।',
      searchUserToBlock: 'ब्लॉक के लिए खोजें...',
      blockedUsersCount: 'ब्लॉक उपयोगकर्ता',
      noBlockedUser: 'कोई नहीं',
      legalDocs: 'कानूनी दस्तावेज़',
      legalDocsSub: 'शर्तें, गोपनीयता, नियम',
      security: 'सुरक्षा',
      logout: 'लॉगआउट',
      dangerZone: 'खतरा क्षेत्र',
      phoneTitle: 'फ़ोन नंबर',
      noPhone: 'कोई नंबर नहीं',
      statisticsTitle: "आंकड़े और मॉनिटाइज़ेशन",
      statisticsOpen: "मेरे आंकड़े देखें",
      statisticsSub: "लाइक्स, टिप्पणियाँ, शेयर, प्ले, फ़ॉलोअर्स",
      copy_link: "लिंक कॉपी करें",
      link_copied: "लिंक कॉपी हो गया"
    },
    create: { selectLanguage: 'सामग्री की भाषा', languageHint: 'अपनी सामग्री की भाषा चुनें', title: 'शीर्षक', description: 'विवरण', content: 'सामग्री', coverImage: 'कवर इमेज', audio: 'ऑडियो', video: 'वीडियो' },
    languages: { en: 'अंग्रेज़ी', es: 'स्पेनिश', fr: 'फ्रेंच', ar: 'अरबी', pt: 'पुर्तगाली', de: 'जर्मन', ru: 'रूसी', zh: 'चीनी', ja: 'जापानी', hi: 'हिन्दी', nl: 'डच', sw: 'स्वाहिली' },
    discover: { title: 'खोजें', subtitle: 'फिल्में, सीरीज़, समाचार, AI और MyMouv', tabCinema: 'सिनेमा', tabStudio: 'Studio', upcomingReleases: 'आगामी रिलीज़', popCulture: 'पॉप कल्चर, मंगा, थिएटर', bestFilms: 'सर्वश्रेष्ठ फिल्में और सीरीज़', boxOffice: 'बॉक्स ऑफिस', learnMore: 'और जानें' },
    filmIA: { title: 'Destine IA', subtitle: 'भावनात्मक रूप से बुद्धिमान वॉयस AI', greeting: 'नमस्ते!', greetingText: 'मैं Déesse हूँ, आपकी भावनात्मक रूप से बुद्धिमान वॉयस AI।', suggestions: ['आज की खबरें बताओ', 'नवीनतम समाचार क्या हैं?', 'एक अच्छी फिल्म सुझाओ', '2024 के ऑस्कर विजेता कौन हैं?', 'इस साल सबसे प्रतीक्षित फिल्में', 'फ्रांसीसी सिनेमा के बारे में बताओ'], newConversation: 'नई बातचीत', movieGameTitle: '🎬 मिनी-गेम: फ़िल्म पहचानें', movieGameSubtitle: 'अपनी सिनेमा संस्कृति परखें', movieGameReady: 'तैयार हैं?', movieGameDescription: 'छिपी सिनॉप्सिस से फ़िल्म पहचानें।', movieGameStart: '🎬 शुरू करें', movieGameAnswerPlaceholder: 'आपका उत्तर...', movieGameSubmit: 'भेजें', movieGameOrVoice: 'या आवाज़ से', movieGameVoiceAnswer: 'आवाज़ से जवाब', movieGameStop: 'रोकें', movieGameBravo: 'शाबाश!', movieGameTryAgain: 'इस बार नहीं...', movieGameCorrectAnswer: 'उत्तर था:', movieGameReplay: 'फिर से खेलें', movieGameAttempt: 'प्रयास', movieGameImageMode: '🎨 छवि मोड', movieGameImageLimit: 'दैनिक सीमा (5/दिन)' },
    messages: { title: 'MyTalk', searchPlaceholder: 'उपयोगकर्ता खोजें...', conversations: 'संदेश', invitations: 'निमंत्रण', noMessages: 'कोई संदेश नहीं', typeMessage: 'संदेश लिखें...', learnMore: 'और जानें', record: 'रिकॉर्ड', publish: 'प्रकाशित करें', titleField: 'शीर्षक', descriptionField: 'विवरण' },
    statistics: {
      title: "आंकड़े और मॉनिटाइज़ेशन",
      subtitle: "अपनी सामग्री की पहुंच और दर्शकों की भागीदारी पर नज़र रखें।",
      memberSince: "सदस्य बनने की तिथि",
      global: "अवलोकन",
      audience: "दर्शक",
      gimToli: "Gim Toli",
      shortFilms: "लघु फिल्में",
      podcasts: "पॉडकास्ट",
      totalLikes: "प्राप्त लाइक्स",
      totalComments: "टिप्पणियाँ",
      totalShares: "शेयर",
      totalPlays: "प्ले / व्यूज़",
      followers: "फ़ॉलोअर्स",
      following: "फ़ॉलोइंग",
      saved: "सहेजे गए",
      activeStories: "सक्रिय कहानियाँ",
      posts: "पोस्ट",
      likes: "लाइक्स",
      comments: "टिप्पणियाँ",
      shares: "शेयर",
      plays: "प्ले",
      views: "व्यूज़",
    },
    monetization: {
      title: "मॉनिटाइज़ेशन",
      payouts: "Payments received",
      noPayouts: "No payment received yet.",
      eligibility: "Destine पर मॉनिटाइज़ेशन",
      unlocked: "आप अपने Gim Toli, पॉडकास्ट और लघु फिल्मों में स्पॉन्सर जोड़ सकते हैं।",
      locked: "{threshold} फ़ॉलोअर्स पर मॉनिटाइज़ेशन अनलॉक करें।",
      followersOf: "फ़ॉलोअर्स",
      policy: "मॉनिटाइज़ेशन नीति",
      iban: "बैंक विवरण (IBAN)",
      ibanHelp: "केवल उन PRO खातों को दिखता है जिन्होंने स्पॉन्सरशिप स्वीकार की है।",
      iban_save: "सहेजें",
      iban_saved: "IBAN सहेजा गया",
      requests: "मेरे स्पॉन्सरशिप अनुरोध",
      noRequests: "अभी तक कोई अनुरोध नहीं भेजा गया।",
      clicks: "स्पॉन्सर लिंक क्लिक",
      partnerWith: "स्पॉन्सर के साथ साझा करें",
      shareWithSponsor: "स्पॉन्सर के साथ साझा करें",
      lockedShort: "लॉक्ड",
      info_title: "मुद्रीकरण",
      info_body: "5,000 फॉलोअर्स से, आप अपने कंटेंट पर एक स्पॉन्सर जोड़ सकते हैं और 15+ मुद्राओं में सीधे भुगतान प्राप्त कर सकते हैं।",
      info_cta: "अधिक जानें",
    },
    ads: {
      title: "Destine Ads",
      payNow: "クリエイターに支払う",
      payHint: "Stripe手数料（約2.9% + €0.30）はスポンサーが負担 — クリエイターは正確な金額を受け取ります。",
      paid: "支払い完了",
      myAds: "मेरे विज्ञापन",
      analytics: "एनालिटिक्स",
      sponsorshipRequests: "स्पॉन्सरशिप अनुरोध",
      myOffers: "मेरी ऑफ़र्स",
    },

    groups: {
      tab: "समूह",
      create: "समूह बनाएं",
      name: "समूह का नाम",
      theme: "विषय",
      rules: "नियम",
      profile_image: "प्रोफ़ाइल फोटो",
      request_join: "जुड़ने का अनुरोध",
      pending: "अनुरोध लंबित",
      member: "सदस्य",
      creator: "निर्माता",
      admin: "व्यवस्थापक",
      members: "सदस्य",
      leave: "समूह छोड़ें",
      delete: "समूह हटाएँ",
      no_groups: "अभी तक कोई समूह नहीं",
      search_groups: "समूह खोजें…",
      info: "समूह की जानकारी",
      invitations: "समूह अनुरोध",
      accept: "स्वीकार",
      reject: "अस्वीकार",
      created_by: "द्वारा निर्मित",
      placeholder_message: "संदेश…",
      send: "भेजें",
      unread_messages: "नए संदेश"
    },
    calls: {
      dnd_title: "व्यवधान न करें",
      dnd_desc: "सक्षम होने पर आपको ऐप में वॉयस कॉल प्राप्त नहीं होंगी।",
      peer_dnd: "इस उपयोगकर्ता ने व्यवधान न करें मोड चालू किया है",
      connecting: "कनेक्ट हो रहा है…",
      ringing: "घंटी बज रही है…",
      in_call: "कॉल में",
      ended: "समाप्त",
      error: "त्रुटि",
      preparing: "कॉल तैयार हो रही है…",
      waiting: "उत्तर की प्रतीक्षा…",
      daily_left: "आज शेष",
      quota_exceeded: "आपने 30 मिनट की दैनिक कॉल सीमा पूरी कर ली है।",
      not_configured: "इस सर्वर पर वॉयस कॉल सक्षम नहीं हैं।",
      quota_reached: "दैनिक सीमा पूरी हुई"
    },
    screenshot: {
      taken: "{name} ने इस बातचीत का स्क्रीनशॉट लिया",
      i_took: "आपने इस बातचीत का स्क्रीनशॉट लिया"
    },
    eshop: {
      title: "MyShop",
      see_all: "सभी देखें",
      search_placeholder: "दुकान या उत्पाद खोजें…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "मेरी दुकान",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "दुकान बनाएं",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "उत्पाद",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "सूची",
      no_products: "No products yet",
      buy: "खरीदें",
      checkout: "भुगतान",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "भुगतान करें",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "समीक्षाएं",
      no_reviews: "No reviews yet",
      write_review: "समीक्षा लिखें",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "सभी",
      cat_fashion: "फैशन",
      cat_beauty: "सौंदर्य",
      cat_food: "खाद्य",
      cat_myfood: "MyFood",
      cat_art: "कला",
      cat_music: "संगीत",
      cat_books: "पुस्तकें",
      cat_electronics: "इलेक्ट्रॉनिक्स",
      cat_home: "घर",
      cat_handcraft: "हस्तशिल्प",
      cat_wellness: "स्वास्थ्य",
      cat_services: "सेवाएं",
      cat_education: "शिक्षा",
      cat_kids: "बच्चे",
      cat_sport: "खेल",
      cat_jewelry: "गहने",
      cat_other: "अन्य",
      rate_help: "1 से 5 सितारे + टिप्पणी",
      report_shop: "दुकान रिपोर्ट करें",
      reviews_count: "समीक्षाएं",
      review_one: "समीक्षा",
      no_reviews_short: "कोई समीक्षा नहीं"
    },
    },

  // Dutch
  nl: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Events & concerten',
      seeAll: 'Alles bekijken',
      upcoming: 'Aankomend',
      empty: 'Nog geen events.',
      buy: 'Kopen',
      book: 'Reserveren',
      soldOut: 'Uitverkocht',
      ticketsWord: 'tickets',
      share: 'Delen',
      report: 'Melden',
      myTickets: 'Mijn MyMouv-tickets',
      discover: 'Events ontdekken',
    },
    vocaux: "Voicememo's",
    nav: { home: 'Home', explorer: 'Ontdekken', discover: 'Ontdek', messages: 'MyTalk', filmAI: 'Déesse', profile: 'Profiel', admin: 'Admin' },
    common: { loading: 'Laden...', error: 'Fout', success: 'Succes', cancel: 'Annuleren', save: 'Opslaan', saved: 'Opgeslagen', delete: 'Verwijderen', edit: 'Bewerken', share: 'Delen', report: 'Melden', search: 'Zoeken', new: 'Nieuw', publish: 'Publiceren', send: 'Verzenden', close: 'Sluiten', back: 'Terug', next: 'Volgende', confirm: 'Bevestigen', yes: 'Ja', no: 'Nee' },
    explorer: { title: 'Ontdekken', subtitle: 'Podcasts, films en meer', searchPlaceholder: 'Zoek inhoud...', podcasts: 'Podcasts', freeFilms: 'Gratis films', news: 'Nieuws', shortFilms: 'Korte films', watchNow: 'Nu bekijken', noContent: 'Geen inhoud beschikbaar', qualityWarning: 'Alleen korte films van hoge kwaliteit worden geaccepteerd.', whereToWatch: 'Waar kijken?', whereToWatchSubtitle: 'Streamingplatforms in jouw land' },
    profile: { title: 'Profiel', followers: 'Volgers', following: 'Volgend', posts: 'Berichten', editProfile: 'Profiel bewerken', settings: 'Instellingen', gimToli: 'Gim Toli', podcasts: 'Podcasts', news: 'Nieuws', videos: 'Videos', saved: 'Opgeslagen', bioAudio: 'Introductie-audio' },
    settings: {
      backToProfile: 'Terug naar profiel', title: 'Instellingen', accountInfo: 'Accountinformatie', notifications: 'Meldingen', privacy: 'Privacy', language: 'Taal', changePassword: 'Wachtwoord wijzigen', deleteAccount: 'Account verwijderen', proSpace: 'PRO ruimte', helpSupport: 'Hulp', about: 'Over', selectLanguage: 'Taal selecteren', aboutIATitle: 'Over Destine AI', aboutIAIntro: 'Destine AI is de slimme assistent in je app. Helpt dagelijks zonder je privéberichten te lezen.', aboutIACanDo: 'Wat het kan:', aboutIAPrivacy: 'Privacy:', aboutIAFeatures: 'Chatten (tekst of spraak);Actueel nieuws geven;Praten over films, series;Emoties van Gim Tolis analyseren;Spraakberichten transcriberen', aboutIAPrivacyPoints: 'Privégesprekken worden nooit gelezen;Emotie-analyse alleen op publieke Gim Tolis;Geen gevoelige data gedeeld', openIA: 'Open Destine AI', countryForWatch: 'Land voor "Waar kijken?"', countryForWatchSubtitle: 'Bepaalt platforms in Explorer', updatedToast: 'Land bijgewerkt ✓',
    notifStatusGranted: '✅ Ingeschakeld — tik om te beheren in iPhone-instellingen',
    notifStatusDenied: '❌ Uitgeschakeld — tik om iPhone-instellingen te openen',
    notifStatusWeb: 'Alleen beschikbaar in de mobiele app',
    notifStatusEnable: 'Tik om meldingen in te schakelen',
      titleHero: 'Instellingen',
      subtitleHero: 'Beheer je account en voorkeuren',
      appearance: 'Uiterlijk',
      darkMode: 'Donkere modus',
      lightMode: 'Licht — Roze',
      whiteMode: 'Licht — Wit',
      active: 'Actief',
      changePasswordSub: 'Wachtwoord wijzigen',
      phoneInChats: 'Telefoon in chats',
      phoneInChatsHidden: 'Nummer verborgen',
      phoneInChatsShown: 'Nummer zichtbaar',
      location: 'Locatie',
      locationOn: 'Locatie aan',
      locationOff: 'Locatie uit',
      locationActivated: 'Locatie geactiveerd',
      myComments: 'Mijn reacties',
      viewMyComments: 'Mijn reacties bekijken',
      viewMyCommentsSub: 'Beheer alle reacties',
      pushNotifications: 'Pushmeldingen',
      weeklyCinemaDigest: 'Wekelijkse bioscooprelease',
      weeklyCinemaDigestSub: 'Ontvang wekelijks een e-mail + notificatie over aankomende releases.',
      pushNotifMobileOnly: 'Alleen in mobiele app',
      reportsTitle: 'Klachten',
      makeReport: 'Een klacht indienen',
      makeReportSub: 'Probleem melden',
      blockedUsers: 'Geblokkeerde gebruikers',
      blockedUsersDesc: 'Blokkeer gebruikers wier inhoud je niet meer wilt zien.',
      searchUserToBlock: 'Zoek gebruiker om te blokkeren...',
      blockedUsersCount: 'Geblokkeerde gebruikers',
      noBlockedUser: 'Geen geblokkeerd',
      legalDocs: 'Juridische documenten',
      legalDocsSub: 'Voorwaarden, privacy, regels',
      security: 'Beveiliging',
      logout: 'Uitloggen',
      dangerZone: 'Gevarenzone',
      phoneTitle: 'Telefoonnummer',
      noPhone: 'Geen nummer',
      statisticsTitle: "Statistieken en monetisatie",
      statisticsOpen: "Mijn statistieken bekijken",
      statisticsSub: "Likes, reacties, gedeeld, afspelingen, volgers",
      copy_link: "Link kopiëren",
      link_copied: "Link gekopieerd"
    },
    create: { selectLanguage: 'Inhoudstaal', languageHint: 'Selecteer de taal van uw inhoud', title: 'Titel', description: 'Beschrijving', content: 'Inhoud', coverImage: 'Omslagafbeelding', audio: 'Audio', video: 'Video' },
    languages: { en: 'Engels', es: 'Spaans', fr: 'Frans', ar: 'Arabisch', pt: 'Portugees', de: 'Duits', ru: 'Russisch', zh: 'Chinees', ja: 'Japans', hi: 'Hindi', nl: 'Nederlands', sw: 'Swahili' },
    discover: { title: 'Ontdek', subtitle: 'Films, series, nieuws, AI en MyMouv', tabCinema: 'Bioscoop', tabStudio: 'Studio', upcomingReleases: 'Binnenkort in de bioscoop', popCulture: 'Popcultuur, manga, theater', bestFilms: 'Beste films en series', boxOffice: 'Box Office', learnMore: 'Meer info' },
    filmIA: { title: 'Destine IA', subtitle: 'Emotioneel intelligente stem-AI', greeting: 'Hallo!', greetingText: 'Ik ben Déesse, je emotioneel intelligente stem-AI.', suggestions: ['Vertel me het nieuws van vandaag', 'Wat is het laatste nieuws?', 'Beveel een goede film aan', 'Wat zijn de Oscars 2024?', 'Meest verwachte films dit jaar', 'Vertel me over Franse cinema'], newConversation: 'Nieuw gesprek', movieGameTitle: '🎬 Minigame: Raad de film', movieGameSubtitle: 'Test je filmkennis', movieGameReady: 'Klaar?', movieGameDescription: 'Raad een film via een verborgen synopsis.', movieGameStart: '🎬 Start', movieGameAnswerPlaceholder: 'Jouw antwoord...', movieGameSubmit: 'Versturen', movieGameOrVoice: 'of via spraak', movieGameVoiceAnswer: 'Antwoorden via spraak', movieGameStop: 'Stop', movieGameBravo: 'Bravo!', movieGameTryAgain: 'Niet deze keer...', movieGameCorrectAnswer: 'Het antwoord was:', movieGameReplay: 'Opnieuw spelen', movieGameAttempt: 'Poging', movieGameImageMode: '🎨 Afbeeldingsmodus', movieGameImageLimit: 'Daglimiet bereikt (5/dag)', regionalLangTitle: 'Antwoord in regionale taal van Guyana', regionalLangSubtitle: 'De IA zal in de gekozen taal antwoorden op basis van het corpus dat door de gemeenschap is bijgedragen.', regionalLangOff: 'Geen (hoofdtaal)' },
    messages: { title: 'MyTalk', searchPlaceholder: 'Gebruikers zoeken...', conversations: 'Berichten', invitations: 'Uitnodigingen', noMessages: 'Geen berichten', typeMessage: 'Typ een bericht...', learnMore: 'Meer info', record: 'Opnemen', publish: 'Publiceren', titleField: 'Titel', descriptionField: 'Beschrijving' },
    statistics: {
      title: "Statistieken en monetisatie",
      subtitle: "Volg het bereik van je content en de betrokkenheid van je publiek.",
      memberSince: "Lid sinds",
      global: "Overzicht",
      audience: "Publiek",
      gimToli: "Gim Toli",
      shortFilms: "Korte films",
      podcasts: "Podcasts",
      totalLikes: "Ontvangen likes",
      totalComments: "Reacties",
      totalShares: "Gedeeld",
      totalPlays: "Afspelingen / Weergaven",
      followers: "Volgers",
      following: "Volgend",
      saved: "Opgeslagen",
      activeStories: "Actieve stories",
      posts: "Berichten",
      likes: "Likes",
      comments: "Reacties",
      shares: "Gedeeld",
      plays: "Afspelingen",
      views: "Weergaven",
    },
    monetization: {
      title: "Monetisatie",
      payouts: "प्राप्त भुगतान",
      noPayouts: "अभी तक कोई भुगतान प्राप्त नहीं हुआ।",
      eligibility: "Monetisatie op Destine",
      unlocked: "Voeg een sponsor toe aan je Gim Toli, podcasts en korte films.",
      locked: "Ontgrendel monetisatie bij {threshold} volgers.",
      followersOf: "volgers",
      policy: "Monetisatiebeleid",
      iban: "Bankgegevens (IBAN)",
      ibanHelp: "Alleen zichtbaar voor PRO-accounts die een sponsoring hebben geaccepteerd.",
      iban_save: "Opslaan",
      iban_saved: "IBAN opgeslagen",
      requests: "Mijn sponsoraanvragen",
      noRequests: "Nog geen aanvraag verzonden.",
      clicks: "klikken op sponsorlink",
      partnerWith: "Delen met sponsor",
      shareWithSponsor: "Delen met sponsor",
      lockedShort: "Vergrendeld",
      info_title: "Monetarisering",
      info_body: "Vanaf 5.000 volgers kunt u een sponsor aan uw content koppelen en directe betalingen ontvangen in 15+ valuta's.",
      info_cta: "Meer informatie",
    },

    groups: {
      tab: "Groepen",
      create: "Groep aanmaken",
      name: "Groepsnaam",
      theme: "Thema",
      rules: "Regels",
      profile_image: "Profielfoto",
      request_join: "Verzoek om deel te nemen",
      pending: "Verzoek in afwachting",
      member: "Lid",
      creator: "Maker",
      admin: "Beheerder",
      members: "Leden",
      leave: "Groep verlaten",
      delete: "Groep verwijderen",
      no_groups: "Nog geen groepen",
      search_groups: "Groepen zoeken…",
      info: "Groepsinformatie",
      invitations: "Groepsverzoeken",
      accept: "Accepteren",
      reject: "Weigeren",
      created_by: "Aangemaakt door",
      placeholder_message: "Bericht…",
      send: "Verzenden",
      unread_messages: "Nieuwe berichten",
      encryptedStorage: "Versleutelde opslag",
      reportGroup: "Deze groep melden"
    },

    regional: {
      helpTitle: "Help Destine IA de regionale talen van Frans-Guyana te begrijpen.",
      activeLang: "Actieve taal:",
      formatTitle: "Format",
      formatHint: "Schrijf in het Frans / Engels / Nederlands, voeg « = » toe en vervolgens de vertaling.",
      example: "Bv: Kun je een afbeelding van een rode auto maken? = Yu sa méké wang photo fou wang lébi wagi gim?",
      pickerLabel: "Taal:",
      restrictions: "Alleen tekst en spraakberichten (geen foto's of video's). Non-profit doel.",
      leave: "Verlaten",
      confirmLeave: "De groep verlaten? Je kunt op elk moment terugkomen.",
      left: "Je hebt de groep verlaten",
      noMedia: "Niet beschikbaar in deze groep",
      ackPrefix: "Vertaling geïntegreerd in",
      ackThanks: "Bedankt voor je bijdrage!",
      ackPairs: "paren in",
      groupName: "Destine IA — Regionale talen 🇬🇫",
      groupTheme: "Help de IA om ndjuka, saramaka, Guyanees creools, hmong, kali'na, palikur, teko, wayana en wayampi te begrijpen.",
      groupRules: "Non-profit doel: Destine IA trainen om de regionale talen van Frans-Guyana te begrijpen en te beantwoorden.\n\nFormat van bijdragen:\n  <zin in Frans / Engels / Nederlands> = <vertaling in de gekozen taal>\n\nVoorbeeld (djuka): Kun je een afbeelding van een rode auto maken? = Yu sa méké wang photo fou wang lébi wagi gim?\n\nWees respectvol — elk ongepast bericht kan worden gemeld."
    },

    ads: {
      title: "Destine Ads",
      payNow: "क्रिएटर को भुगतान करें",
      payHint: "Stripe शुल्क आपके द्वारा (~2.9% + €0.30) — क्रिएटर को सटीक राशि मिलती है।",
      paid: "भुगतान पूर्ण",
      subtitle: "Beheer je advertenties en volg je prestaties",
      createAd: "Advertentie maken",
      myAds: "Mijn advertenties",
      analytics: "Analytics",
      sponsorshipRequests: "Sponsorverzoeken",
      myOffers: "Mijn aanbiedingen",
      activeAds: "Actieve advertenties",
      totalImpressions: "Totale weergaven",
      totalClicks: "Totale kliks",
      ctr: "Klikfrequentie (CTR)",
      avgCtr: "Gemiddelde CTR",
      conversionRate: "Conversieratio",
      adsCreated: "Gemaakte advertenties",
      activeShort: "actief",
      performanceSummary: "Prestatie-overzicht",
      details: "Details",
      perAdPerformance: "Prestatie per advertentie",
      myShop: "Mijn MyShop",
      sellYourProductsServices: "Verkoop je producten & diensten",
      payoutTitle: "Bankgegevens (MyShop)",
      payoutModify: "Wijzigen",
      payoutFill: "Invullen",
      payoutHint: "Deze gegevens zijn nodig om uitbetalingen van je verkoop te ontvangen (Destine-commissie: 5%). Alleen zichtbaar voor jou en het admin-team.",
      companyName: "Bedrijfsnaam",
      iban: "IBAN",
      bic: "BIC",
      companyPlaceholder: "Bedrijfsnaam (bv. BV Winkel XYZ)",
      bicPlaceholder: "BIC / SWIFT",
      save: "Opslaan",
      saving: "Opslaan…",
      cancel: "Annuleren",
      saved: "Gegevens opgeslagen",
      genericError: "Fout",
      noAdsYet: "Nog geen advertenties",
      noAdsHint: "Maak je eerste advertentie om te beginnen",
      statusPendingPayment: "Wacht op betaling",
      statusApproved: "Goedgekeurd",
      statusActive: "Actief",
      statusExpired: "Verlopen",
      statusPending: "In afwachting",
      adVideo: "Video",
      adImage: "Afbeelding",
      adAudio: "Audio",
      duration: "Duur",
      days: "dagen",
      broadcastZones: "Uitzendzones:",
      impressions: "Weergaven",
      clicks: "Kliks",
      delete: "Verwijderen",
      pay: "Betalen",
      checkPayment: "Betaling controleren",
      checking: "Controleren…",
      createModalTitle: "Advertentie maken",
      adTypeLabel: "Advertentietype",
      videoMax: "Max 30s, 30 MB",
      imageMax: "Max 5 MB",
      audioMax: "Max 30s, MP3",
      file: "Bestand",
      maxDuration: "Maximale duur: 30 seconden",
      broadcastDuration: "Uitzendduur",
      sevenDays: "7 dagen",
      externalLinkOptional: "Externe link (optioneel)",
      sitePlaceholder: "https://jouw-site.com",
      externalLinkHint: "URL naar je site, product of dienst",
      feedGimToli: "Feed (Gim Toli)",
      podcasts: "Podcasts",
      stories: "Stories",
      adPrice: "Advertentieprijs",
      videoPriceLabel: "€100 voor 7 dagen (video)",
      audioPriceLabel: "€50 voor 7 dagen (audio)",
      imagePriceLabel: "€50 voor 7 dagen (afbeelding)",
      creating: "Maken…",
      createAndPay: "Maken en betalen",
      selectFile: "Selecteer een bestand",
      selectAtLeastOneZone: "Selecteer minstens één uitzendzone",
      adCreated: "Advertentie aangemaakt! Ga door naar de betaling.",
      createError: "Fout bij het aanmaken",
      myOffersPanel: "Mijn sponsoraanbiedingen",
      newOffer: "Nieuwe aanbieding",
      noOffersYet: "Nog geen aanbieding gepubliceerd. Maak er een aan zodat makers ze zien bij het delen.",
      offerTitleLabel: "Titel",
      offerTitlePlaceholder: "Bv: Lancering van ons nieuwe parfum",
      offerDescLabel: "Beschrijving (wat moet de maker zeggen?)",
      offerDescPlaceholder: "Beschrijf het product of de dienst die de maker moet noemen…",
      offerKindsLabel: "Geaccepteerde inhoudstypen",
      offerKindGimToli: "Gim Toli",
      offerKindPodcast: "Podcast",
      offerAmountPlaceholder: "Bedrag",
      offerCurrencyEUR: "EUR",
      offerRule: "De maker moet minimaal 10 seconden over de sponsor spreken in zijn Gim Toli of podcast (of een vermelding in een korte film). Deze regel wordt door Destine opgelegd.",
      publishOffer: "Aanbieding publiceren",
      offerTitleRequired: "Titel vereist",
      offerDescRequired: "Beschrijving vereist",
      offerAmountInvalid: "Ongeldig bedrag",
      offerPublished: "Aanbieding gepubliceerd",
      offerDeleted: "Aanbieding verwijderd",
      filterAll: "Alles",
      filterPending: "In afwachting",
      filterAccepted: "Geaccepteerd",
      filterRejected: "Afgewezen",
      noSponsorshipRequests: "Geen sponsorverzoeken.",
      kindGimToli: "Gim Toli",
      kindPodcast: "Podcast",
      kindShortFilm: "Korte film",
      noCallbacks: "Nog geen terugbelverzoeken.",
      noCallbacksHint: "Terugbelverzoeken van kopers op je diensten verschijnen hier.",
      client: "Klant",
      markCalled: "Markeren als teruggebeld",
      archive: "Archiveren",
      updated: "Bijgewerkt",
      shopAccounting: "MyShop boekhouding",
      detailsBtn: "Details",
      gross: "Bruto",
      commissionPct: "Commissie",
      netReceive: "Netto uitbetaling",
      salesCount: "verkoop/verkopen",
      shopsCount: "winkel(s)",
      netExplain: "Netto = omzet minus Destine-commissie.",
      back: "Terug",
      proOnly: "Alleen PRO-accounts",
      loading: "Laden…",
      paymentChecking: "Betaling controleren…",
      paymentConfirmed: "Betaling bevestigd!",
      paymentProcessing: "Betaling wordt verwerkt…",
      paymentCheckError: "Verificatiefout",
      paymentCreateError: "Fout bij aanmaken van betaling",
      notifications: "Meldingen",
      paymentCanceled: "Betaling geannuleerd",
      confirmDelete: "Wil je deze advertentie echt verwijderen?",
      adDeleted: "Advertentie verwijderd",
      deleteError: "Fout bij verwijderen",
      acceptedTypes: "Geaccepteerde types",
      minTalk: "Minimale spreektijd",
      confirmDeleteOffer: "Deze aanbieding verwijderen?",
      followers: "Volgers",
      likes: "Likes",
      plays: "Afspelen",
      accept: "Accepteren",
      reject: "Afwijzen",
      sponsorAccepted: "Sponsoring geaccepteerd",
      sponsorRejected: "Verzoek afgewezen",
      payoutCoords: "Betalingsgegevens",
      holder: "Begunstigde",
      sponsorLinkClicks: "Kliks op sponsorlink",
      publishing: "Publiceren…",
      chooseAtLeastOneKind: "Kies minstens één inhoudstype",
    },
    calls: {
      dnd_title: "Niet storen",
      dnd_desc: "Indien ingeschakeld ontvangt u geen spraakoproepen in de app.",
      peer_dnd: "Deze gebruiker heeft Niet storen geactiveerd",
      connecting: "Verbinden…",
      ringing: "Bellen…",
      in_call: "In gesprek",
      ended: "Beëindigd",
      error: "Fout",
      preparing: "Oproep voorbereiden…",
      waiting: "Wachten op antwoord…",
      daily_left: "Vandaag over",
      quota_exceeded: "U heeft uw dagelijkse quotum van 30 minuten bereikt.",
      not_configured: "Spraakoproepen zijn niet ingeschakeld op deze server.",
      quota_reached: "Dagelijks quotum bereikt"
    },
    screenshot: {
      taken: "{name} heeft een screenshot van dit gesprek gemaakt",
      i_took: "U heeft een screenshot van dit gesprek gemaakt"
    },
    eshop: {
      title: "MyShop",
      see_all: "Alles bekijken",
      search_placeholder: "Zoek winkel of product…",
      empty: "Nog geen winkels",
      load_more: "Load more",
      my_shop: "Mijn winkel",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Winkel aanmaken",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Producten",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "Catalogus",
      no_products: "No products yet",
      buy: "Kopen",
      checkout: "Betalen",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "Betalen",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "Recensies",
      no_reviews: "No reviews yet",
      write_review: "Recensie schrijven",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "Alles",
      cat_fashion: "Mode",
      cat_beauty: "Schoonheid",
      cat_food: "Voeding",
      cat_myfood: "MyFood",
      cat_art: "Kunst",
      cat_music: "Muziek",
      cat_books: "Boeken",
      cat_electronics: "Elektronica",
      cat_home: "Huis",
      cat_handcraft: "Ambacht",
      cat_wellness: "Welzijn",
      cat_services: "Diensten",
      cat_education: "Onderwijs",
      cat_kids: "Kinderen",
      cat_sport: "Sport",
      cat_jewelry: "Sieraden",
      cat_other: "Overig",
      rate_help: "1 tot 5 sterren + opmerking",
      report_shop: "Winkel melden",
      reviews_count: "recensies",
      review_one: "recensie",
      no_reviews_short: "Geen recensies"
    },
    },

  // Swahili
  sw: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Matukio na tamasha',
      seeAll: 'Angalia yote',
      upcoming: 'Yajayo',
      empty: 'Hakuna matukio bado.',
      buy: 'Nunua',
      book: 'Weka',
      soldOut: 'Yameisha',
      ticketsWord: 'tikiti',
      share: 'Shiriki',
      report: 'Ripoti',
      myTickets: 'Tikiti zangu za MyMouv',
      discover: 'Gundua matukio',
    },
    vocaux: 'Sauti',
    nav: { home: 'Nyumbani', explorer: 'Gundua', discover: 'Tafuta', messages: 'MyTalk', filmAI: 'Déesse', profile: 'Wasifu', admin: 'Msimamizi' },
    common: { loading: 'Inapakia...', error: 'Kosa', success: 'Imefanikiwa', cancel: 'Ghairi', save: 'Hifadhi', saved: 'Imehifadhiwa', delete: 'Futa', edit: 'Hariri', share: 'Shiriki', report: 'Ripoti', search: 'Tafuta', new: 'Mpya', publish: 'Chapisha', send: 'Tuma', close: 'Funga', back: 'Rudi', next: 'Ifuatayo', confirm: 'Thibitisha', yes: 'Ndiyo', no: 'Hapana' },
    explorer: { title: 'Gundua', subtitle: 'Podikasti, filamu na zaidi', searchPlaceholder: 'Tafuta maudhui...', podcasts: 'Podikasti', freeFilms: 'Filamu za bure', news: 'Habari', shortFilms: 'Filamu fupi', watchNow: 'Tazama sasa', noContent: 'Hakuna maudhui', qualityWarning: 'Filamu fupi za ubora wa juu pekee zitakubaliwa.', whereToWatch: 'Wapi pa kutazama?', whereToWatchSubtitle: 'Majukwaa ya utiririshaji nchini mwako' },
    profile: { title: 'Wasifu', followers: 'Wafuasi', following: 'Unafuata', posts: 'Machapisho', editProfile: 'Hariri wasifu', settings: 'Mipangilio', gimToli: 'Gim Toli', podcasts: 'Podikasti', news: 'Habari', videos: 'Video', saved: 'Zilizohifadhiwa', bioAudio: 'Sauti ya utangulizi' },
    settings: {
      backToProfile: 'Rudi kwenye wasifu', title: 'Mipangilio', accountInfo: 'Taarifa za akaunti', notifications: 'Arifa', privacy: 'Faragha', language: 'Lugha', changePassword: 'Badilisha nenosiri', deleteAccount: 'Futa akaunti', proSpace: 'Nafasi ya PRO', helpSupport: 'Msaada', about: 'Kuhusu', selectLanguage: 'Chagua lugha', aboutIATitle: 'Kuhusu Destine AI', aboutIAIntro: 'Destine AI ni msaidizi mahiri katika programu yako. Anakusaidia kila siku bila kusoma ujumbe wako wa faragha.', aboutIACanDo: 'Anachoweza kufanya:', aboutIAPrivacy: 'Faragha:', aboutIAFeatures: 'Kuongea nawe (maandishi au sauti);Habari za hivi karibuni;Kuongea kuhusu sinema;Kuchanganua hisia za Gim Tolis;Kunakili sauti', aboutIAPrivacyPoints: 'Mazungumzo ya faragha hayasomwi;Uchambuzi wa hisia ni Gim Tolis za umma tu;Data nyeti haishirikishwi', openIA: 'Fungua Destine AI', countryForWatch: 'Nchi ya "Wapi pa kutazama?"', countryForWatchSubtitle: 'Huamua majukwaa katika Explorer', updatedToast: 'Nchi imesasishwa ✓',
    notifStatusGranted: '✅ Zimewashwa — gusa kudhibiti katika Mipangilio ya iPhone',
    notifStatusDenied: '❌ Zimezimwa — gusa kufungua Mipangilio ya iPhone',
    notifStatusWeb: 'Inapatikana kwenye app ya simu tu',
    notifStatusEnable: 'Gusa kuwasha arifa',
      titleHero: 'Mipangilio',
      subtitleHero: 'Dhibiti akaunti na mapendeleo',
      appearance: 'Mwonekano',
      darkMode: 'Hali nyeusi',
      lightMode: 'Nyepesi — Waridi',
      whiteMode: 'Nyepesi — Nyeupe',
      active: 'Inafanya',
      changePasswordSub: 'Badilisha nenosiri',
      phoneInChats: 'Simu kwenye gumzo',
      phoneInChatsHidden: 'Nambari imefichwa',
      phoneInChatsShown: 'Nambari inaonyeshwa',
      location: 'Eneo',
      locationOn: 'Eneo limewashwa',
      locationOff: 'Eneo limezimwa',
      locationActivated: 'Eneo limewashwa',
      myComments: 'Maoni yangu',
      viewMyComments: 'Angalia maoni yangu',
      viewMyCommentsSub: 'Dhibiti maoni yote',
      pushNotifications: 'Arifa za push',
      weeklyCinemaDigest: 'Filamu mpya za kila wiki',
      weeklyCinemaDigestSub: 'Pokea barua pepe + arifa ya kila wiki kuhusu filamu zinazokuja.',
      pushNotifMobileOnly: 'Kwenye programu ya simu tu',
      reportsTitle: 'Malalamiko',
      makeReport: 'Toa malalamiko',
      makeReportSub: 'Ripoti tatizo',
      blockedUsers: 'Watumiaji walioziwa',
      blockedUsersDesc: 'Zima watumiaji.',
      searchUserToBlock: 'Tafuta mtumiaji wa kuziwa...',
      blockedUsersCount: 'Walioziwa',
      noBlockedUser: 'Hakuna',
      legalDocs: 'Hati za kisheria',
      legalDocsSub: 'Masharti, faragha, sheria',
      security: 'Usalama',
      logout: 'Toka',
      dangerZone: 'Eneo la hatari',
      phoneTitle: 'Nambari ya simu',
      noPhone: 'Hakuna nambari',
      statisticsTitle: "Takwimu na mapato",
      statisticsOpen: "Tazama takwimu zangu",
      statisticsSub: "Vipendwa, maoni, mishiriko, uchezaji, wafuasi",
      copy_link: "Nakili kiungo",
      link_copied: "Kiungo kimenakiliwa"
    },
    create: { selectLanguage: 'Lugha ya maudhui', languageHint: 'Chagua lugha ya maudhui yako', title: 'Kichwa', description: 'Maelezo', content: 'Maudhui', coverImage: 'Picha ya jalada', audio: 'Sauti', video: 'Video' },
    languages: { en: 'Kiingereza', es: 'Kihispania', fr: 'Kifaransa', ar: 'Kiarabu', pt: 'Kireno', de: 'Kijerumani', ru: 'Kirusi', zh: 'Kichina', ja: 'Kijapani', hi: 'Kihindi', nl: 'Kiholanzi', sw: 'Kiswahili' },
    discover: { title: 'Gundua', subtitle: 'Filamu, tamthilia, habari, AI na MyMouv', tabCinema: 'Sinema', tabStudio: 'Studio', upcomingReleases: 'Zinazokuja hivi karibuni', popCulture: 'Utamaduni wa pop, manga, ukumbi', bestFilms: 'Filamu bora na tamthilia', boxOffice: 'Box Office', learnMore: 'Jifunze zaidi' },
    filmIA: { title: 'Destine IA', subtitle: 'AI ya sauti yenye akili ya kihisia', greeting: 'Habari!', greetingText: 'Mimi ni Déesse, AI yako ya sauti yenye akili ya kihisia.', suggestions: ['Niambie habari za leo', 'Habari mpya ni zipi?', 'Nipendekeze filamu nzuri', 'Oscars 2024 ni zipi?', 'Filamu zinazotarajiwa zaidi mwaka huu', 'Nieleze kuhusu sinema ya Kifaransa'], newConversation: 'Mazungumzo mapya', movieGameTitle: '🎬 Mchezo mdogo: Kisia filamu', movieGameSubtitle: 'Pima ujuzi wako wa sinema', movieGameReady: 'Tayari?', movieGameDescription: 'Kisia filamu kutoka muhtasari uliofichwa.', movieGameStart: '🎬 Anza', movieGameAnswerPlaceholder: 'Jibu lako...', movieGameSubmit: 'Tuma', movieGameOrVoice: 'au kwa sauti', movieGameVoiceAnswer: 'Jibu kwa sauti', movieGameStop: 'Simama', movieGameBravo: 'Vyema!', movieGameTryAgain: 'Si safari hii...', movieGameCorrectAnswer: 'Jibu lilikuwa:', movieGameReplay: 'Cheza tena', movieGameAttempt: 'Jaribio', movieGameImageMode: '🎨 Hali ya picha', movieGameImageLimit: 'Kiwango cha siku kimefikiwa (5/siku)' },
    messages: { title: 'MyTalk', searchPlaceholder: 'Tafuta watumiaji...', conversations: 'Ujumbe', invitations: 'Mialiko', noMessages: 'Hakuna ujumbe', typeMessage: 'Andika ujumbe...', learnMore: 'Jifunze zaidi', record: 'Rekodi', publish: 'Chapisha', titleField: 'Kichwa', descriptionField: 'Maelezo' },
    statistics: {
      title: "Takwimu na mapato",
      subtitle: "Fuatilia ufikiaji wa maudhui yako na ushiriki wa hadhira yako.",
      memberSince: "Mwanachama tangu",
      global: "Muhtasari",
      audience: "Hadhira",
      gimToli: "Gim Toli",
      shortFilms: "Filamu fupi",
      podcasts: "Podikasti",
      totalLikes: "Vipendwa vilivyopokelewa",
      totalComments: "Maoni",
      totalShares: "Mishiriko",
      totalPlays: "Uchezaji / Mionekano",
      followers: "Wafuasi",
      following: "Unaowafuata",
      saved: "Yaliyohifadhiwa",
      activeStories: "Hadithi hai",
      posts: "Machapisho",
      likes: "Vipendwa",
      comments: "Maoni",
      shares: "Mishiriko",
      plays: "Uchezaji",
      views: "Mionekano",
    },
    monetization: {
      title: "Mapato",
      payouts: "Ontvangen betalingen",
      noPayouts: "Nog geen betaling ontvangen.",
      eligibility: "Mapato kwenye Destine",
      unlocked: "Unaweza kuongeza mfadhili kwa Gim Toli, podikasti na filamu fupi zako.",
      locked: "Fungua mapato ukifika wafuasi {threshold}.",
      followersOf: "wafuasi",
      policy: "Sera ya mapato",
      iban: "Maelezo ya benki (IBAN)",
      ibanHelp: "Inaonekana tu kwa akaunti za PRO zilizokubali ufadhili.",
      iban_save: "Hifadhi",
      iban_saved: "IBAN imehifadhiwa",
      requests: "Maombi yangu ya ufadhili",
      noRequests: "Hakuna ombi lililotumwa bado.",
      clicks: "mibofyo kwenye kiungo cha mfadhili",
      partnerWith: "Shiriki na mfadhili",
      shareWithSponsor: "Shiriki na mfadhili",
      lockedShort: "Imefungwa",
      info_title: "Kupata Mapato",
      info_body: "Kuanzia wafuasi 5,000, unaweza kuongeza mdhamini kwa maudhui yako na kupokea malipo ya moja kwa moja katika sarafu 15+.",
      info_cta: "Jifunze zaidi",
    },
    ads: {
      title: "Destine Ads",
      payNow: "Betaal de creator",
      payHint: "Stripe-kosten (~2,9 % + € 0,30) worden door jou betaald — de creator ontvangt het exacte bedrag.",
      paid: "Betaling voltooid",
      myAds: "Matangazo yangu",
      analytics: "Uchanganuzi",
      sponsorshipRequests: "Maombi ya ufadhili",
      myOffers: "Ofa zangu",
    },

    groups: {
      tab: "Vikundi",
      create: "Unda kikundi",
      name: "Jina la kikundi",
      theme: "Mada",
      rules: "Sheria",
      profile_image: "Picha ya wasifu",
      request_join: "Omba kujiunga",
      pending: "Ombi linasubiri",
      member: "Mwanachama",
      creator: "Muundaji",
      admin: "Msimamizi",
      members: "Wanachama",
      leave: "Toka kikundini",
      delete: "Futa kikundi",
      no_groups: "Hakuna vikundi bado",
      search_groups: "Tafuta vikundi…",
      info: "Maelezo ya kikundi",
      invitations: "Maombi ya vikundi",
      accept: "Kubali",
      reject: "Kataa",
      created_by: "Imeundwa na",
      placeholder_message: "Ujumbe…",
      send: "Tuma",
      unread_messages: "Ujumbe mpya"
    },
    calls: {
      dnd_title: "Usinisumbue",
      dnd_desc: "Ikiwashwa, hutapokea simu za sauti kwenye programu.",
      peer_dnd: "Mtumiaji huyu amewasha hali ya Usinisumbue",
      connecting: "Inaunganisha…",
      ringing: "Inalia…",
      in_call: "Kwenye simu",
      ended: "Imeisha",
      error: "Hitilafu",
      preparing: "Inaandaa simu…",
      waiting: "Inasubiri jibu…",
      daily_left: "Imebakia leo",
      quota_exceeded: "Umemaliza kikomo cha dakika 30 cha kila siku.",
      not_configured: "Simu za sauti hazijaamilishwa kwenye seva hii.",
      quota_reached: "Kikomo cha kila siku kimefikiwa"
    },
    screenshot: {
      taken: "{name} alipiga picha ya skrini ya mazungumzo haya",
      i_took: "Ulipiga picha ya skrini ya mazungumzo haya"
    },
    eshop: {
      title: "MyShop",
      see_all: "Tazama yote",
      search_placeholder: "Tafuta duka au bidhaa…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "Duka langu",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Tengeneza duka",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Bidhaa",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "Katalogi",
      no_products: "No products yet",
      buy: "Nunua",
      checkout: "Malipo",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "Lipa",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "Maoni",
      no_reviews: "No reviews yet",
      write_review: "Andika maoni",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "Yote",
      cat_fashion: "Mitindo",
      cat_beauty: "Urembo",
      cat_food: "Chakula",
      cat_myfood: "MyFood",
      cat_art: "Sanaa",
      cat_music: "Muziki",
      cat_books: "Vitabu",
      cat_electronics: "Elektroniki",
      cat_home: "Nyumbani",
      cat_handcraft: "Ufundi",
      cat_wellness: "Afya",
      cat_services: "Huduma",
      cat_education: "Elimu",
      cat_kids: "Watoto",
      cat_sport: "Michezo",
      cat_jewelry: "Mapambo",
      cat_other: "Nyingine",
      rate_help: "Nyota 1 hadi 5 + maoni",
      report_shop: "Ripoti duka",
      reviews_count: "maoni",
      review_one: "maoni",
      no_reviews_short: "Hakuna maoni"
    },
    }
};

export const languageFlags = {
  en: '🇬🇧',
  es: '🇪🇸',
  fr: '🇫🇷',
  ar: '🇸🇦',
  pt: '🇵🇹',
  de: '🇩🇪',
  ru: '🇷🇺',
  zh: '🇨🇳',
  ja: '🇯🇵',
  hi: '🇮🇳',
  nl: '🇳🇱',
  sw: '🇰🇪',
  ht: '🇭🇹'
};

export const languageNames = {
  en: { en: 'English', fr: 'Anglais', native: 'English' },
  es: { en: 'Spanish', fr: 'Espagnol', native: 'Español' },
  fr: { en: 'French', fr: 'Français', native: 'Français' },
  ar: { en: 'Arabic', fr: 'Arabe', native: 'العربية' },
  pt: { en: 'Portuguese', fr: 'Portugais', native: 'Português' },
  de: { en: 'German', fr: 'Allemand', native: 'Deutsch' },
  ru: { en: 'Russian', fr: 'Russe', native: 'Русский' },
  zh: { en: 'Chinese', fr: 'Chinois', native: '中文' },
  ja: { en: 'Japanese', fr: 'Japonais', native: '日本語' },
  hi: { en: 'Hindi', fr: 'Hindi', native: 'हिन्दी' },
  nl: { en: 'Dutch', fr: 'Néerlandais', native: 'Nederlands' },
  sw: { en: 'Swahili', fr: 'Swahili', native: 'Kiswahili' },
  ht: { en: 'Haitian Creole', fr: 'Créole haïtien', native: 'Kreyòl ayisyen' }
};

export const supportedLanguages = ['en', 'es', 'fr', 'ar', 'pt', 'de', 'ru', 'zh', 'ja', 'hi', 'nl', 'sw', 'ht'];

// ---------------------------------------------------------------------------
// Studio + e-Dépôts namespaces (v47.4) — injected into each language at runtime.
// Keys are intentionally short and shared by Studio tab, Voice-to-Avatar page,
// audio storytelling mini-games and the e-Dépôts (SACD-style) section.
// ---------------------------------------------------------------------------
const _studio_edepots_i18n = {
  en: {
    studio: { tab: 'Studio', voiceToAvatar: 'Voice → animated avatar', subtitle: 'Turn your voice into an animated avatar', stories: 'Audio stories', storiesHint: '10 min max • 60s turns • everyone can view, only followers can contribute', newStory: 'New', podcasts: 'Podcasts', addTurn: 'Record a turn (60s max)', stopRecord: 'Stop', send: 'Send', translate: 'Translate', publishStory: 'Publish as Story (24h)', aiAvatar: 'AI avatar from your photo', aiAvatarHint: 'Upload a selfie — AI creates a stylized portrait that looks like you (3 free per day)', uploadPhoto: 'Upload a photo', regenerate: 'Regenerate', customizeColors: 'Customize colors', skin: 'Skin', hair: 'Hair', eyes: 'Eyes', closed: 'Closed', followersOnly: 'Followers only', readOnly: 'View only' },
    edepots: { title: 'e-Deposits', subtitle: 'Numerical deposit for your original works', newDeposit: 'New deposit', workType: 'Type of work', duration: 'Duration', coAuthors: 'Co-authors', payAndDeposit: 'Pay 10€ and deposit', certificate: 'Certificate', original: 'Original file', deleteConfirm: 'Confirm deletion with your date of birth' },
  },
  es: {
    studio: { tab: 'Estudio', voiceToAvatar: 'Voz → avatar animado', subtitle: 'Convierte tu voz en un avatar animado', stories: 'Historias de audio', storiesHint: '10 min máx • turnos de 60 s • visible para todos, solo los seguidores participan', newStory: 'Nueva', podcasts: 'Podcasts', addTurn: 'Grabar un turno (60 s máx)', stopRecord: 'Detener', send: 'Enviar', translate: 'Traducir', publishStory: 'Publicar como Story (24 h)', aiAvatar: 'Avatar IA desde tu foto', aiAvatarHint: 'Sube un selfie — la IA crea un retrato estilizado que se te parece (3 gratis al día)', uploadPhoto: 'Subir una foto', regenerate: 'Regenerar', customizeColors: 'Personalizar colores', skin: 'Piel', hair: 'Cabello', eyes: 'Ojos', closed: 'Cerrada', followersOnly: 'Solo seguidores', readOnly: 'Solo lectura' },
    edepots: { title: 'e-Depósitos', subtitle: 'Depósito digital de tus obras originales', newDeposit: 'Nuevo depósito', workType: 'Tipo de obra', duration: 'Duración', coAuthors: 'Coautores', payAndDeposit: 'Pagar 10 € y depositar', certificate: 'Certificado', original: 'Archivo original', deleteConfirm: 'Confirma la eliminación con tu fecha de nacimiento' },
  },
  fr: {
    studio: { tab: 'Studio', voiceToAvatar: 'Voix → avatar animé', subtitle: 'Transforme ta voix en avatar animé', stories: 'Histoires audio', storiesHint: '10 min max • tours de 60 s • visible par tous, participation réservée aux abonnés du créateur', newStory: 'Nouvelle', podcasts: 'Podcasts', addTurn: 'Enregistrer un tour (60 s max)', stopRecord: 'Arrêter', send: 'Envoyer', translate: 'Traduire', publishStory: 'Publier en Story (24 h)', aiAvatar: 'Avatar IA à partir de votre photo', aiAvatarHint: "Téléversez un selfie : l'IA crée un portrait stylisé qui vous ressemble (3 gratuits par jour)", uploadPhoto: 'Téléverser une photo', regenerate: 'Régénérer', customizeColors: 'Personnaliser les couleurs', skin: 'Peau', hair: 'Cheveux', eyes: 'Yeux', closed: 'Fermée', followersOnly: 'Abonnés uniquement', readOnly: 'Lecture uniquement' },
    edepots: { title: 'e-Dépôts', subtitle: 'Dépôt numérique de vos œuvres originales', newDeposit: 'Nouveau dépôt', workType: "Type d'œuvre", duration: 'Durée', coAuthors: 'Co-auteurs', payAndDeposit: 'Payer 10 € et déposer', certificate: 'Certificat', original: 'Œuvre originale', deleteConfirm: 'Confirmer la suppression avec votre date de naissance' },
  },
  ar: {
    studio: { tab: 'الاستوديو', voiceToAvatar: 'الصوت ← أفاتار متحرك', subtitle: 'حوّل صوتك إلى أفاتار متحرك', stories: 'قصص صوتية', storiesHint: '10 دقائق كحد أقصى • أدوار 60 ثانية • مرئية للجميع، المشاركة للمشتركين فقط', newStory: 'جديدة', podcasts: 'بودكاست', addTurn: 'سجّل دورًا (60 ث كحد أقصى)', stopRecord: 'إيقاف', send: 'إرسال', translate: 'ترجمة', publishStory: 'انشر كقصة (24 س)', aiAvatar: 'أفاتار بالذكاء الاصطناعي من صورتك', aiAvatarHint: 'ارفع صورة شخصية وسينشئ الذكاء الاصطناعي بورتريهًا يشبهك (3 يوميًا مجانًا)', uploadPhoto: 'رفع صورة', regenerate: 'إعادة الإنشاء', customizeColors: 'تخصيص الألوان', skin: 'البشرة', hair: 'الشعر', eyes: 'العيون', closed: 'مغلقة', followersOnly: 'للمشتركين فقط', readOnly: 'قراءة فقط' },
    edepots: { title: 'الإيداع الإلكتروني', subtitle: 'إيداع رقمي لأعمالك الأصلية', newDeposit: 'إيداع جديد', workType: 'نوع العمل', duration: 'المدة', coAuthors: 'مؤلفون مشاركون', payAndDeposit: 'ادفع 10 € وأودع', certificate: 'الشهادة', original: 'الملف الأصلي', deleteConfirm: 'أكد الحذف بتاريخ ميلادك' },
  },
  pt: {
    studio: { tab: 'Estúdio', voiceToAvatar: 'Voz → avatar animado', subtitle: 'Transforme sua voz num avatar animado', stories: 'Histórias em áudio', storiesHint: '10 min máx • turnos de 60 s • visível para todos, só seguidores participam', newStory: 'Nova', podcasts: 'Podcasts', addTurn: 'Gravar um turno (60 s máx)', stopRecord: 'Parar', send: 'Enviar', translate: 'Traduzir', publishStory: 'Publicar como Story (24 h)', aiAvatar: 'Avatar IA a partir da sua foto', aiAvatarHint: 'Envie uma selfie — a IA cria um retrato estilizado parecido com você (3 grátis por dia)', uploadPhoto: 'Enviar foto', regenerate: 'Regenerar', customizeColors: 'Personalizar cores', skin: 'Pele', hair: 'Cabelo', eyes: 'Olhos', closed: 'Fechada', followersOnly: 'Apenas seguidores', readOnly: 'Apenas leitura' },
    edepots: { title: 'e-Depósitos', subtitle: 'Depósito digital das suas obras originais', newDeposit: 'Novo depósito', workType: 'Tipo de obra', duration: 'Duração', coAuthors: 'Coautores', payAndDeposit: 'Pagar 10 € e depositar', certificate: 'Certificado', original: 'Arquivo original', deleteConfirm: 'Confirme a exclusão com sua data de nascimento' },
  },
  de: {
    studio: { tab: 'Studio', voiceToAvatar: 'Stimme → animierter Avatar', subtitle: 'Verwandle deine Stimme in einen animierten Avatar', stories: 'Audio-Storys', storiesHint: 'Max. 10 Min • 60-s-Runden • für alle sichtbar, nur Follower können beitragen', newStory: 'Neu', podcasts: 'Podcasts', addTurn: 'Runde aufnehmen (max. 60 s)', stopRecord: 'Stopp', send: 'Senden', translate: 'Übersetzen', publishStory: 'Als Story posten (24 h)', aiAvatar: 'KI-Avatar aus deinem Foto', aiAvatarHint: 'Lade ein Selfie hoch – die KI erstellt ein stilisiertes Porträt, das dir ähnelt (3 pro Tag gratis)', uploadPhoto: 'Foto hochladen', regenerate: 'Neu generieren', customizeColors: 'Farben anpassen', skin: 'Haut', hair: 'Haare', eyes: 'Augen', closed: 'Geschlossen', followersOnly: 'Nur Follower', readOnly: 'Nur lesen' },
    edepots: { title: 'e-Hinterlegungen', subtitle: 'Digitale Hinterlegung deiner Originalwerke', newDeposit: 'Neue Hinterlegung', workType: 'Werkart', duration: 'Dauer', coAuthors: 'Mitautoren', payAndDeposit: '10 € zahlen & hinterlegen', certificate: 'Zertifikat', original: 'Originaldatei', deleteConfirm: 'Löschung mit deinem Geburtsdatum bestätigen' },
  },
  ru: {
    studio: { tab: 'Студия', voiceToAvatar: 'Голос → анимированный аватар', subtitle: 'Превратите голос в анимированного аватара', stories: 'Аудио-истории', storiesHint: 'до 10 мин • ходы по 60 с • видны всем, участвуют только подписчики', newStory: 'Новая', podcasts: 'Подкасты', addTurn: 'Записать ход (макс. 60 с)', stopRecord: 'Стоп', send: 'Отправить', translate: 'Перевести', publishStory: 'Опубликовать как Story (24 ч)', aiAvatar: 'ИИ-аватар по фото', aiAvatarHint: 'Загрузите селфи — ИИ создаст стилизованный портрет, похожий на вас (3 в день бесплатно)', uploadPhoto: 'Загрузить фото', regenerate: 'Сгенерировать снова', customizeColors: 'Настроить цвета', skin: 'Кожа', hair: 'Волосы', eyes: 'Глаза', closed: 'Закрыта', followersOnly: 'Только подписчики', readOnly: 'Только просмотр' },
    edepots: { title: 'e-Депозиты', subtitle: 'Цифровое депонирование оригинальных произведений', newDeposit: 'Новый депозит', workType: 'Тип произведения', duration: 'Срок', coAuthors: 'Соавторы', payAndDeposit: 'Оплатить 10 € и депонировать', certificate: 'Свидетельство', original: 'Оригинальный файл', deleteConfirm: 'Подтвердите удаление вашей датой рождения' },
  },
  zh: {
    studio: { tab: '工作室', voiceToAvatar: '声音 → 动画头像', subtitle: '把你的声音变成动画头像', stories: '音频故事', storiesHint: '最长 10 分钟 · 每回合 60 秒 · 任何人可观看，仅粉丝可参与', newStory: '新建', podcasts: '播客', addTurn: '录制一回合（最长 60 秒）', stopRecord: '停止', send: '发送', translate: '翻译', publishStory: '发布为故事（24 小时）', aiAvatar: '从照片生成 AI 头像', aiAvatarHint: '上传自拍 — AI 生成与你相似的风格化肖像（每天 3 次免费）', uploadPhoto: '上传照片', regenerate: '重新生成', customizeColors: '自定义颜色', skin: '肤色', hair: '头发', eyes: '眼睛', closed: '已关闭', followersOnly: '仅粉丝', readOnly: '只读' },
    edepots: { title: '电子存证', subtitle: '为原创作品提供数字化存证', newDeposit: '新增存证', workType: '作品类型', duration: '期限', coAuthors: '合著者', payAndDeposit: '支付 10 € 并存证', certificate: '证书', original: '原始文件', deleteConfirm: '请用出生日期确认删除' },
  },
  ja: {
    studio: { tab: 'スタジオ', voiceToAvatar: '声 → 動くアバター', subtitle: '声でアバターを動かそう', stories: '音声ストーリー', storiesHint: '最大10分 ・ 各ターン60秒 ・ 誰でも視聴可、参加はフォロワー限定', newStory: '新規', podcasts: 'ポッドキャスト', addTurn: 'ターンを録音（最大60秒）', stopRecord: '停止', send: '送信', translate: '翻訳', publishStory: 'ストーリーに投稿（24時間）', aiAvatar: '写真からAIアバター', aiAvatarHint: 'セルフィーをアップロードすると、AIが本人に似たスタイライズ画像を生成します（1日3回まで無料）', uploadPhoto: '写真をアップロード', regenerate: '再生成', customizeColors: '色をカスタマイズ', skin: '肌', hair: '髪', eyes: '目', closed: '終了', followersOnly: 'フォロワー限定', readOnly: '閲覧のみ' },
    edepots: { title: 'e-デポジット', subtitle: 'オリジナル作品のデジタル登録', newDeposit: '新規登録', workType: '作品の種類', duration: '期間', coAuthors: '共著者', payAndDeposit: '10€を支払って登録', certificate: '証明書', original: 'オリジナルファイル', deleteConfirm: '生年月日で削除を確認してください' },
  },
  hi: {
    studio: { tab: 'स्टूडियो', voiceToAvatar: 'आवाज़ → एनिमेटेड अवतार', subtitle: 'अपनी आवाज़ को एनिमेटेड अवतार में बदलें', stories: 'ऑडियो कहानियाँ', storiesHint: 'अधिकतम 10 मिनट • 60 सेकंड के टर्न • सब देख सकते हैं, केवल फ़ॉलोअर भाग ले सकते हैं', newStory: 'नई', podcasts: 'पॉडकास्ट', addTurn: 'एक टर्न रिकॉर्ड करें (अधिकतम 60 से)', stopRecord: 'रोकें', send: 'भेजें', translate: 'अनुवाद', publishStory: 'स्टोरी के रूप में पोस्ट करें (24 घंटे)', aiAvatar: 'आपकी तस्वीर से AI अवतार', aiAvatarHint: 'सेल्फी अपलोड करें — AI एक स्टाइलाइज़्ड पोर्ट्रेट बनाएगा (दिन में 3 मुफ्त)', uploadPhoto: 'फोटो अपलोड करें', regenerate: 'फिर से बनाएँ', customizeColors: 'रंग कस्टमाइज़ करें', skin: 'त्वचा', hair: 'बाल', eyes: 'आँखें', closed: 'बंद', followersOnly: 'केवल फ़ॉलोअर', readOnly: 'केवल पढ़ें' },
    edepots: { title: 'e-डिपॉज़िट', subtitle: 'मूल कृतियों का डिजिटल पंजीकरण', newDeposit: 'नई जमा', workType: 'कृति का प्रकार', duration: 'अवधि', coAuthors: 'सह-लेखक', payAndDeposit: '10 € भुगतान करें और जमा करें', certificate: 'प्रमाणपत्र', original: 'मूल फ़ाइल', deleteConfirm: 'जन्म तिथि से विलोपन की पुष्टि करें' },
  },
  nl: {
    studio: { tab: 'Studio', voiceToAvatar: 'Stem → geanimeerde avatar', subtitle: 'Maak van je stem een geanimeerde avatar', stories: 'Audio-verhalen', storiesHint: 'Max 10 min • beurten van 60 s • voor iedereen zichtbaar, alleen volgers nemen deel', newStory: 'Nieuw', podcasts: 'Podcasts', addTurn: 'Een beurt opnemen (max 60 s)', stopRecord: 'Stop', send: 'Verzenden', translate: 'Vertalen', publishStory: 'Plaats als Story (24 u)', aiAvatar: 'AI-avatar van je foto', aiAvatarHint: 'Upload een selfie — de AI maakt een gestileerd portret dat op je lijkt (3 gratis per dag)', uploadPhoto: 'Foto uploaden', regenerate: 'Opnieuw genereren', customizeColors: 'Kleuren aanpassen', skin: 'Huid', hair: 'Haar', eyes: 'Ogen', closed: 'Gesloten', followersOnly: 'Alleen volgers', readOnly: 'Alleen lezen' },
    edepots: { title: 'e-Deposito\'s', subtitle: 'Digitale registratie van je originele werken', newDeposit: 'Nieuwe registratie', workType: 'Werktype', duration: 'Duur', coAuthors: 'Mede-auteurs', payAndDeposit: '10 € betalen & registreren', certificate: 'Certificaat', original: 'Originele bestand', deleteConfirm: 'Bevestig verwijdering met je geboortedatum' },
  },
  sw: {
    studio: { tab: 'Studio', voiceToAvatar: 'Sauti → avatar inayotembea', subtitle: 'Geuza sauti yako kuwa avatar inayotembea', stories: 'Hadithi za sauti', storiesHint: 'Max dakika 10 • zamu za sekunde 60 • inaonekana kwa wote, washiriki ni wafuasi pekee', newStory: 'Mpya', podcasts: 'Podikasti', addTurn: 'Rekodi zamu (max sekunde 60)', stopRecord: 'Simamisha', send: 'Tuma', translate: 'Tafsiri', publishStory: 'Chapisha kama Hadithi (saa 24)', aiAvatar: 'Avatar ya AI kutoka picha yako', aiAvatarHint: 'Pakia selfie — AI itaunda picha iliyobuniwa inayofanana nawe (3 bure kwa siku)', uploadPhoto: 'Pakia picha', regenerate: 'Zalisha tena', customizeColors: 'Badilisha rangi', skin: 'Ngozi', hair: 'Nywele', eyes: 'Macho', closed: 'Imefungwa', followersOnly: 'Wafuasi pekee', readOnly: 'Kusoma tu' },
    edepots: { title: 'e-Amana', subtitle: 'Usajili wa kidijiti wa kazi zako asili', newDeposit: 'Amana mpya', workType: 'Aina ya kazi', duration: 'Muda', coAuthors: 'Wandishi-pamoja', payAndDeposit: 'Lipa 10 € na hifadhi', certificate: 'Cheti', original: 'Faili asili', deleteConfirm: 'Thibitisha kufuta kwa tarehe yako ya kuzaliwa' },
  },
};

// Deep-merge studio + edepots into each language entry
for (const lang of supportedLanguages) {
  if (translations[lang] && _studio_edepots_i18n[lang]) {
    translations[lang].studio  = _studio_edepots_i18n[lang].studio;
    translations[lang].edepots = _studio_edepots_i18n[lang].edepots;
  }
}

// ---------------------------------------------------------------------------
// v50.3 — MyMap + MyFood Couriers namespaces (injected into each language).
// mymap.*  → the interactive shop map (permissions, recenter, legend…)
// eshop.*  → additional keys for the MyFood delivery couriers CRUD.
// ---------------------------------------------------------------------------
const _mymap_couriers_i18n = {
  en: {
    mymap: {
      loading: 'Loading shops…',
      count: '{n} shops located',
      geoUnsupported: 'Geolocation not supported',
      geoDenied: 'Permission denied — showing global view.',
      geoError: 'Unable to fetch your position.',
      myLocation: 'My location',
      recenter: 'Recenter on my location',
      openShop: 'Open shop',
      legend: 'Legend',
    },
    eshop: {
      couriers: 'Couriers', addCourier: 'Add a courier', editCourier: 'Edit courier',
      firstName: 'First name', lastName: 'Last name', phone: 'Phone',
      couriersHint: 'Manage the couriers who deliver for your MyFood restaurant.',
      noCouriersYet: 'No couriers yet',
      confirmDeleteCourier: 'Delete this courier?',
      courierMissing: 'First name, last name and phone are required',
      courierCreated: 'Courier added', courierUpdated: 'Courier updated', courierDeleted: 'Courier removed',
      courierNotes: 'Notes (vehicle, availability…)',
      idDocument: 'ID document (photo)', pickDoc: 'Choose an image', docUploaded: 'Document added',
      orderCourier: 'Courier', noCourier: '— No courier —', callCourier: 'Call courier',
      courier_assigned: 'Courier assigned',
    },
  },
  es: {
    mymap: {
      loading: 'Cargando tiendas…',
      count: '{n} tiendas localizadas',
      geoUnsupported: 'Geolocalización no compatible',
      geoDenied: 'Permiso denegado — vista global.',
      geoError: 'No se pudo obtener tu ubicación.',
      myLocation: 'Mi ubicación',
      recenter: 'Centrar en mi ubicación',
      openShop: 'Abrir la tienda',
      legend: 'Leyenda',
    },
    eshop: {
      couriers: 'Repartidores', addCourier: 'Agregar repartidor', editCourier: 'Editar repartidor',
      firstName: 'Nombre', lastName: 'Apellido', phone: 'Teléfono',
      couriersHint: 'Gestiona los repartidores de tu restaurante MyFood.',
      noCouriersYet: 'Aún no hay repartidores',
      confirmDeleteCourier: '¿Eliminar este repartidor?',
      courierMissing: 'Nombre, apellido y teléfono son obligatorios',
      courierCreated: 'Repartidor agregado', courierUpdated: 'Repartidor actualizado', courierDeleted: 'Repartidor eliminado',
      courierNotes: 'Notas (vehículo, disponibilidad…)',
      idDocument: 'Documento de identidad (foto)', pickDoc: 'Elegir una imagen', docUploaded: 'Documento agregado',
      orderCourier: 'Repartidor', noCourier: '— Sin repartidor —', callCourier: 'Llamar al repartidor',
      courier_assigned: 'Repartidor asignado',
    },
  },
  fr: {
    mymap: {
      loading: 'Chargement des boutiques…',
      count: '{n} boutiques localisées',
      geoUnsupported: 'Géolocalisation non supportée',
      geoDenied: "Autorisation refusée — la carte s'affiche en vue globale.",
      geoError: "Impossible d'obtenir votre position.",
      myLocation: 'Ma position',
      recenter: 'Recentrer sur ma position',
      openShop: 'Ouvrir la boutique',
      legend: 'Légende',
    },
    eshop: {
      couriers: 'Livreurs', addCourier: 'Ajouter un livreur', editCourier: 'Modifier le livreur',
      firstName: 'Prénom', lastName: 'Nom', phone: 'Téléphone',
      couriersHint: 'Gérez les livreurs qui travaillent pour votre restaurant MyFood.',
      noCouriersYet: 'Aucun livreur enregistré',
      confirmDeleteCourier: 'Supprimer ce livreur ?',
      courierMissing: 'Nom, prénom et téléphone requis',
      courierCreated: 'Livreur ajouté', courierUpdated: 'Livreur mis à jour', courierDeleted: 'Livreur supprimé',
      courierNotes: 'Notes (véhicule, disponibilité…)',
      idDocument: "Pièce d'identité (photo)", pickDoc: 'Choisir une image', docUploaded: 'Document ajouté',
      orderCourier: 'Livreur', noCourier: '— Aucun livreur —', callCourier: 'Appeler le livreur',
      courier_assigned: 'Livreur assigné',
    },
  },
  ar: {
    mymap: {
      loading: 'جارٍ تحميل المتاجر…',
      count: 'تم تحديد {n} متجرًا',
      geoUnsupported: 'تحديد الموقع غير مدعوم',
      geoDenied: 'تم رفض الإذن — عرض عام.',
      geoError: 'تعذّر الحصول على موقعك.',
      myLocation: 'موقعي',
      recenter: 'إعادة التوسيط على موقعي',
      openShop: 'فتح المتجر',
      legend: 'مفتاح الرموز',
    },
    eshop: {
      couriers: 'عمال التوصيل', addCourier: 'إضافة عامل توصيل', editCourier: 'تعديل عامل التوصيل',
      firstName: 'الاسم الأول', lastName: 'اسم العائلة', phone: 'الهاتف',
      couriersHint: 'أدر عمال التوصيل التابعين لمطعم MyFood الخاص بك.',
      noCouriersYet: 'لا يوجد عمال توصيل بعد',
      confirmDeleteCourier: 'حذف عامل التوصيل هذا؟',
      courierMissing: 'الاسم واللقب والهاتف مطلوبة',
      courierCreated: 'تمت إضافة عامل التوصيل', courierUpdated: 'تم تحديث عامل التوصيل', courierDeleted: 'تم حذف عامل التوصيل',
      courierNotes: 'ملاحظات (المركبة، التوفر…)',
      idDocument: 'وثيقة الهوية (صورة)', pickDoc: 'اختر صورة', docUploaded: 'تمت إضافة المستند',
      orderCourier: 'عامل التوصيل', noCourier: '— لا يوجد عامل توصيل —', callCourier: 'الاتصال بعامل التوصيل',
      courier_assigned: 'تم تعيين عامل التوصيل',
    },
  },
  pt: {
    mymap: {
      loading: 'Carregando lojas…',
      count: '{n} lojas localizadas',
      geoUnsupported: 'Geolocalização não suportada',
      geoDenied: 'Permissão negada — visão global.',
      geoError: 'Não foi possível obter a sua posição.',
      myLocation: 'Minha posição',
      recenter: 'Centrar na minha posição',
      openShop: 'Abrir loja',
      legend: 'Legenda',
    },
    eshop: {
      couriers: 'Entregadores', addCourier: 'Adicionar entregador', editCourier: 'Editar entregador',
      firstName: 'Nome', lastName: 'Sobrenome', phone: 'Telefone',
      couriersHint: 'Gerencie os entregadores do seu restaurante MyFood.',
      noCouriersYet: 'Nenhum entregador ainda',
      confirmDeleteCourier: 'Excluir este entregador?',
      courierMissing: 'Nome, sobrenome e telefone obrigatórios',
      courierCreated: 'Entregador adicionado', courierUpdated: 'Entregador atualizado', courierDeleted: 'Entregador excluído',
      courierNotes: 'Notas (veículo, disponibilidade…)',
      idDocument: 'Documento de identidade (foto)', pickDoc: 'Escolher uma imagem', docUploaded: 'Documento adicionado',
      orderCourier: 'Entregador', noCourier: '— Sem entregador —', callCourier: 'Ligar para o entregador',
      courier_assigned: 'Entregador atribuído',
    },
  },
  de: {
    mymap: {
      loading: 'Shops werden geladen…',
      count: '{n} Shops lokalisiert',
      geoUnsupported: 'Geolocation nicht unterstützt',
      geoDenied: 'Berechtigung verweigert — globale Ansicht.',
      geoError: 'Standort konnte nicht ermittelt werden.',
      myLocation: 'Mein Standort',
      recenter: 'Auf meinen Standort zentrieren',
      openShop: 'Shop öffnen',
      legend: 'Legende',
    },
    eshop: {
      couriers: 'Kuriere', addCourier: 'Kurier hinzufügen', editCourier: 'Kurier bearbeiten',
      firstName: 'Vorname', lastName: 'Nachname', phone: 'Telefon',
      couriersHint: 'Verwalte die Kuriere deines MyFood-Restaurants.',
      noCouriersYet: 'Noch keine Kuriere',
      confirmDeleteCourier: 'Diesen Kurier löschen?',
      courierMissing: 'Vor-, Nachname und Telefon erforderlich',
      courierCreated: 'Kurier hinzugefügt', courierUpdated: 'Kurier aktualisiert', courierDeleted: 'Kurier gelöscht',
      courierNotes: 'Notizen (Fahrzeug, Verfügbarkeit…)',
      idDocument: 'Ausweisdokument (Foto)', pickDoc: 'Bild wählen', docUploaded: 'Dokument hinzugefügt',
      orderCourier: 'Kurier', noCourier: '— Kein Kurier —', callCourier: 'Kurier anrufen',
      courier_assigned: 'Kurier zugewiesen',
    },
  },
  ru: {
    mymap: {
      loading: 'Загрузка магазинов…',
      count: 'Найдено {n} магазинов',
      geoUnsupported: 'Геолокация не поддерживается',
      geoDenied: 'Доступ запрещён — глобальный вид.',
      geoError: 'Не удалось получить ваше местоположение.',
      myLocation: 'Моё местоположение',
      recenter: 'Центрировать на моём местоположении',
      openShop: 'Открыть магазин',
      legend: 'Легенда',
    },
    eshop: {
      couriers: 'Курьеры', addCourier: 'Добавить курьера', editCourier: 'Редактировать курьера',
      firstName: 'Имя', lastName: 'Фамилия', phone: 'Телефон',
      couriersHint: 'Управляйте курьерами вашего ресторана MyFood.',
      noCouriersYet: 'Пока нет курьеров',
      confirmDeleteCourier: 'Удалить этого курьера?',
      courierMissing: 'Имя, фамилия и телефон обязательны',
      courierCreated: 'Курьер добавлен', courierUpdated: 'Курьер обновлён', courierDeleted: 'Курьер удалён',
      courierNotes: 'Заметки (транспорт, доступность…)',
      idDocument: 'Удостоверение личности (фото)', pickDoc: 'Выбрать изображение', docUploaded: 'Документ добавлен',
      orderCourier: 'Курьер', noCourier: '— Без курьера —', callCourier: 'Позвонить курьеру',
      courier_assigned: 'Курьер назначен',
    },
  },
  zh: {
    mymap: {
      loading: '正在加载店铺…',
      count: '已定位 {n} 家店铺',
      geoUnsupported: '不支持定位',
      geoDenied: '权限被拒绝 — 显示全球视图。',
      geoError: '无法获取您的位置。',
      myLocation: '我的位置',
      recenter: '定位到我的位置',
      openShop: '打开店铺',
      legend: '图例',
    },
    eshop: {
      couriers: '配送员', addCourier: '添加配送员', editCourier: '编辑配送员',
      firstName: '名字', lastName: '姓氏',
      couriersHint: '管理您 MyFood 餐厅的配送员。',
      noCouriersYet: '还没有配送员',
      confirmDeleteCourier: '删除该配送员？',
      courierMissing: '姓名和电话必填',
      courierCreated: '配送员已添加', courierUpdated: '配送员已更新', courierDeleted: '配送员已删除',
      courierNotes: '备注（车辆、可用性…）',
      idDocument: '身份证件（照片）', pickDoc: '选择图片', docUploaded: '文件已添加',
      orderCourier: '配送员', noCourier: '— 无配送员 —', callCourier: '呼叫配送员',
      courier_assigned: '已分配配送员',
    },
  },
  ja: {
    mymap: {
      loading: 'ショップを読み込み中…',
      count: '{n} 件のショップを表示',
      geoUnsupported: '位置情報がサポートされていません',
      geoDenied: '権限が拒否されました — グローバル表示。',
      geoError: '現在地を取得できません。',
      myLocation: '現在地',
      recenter: '現在地に戻す',
      openShop: 'ショップを開く',
      legend: '凡例',
    },
    eshop: {
      couriers: '配達員', addCourier: '配達員を追加', editCourier: '配達員を編集',
      firstName: '名', lastName: '姓', phone: '電話',
      couriersHint: 'MyFood レストランの配達員を管理します。',
      noCouriersYet: '配達員はまだいません',
      confirmDeleteCourier: 'この配達員を削除しますか？',
      courierMissing: '姓名と電話が必須です',
      courierCreated: '配達員を追加しました', courierUpdated: '配達員を更新しました', courierDeleted: '配達員を削除しました',
      courierNotes: 'メモ（車両、対応可能時間…）',
      idDocument: '身分証明書（写真）', pickDoc: '画像を選ぶ', docUploaded: '書類を追加しました',
      orderCourier: '配達員', noCourier: '— 配達員なし —', callCourier: '配達員に電話',
      courier_assigned: '配達員を割り当てました',
    },
  },
  hi: {
    mymap: {
      loading: 'दुकानें लोड हो रही हैं…',
      count: '{n} दुकानें मिलीं',
      geoUnsupported: 'जियोलोकेशन समर्थित नहीं',
      geoDenied: 'अनुमति अस्वीकृत — वैश्विक दृश्य।',
      geoError: 'आपकी लोकेशन प्राप्त नहीं हो सकी।',
      myLocation: 'मेरी लोकेशन',
      recenter: 'मेरी लोकेशन पर केंद्रित करें',
      openShop: 'दुकान खोलें',
      legend: 'लेजेंड',
    },
    eshop: {
      couriers: 'डिलीवरी वाले', addCourier: 'डिलीवरी वाला जोड़ें', editCourier: 'डिलीवरी वाला संपादित करें',
      firstName: 'पहला नाम', lastName: 'उपनाम', phone: 'फ़ोन',
      couriersHint: 'अपने MyFood रेस्तरां के डिलीवरी वालों को प्रबंधित करें।',
      noCouriersYet: 'अभी कोई डिलीवरी वाला नहीं',
      confirmDeleteCourier: 'क्या यह डिलीवरी वाला हटाना है?',
      courierMissing: 'नाम, उपनाम और फ़ोन आवश्यक हैं',
      courierCreated: 'डिलीवरी वाला जोड़ा गया', courierUpdated: 'डिलीवरी वाला अपडेट हुआ', courierDeleted: 'डिलीवरी वाला हटा दिया',
      courierNotes: 'टिप्पणियाँ (वाहन, उपलब्धता…)',
      idDocument: 'पहचान-पत्र (फोटो)', pickDoc: 'चित्र चुनें', docUploaded: 'दस्तावेज़ जोड़ा गया',
      orderCourier: 'डिलीवरी वाला', noCourier: '— कोई डिलीवरी वाला नहीं —', callCourier: 'डिलीवरी वाले को कॉल करें',
      courier_assigned: 'डिलीवरी वाला असाइन किया गया',
    },
  },
  nl: {
    mymap: {
      loading: 'Winkels laden…',
      count: '{n} winkels gevonden',
      geoUnsupported: 'Locatie niet ondersteund',
      geoDenied: 'Toestemming geweigerd — wereldweergave.',
      geoError: 'Kan uw positie niet ophalen.',
      myLocation: 'Mijn locatie',
      recenter: 'Op mijn locatie centreren',
      openShop: 'Winkel openen',
      legend: 'Legenda',
    },
    eshop: {
      couriers: 'Bezorgers', addCourier: 'Bezorger toevoegen', editCourier: 'Bezorger bewerken',
      firstName: 'Voornaam', lastName: 'Achternaam', phone: 'Telefoon',
      couriersHint: 'Beheer de bezorgers van uw MyFood-restaurant.',
      noCouriersYet: 'Nog geen bezorgers',
      confirmDeleteCourier: 'Deze bezorger verwijderen?',
      courierMissing: 'Voornaam, achternaam en telefoon vereist',
      courierCreated: 'Bezorger toegevoegd', courierUpdated: 'Bezorger bijgewerkt', courierDeleted: 'Bezorger verwijderd',
      courierNotes: 'Notities (voertuig, beschikbaarheid…)',
      idDocument: 'Identiteitsbewijs (foto)', pickDoc: 'Kies een afbeelding', docUploaded: 'Document toegevoegd',
      orderCourier: 'Bezorger', noCourier: '— Geen bezorger —', callCourier: 'Bezorger bellen',
      courier_assigned: 'Bezorger toegewezen',
    },
  },
  sw: {
    mymap: {
      loading: 'Inapakia maduka…',
      count: 'Maduka {n} yamepatikana',
      geoUnsupported: 'Mahali hakupatikani',
      geoDenied: 'Ruhusa imekataliwa — mwonekano wa ulimwengu.',
      geoError: 'Imeshindwa kupata eneo lako.',
      myLocation: 'Mahali pangu',
      recenter: 'Rejea mahali pangu',
      openShop: 'Fungua duka',
      legend: 'Ufafanuzi',
    },
    eshop: {
      couriers: 'Waagizaji', addCourier: 'Ongeza mwagizaji', editCourier: 'Hariri mwagizaji',
      firstName: 'Jina la kwanza', lastName: 'Jina la ukoo', phone: 'Simu',
      couriersHint: 'Simamia waagizaji wa mgahawa wako wa MyFood.',
      noCouriersYet: 'Hakuna waagizaji bado',
      confirmDeleteCourier: 'Futa mwagizaji huyu?',
      courierMissing: 'Jina, jina la ukoo na simu vinahitajika',
      courierCreated: 'Mwagizaji ameongezwa', courierUpdated: 'Mwagizaji amesasishwa', courierDeleted: 'Mwagizaji ameondolewa',
      courierNotes: 'Maelezo (gari, upatikanaji…)',
      idDocument: 'Kitambulisho (picha)', pickDoc: 'Chagua picha', docUploaded: 'Hati imeongezwa',
      orderCourier: 'Mwagizaji', noCourier: '— Hakuna mwagizaji —', callCourier: 'Piga simu mwagizaji',
      courier_assigned: 'Mwagizaji amepangwa',
    },
  },
  ht: {
    mymap: {
      loading: 'Ap chaje boutik yo…',
      count: '{n} boutik jwenn',
      geoUnsupported: 'Jeyolokalizasyon pa sipòte',
      geoDenied: 'Otorizasyon refize — vi jeneral.',
      geoError: 'Pa kapab jwenn pozisyon ou.',
      myLocation: 'Kote m ye',
      recenter: 'Retounen kote m ye',
      openShop: 'Louvri boutik la',
      legend: 'Lejand',
    },
    eshop: {
      couriers: 'Livrè yo', addCourier: 'Ajoute yon livrè', editCourier: 'Modifye livrè a',
      firstName: 'Non', lastName: 'Siyati', phone: 'Telefòn',
      couriersHint: 'Jere livrè yo k ap travay pou restoran MyFood ou a.',
      noCouriersYet: 'Poko gen livrè',
      confirmDeleteCourier: 'Efase livrè sa a?',
      courierMissing: 'Non, siyati ak telefòn obligatwa',
      courierCreated: 'Livrè ajoute', courierUpdated: 'Livrè mete ajou', courierDeleted: 'Livrè efase',
      courierNotes: 'Nòt (machin, disponiblite…)',
      idDocument: 'Pyès idantite (foto)', pickDoc: 'Chwazi yon imaj', docUploaded: 'Dokiman ajoute',
      orderCourier: 'Livrè', noCourier: '— Pa gen livrè —', callCourier: 'Rele livrè a',
      courier_assigned: 'Livrè asiyen',
    },
  },
};

// Merge mymap + eshop couriers keys into each language. eshop is a nested
// object that already contains other keys, so we shallow-merge to preserve
// existing translations while adding the new ones.
// NOTE: the actual merge runs at the very bottom of this file, AFTER every
// late-defined language block (notably translations.ht which is wholesale
// re-assigned below via Object.assign). Running the loop here would silently
// wipe out the ht additions.

// =============================================================================
// HAITIAN CREOLE (ht) — 13th language. AUTO-GENERATED by
// /app/backend/tools/generate_ht_translations.py via GPT-4o-mini.
// Edit the generator, not this block directly.
// =============================================================================
translations.ht = Object.assign(
  {
  "nav": {
    "home": "Akèy",
    "explorer": "Eksplore",
    "discover": "Dekouvri",
    "messages": "Mesaj",
    "filmAI": "Film IA",
    "profile": "Pwofil",
    "admin": "Administratè"
  },
  "common": {
    "loading": "Chajman...",
    "error": "Erè",
    "success": "Siksè",
    "cancel": "Anile",
    "save": "Sove",
    "delete": "Efase",
    "edit": "Modifye",
    "share": "Pataje",
    "report": "Rapòte",
    "search": "Rechèch",
    "new": "Nouvo",
    "publish": "Pibliye",
    "send": "Voye",
    "close": "Fermé",
    "back": "Retounen",
    "next": "Suivant",
    "confirm": "Konfime",
    "yes": "Wi",
    "no": "Non"
  },
  "auth": {
    "login": "Konekte",
    "logout": "Dekonekte",
    "register": "Enskri",
    "email": "Imèl",
    "password": "Modpas",
    "confirmPassword": "Konfime modpas",
    "forgotPassword": "Ou bliye modpas ?",
    "resetPassword": "Reyajiste modpas",
    "newPassword": "Nouvo modpas",
    "age": "Laj",
    "siret": "Nimewo SIRET",
    "joinDestine": "Rejwen Destine",
    "accountType": "Kalite kont",
    "accountID": "ID kont",
    "accountPRO": "Kont PRO",
    "appLanguage": "Lang aplikasyon an",
    "fullName": "Non konplè",
    "yourName": "Non ou",
    "birthDate": "Dat nesans",
    "optional": "opsyonèl",
    "alreadyAccount": "Ou deja gen yon kont ? Konekte",
    "noAccount": "Pa gen kont ? Enskri",
    "signIn": "Konekte",
    "signUp": "Enskri",
    "verification": "Vérification"
  },
  "explorer": {
    "title": "Eksplore",
    "subtitle": "Podcasts, films, atik ak plis",
    "searchPlaceholder": "Rechèch kontni, itilizatè, Gim Tolis...",
    "podcasts": "Podcasts",
    "freeFilms": "Films lib de dwa",
    "news": "Aktualite",
    "shortFilms": "Films kout",
    "watchNow": "Gade kounye a",
    "noContent": "Pa gen kontni disponib",
    "qualityWarning": "Se sèlman pi bon kout fim yo ap rete. Videyo ki nan move kalite kapab efase pa administratè yo.",
    "whereToWatch": "Kote pou gade ?",
    "whereToWatchSubtitle": "Platfòm streaming nan peyi ou"
  },
  "discover": {
    "title": "Sinema",
    "subtitle": "Films, seri ak aktualite",
    "upcomingReleases": "Pwòch sòti sinema",
    "popCulture": "Pop culture, mangas, teyat",
    "bestFilms": "Pi bon films ak seri",
    "boxOffice": "Box Office",
    "learnMore": "Aprann plis"
  },
  "filmIA": {
    "title": "Destine IA",
    "subtitle": "AI vokal ki gen entèlijans emosyonèl",
    "greeting": "Bonjou !",
    "greetingText": "Mwen se Déesse, AI vokal ou ki gen entèlijans emosyonèl.",
    "suggestions": [
      "Raconte-mwen aktualite jounen an",
      "Ki dènye nouvèl yo ?",
      "Rekomande-mwen yon bon fim",
      "Ki sa ki Oscars 2024 ?",
      "Films ki pi espere ane sa a",
      "Eksplike-mwen sinema fransè"
    ],
    "newConversation": "Nouvelle konvèsasyon",
    "movieGameTitle": "🎬 Mini-jwèt : Devine fim nan",
    "movieGameSubtitle": "Teste kilt ou sou sinema — reponn an vokal epi touche pwen",
    "movieGameReady": "Prêt(e) pou briye ?",
    "movieGameDescription": "Devine yon fim sou baz yon sinopsis kache. Reponn an vokal oswa pa ekri. Nòt maksimòm : 100 pwen soti nan premye kou.",
    "movieGameStart": "🎬 Kòmanse",
    "movieGameAnswerPlaceholder": "Repons ou...",
    "movieGameSubmit": "Voye",
    "movieGameOrVoice": "oswa an vokal",
    "movieGameVoiceAnswer": "Reponn an vokal",
    "movieGameStop": "Sispann",
    "movieGameBravo": "Bravo !",
    "movieGameTryAgain": "Pa fwa sa a...",
    "movieGameCorrectAnswer": "Repons lan te :",
    "movieGameReplay": "Rejwe",
    "movieGameAttempt": "Esè",
    "movieGameImageMode": "🎨 Mòd imaj aktive : pwochen vokal ou ap jenere yon imaj",
    "movieGameImageLimit": "Limit chak jou reyalize (5/jou)"
  },
  "messages": {
    "title": "Mesaj",
    "searchPlaceholder": "Rechèch itilizatè...",
    "conversations": "Konvèsasyon",
    "invitations": "Envitasyon",
    "noMessages": "Pa gen mesaj",
    "typeMessage": "Ekri yon mesaj...",
    "learnMore": "Aprann plis",
    "record": "Anrejistre",
    "publish": "Pibliye",
    "titleField": "Tit",
    "descriptionField": "Deskripsyon"
  },
  "profile": {
    "title": "Pwofil",
    "followers": "Abònen",
    "following": "Abòneman",
    "posts": "Publikasyon",
    "editProfile": "Modifye pwofil",
    "settings": "Anviwònman",
    "gimToli": "Gim Toli",
    "podcasts": "Podcasts",
    "news": "Aktualite",
    "videos": "Videyo",
    "saved": "Anrejistreman",
    "bioAudio": "Vwa prezantasyon",
    "tab_saved": "Anrejistreman",
    "tab_edepots": "e-Dépôts"
  },
  "settings": {
    "title": "Anviwònman",
    "accountInfo": "Enfòmasyon kont",
    "notifications": "Notifikasyon",
    "privacy": "Konfidansyalite",
    "language": "Lang",
    "changePassword": "Chanje modpas",
    "deleteAccount": "Efase kont mwen",
    "proSpace": "Espas PRO",
    "helpSupport": "Ede ak sipò",
    "about": "A propos",
    "selectLanguage": "Chwazi lang lan",
    "aboutIATitle": "A propos Destine IA",
    "aboutIAIntro": "Destine IA se asistan entelijan ki entegre nan aplikasyon ou. Li ede ou chak jou, san li pa janm gen aksè ak mesaj prive ou.",
    "aboutIACanDo": "Sa li ka fè :",
    "aboutIAPrivacy": "Konfidansyalite :",
    "aboutIAFeatures": "Diskite avè ou (teksti oswa vwa gras a Whisper);Ba ou aktualite moman an;Pale avè ou sou sinema, seri, sòti;Analize emosyon Gim Toli ou yo (lajwa, kalm, enèji...);Transkri vwa ou otomatikman",
    "aboutIAPrivacyPoints": "Diskisyon prive ou yo pa janm li pa IA;Analiz emosyonèl fèt sèlman sou Gim Toli piblik;Pa gen done sansib ki pataje ak lòt moun",
    "openIA": "Ouvri Destine IA",
    "countryForWatch": "Peyi pou « Kote pou gade ? »",
    "countryForWatchSubtitle": "Detèmine platfòm yo ki parèt nan Eksplore",
    "updatedToast": "Peyi ajou ✓",
    "titleHero": "Paramèt",
    "subtitleHero": "Jere kont ou ak preferans ou",
    "appearance": "Aparans",
    "darkMode": "Mòd Fènwa",
    "lightMode": "Mòd Klè",
    "active": "Aktif",
    "changePasswordSub": "Modifye modpas ou ak fim préféré",
    "phoneInChats": "Nimewo telefòn nan diskisyon",
    "phoneInChatsHidden": "Nimewo ou a kache nan diskisyon",
    "phoneInChatsShown": "Nimewo ou a vizib pa moun ou korespondan yo",
    "location": "Lokasyon",
    "locationOn": "Lokasyon aktive — ou ka pataje pozisyon ou nan diskisyon",
    "locationOff": "Lokasyon dezaktive — peze pou ouvri anviwònman yo",
    "locationActivated": "Lokasyon aktive",
    "myComments": "Kòmantè mwen",
    "viewMyComments": "Gade kòmantè mwen",
    "viewMyCommentsSub": "Jere tout kòmantè ou te laisse sou Gim Toli ak Podcasts",
    "pushNotifications": "Notifikasyon push",
    "pushNotifMobileOnly": "Disponib sèlman sou app mobil",
    "weeklyCinemaDigest": "Nouvo fim sinema chak semèn",
    "weeklyCinemaDigestSub": "Resevwa yon imèl + notifikasyon chak semèn sou nouvo sòti fim.",
    "reportsTitle": "Reklamasyon",
    "makeReport": "Fè yon reklamasyon",
    "makeReportSub": "Rapòte yon pwoblèm oswa kontakte sipò",
    "blockedUsers": "Itilizatè bloke",
    "blockedUsersDesc": "Bloke itilizatè ou pa vle wè kontni yo ankò. Yo pap ka kontakte ou ankò ni wè pwofil ou.",
    "searchUserToBlock": "Rechèch itilizatè pou bloke...",
    "blockedUsersCount": "Itilizatè bloke",
    "noBlockedUser": "Pa gen itilizatè bloke",
    "legalDocs": "Dokiman legal",
    "legalDocsSub": "CGU, politik de konfidansyalite, règ kominotè",
    "security": "Sekirite",
    "logout": "Dekonekte",
    "dangerZone": "Zòn danjere",
    "phoneTitle": "Nimewo telefòn",
    "noPhone": "Pa gen nimewo",
    "statisticsTitle": "Estatistik ak monetizasyon",
    "statisticsOpen": "Gade estatistik mwen",
    "statisticsSub": "Likes, kòmantè, pataj, lektye, abònen"
  },
  "create": {
    "selectLanguage": "Lang kontni an",
    "languageHint": "Chwazi lang kontni ou",
    "title": "Tit",
    "description": "Deskripsyon",
    "content": "Kontni",
    "coverImage": "Imaj kouvèti",
    "audio": "Odyo",
    "video": "Videyo"
  },
  "tooltips": {
    "ageInfo": "Rempli laj ou pou ranfòse sekirite kont ou",
    "siretInfo": "SIRET ou a ap sèvi pou verifye kont ou ak ranfòse sekirite li"
  },
  "statistics": {
    "title": "Estatistik ak monetizasyon",
    "subtitle": "Suivi koule kontni ou ak angajman odyans ou.",
    "memberSince": "Manm depi",
    "global": "Apèsi",
    "audience": "Odyans",
    "gimToli": "Gim Toli",
    "shortFilms": "Films kout",
    "podcasts": "Podcasts",
    "totalLikes": "J'aime resevwa",
    "totalComments": "Kòmantè",
    "totalShares": "Pataj",
    "totalPlays": "Lektye / Vues",
    "followers": "Abònen",
    "following": "Abòneman",
    "saved": "Anrejistre",
    "activeStories": "Istwa aktif",
    "posts": "Publikasyon",
    "likes": "J'aime",
    "comments": "Kòmantè",
    "shares": "Pataj",
    "plays": "Lektye",
    "views": "Vues"
  },
  "monetization": {
    "title": "Monetizasyon",
    "eligibility": "Monetizasyon Destine",
    "unlocked": "Ou ka ajoute yon sponsor sou Gim Toli ou, podcasts ak films kout.",
    "locked": "Debloke monetizasyon a {threshold} abònen.",
    "followersOf": "abònen",
    "policy": "Politik monetizasyon",
    "iban": "Enfòmasyon bankè (IBAN)",
    "ibanHelp": "Vizib sèlman pa kont PRO ki te aksepte yon sponsor.",
    "iban_save": "Sove",
    "iban_saved": "IBAN sove",
    "requests": "Demann sponsor mwen",
    "noRequests": "Pa gen demann voye pou kounye a.",
    "clicks": "klik sou lyen sponsor",
    "partnerWith": "Pataje ak sponsor",
    "shareWithSponsor": "Pataje ak sponsor",
    "lockedShort": "Bloke",
    "info_title": "Monetizasyon",
    "info_body": "Depi 5 000 abònen, ou ka atache yon sponsor sou kontni ou ak resevwa peman dirèk nan plis pase 15 lajan.",
    "info_cta": "Aprann plis"
  },
  "ads": {
    "title": "Destine Ads",
    "myAds": "Piblikite mwen",
    "analytics": "Analiz",
    "sponsorshipRequests": "Demann sponsor",
    "myOffers": "Of mwen"
  },
  "groups": {
    "tab": "Goup",
    "create": "Kreye yon goup",
    "name": "Non goup la",
    "theme": "Tèm",
    "rules": "Règ",
    "profile_image": "Foto pwofil",
    "request_join": "Mande pou rantre",
    "pending": "Demande an atant",
    "member": "Manm",
    "creator": "Kreyatè",
    "admin": "Administratè",
    "members": "Manm",
    "leave": "Kite goup la",
    "delete": "Efase goup la",
    "no_groups": "Pa gen goup pou kounye a",
    "search_groups": "Rechèch goup…",
    "info": "Enfòmasyon goup la",
    "invitations": "Demande goup",
    "accept": "Aksepte",
    "reject": "Refize",
    "created_by": "Kreye pa",
    "placeholder_message": "Mesaj…",
    "send": "Voye",
    "unread_messages": "Nouvo mesaj"
  },
  "calls": {
    "dnd_title": "Pa deranje",
    "dnd_desc": "Lè li aktive, ou pa resevwa apèl vokal nan app a.",
    "peer_dnd": "Itilizatè sa a aktive Pa deranje",
    "connecting": "Koneksyon...",
    "ringing": "Sonnerie...",
    "in_call": "Nan apèl",
    "ended": "Apèl fini",
    "error": "Erè",
    "preparing": "Prepared apèl...",
    "waiting": "An atant repons...",
    "daily_left": "Rete jodi a",
    "quota_exceeded": "Ou te reyalize quota ou nan 30 minit apèl pou jodi a.",
    "not_configured": "Apèl vokal yo pa aktive sou sèvè sa a.",
    "quota_reached": "Quota chak jou reyalize"
  },
  "screenshot": {
    "taken": "{name} te fè yon kaptur ekran de diskisyon sa a",
    "i_took": "Ou te fè yon kaptur ekran de diskisyon sa a"
  }
},
  {
    studio: {
    tab: 'Studio',
    voiceToAvatar: 'Vwa → avatar animasyon',
    subtitle: 'Vire vwa ou an yon avatar animasyon — gras a Destine IA',
    stories: 'Istwa odyo',
    storiesHint: '10 min max • won 60s • tout moun ka gade, sèlman moun k ap swiv kreyatè a ka patisipe',
    newStory: 'Nouvo',
    podcasts: 'Podkas',
    addTurn: 'Anrejistre yon won (60s max)',
    stopRecord: 'Kanpe',
    send: 'Voye',
    translate: 'Tradui',
    publishStory: 'Pibliye kòm Istwa (24è)',
    aiAvatar: 'Avatar IA soti nan foto ou',
    aiAvatarHint: "Mete yon selfi : IA a kreye yon pòtrè ki sanble ak ou (3 gratis chak jou)",
    uploadPhoto: 'Mete yon foto',
    regenerate: 'Refè',
    customizeColors: 'Pèsonalize koulè yo',
    skin: 'Po', hair: 'Cheve', eyes: 'Je',
    closed: 'Fèmen', followersOnly: 'Sèlman moun k ap swiv', readOnly: 'Sèlman lekti',
  },
    edepots: {
    title: 'e-Depo',
    subtitle: 'Anrejistreman dijital pou ouvraj orijinal ou yo',
    newDeposit: 'Nouvo depo',
    workType: 'Kalite ouvraj',
    duration: 'Dire',
    coAuthors: 'Ko-otè',
    payAndDeposit: 'Peye 10 € epi depoze',
    certificate: 'Sètifika',
    original: 'Fichye orijinal la',
    deleteConfirm: 'Konfime efasman an avèk dat nesans ou',
  },
    languages: { ht: 'Kreyòl ayisyen' },
  }
);

// -----------------------------------------------------------------------
// PROFILE TAB KEYS — were missing in source FR/EN translation blocks.
// Add them to ALL languages so `t('profile.tab_saved')` and `t('profile.tab_edepots')`
// stop showing the raw key in the UI.
// -----------------------------------------------------------------------
const _profile_tab_i18n = {
  en: { tab_saved: 'Saved', tab_edepots: 'e-Deposits', photos: 'Photos' },
  es: { tab_saved: 'Guardado', tab_edepots: 'e-Depósitos', photos: 'Fotos' },
  fr: { tab_saved: 'Enregistrements', tab_edepots: 'e-Dépôts', photos: 'Photos' },
  ar: { tab_saved: 'المحفوظات', tab_edepots: 'الإيداع الإلكتروني', photos: 'الصور' },
  pt: { tab_saved: 'Salvos', tab_edepots: 'e-Depósitos', photos: 'Fotos' },
  de: { tab_saved: 'Gespeichert', tab_edepots: 'e-Hinterlegungen', photos: 'Fotos' },
  ru: { tab_saved: 'Сохранённые', tab_edepots: 'e-Депозиты', photos: 'Фото' },
  zh: { tab_saved: '已保存', tab_edepots: '电子存证', photos: '照片' },
  ja: { tab_saved: '保存済み', tab_edepots: 'e-デポジット', photos: '写真' },
  hi: { tab_saved: 'सहेजे गए', tab_edepots: 'e-डिपॉज़िट', photos: 'फ़ोटो' },
  nl: { tab_saved: 'Opgeslagen', tab_edepots: 'e-Deposito\'s', photos: 'Foto\'s' },
  sw: { tab_saved: 'Zilizohifadhiwa', tab_edepots: 'e-Amana', photos: 'Picha' },
  ht: { tab_saved: 'Sove', tab_edepots: 'e-Depo', photos: 'Foto' },
};
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  if (!translations[lang].profile) translations[lang].profile = {};
  Object.assign(translations[lang].profile, _profile_tab_i18n[lang] || _profile_tab_i18n.en);
}

// =============================================================================
// Studio + e-Dépôts EXTRA UI strings (visible labels) — applied LAST so they
// survive the wholesale re-assignment of translations.ht above.
// =============================================================================
const _studio_edepots_extras = {
  en: {
    studio: { cta_powered_by: 'powered by Destine AI', cta_description: 'Turn your voice into a 2D synced avatar (anime, Pixar, Destinemoji, realistic)', recordSection: 'Record (60s max)', start: 'Start', resume: 'Retake', download: 'Download', voiceEffects: 'Voice effects', applying: 'Applying…', backToOriginal: 'Back to original voice', generating: 'Generating…', backTo2D: 'Back to 2D skin', animate: 'Animate the avatar', playing: 'Playing…', pickStyle: 'Pick a style', styleAnime: 'Japanese Anime', stylePixar: 'Pixar Cartoon', styleDestinemoji: 'Destinemoji', styleRealiste: 'Realistic', noStoryYet: 'No story yet', startFirstStory: 'Start the first story', newStoryTitle: 'New audio story', newStoryIntro: 'Describe your story so followers can continue it, 60 seconds at a time.', titleLabel: 'Title', introLabel: 'Intro (optional)', createStory: 'Create the story', participants: 'participants', commentsTitle: 'Comments', noComment: 'No comment — be the first!', writeComment: 'Write a comment…', translation: 'Translation', subscribeToParticipate: 'Subscribe to {name} to take part', readOnlyView: 'Read-only', listenVoice: 'Play voice', pause: 'Pause', everyoneViewFollowersWrite: '10 min max • 60s turns • visible to everyone, contributions reserved to followers', myAvatarCaption: 'My Destine avatar' },
    edepots: { titleHeader: 'My e-Deposits', subHeader: 'Protect your original works (SACD-style digital deposit, 10 € per deposit)', noDeposits: 'No deposits yet', newButton: 'New deposit', titleField: 'Title', descField: 'Description', filesField: 'Files', coAuthorsField: 'Co-authors (optional)', durationField: 'Duration', payCta: 'Pay 10 € and deposit', certificateBtn: 'Certificate (PDF)', originalBtn: 'Original file', deleteCta: 'Delete', deleteWarning: 'Once deleted, this deposit and its certificate are lost forever.', enterBirthDate: 'Enter your date of birth', confirmDelete: 'Confirm deletion', cancel: 'Cancel' },
  },
  fr: {
    studio: { cta_powered_by: 'grâce à Destine IA', cta_description: 'Transformez votre voix en avatar 2D synchronisé (anime, Pixar, Destinemoji, réaliste)', recordSection: 'Enregistrer (60s max)', start: 'Démarrer', resume: 'Reprendre', download: 'Télécharger', voiceEffects: 'Effets de voix', applying: 'Application…', backToOriginal: 'Revenir à la voix originale', generating: 'Génération en cours…', backTo2D: 'Revenir au skin 2D', animate: "Animer l'avatar", playing: 'En cours…', pickStyle: 'Choisissez un style', styleAnime: 'Anime japonais', stylePixar: 'Cartoon Pixar', styleDestinemoji: 'Destinemoji', styleRealiste: 'Réaliste', noStoryYet: 'Aucune histoire pour le moment', startFirstStory: 'Lancer la 1ère histoire', newStoryTitle: 'Nouvelle histoire audio', newStoryIntro: 'Démarrez une histoire que vos abonnés pourront continuer, 60 secondes à la fois.', titleLabel: 'Titre', introLabel: 'Intro (facultative)', createStory: "Créer l'histoire", participants: 'participants', commentsTitle: 'Commentaires', noComment: 'Aucun commentaire — soyez le premier !', writeComment: 'Écrire un commentaire…', translation: 'Traduction', subscribeToParticipate: 'Abonnez-vous à {name} pour participer', readOnlyView: 'Lecture uniquement', listenVoice: 'Lire la voix', pause: 'Pause', everyoneViewFollowersWrite: '10 min max • tours de 60s • visible par tous, participation réservée aux abonnés du créateur', myAvatarCaption: 'Mon avatar Destine' },
    edepots: { titleHeader: 'Mes e-Dépôts', subHeader: 'Protégez vos œuvres originales (dépôt numérique style SACD, 10 € par dépôt)', noDeposits: 'Aucun dépôt pour le moment', newButton: 'Nouveau dépôt', titleField: 'Titre', descField: 'Description', filesField: 'Fichiers', coAuthorsField: 'Co-auteurs (facultatif)', durationField: 'Durée', payCta: 'Payer 10 € et déposer', certificateBtn: 'Certificat (PDF)', originalBtn: 'Œuvre originale', deleteCta: 'Supprimer', deleteWarning: 'Une fois supprimé, ce dépôt et son certificat sont perdus définitivement.', enterBirthDate: 'Entrez votre date de naissance', confirmDelete: 'Confirmer la suppression', cancel: 'Annuler' },
  },
  ht: {
    mymouv: {
      title: 'MyMouv',
      subtitle: 'Evènman ak konsè',
      seeAll: 'Wè tout',
      upcoming: 'K ap vini',
      empty: 'Poko gen evènman.',
      buy: 'Achte',
      book: 'Rezève',
      soldOut: 'Fini nèt',
      ticketsWord: 'tikè',
      share: 'Pataje',
      report: 'Denonse',
      myTickets: 'Tikè MyMouv mwen',
      discover: 'Dekouvri evènman yo',
    },
    studio: { cta_powered_by: 'gras a Destine IA', cta_description: 'Vire vwa ou an yon avatar 2D ki sinkwonize (anime, Pixar, Destinemoji, reyalis)', recordSection: 'Anrejistre (60s max)', start: 'Kòmanse', resume: 'Refè', download: 'Telechaje', voiceEffects: 'Efè vwa', applying: 'N ap aplike…', backToOriginal: 'Tounen sou vwa orijinal la', generating: 'N ap kreye…', backTo2D: 'Retounen sou avatar 2D la', animate: 'Anime avatar la', playing: 'K ap jwe…', pickStyle: 'Chwazi yon estil', styleAnime: 'Anime japonè', stylePixar: 'Katon Pixar', styleDestinemoji: 'Destinemoji', styleRealiste: 'Reyalis', noStoryYet: 'Pa gen istwa pou kounye a', startFirstStory: 'Kòmanse 1ye istwa a', newStoryTitle: 'Nouvo istwa odyo', newStoryIntro: 'Kòmanse yon istwa moun k ap swiv ou yo ka kontinye, 60 segond chak fwa.', titleLabel: 'Tit', introLabel: 'Entwodiksyon (opsyonèl)', createStory: 'Kreye istwa a', participants: 'patisipan', commentsTitle: 'Kòmantè', noComment: 'Pa gen kòmantè — se ou ki premye !', writeComment: 'Ekri yon kòmantè…', translation: 'Tradiksyon', subscribeToParticipate: 'Abònè ou ak {name} pou patisipe', readOnlyView: 'Sèlman lekti', listenVoice: 'Tande vwa', pause: 'Kanpe', everyoneViewFollowersWrite: '10 min max • won 60s • tout moun ka gade, sèlman moun k ap swiv ka patisipe', myAvatarCaption: 'Avatar Destine mwen' },
    edepots: { titleHeader: 'e-Depo mwen yo', subHeader: 'Pwoteje ouvraj orijinal ou yo (depo dijital tankou SACD, 10 € pou chak depo)', noDeposits: 'Pa gen okenn depo pou kounye a', newButton: 'Nouvo depo', titleField: 'Tit', descField: 'Deskripsyon', filesField: 'Fichye', coAuthorsField: 'Ko-otè (opsyonèl)', durationField: 'Dire', payCta: 'Peye 10 € epi depoze', certificateBtn: 'Sètifika (PDF)', originalBtn: 'Fichye orijinal', deleteCta: 'Efase', deleteWarning: 'Yon fwa ou efase l, depo sa a ak sètifika l yo pèdi pou tout bon.', enterBirthDate: 'Antre dat nesans ou', confirmDelete: 'Konfime efasman an', cancel: 'Anile' },
    eshop: {
      title: "MyShop",
      see_all: "Gade tout",
      search_placeholder: "Chèche yon boutik oswa pwodwi…",
      empty: "No shops yet",
      load_more: "Load more",
      my_shop: "Boutik mwen",
      my_shops: "My shops",
      no_shop_yet: "You don't have a shop yet",
      create_first: "Create my shop",
      create_shop: "Kreye yon boutik",
      edit_shop: "Edit shop",
      shop_created: "Shop created",
      shop_deleted: "Shop deleted",
      confirm_delete_shop: "Permanently delete this shop?",
      delete_shop: "Delete shop",
      name: "Shop name",
      category: "Category",
      country: "Country (ISO)",
      currency: "Currency",
      description: "Business description",
      upload_cover: "Cover photo",
      address_full: "Postal address",
      phone: "Phone",
      website: "Website (optional)",
      shipping: "Shipping",
      shipping_fee: "Fee",
      shipping_fee_cents: "Fee (cents)",
      shipping_terms_short: "Terms",
      company_date: "Company creation date",
      payout_info: "Bank info (for payouts)",
      pay_extra_now: "Pay €500 now for an extra shop?",
      pro_required: "PRO account required",
      pro_required_desc: "Only PRO accounts can create a shop on Destine.",
      new: "New",
      fill_required: "Required fields missing",
      fill_all: "Please fill all fields",
      products: "Pwodwi",
      add_product: "New product / service",
      edit_product: "Edit product",
      kind: "Type",
      kind_product: "Product",
      kind_service: "Service",
      title_field: "Title",
      price_cents: "Price (cents)",
      photos: "Photos",
      video_url: "Video (URL, <60s)",
      stock: "Stock (empty = unlimited)",
      catalog: "Katalòg",
      no_products: "No products yet",
      buy: "Achte",
      checkout: "Peyman",
      fullname: "Full name",
      address: "Shipping address",
      quantity: "Quantity",
      subtotal: "Subtotal",
      pay: "Peye",
      accept_cgv: "I accept the",
      cgv: "Terms of sale",
      must_accept_cgv: "You must accept the terms",
      cgv_link: "Terms of sale",
      order_placed: "Order placed",
      reviews: "Avi",
      no_reviews: "No reviews yet",
      write_review: "Bay yon avi",
      publish_review: "Publish",
      review_thanks: "Thanks for your review",
      review_placeholder: "Your comment (optional)",
      orders: "Orders",
      my_orders: "My orders",
      no_orders: "No orders",
      tracking_number: "Tracking number",
      tracking_required: "Tracking number required",
      marked_shipped: "Marked as shipped",
      claims: "Claims",
      no_claims: "No claims",
      respond: "Respond",
      your_response: "Your response",
      your_response_placeholder: "Your response…",
      analytics: "Sales",
      today: "Today",
      this_week: "This week",
      this_month: "This month",
      this_year: "This year",
      total_net: "Total net",
      sales: "sales",
      after_commission: "After 5% Destine commission",
      settings: "Settings",
      no_description: "No description",
      cat_mymap: "MyMap",
      cat_all: "Tout",
      cat_fashion: "Mòd",
      cat_beauty: "Bote",
      cat_food: "Manje",
      cat_myfood: "MyFood",
      cat_art: "Atizay",
      cat_music: "Mizik",
      cat_books: "Liv",
      cat_electronics: "Elektwonik",
      cat_home: "Kay",
      cat_handcraft: "Atizana",
      cat_wellness: "Byennèt",
      cat_services: "Sèvis",
      cat_education: "Edikasyon",
      cat_kids: "Timoun",
      cat_sport: "Espò",
      cat_jewelry: "Bijou",
      cat_other: "Lòt",
      rate_help: "1 a 5 zetwal + kòmantè",
      report_shop: "Rapòte boutik",
      reviews_count: "avi",
      review_one: "avi",
      no_reviews_short: "Pa gen avi"
    },
    },
  es: {
    studio: { cta_powered_by: 'gracias a Destine IA', cta_description: 'Convierte tu voz en un avatar 2D sincronizado (anime, Pixar, Destinemoji, realista)', recordSection: 'Grabar (60s máx)', start: 'Empezar', resume: 'Rehacer', download: 'Descargar', voiceEffects: 'Efectos de voz', applying: 'Aplicando…', backToOriginal: 'Volver a la voz original', generating: 'Generando…', backTo2D: 'Volver al avatar 2D', animate: 'Animar el avatar', playing: 'Reproduciendo…', pickStyle: 'Elige un estilo', styleAnime: 'Anime japonés', stylePixar: 'Cartoon Pixar', styleDestinemoji: 'Destinemoji', styleRealiste: 'Realista', noStoryYet: 'Aún no hay historias', startFirstStory: 'Empezar la 1ª historia', newStoryTitle: 'Nueva historia de audio', newStoryIntro: 'Comienza una historia que tus seguidores podrán continuar, 60 segundos cada vez.', titleLabel: 'Título', introLabel: 'Intro (opcional)', createStory: 'Crear la historia', participants: 'participantes', commentsTitle: 'Comentarios', noComment: '¡Sin comentarios — sé el primero!', writeComment: 'Escribe un comentario…', translation: 'Traducción', subscribeToParticipate: 'Sigue a {name} para participar', readOnlyView: 'Solo lectura', listenVoice: 'Escuchar voz', pause: 'Pausa', everyoneViewFollowersWrite: '10 min máx • turnos de 60s • visible para todos, solo seguidores pueden contribuir', myAvatarCaption: 'Mi avatar Destine' },
    edepots: { titleHeader: 'Mis e-Depósitos', subHeader: 'Protege tus obras originales (depósito digital al estilo SACD, 10 € por depósito)', noDeposits: 'Aún no hay depósitos', newButton: 'Nuevo depósito', titleField: 'Título', descField: 'Descripción', filesField: 'Archivos', coAuthorsField: 'Coautores (opcional)', durationField: 'Duración', payCta: 'Pagar 10 € y depositar', certificateBtn: 'Certificado (PDF)', originalBtn: 'Archivo original', deleteCta: 'Eliminar', deleteWarning: 'Una vez eliminado, este depósito y su certificado se pierden para siempre.', enterBirthDate: 'Introduce tu fecha de nacimiento', confirmDelete: 'Confirmar eliminación', cancel: 'Cancelar' },
  },
};
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  const src = _studio_edepots_extras[lang] || _studio_edepots_extras.en;
  // Generic merge: propagate ALL namespaces from the extras block (not just
  // studio/edepots) so any new sub-object (e.g. mymouv for `ht`) survives.
  for (const ns of Object.keys(src)) {
    if (!translations[lang][ns]) translations[lang][ns] = {};
    Object.assign(translations[lang][ns], src[ns]);
  }
}

// =============================================================================
// v48.8 extras — Settings + Profile + MyMouv full-page + Poster Scanner + Refunds
// Merged after the base translations via the same generic loop below. This
// isolates the deltas so we can extend features without touching the base
// language blocks.
// =============================================================================
const _v488_extras = {
  fr: {
    mymouvHome: { seeAll: 'Voir tout', upcoming: 'À venir', empty: "Aucun événement pour l'instant.", tickets: 'billets', from: 'à partir de', free: 'Gratuit', soldOut: 'Complet', heroTitle1: 'Événements &', heroTitle2: 'Concerts', heroSubtitle: 'Découvrez les meilleurs événements près de chez vous', noneMonth: 'Aucun événement ce mois-ci.', eventsCount: 'événement(s)', seatsRemaining: 'places restantes' },
    mymouvEvent: { by: 'Par', location: 'Localisation', gallery: 'Galerie', tickets: 'Billets', havePromo: "J'ai un code promo", available: 'disponibles', seats: 'places', redirecting: 'Redirection…', buyBtn: 'Acheter', reserveBtn: 'Réserver', moreInfo: "Plus d'infos", usePromo: 'Utiliser un code promo', promoHint: 'Un code promo offre 1 billet gratuit (usage unique).', ticketType: 'Type de billet', promoCodeLabel: 'Code promo', validateBtn: 'Valider', reportTitle: 'Signaler cet événement', reportPlaceholder: 'Précisez la raison…', sendBtn: 'Envoyer' },
    mymouvForm: { titleNew: 'Nouvel événement', titleEdit: "Modifier l'événement", coverLabel: 'Image de couverture', coverHint: 'recommandé 1920×1080 px, ratio 16:9, JPG/PNG/WebP, max 15 Mo', importCover: 'Importer la couverture', titleField: 'Titre *', descField: 'Description', dateField: 'Date *', timeField: 'Heure', placeName: 'Nom du lieu (ex: Olympia)', address: 'Adresse complète *', locate: 'Localiser', geocodeError: 'Erreur de géocodage', addressFound: 'Adresse localisée', securityLabel: 'Mesures de sécurité', securityPlaceholder: "Contrôle d'identité, fouille, âge minimum...", lineupLabel: 'Line-up', addArtist: 'Ajouter un artiste', artistName: 'Nom', artistLink: 'Lien (Wikipédia/réseau)', ticketTypes: 'Types de billets', addTicketType: 'Ajouter un type de billet', ticketName: 'Nom (ex: Standard)', ticketPrice: 'Prix', ticketQty: 'Quantité', ticketVIP: 'VIP', externalLinkTitle: 'Titre du lien externe', externalLinkUrl: 'URL du lien', addImages: 'Image', addVideo: 'Vidéo (< 60s)', videoDone: 'Vidéo', publishNow: 'Publier immédiatement', save: 'Enregistrer', cancelBtn: 'Annuler', savingBtn: 'Enregistrement…' },
    months: { short: { jan: 'JAN', feb: 'FÉV', mar: 'MAR', apr: 'AVR', may: 'MAI', jun: 'JUN', jul: 'JUL', aug: 'AOÛ', sep: 'SEP', oct: 'OCT', nov: 'NOV', dec: 'DÉC' } },
    mymouv: { title: 'MyMouv', subtitle: 'Événements & concerts' },
    callUsage: { title: "Temps d'appel", last30: '30 derniers jours', description: "Total que vous avez utilisé pour passer des appels (le récepteur n'est pas décompté).", quota: 'Quota : 30 min/jour', callsInitiated: 'appel(s) initié(s)', callsShort: 'appel(s)' },
    notifs: { title: 'Notifications', description: 'Recevez les alertes de nouveaux messages, followers et événements MyMouv sur votre appareil.', enable: 'Activer les notifications', enabled: 'Notifications activées', denied: 'Refusé — activer dans les réglages système', webOnly: 'Uniquement sur mobile' },
    changeEmail: { title: "Changer d'adresse email", description: 'Un code de vérification sera envoyé à la nouvelle adresse.', newEmailLabel: 'Nouvelle adresse', codeLabel: 'Code reçu par email', sendCode: 'Envoyer le code', confirm: 'Confirmer le changement', cancel: 'Annuler' },
    refunds: { sectionTitle: 'Remboursements', sectionDescription: 'Vos billets MyMouv annulés — vous pouvez demander un remboursement instantané par carte.', empty: 'Aucun billet éligible au remboursement pour le moment.', eligibleCount: '{n} billet(s) éligible(s) au remboursement.', allDone: 'Tous vos remboursements ont été traités.', eventCancelled: 'Événement annulé', amount: 'Montant', done: 'Remboursé', requestBtn: 'Demander le remboursement', confirm: 'Demander le remboursement complet ? Le montant sera crédité sur votre carte sous 5 à 10 jours ouvrés.', success: 'Remboursement en cours — vous recevrez un e-mail de confirmation.', error: 'Erreur' },
    profileActions: { message: 'Message', follow: 'Suivre', following: 'Abonné', unfollow: 'Se désabonner', shopTab: 'MyShop', externalLink: 'Site web' },
    posterScanner: { title: 'Scanner une affiche de film', subtitle: "Prenez en photo l'affiche d'un film au cinéma", hint: 'Destine IA identifie le titre et vous présente le film.', takePhoto: 'Prendre en photo', upload: 'Importer', analyzing: 'Analyse en cours…', detected: 'Détecté · confiance :', notDetected: "L'IA n'a pas pu identifier de film sur cette image. Réessayez avec une photo plus nette.", retry: 'Réessayer', trailer: 'Bande-annonce', askMyIA: 'Demander à Déesse', scanAnother: 'Scanner une autre', tooLarge: 'Image trop grande (max 8 Mo)', invalidFormat: 'Format non supporté (JPG, PNG, WebP uniquement)', error: "Erreur d'analyse", cameraCTA: 'Scanner une affiche de film', cameraDescription: "Photographiez une affiche au cinéma et laissez Déesse identifier le film." },
    mymouvAds: { title: 'MyMouv — Mes événements', ibanLabel: 'IBAN pour les versements MyMouv', ibanHolder: 'Nom du titulaire', save: 'Enregistrer', myEvents: 'Mes événements', scannerBtn: 'Scanner', createBtn: 'Créer un événement', empty: "Aucun événement pour l'instant.", published: 'Publié', draft: 'Brouillon', cancelled: 'Annulé', ticketsSold: 'Billets vendus', grossRevenue: 'Recette brute', fees: 'Frais Stripe + Destine', netAmount: 'Net à recevoir', promoTickets: 'Billets code promo', promoUsed: 'utilisés', promoCodesBtn: 'Codes promo', cancelEventBtn: "Annuler l'événement", closeSaleBtn: 'Clôturer la vente', csvBtn: 'Export CSV', payoutValidated: 'Versement validé — email envoyé', payoutPending: 'Vente clôturée — en attente admin', cancelConfirmTitle: "Annuler « {title} » ? Tous les acheteurs seront prévenus et pourront demander un remboursement.", cancelConfirmReasonLabel: 'Motif (obligatoire) :', cancelSuccessMsg: 'Événement annulé. Les acheteurs ont été notifiés.', closeSaleConfirm: 'Clôturer la vente pour « {title} » ? Les admins seront notifiés pour valider ton versement.' },
    commission: { title: 'Modèle de commission MyMouv', bullet1: 'Frais Stripe — 1,5 % + 0,25 € par transaction', bullet2: 'Commission Destine — 0,75 € par billet vendu', bullet3: "Le reste vous est reversé sur votre IBAN après validation admin.", exampleTitle: 'Exemple pour un billet à 10 €', paidByFan: 'Prix payé par le fan', stripeFee: 'Frais Stripe (1,5 % + 0,25 €)', destineFee: 'Commission Destine (0,75 €)', netToOrg: "Net reversé à l'organisateur", promoFree: 'Les billets gratuits (codes promo, invitations) ne génèrent aucun frais.', reverseHint: 'Envie de recevoir un montant net précis ? Calculez à l\'envers : prix du billet = (net souhaité + 1,00 €) ÷ 0,985. Exemple : pour toucher 10 € net, fixez le billet à ~11,17 € (10 € + commissions Stripe + Destine).', payoutScheduleTitle: 'Calendrier des versements', payoutSchedule1: '50 % du montant net est versé 1 semaine avant le jour de l\u2019événement.', payoutSchedule2: 'Les 100 % (solde) sont déclenchés le jour même de l\u2019événement.', payoutScheduleHint: 'La réception effective des fonds dépend des délais de votre banque.' },
  },
  en: {
    callUsage: { title: 'Call time', last30: 'Last 30 days', description: "Total time you have used to make calls (the receiver is not counted).", quota: 'Quota: 30 min/day', callsInitiated: 'call(s) initiated', callsShort: 'call(s)' },
    notifs: { title: 'Notifications', description: 'Get alerts for new messages, followers and MyMouv events on your device.', enable: 'Enable notifications', enabled: 'Notifications enabled', denied: 'Denied — enable in system settings', webOnly: 'Mobile only' },
    changeEmail: { title: 'Change email address', description: 'A verification code will be sent to the new address.', newEmailLabel: 'New address', codeLabel: 'Code received by email', sendCode: 'Send code', confirm: 'Confirm change', cancel: 'Cancel' },
    refunds: { sectionTitle: 'Refunds', sectionDescription: 'Your cancelled MyMouv tickets — you can request an instant card refund.', empty: 'No tickets eligible for refund at the moment.', eligibleCount: '{n} ticket(s) eligible for refund.', allDone: 'All your refunds have been processed.', eventCancelled: 'Event cancelled', amount: 'Amount', done: 'Refunded', requestBtn: 'Request refund', confirm: 'Request a full refund? The amount will be credited to your card within 5 to 10 business days.', success: 'Refund in progress — you will receive a confirmation email.', error: 'Error' },
    profileActions: { message: 'Message', follow: 'Follow', following: 'Following', unfollow: 'Unfollow', shopTab: 'e-Shop', externalLink: 'Website' },
    posterScanner: { title: 'Scan a movie poster', subtitle: 'Take a photo of a movie poster at the cinema', hint: 'Destine AI identifies the title and shows you the movie.', takePhoto: 'Take photo', upload: 'Upload', analyzing: 'Analyzing…', detected: 'Detected · confidence:', notDetected: 'The AI could not identify a movie in this image. Try again with a sharper photo.', retry: 'Retry', trailer: 'Trailer', askMyIA: 'Ask My AI', scanAnother: 'Scan another', tooLarge: 'Image too large (max 8 MB)', invalidFormat: 'Unsupported format (JPG, PNG, WebP only)', error: 'Analysis error', cameraCTA: 'Scan a movie poster', cameraDescription: 'Snap a movie poster at the cinema and let My AI identify the film.' },
    mymouvHome: { seeAll: 'See all', upcoming: 'Upcoming', empty: 'No events yet.', tickets: 'tickets', from: 'from', free: 'Free', soldOut: 'Sold out', heroTitle1: 'Events &', heroTitle2: 'Concerts', heroSubtitle: 'Discover the best events near you', noneMonth: 'No events this month.', eventsCount: 'event(s)', seatsRemaining: 'seats remaining' },
    mymouvEvent: { by: 'By', location: 'Location', gallery: 'Gallery', tickets: 'Tickets', havePromo: 'I have a promo code', available: 'available', seats: 'seats', redirecting: 'Redirecting…', buyBtn: 'Buy', reserveBtn: 'Reserve', moreInfo: 'More info', usePromo: 'Use a promo code', promoHint: 'A promo code offers 1 free ticket (single-use).', ticketType: 'Ticket type', promoCodeLabel: 'Promo code', validateBtn: 'Validate', reportTitle: 'Report this event', reportPlaceholder: 'Please specify the reason…', sendBtn: 'Send' },
    months: { short: { jan: 'JAN', feb: 'FEB', mar: 'MAR', apr: 'APR', may: 'MAY', jun: 'JUN', jul: 'JUL', aug: 'AUG', sep: 'SEP', oct: 'OCT', nov: 'NOV', dec: 'DEC' } },
    mymouv: { title: 'MyMouv', subtitle: 'Events & concerts' },
    mymouvAds: { title: 'MyMouv — My events', ibanLabel: 'IBAN for MyMouv payouts', ibanHolder: 'Account holder name', save: 'Save', myEvents: 'My events', scannerBtn: 'Scanner', createBtn: 'Create event', empty: 'No events yet.', published: 'Published', draft: 'Draft', cancelled: 'Cancelled', ticketsSold: 'Tickets sold', grossRevenue: 'Gross revenue', fees: 'Stripe + Destine fees', netAmount: 'Net to receive', promoTickets: 'Promo-code tickets', promoUsed: 'used', promoCodesBtn: 'Promo codes', cancelEventBtn: 'Cancel event', closeSaleBtn: 'Close sale', csvBtn: 'Export CSV', payoutValidated: 'Payout validated — email sent', payoutPending: 'Sale closed — awaiting admin', cancelConfirmTitle: 'Cancel "{title}"? All buyers will be notified and can request a refund.', cancelConfirmReasonLabel: 'Reason (required):', cancelSuccessMsg: 'Event cancelled. Buyers have been notified.', closeSaleConfirm: 'Close sale for "{title}"? Admins will be notified to validate your payout.' },
    mymouvForm: { titleNew: 'New event', titleEdit: 'Edit event', coverLabel: 'Cover image', coverHint: 'recommended 1920×1080 px, 16:9 ratio, JPG/PNG/WebP, max 15 MB', importCover: 'Import cover', titleField: 'Title *', descField: 'Description', dateField: 'Date *', timeField: 'Time', placeName: 'Place name (e.g. Olympia)', address: 'Full address *', locate: 'Locate', geocodeError: 'Geocoding error', addressFound: 'Address located', securityLabel: 'Security measures', securityPlaceholder: 'ID check, search, minimum age…', lineupLabel: 'Line-up', addArtist: 'Add artist', artistName: 'Name', artistLink: 'Link (Wikipedia/social)', ticketTypes: 'Ticket types', addTicketType: 'Add ticket type', ticketName: 'Name (e.g. Standard)', ticketPrice: 'Price', ticketQty: 'Quantity', ticketVIP: 'VIP', externalLinkTitle: 'External link title', externalLinkUrl: 'Link URL', addImages: 'Image', addVideo: 'Video (< 60s)', videoDone: 'Video', publishNow: 'Publish immediately', save: 'Save', cancelBtn: 'Cancel', savingBtn: 'Saving…' },
    commission: { title: 'MyMouv commission model', bullet1: 'Stripe fees — 1.5% + €0.25 per transaction', bullet2: 'Destine commission — €0.75 per ticket sold', bullet3: 'The remainder is paid to your IBAN after admin validation.', exampleTitle: 'Example for a €10 ticket', paidByFan: 'Paid by the fan', stripeFee: 'Stripe fees (1.5% + €0.25)', destineFee: 'Destine commission (€0.75)', netToOrg: 'Net paid to the organizer', promoFree: 'Free tickets (promo codes, invitations) generate no fees.', reverseHint: 'Want a specific net amount? Reverse-calculate: ticket price = (target net + €1.00) ÷ 0.985. Example: to receive €10 net, price the ticket at ~€11.17 (€10 + Stripe + Destine commissions).', payoutScheduleTitle: 'Payout schedule', payoutSchedule1: '50% of the net amount is paid out 1 week before the event day.', payoutSchedule2: 'The full 100% (balance) is triggered on the day of the event itself.', payoutScheduleHint: 'Actual receipt of funds depends on your bank\u2019s processing times.' },
  },
};
// Broadcast the 11 remaining languages by cloning EN (safer than leaving them
// with raw dotted keys — they will be gradually translated in future iters).
for (const l of ['es','ar','pt','de','ru','zh','ja','hi','nl','sw','ht']) {
  if (!_v488_extras[l]) _v488_extras[l] = JSON.parse(JSON.stringify(_v488_extras.en));
}
// Lightweight per-language overrides so users of common languages see native
// UI without waiting for a full translation pass.
_v488_extras.es.refunds = { ..._v488_extras.es.refunds, sectionTitle: 'Reembolsos', sectionDescription: 'Tus entradas MyMouv canceladas — puedes solicitar un reembolso instantáneo a tu tarjeta.', empty: 'Ninguna entrada elegible para reembolso.', requestBtn: 'Solicitar reembolso', done: 'Reembolsado', amount: 'Importe', eventCancelled: 'Evento cancelado', confirm: '¿Solicitar reembolso completo? Se acreditará a tu tarjeta en 5 a 10 días hábiles.', success: 'Reembolso en curso — recibirás un correo de confirmación.' };
_v488_extras.pt.refunds = { ..._v488_extras.pt.refunds, sectionTitle: 'Reembolsos', sectionDescription: 'Seus ingressos MyMouv cancelados — você pode pedir o reembolso instantâneo no cartão.', requestBtn: 'Pedir reembolso', done: 'Reembolsado', amount: 'Valor', eventCancelled: 'Evento cancelado' };
_v488_extras.de.refunds = { ..._v488_extras.de.refunds, sectionTitle: 'Rückerstattungen', sectionDescription: 'Deine stornierten MyMouv-Tickets — sofortige Rückerstattung auf Karte möglich.', requestBtn: 'Rückerstattung anfordern', done: 'Erstattet', amount: 'Betrag', eventCancelled: 'Event abgesagt' };
_v488_extras.ar.refunds = { ..._v488_extras.ar.refunds, sectionTitle: 'المبالغ المستردة', sectionDescription: 'تذاكر MyMouv الملغاة الخاصة بك — يمكنك طلب استرداد فوري إلى بطاقتك.', requestBtn: 'طلب الاسترداد', done: 'تم الاسترداد', amount: 'المبلغ', eventCancelled: 'تم إلغاء الفعالية' };
_v488_extras.ja.refunds = { ..._v488_extras.ja.refunds, sectionTitle: '返金', requestBtn: '返金を申請', done: '返金済み', amount: '金額', eventCancelled: 'イベント中止' };
_v488_extras.zh.refunds = { ..._v488_extras.zh.refunds, sectionTitle: '退款', requestBtn: '申请退款', done: '已退款', amount: '金额', eventCancelled: '活动已取消' };
_v488_extras.ht.refunds = { ..._v488_extras.ht.refunds, sectionTitle: 'Ranbousman', sectionDescription: 'Tikè MyMouv anile yo — ou ka mande ranbousman imedya sou kat kredi w.', requestBtn: 'Mande ranbousman', done: 'Ranbouse', amount: 'Kantite', eventCancelled: 'Evènman anile' };
// Cross-language profileActions (Message + Follow)
_v488_extras.es.profileActions = { message: 'Mensaje', follow: 'Seguir', following: 'Siguiendo', unfollow: 'Dejar de seguir', shopTab: 'e-Tienda', externalLink: 'Sitio web' };
_v488_extras.pt.profileActions = { message: 'Mensagem', follow: 'Seguir', following: 'Seguindo', unfollow: 'Deixar de seguir', shopTab: 'e-Loja', externalLink: 'Site' };
_v488_extras.de.profileActions = { message: 'Nachricht', follow: 'Folgen', following: 'Folge ich', unfollow: 'Entfolgen', shopTab: 'e-Shop', externalLink: 'Website' };
_v488_extras.ar.profileActions = { message: 'رسالة', follow: 'متابعة', following: 'أتابع', unfollow: 'إلغاء المتابعة', shopTab: 'المتجر الإلكتروني', externalLink: 'الموقع' };
_v488_extras.ja.profileActions = { message: 'メッセージ', follow: 'フォロー', following: 'フォロー中', unfollow: 'フォロー解除', shopTab: 'e-ショップ', externalLink: 'ウェブサイト' };
_v488_extras.zh.profileActions = { message: '消息', follow: '关注', following: '已关注', unfollow: '取消关注', shopTab: 'e-店铺', externalLink: '网站' };
_v488_extras.ru.profileActions = { message: 'Сообщение', follow: 'Подписаться', following: 'Вы подписаны', unfollow: 'Отписаться', shopTab: 'Магазин', externalLink: 'Сайт' };
_v488_extras.hi.profileActions = { message: 'संदेश', follow: 'फ़ॉलो', following: 'फ़ॉलो कर रहे हैं', unfollow: 'अनफ़ॉलो', shopTab: 'ई-दुकान', externalLink: 'वेबसाइट' };
_v488_extras.nl.profileActions = { message: 'Bericht', follow: 'Volgen', following: 'Ik volg', unfollow: 'Ontvolgen', shopTab: 'e-Winkel', externalLink: 'Website' };
_v488_extras.sw.profileActions = { message: 'Ujumbe', follow: 'Fuata', following: 'Unafuata', unfollow: 'Acha kufuata', shopTab: 'e-Duka', externalLink: 'Tovuti' };
_v488_extras.ht.profileActions = { message: 'Mesaj', follow: 'Swiv', following: 'W ap swiv', unfollow: 'Sispann swiv', shopTab: 'e-Boutik', externalLink: 'Sit wèb' };
// mymouvHome seeAll — critical (user reported)
_v488_extras.es.mymouvHome = { ..._v488_extras.es.mymouvHome, seeAll: 'Ver todo', upcoming: 'Próximos', empty: 'No hay eventos por ahora.', tickets: 'entradas', from: 'desde', free: 'Gratis', soldOut: 'Agotado', heroTitle1: 'Eventos &', heroTitle2: 'Conciertos', heroSubtitle: 'Descubre los mejores eventos cerca de ti', noneMonth: 'Ningún evento este mes.', eventsCount: 'evento(s)', seatsRemaining: 'plazas restantes' };
_v488_extras.es.mymouvEvent = { by: 'Por', location: 'Ubicación', gallery: 'Galería', tickets: 'Entradas', havePromo: 'Tengo un código promo', available: 'disponibles', seats: 'plazas', redirecting: 'Redirigiendo…', buyBtn: 'Comprar', reserveBtn: 'Reservar', moreInfo: 'Más información', usePromo: 'Usar un código promo', promoHint: 'Un código promo ofrece 1 entrada gratis (uso único).', ticketType: 'Tipo de entrada', promoCodeLabel: 'Código promo', validateBtn: 'Validar', reportTitle: 'Denunciar este evento', reportPlaceholder: 'Indica el motivo…', sendBtn: 'Enviar' };
_v488_extras.pt.mymouvHome = { ..._v488_extras.pt.mymouvHome, seeAll: 'Ver tudo', upcoming: 'Próximos', empty: 'Sem eventos por enquanto.', tickets: 'ingressos', from: 'a partir de', free: 'Grátis', soldOut: 'Esgotado', heroTitle1: 'Eventos &', heroTitle2: 'Concertos', heroSubtitle: 'Descubra os melhores eventos perto de você', noneMonth: 'Nenhum evento neste mês.', eventsCount: 'evento(s)', seatsRemaining: 'lugares restantes' };
_v488_extras.pt.mymouvEvent = { by: 'Por', location: 'Localização', gallery: 'Galeria', tickets: 'Ingressos', havePromo: 'Tenho um código promo', available: 'disponíveis', seats: 'lugares', redirecting: 'Redirecionando…', buyBtn: 'Comprar', reserveBtn: 'Reservar', moreInfo: 'Mais informações', usePromo: 'Usar código promo', promoHint: 'Um código promo oferece 1 ingresso grátis (uso único).', ticketType: 'Tipo de ingresso', promoCodeLabel: 'Código promo', validateBtn: 'Validar', reportTitle: 'Denunciar este evento', reportPlaceholder: 'Informe o motivo…', sendBtn: 'Enviar' };
_v488_extras.de.mymouvHome = { ..._v488_extras.de.mymouvHome, seeAll: 'Alle ansehen', upcoming: 'Kommende', empty: 'Noch keine Events.', tickets: 'Tickets', from: 'ab', free: 'Gratis', soldOut: 'Ausverkauft', heroTitle1: 'Events &', heroTitle2: 'Konzerte', heroSubtitle: 'Entdecke die besten Events in deiner Nähe', noneMonth: 'Keine Events in diesem Monat.', eventsCount: 'Event(s)', seatsRemaining: 'Plätze verfügbar' };
_v488_extras.de.mymouvEvent = { by: 'Von', location: 'Ort', gallery: 'Galerie', tickets: 'Tickets', havePromo: 'Ich habe einen Promo-Code', available: 'verfügbar', seats: 'Plätze', redirecting: 'Weiterleitung…', buyBtn: 'Kaufen', reserveBtn: 'Reservieren', moreInfo: 'Mehr Infos', usePromo: 'Promo-Code verwenden', promoHint: 'Ein Promo-Code bietet 1 kostenloses Ticket (einmalige Nutzung).', ticketType: 'Ticket-Typ', promoCodeLabel: 'Promo-Code', validateBtn: 'Bestätigen', reportTitle: 'Event melden', reportPlaceholder: 'Grund angeben…', sendBtn: 'Senden' };
_v488_extras.ar.mymouvHome = { ..._v488_extras.ar.mymouvHome, seeAll: 'عرض الكل', upcoming: 'القادمة', empty: 'لا توجد فعاليات بعد.', tickets: 'تذاكر', from: 'ابتداءً من', free: 'مجاني', soldOut: 'نفدت', heroTitle1: 'فعاليات &', heroTitle2: 'حفلات', heroSubtitle: 'اكتشف أفضل الفعاليات بالقرب منك', noneMonth: 'لا توجد فعاليات هذا الشهر.', eventsCount: 'فعالية', seatsRemaining: 'مقاعد متبقية' };
_v488_extras.ar.mymouvEvent = { by: 'بواسطة', location: 'الموقع', gallery: 'المعرض', tickets: 'التذاكر', havePromo: 'لدي رمز ترويجي', available: 'متاح', seats: 'مقاعد', redirecting: 'جارٍ التحويل…', buyBtn: 'شراء', reserveBtn: 'حجز', moreInfo: 'مزيد من المعلومات', usePromo: 'استخدم رمزًا ترويجيًا', promoHint: 'يوفر الرمز الترويجي تذكرة مجانية واحدة (استخدام واحد).', ticketType: 'نوع التذكرة', promoCodeLabel: 'الرمز الترويجي', validateBtn: 'تأكيد', reportTitle: 'الإبلاغ عن هذه الفعالية', reportPlaceholder: 'حدد السبب…', sendBtn: 'إرسال' };
_v488_extras.ja.mymouvHome = { ..._v488_extras.ja.mymouvHome, seeAll: 'すべて見る', upcoming: '近日開催', empty: 'まだイベントがありません。', tickets: 'チケット', from: 'から', free: '無料', soldOut: '完売', heroTitle1: 'イベント &', heroTitle2: 'コンサート', heroSubtitle: '近くの最高のイベントを発見', noneMonth: '今月はイベントがありません。', eventsCount: 'イベント', seatsRemaining: '残席' };
_v488_extras.ja.mymouvEvent = { by: '主催', location: '場所', gallery: 'ギャラリー', tickets: 'チケット', havePromo: 'プロモコードを持っています', available: '利用可能', seats: '席', redirecting: 'リダイレクト中…', buyBtn: '購入', reserveBtn: '予約', moreInfo: '詳細', usePromo: 'プロモコードを使用', promoHint: 'プロモコードで1枚の無料チケット（一度限り）。', ticketType: 'チケット種別', promoCodeLabel: 'プロモコード', validateBtn: '確定', reportTitle: 'このイベントを報告', reportPlaceholder: '理由を明記…', sendBtn: '送信' };
_v488_extras.zh.mymouvHome = { ..._v488_extras.zh.mymouvHome, seeAll: '查看全部', upcoming: '即将上演', empty: '暂无活动。', tickets: '门票', from: '起', free: '免费', soldOut: '售罄', heroTitle1: '活动 &', heroTitle2: '演出', heroSubtitle: '发现您附近最佳活动', noneMonth: '本月无活动。', eventsCount: '个活动', seatsRemaining: '剩余席位' };
_v488_extras.zh.mymouvEvent = { by: '主办', location: '地点', gallery: '相册', tickets: '门票', havePromo: '我有优惠码', available: '可用', seats: '席位', redirecting: '跳转中…', buyBtn: '购买', reserveBtn: '预订', moreInfo: '更多信息', usePromo: '使用优惠码', promoHint: '优惠码可兑换 1 张免费门票（一次性使用）。', ticketType: '票种', promoCodeLabel: '优惠码', validateBtn: '确认', reportTitle: '举报此活动', reportPlaceholder: '请说明原因…', sendBtn: '发送' };
_v488_extras.ht.mymouvHome = { ..._v488_extras.ht.mymouvHome, seeAll: 'Wè tout', upcoming: 'K ap vini', empty: 'Poko gen evènman.', tickets: 'tikè', from: 'apati de', free: 'Gratis', soldOut: 'Fini nèt', heroTitle1: 'Evènman &', heroTitle2: 'Konsè', heroSubtitle: 'Dekouvri pi bon evènman toupre w', noneMonth: 'Pa gen evènman mwa sa a.', eventsCount: 'evènman', seatsRemaining: 'plas ki rete' };
_v488_extras.ht.mymouvEvent = { by: 'Pa', location: 'Kote', gallery: 'Galeri', tickets: 'Tikè', havePromo: 'Mwen gen yon kòd pwomo', available: 'disponib', seats: 'plas', redirecting: 'N ap redireksyone…', buyBtn: 'Achte', reserveBtn: 'Rezève', moreInfo: 'Plis enfòmasyon', usePromo: 'Sèvi ak yon kòd pwomo', promoHint: 'Yon kòd pwomo bay 1 tikè gratis (yon sèl fwa).', ticketType: 'Kalite tikè', promoCodeLabel: 'Kòd pwomo', validateBtn: 'Valide', reportTitle: 'Denonse evènman sa a', reportPlaceholder: 'Presize rezon an…', sendBtn: 'Voye' };
// Poster scanner critical strings
_v488_extras.es.posterScanner = { ..._v488_extras.es.posterScanner, title: 'Escanear un cartel de película', takePhoto: 'Tomar foto', upload: 'Importar', analyzing: 'Analizando…', askMyIA: 'Preguntar a Déesse', scanAnother: 'Escanear otro', cameraCTA: 'Escanear cartel', cameraDescription: 'Fotografía un cartel en el cine y deja que Déesse identifique la película.' };
_v488_extras.pt.posterScanner = { ..._v488_extras.pt.posterScanner, title: 'Escanear pôster de filme', takePhoto: 'Tirar foto', upload: 'Importar', askMyIA: 'Perguntar à Déesse' };
_v488_extras.de.posterScanner = { ..._v488_extras.de.posterScanner, title: 'Filmplakat scannen', takePhoto: 'Foto machen', upload: 'Hochladen', askMyIA: 'Déesse fragen' };
_v488_extras.ht.posterScanner = { ..._v488_extras.ht.posterScanner, title: 'Eskane yon afich fim', takePhoto: 'Pran yon foto', upload: 'Enpòte', analyzing: 'N ap analize…', askMyIA: 'Mande Déesse', scanAnother: 'Eskane yon lòt' };
// Event creation form (mymouvForm) — critical (organizer panel)
_v488_extras.es.mymouvForm = { ..._v488_extras.es.mymouvForm, titleNew: 'Nuevo evento', titleEdit: 'Editar evento', coverLabel: 'Imagen de portada', coverHint: 'recomendado 1920×1080 px, ratio 16:9, JPG/PNG/WebP, máx 15 MB', importCover: 'Importar portada', titleField: 'Título *', descField: 'Descripción', dateField: 'Fecha *', timeField: 'Hora', placeName: 'Nombre del lugar (ej: Olympia)', address: 'Dirección completa *', locate: 'Localizar', securityLabel: 'Medidas de seguridad', securityPlaceholder: 'Control de identidad, cacheo, edad mínima…', lineupLabel: 'Line-up', addArtist: 'Añadir artista', artistName: 'Nombre', artistLink: 'Enlace (Wikipedia/red)', ticketTypes: 'Tipos de entradas', addTicketType: 'Añadir tipo de entrada', ticketName: 'Nombre (ej: Estándar)', ticketPrice: 'Precio', ticketQty: 'Cantidad', ticketVIP: 'VIP', externalLinkTitle: 'Título del enlace externo', externalLinkUrl: 'URL del enlace', addImages: 'Imagen', addVideo: 'Vídeo (< 60s)', videoDone: 'Vídeo', publishNow: 'Publicar ahora', save: 'Guardar', cancelBtn: 'Cancelar', savingBtn: 'Guardando…' };
_v488_extras.pt.mymouvForm = { ..._v488_extras.pt.mymouvForm, titleNew: 'Novo evento', titleEdit: 'Editar evento', coverLabel: 'Imagem de capa', coverHint: 'recomendado 1920×1080 px, proporção 16:9, JPG/PNG/WebP, máx 15 MB', importCover: 'Importar capa', titleField: 'Título *', descField: 'Descrição', dateField: 'Data *', timeField: 'Hora', placeName: 'Nome do local (ex: Olympia)', address: 'Endereço completo *', locate: 'Localizar', securityLabel: 'Medidas de segurança', securityPlaceholder: 'Controle de identidade, revista, idade mínima…', lineupLabel: 'Line-up', addArtist: 'Adicionar artista', artistName: 'Nome', artistLink: 'Link (Wikipédia/rede)', ticketTypes: 'Tipos de ingressos', addTicketType: 'Adicionar tipo', ticketName: 'Nome (ex: Padrão)', ticketPrice: 'Preço', ticketQty: 'Quantidade', ticketVIP: 'VIP', externalLinkTitle: 'Título do link externo', externalLinkUrl: 'URL do link', addImages: 'Imagem', addVideo: 'Vídeo (< 60s)', videoDone: 'Vídeo', publishNow: 'Publicar agora', save: 'Salvar', cancelBtn: 'Cancelar', savingBtn: 'Salvando…' };
_v488_extras.de.mymouvForm = { ..._v488_extras.de.mymouvForm, titleNew: 'Neues Event', titleEdit: 'Event bearbeiten', coverLabel: 'Titelbild', coverHint: 'empfohlen 1920×1080 px, 16:9, JPG/PNG/WebP, max 15 MB', importCover: 'Titelbild hochladen', titleField: 'Titel *', descField: 'Beschreibung', dateField: 'Datum *', timeField: 'Uhrzeit', placeName: 'Name des Veranstaltungsortes', address: 'Vollständige Adresse *', locate: 'Lokalisieren', securityLabel: 'Sicherheitsmaßnahmen', securityPlaceholder: 'Ausweiskontrolle, Durchsuchung, Mindestalter…', lineupLabel: 'Line-up', addArtist: 'Künstler hinzufügen', artistName: 'Name', artistLink: 'Link (Wikipedia/Social)', ticketTypes: 'Ticket-Typen', addTicketType: 'Typ hinzufügen', ticketName: 'Name (z. B. Standard)', ticketPrice: 'Preis', ticketQty: 'Menge', ticketVIP: 'VIP', externalLinkTitle: 'Titel des externen Links', externalLinkUrl: 'Link-URL', addImages: 'Bild', addVideo: 'Video (< 60s)', videoDone: 'Video', publishNow: 'Sofort veröffentlichen', save: 'Speichern', cancelBtn: 'Abbrechen', savingBtn: 'Speichern…' };
_v488_extras.ar.mymouvForm = { ..._v488_extras.ar.mymouvForm, titleNew: 'فعالية جديدة', titleEdit: 'تعديل الفعالية', coverLabel: 'صورة الغلاف', coverHint: 'يوصى بـ 1920×1080، نسبة 16:9، JPG/PNG/WebP، حد أقصى 15 ميغابايت', importCover: 'استيراد الغلاف', titleField: 'العنوان *', descField: 'الوصف', dateField: 'التاريخ *', timeField: 'الوقت', placeName: 'اسم المكان', address: 'العنوان الكامل *', locate: 'تحديد', securityLabel: 'إجراءات الأمان', lineupLabel: 'قائمة الفنانين', addArtist: 'إضافة فنان', artistName: 'الاسم', ticketTypes: 'أنواع التذاكر', addTicketType: 'إضافة نوع', ticketName: 'الاسم', ticketPrice: 'السعر', ticketQty: 'الكمية', ticketVIP: 'VIP', publishNow: 'نشر الآن', save: 'حفظ', cancelBtn: 'إلغاء', savingBtn: 'جارٍ الحفظ…' };
_v488_extras.ja.mymouvForm = { ..._v488_extras.ja.mymouvForm, titleNew: '新しいイベント', titleEdit: 'イベントを編集', coverLabel: 'カバー画像', importCover: 'カバーをアップロード', titleField: 'タイトル *', descField: '説明', dateField: '日付 *', timeField: '時刻', placeName: '会場名', address: '完全な住所 *', locate: '検索', securityLabel: 'セキュリティ対策', lineupLabel: 'ラインナップ', addArtist: 'アーティスト追加', ticketTypes: 'チケット種別', addTicketType: '種別を追加', ticketName: '名前', ticketPrice: '価格', ticketQty: '数量', publishNow: '今すぐ公開', save: '保存', cancelBtn: 'キャンセル', savingBtn: '保存中…' };
_v488_extras.zh.mymouvForm = { ..._v488_extras.zh.mymouvForm, titleNew: '新建活动', titleEdit: '编辑活动', coverLabel: '封面图片', importCover: '上传封面', titleField: '标题 *', descField: '描述', dateField: '日期 *', timeField: '时间', placeName: '场地名称', address: '完整地址 *', locate: '定位', securityLabel: '安全措施', lineupLabel: '演出阵容', addArtist: '添加艺人', ticketTypes: '票种', addTicketType: '添加票种', ticketName: '名称', ticketPrice: '价格', ticketQty: '数量', publishNow: '立即发布', save: '保存', cancelBtn: '取消', savingBtn: '保存中…' };
_v488_extras.ht.mymouvForm = { ..._v488_extras.ht.mymouvForm, titleNew: 'Nouvo evènman', titleEdit: 'Modifye evènman', coverLabel: 'Imaj kouvèti', importCover: 'Enpòte kouvèti a', titleField: 'Tit *', descField: 'Deskripsyon', dateField: 'Dat *', timeField: 'Lè', placeName: 'Non kote a', address: 'Adrès konplè *', locate: 'Lokalize', securityLabel: 'Mezi sekirite', lineupLabel: 'Line-up', addArtist: 'Ajoute yon atis', ticketTypes: 'Kalite tikè', addTicketType: 'Ajoute yon kalite', ticketName: 'Non', ticketPrice: 'Pri', ticketQty: 'Kantite', publishNow: 'Pibliye kounye a', save: 'Anrejistre', cancelBtn: 'Anile', savingBtn: 'N ap anrejistre…' };
// Months short — non-English
_v488_extras.es.months = { short: { jan: 'ENE', feb: 'FEB', mar: 'MAR', apr: 'ABR', may: 'MAY', jun: 'JUN', jul: 'JUL', aug: 'AGO', sep: 'SEP', oct: 'OCT', nov: 'NOV', dec: 'DIC' } };
_v488_extras.pt.months = { short: { jan: 'JAN', feb: 'FEV', mar: 'MAR', apr: 'ABR', may: 'MAI', jun: 'JUN', jul: 'JUL', aug: 'AGO', sep: 'SET', oct: 'OUT', nov: 'NOV', dec: 'DEZ' } };
_v488_extras.de.months = { short: { jan: 'JAN', feb: 'FEB', mar: 'MÄR', apr: 'APR', may: 'MAI', jun: 'JUN', jul: 'JUL', aug: 'AUG', sep: 'SEP', oct: 'OKT', nov: 'NOV', dec: 'DEZ' } };
_v488_extras.ar.months = { short: { jan: 'يناير', feb: 'فبراير', mar: 'مارس', apr: 'أبريل', may: 'مايو', jun: 'يونيو', jul: 'يوليو', aug: 'أغسطس', sep: 'سبتمبر', oct: 'أكتوبر', nov: 'نوفمبر', dec: 'ديسمبر' } };
_v488_extras.ja.months = { short: { jan: '1月', feb: '2月', mar: '3月', apr: '4月', may: '5月', jun: '6月', jul: '7月', aug: '8月', sep: '9月', oct: '10月', nov: '11月', dec: '12月' } };
_v488_extras.zh.months = { short: { jan: '1月', feb: '2月', mar: '3月', apr: '4月', may: '5月', jun: '6月', jul: '7月', aug: '8月', sep: '9月', oct: '10月', nov: '11月', dec: '12月' } };
_v488_extras.ht.months = { short: { jan: 'JAN', feb: 'FEV', mar: 'MAS', apr: 'AVR', may: 'ME', jun: 'JEN', jul: 'JIYE', aug: 'DAO', sep: 'SEP', oct: 'OKT', nov: 'NOV', dec: 'DES' } };
_v488_extras.ru.months = { short: { jan: 'ЯНВ', feb: 'ФЕВ', mar: 'МАР', apr: 'АПР', may: 'МАЙ', jun: 'ИЮН', jul: 'ИЮЛ', aug: 'АВГ', sep: 'СЕН', oct: 'ОКТ', nov: 'НОЯ', dec: 'ДЕК' } };
_v488_extras.hi.months = { short: { jan: 'जन', feb: 'फ़र', mar: 'मार्च', apr: 'अप्रै', may: 'मई', jun: 'जून', jul: 'जुला', aug: 'अग', sep: 'सित', oct: 'अक्टू', nov: 'नव', dec: 'दिस' } };
_v488_extras.nl.months = { short: { jan: 'JAN', feb: 'FEB', mar: 'MRT', apr: 'APR', may: 'MEI', jun: 'JUN', jul: 'JUL', aug: 'AUG', sep: 'SEP', oct: 'OKT', nov: 'NOV', dec: 'DEC' } };
_v488_extras.sw.months = { short: { jan: 'JAN', feb: 'FEB', mar: 'MAC', apr: 'APR', may: 'MEI', jun: 'JUN', jul: 'JUL', aug: 'AGO', sep: 'SEP', oct: 'OKT', nov: 'NOV', dec: 'DES' } };
_v488_extras.ru.mymouv = _v488_extras.ru.mymouv || { title: 'MyMouv', subtitle: 'События и концерты' };
_v488_extras.hi.mymouv = _v488_extras.hi.mymouv || { title: 'MyMouv', subtitle: 'इवेंट और कॉन्सर्ट' };
_v488_extras.nl.mymouv = _v488_extras.nl.mymouv || { title: 'MyMouv', subtitle: 'Evenementen & concerten' };
_v488_extras.sw.mymouv = _v488_extras.sw.mymouv || { title: 'MyMouv', subtitle: 'Matukio & matamasha' };
_v488_extras.es.mymouv = { title: 'MyMouv', subtitle: 'Eventos & conciertos' };
_v488_extras.pt.mymouv = { title: 'MyMouv', subtitle: 'Eventos & concertos' };
_v488_extras.de.mymouv = { title: 'MyMouv', subtitle: 'Events & Konzerte' };
_v488_extras.ar.mymouv = { title: 'MyMouv', subtitle: 'الفعاليات والحفلات' };
_v488_extras.ja.mymouv = { title: 'MyMouv', subtitle: 'イベント & コンサート' };
_v488_extras.zh.mymouv = { title: 'MyMouv', subtitle: '活动 & 演出' };
_v488_extras.ht.mymouv = { title: 'MyMouv', subtitle: 'Evènman & konsè' };
// Payout schedule (50% one week before + 100% on event day) — 13 languages
_v488_extras.fr = _v488_extras.fr || {};
_v488_extras.fr.commission = { ..._v488_extras.fr.commission, payoutScheduleTitle: 'Calendrier des versements', payoutSchedule1: '50 % du montant net est versé 1 semaine avant le jour de l\u2019événement.', payoutSchedule2: 'Les 100 % (solde) sont déclenchés le jour même de l\u2019événement.', payoutScheduleHint: 'La réception effective des fonds dépend des délais de votre banque.' };
_v488_extras.es.commission = { ..._v488_extras.es.commission, payoutScheduleTitle: 'Calendario de pagos', payoutSchedule1: 'El 50 % del importe neto se abona 1 semana antes del día del evento.', payoutSchedule2: 'El 100 % (saldo) se activa el mismo día del evento.', payoutScheduleHint: 'La recepción real de los fondos depende de los plazos de tu banco.' };
_v488_extras.pt.commission = { ..._v488_extras.pt.commission, payoutScheduleTitle: 'Calendário de pagamentos', payoutSchedule1: '50% do valor líquido é pago 1 semana antes do dia do evento.', payoutSchedule2: 'Os 100% (saldo) são liberados no próprio dia do evento.', payoutScheduleHint: 'A recepção efetiva dos fundos depende dos prazos do seu banco.' };
_v488_extras.de.commission = { ..._v488_extras.de.commission, payoutScheduleTitle: 'Auszahlungsplan', payoutSchedule1: '50 % des Nettobetrags werden 1 Woche vor dem Event ausgezahlt.', payoutSchedule2: 'Die vollen 100 % (Restbetrag) werden am Event-Tag selbst ausgelöst.', payoutScheduleHint: 'Der tatsächliche Geldeingang hängt von den Bearbeitungszeiten deiner Bank ab.' };
_v488_extras.ru.commission = { ..._v488_extras.ru.commission, payoutScheduleTitle: 'График выплат', payoutSchedule1: '50 % чистой суммы выплачивается за 1 неделю до дня мероприятия.', payoutSchedule2: 'Полные 100 % (остаток) переводятся в день самого мероприятия.', payoutScheduleHint: 'Фактическое получение средств зависит от сроков вашего банка.' };
_v488_extras.zh.commission = { ..._v488_extras.zh.commission, payoutScheduleTitle: '结款时间表', payoutSchedule1: '净额的 50% 在活动当天的前 1 周结款。', payoutSchedule2: '完整的 100%（余额）在活动当天启动结款。', payoutScheduleHint: '实际到账时间取决于您银行的处理时长。' };
_v488_extras.ja.commission = { ..._v488_extras.ja.commission, payoutScheduleTitle: '支払スケジュール', payoutSchedule1: '純額の50%はイベント当日の1週間前に支払われます。', payoutSchedule2: '残り100%（残額）はイベント当日に処理が開始されます。', payoutScheduleHint: '実際の入金は、ご利用の銀行の処理期間により異なります。' };
_v488_extras.hi.commission = { ..._v488_extras.hi.commission, payoutScheduleTitle: 'भुगतान अनुसूची', payoutSchedule1: 'शुद्ध राशि का 50% इवेंट के दिन से 1 सप्ताह पहले भुगतान किया जाता है।', payoutSchedule2: 'पूरा 100% (शेष) इवेंट के दिन ट्रिगर होता है।', payoutScheduleHint: 'धन की वास्तविक प्राप्ति आपके बैंक के प्रसंस्करण समय पर निर्भर करती है।' };
_v488_extras.nl.commission = { ..._v488_extras.nl.commission, payoutScheduleTitle: 'Uitbetalingsschema', payoutSchedule1: '50% van het nettobedrag wordt 1 week vóór de eventdag uitbetaald.', payoutSchedule2: 'De volledige 100% (saldo) wordt op de eventdag zelf geactiveerd.', payoutScheduleHint: 'De daadwerkelijke ontvangst hangt af van de verwerkingstijd van je bank.' };
_v488_extras.sw.commission = { ..._v488_extras.sw.commission, payoutScheduleTitle: 'Ratiba ya malipo', payoutSchedule1: '50 % ya kiasi halisi hulipwa wiki 1 kabla ya siku ya tukio.', payoutSchedule2: '100 % kamili (salio) huanzishwa siku ile ile ya tukio.', payoutScheduleHint: 'Kupokea fedha halisi kunategemea muda wa uchakataji wa benki yako.' };
_v488_extras.ar.commission = { ..._v488_extras.ar.commission, payoutScheduleTitle: 'جدول المدفوعات', payoutSchedule1: 'يتم دفع 50٪ من المبلغ الصافي قبل يوم الفعالية بأسبوع واحد.', payoutSchedule2: 'يتم إطلاق نسبة 100٪ الكاملة (الرصيد) في يوم الفعالية نفسه.', payoutScheduleHint: 'يعتمد الاستلام الفعلي للأموال على مدة معالجة البنك الخاص بك.' };
_v488_extras.ht.commission = { ..._v488_extras.ht.commission, payoutScheduleTitle: 'Kalandriye peman', payoutSchedule1: '50 % nan montan nèt la peye 1 semèn anvan jou evènman an.', payoutSchedule2: 'Tout 100 % la (rès la) deklanche menm jou evènman an.', payoutScheduleHint: 'Resepsyon reyèl lajan an depann de tan bank ou pou trete a.' };
// Commission model — native for main languages
_v488_extras.es.commission = { title: 'Modelo de comisión MyMouv', bullet1: 'Comisiones Stripe — 1,5 % + 0,25 € por transacción', bullet2: 'Comisión Destine — 0,75 € por entrada vendida', bullet3: 'El resto se te transfiere a tu IBAN tras validación del admin.', exampleTitle: 'Ejemplo para una entrada de 10 €', paidByFan: 'Pagado por el fan', stripeFee: 'Comisiones Stripe (1,5 % + 0,25 €)', destineFee: 'Comisión Destine (0,75 €)', netToOrg: 'Neto pagado al organizador', promoFree: 'Las entradas gratis (códigos promo, invitaciones) no generan comisiones.' };
_v488_extras.pt.commission = { title: 'Modelo de comissão MyMouv', bullet1: 'Taxas Stripe — 1,5 % + 0,25 € por transação', bullet2: 'Comissão Destine — 0,75 € por ingresso vendido', bullet3: 'O restante é transferido para o seu IBAN após validação do admin.', exampleTitle: 'Exemplo para um ingresso de 10 €', paidByFan: 'Pago pelo fã', stripeFee: 'Taxas Stripe (1,5 % + 0,25 €)', destineFee: 'Comissão Destine (0,75 €)', netToOrg: 'Líquido pago ao organizador', promoFree: 'Ingressos gratuitos (códigos promo, convites) não geram taxas.' };
_v488_extras.de.commission = { title: 'MyMouv-Provisionsmodell', bullet1: 'Stripe-Gebühren — 1,5 % + 0,25 € pro Transaktion', bullet2: 'Destine Provision — 0,75 € pro verkauftem Ticket', bullet3: 'Der Rest wird nach Admin-Validierung auf deine IBAN überwiesen.', exampleTitle: 'Beispiel für ein 10-€-Ticket', paidByFan: 'Vom Fan bezahlt', stripeFee: 'Stripe-Gebühren (1,5 % + 0,25 €)', destineFee: 'Destine Provision (0,75 €)', netToOrg: 'Netto an den Veranstalter', promoFree: 'Kostenlose Tickets (Promo-Codes, Einladungen) verursachen keine Gebühren.', reverseHint: 'Sie möchten einen bestimmten Netto-Betrag erhalten? Rückwärts-Rechnung: Ticketpreis = (gewünschter Netto + 1,00 €) ÷ 0,985. Beispiel: Um 10 € netto zu erhalten, setzen Sie den Ticketpreis auf ~11,17 € (10 € + Stripe- + Destine-Provisionen).' };
_v488_extras.ar.commission = { title: 'نموذج عمولة MyMouv', bullet1: 'رسوم Stripe — 1.5٪ + 0.25 € لكل معاملة', bullet2: 'عمولة Destine — 0.75 € لكل تذكرة مباعة', bullet3: 'يُحوَّل الباقي إلى IBAN الخاص بك بعد موافقة المشرف.', exampleTitle: 'مثال لتذكرة بـ 10 €', paidByFan: 'المبلغ المدفوع من المعجب', stripeFee: 'رسوم Stripe (1.5٪ + 0.25 €)', destineFee: 'عمولة Destine (0.75 €)', netToOrg: 'الصافي المدفوع للمنظم', promoFree: 'التذاكر المجانية (رموز ترويجية، دعوات) لا تولّد رسومًا.', reverseHint: 'هل تريد استلام صافي محدد؟ احسب بالعكس: سعر التذكرة = (الصافي المرغوب + 1.00 €) ÷ 0.985. مثال: لاستلام 10 € صافي، حدّد سعر التذكرة عند ~11.17 € (10 € + رسوم Stripe + عمولة Destine).' };
_v488_extras.ja.commission = { title: 'MyMouv 手数料モデル', bullet1: 'Stripe 手数料 — 取引ごとに 1.5% + €0.25', bullet2: 'Destine 手数料 — チケット販売あたり €0.75', bullet3: '残額は管理者承認後、IBAN に振り込まれます。', exampleTitle: '€10 チケットの例', paidByFan: 'ファンが支払った金額', stripeFee: 'Stripe 手数料 (1.5% + €0.25)', destineFee: 'Destine 手数料 (€0.75)', netToOrg: '主催者への純額', promoFree: '無料チケット（プロモコード、招待）には手数料がかかりません。', reverseHint: '希望する純額を受け取りたいですか？逆算：チケット価格 =（希望純額 + €1.00）÷ 0.985。例：€10 の純額を受け取るには、チケットを約 €11.17 に設定してください。' };
_v488_extras.ht.commission = { title: 'Modèl komisyon MyMouv', bullet1: 'Frè Stripe — 1,5 % + 0,25 € pou chak tranzaksyon', bullet2: 'Komisyon Destine — 0,75 € pou chak tikè ki vann', bullet3: 'Rès la ap voye sou IBAN ou apre validasyon admin.', exampleTitle: 'Egzanp pou yon tikè 10 €', paidByFan: 'Pri fan an peye', stripeFee: 'Frè Stripe (1,5 % + 0,25 €)', destineFee: 'Komisyon Destine (0,75 €)', netToOrg: 'Net òganizatè a resevwa', promoFree: 'Tikè gratis (kòd pwomo, envitasyon) pa jenere okenn frè.', reverseHint: 'Ou vle resevwa yon montan nèt egzak ? Kalkile alanvè : pri tikè a = (nèt ou vle a + 1,00 €) ÷ 0,985. Egzanp : pou resevwa 10 € nèt, mete pri tikè a nan ~11,17 €.' };
_v488_extras.ru = _v488_extras.ru || {};
_v488_extras.ru.commission = { title: 'Модель комиссии MyMouv', bullet1: 'Комиссии Stripe — 1,5 % + 0,25 € за транзакцию', bullet2: 'Комиссия Destine — 0,75 € за проданный билет', bullet3: 'Остаток переводится на ваш IBAN после подтверждения администратора.', exampleTitle: 'Пример для билета за 10 €', paidByFan: 'Платит фан', stripeFee: 'Комиссии Stripe (1,5 % + 0,25 €)', destineFee: 'Комиссия Destine (0,75 €)', netToOrg: 'Чистая сумма организатору', promoFree: 'Бесплатные билеты (промо-коды, приглашения) не облагаются комиссиями.', reverseHint: 'Хотите получить точную чистую сумму? Обратный расчёт: цена билета = (желаемый нетто + 1,00 €) ÷ 0,985. Пример: чтобы получить 10 € нетто, установите цену билета ~11,17 €.' };
_v488_extras.hi = _v488_extras.hi || {};
_v488_extras.hi.commission = { title: 'MyMouv कमीशन मॉडल', bullet1: 'Stripe शुल्क — प्रति लेन-देन 1.5% + €0.25', bullet2: 'Destine कमीशन — प्रति बिकी टिकट €0.75', bullet3: 'शेष राशि प्रशासक स्वीकृति के बाद आपके IBAN में स्थानांतरित होगी।', exampleTitle: '€10 टिकट का उदाहरण', paidByFan: 'फैन द्वारा भुगतान', stripeFee: 'Stripe शुल्क (1.5% + €0.25)', destineFee: 'Destine कमीशन (€0.75)', netToOrg: 'आयोजक को शुद्ध राशि', promoFree: 'निःशुल्क टिकट (प्रोमो कोड, आमंत्रण) पर कोई शुल्क नहीं।', reverseHint: 'निर्दिष्ट शुद्ध राशि प्राप्त करना चाहते हैं? उल्टी गणना: टिकट मूल्य = (वांछित शुद्ध + €1.00) ÷ 0.985। उदाहरण: €10 शुद्ध पाने के लिए, टिकट लगभग €11.17 पर सेट करें।' };
_v488_extras.nl = _v488_extras.nl || {};
_v488_extras.nl.commission = { title: 'MyMouv-commissiemodel', bullet1: 'Stripe-kosten — 1,5 % + € 0,25 per transactie', bullet2: 'Destine-commissie — € 0,75 per verkocht ticket', bullet3: 'Het restant wordt na admin-validatie op je IBAN gestort.', exampleTitle: 'Voorbeeld voor een ticket van € 10', paidByFan: 'Betaald door de fan', stripeFee: 'Stripe-kosten (1,5 % + € 0,25)', destineFee: 'Destine-commissie (€ 0,75)', netToOrg: 'Netto uitbetaald aan de organisator', promoFree: 'Gratis tickets (promocodes, uitnodigingen) genereren geen kosten.', reverseHint: 'Wil je een specifiek netto ontvangen? Reken achterwaarts: ticketprijs = (gewenste netto + € 1,00) ÷ 0,985. Voorbeeld: om € 10 netto te ontvangen, zet de ticketprijs op ~ € 11,17.' };
_v488_extras.sw = _v488_extras.sw || {};
_v488_extras.sw.commission = { title: 'Modeli ya tume MyMouv', bullet1: 'Ada za Stripe — 1.5% + €0.25 kwa muamala', bullet2: 'Tume ya Destine — €0.75 kwa tikiti iliyouzwa', bullet3: 'Salio hutumwa kwa IBAN yako baada ya idhini ya msimamizi.', exampleTitle: 'Mfano wa tikiti ya €10', paidByFan: 'Amelipwa na shabiki', stripeFee: 'Ada za Stripe (1.5% + €0.25)', destineFee: 'Tume ya Destine (€0.75)', netToOrg: 'Kiasi halisi kwa mratibu', promoFree: 'Tikiti za bure (misimbo ya kutangaza, mialiko) hazitozwi ada.', reverseHint: 'Unataka kupokea kiasi halisi mahsusi? Hesabu kinyume: bei ya tikiti = (halisi unayotaka + €1.00) ÷ 0.985. Mfano: kupata €10 halisi, weka tikiti kwa ~€11.17.' };
// Change Email — native for main languages
_v488_extras.es.changeEmail = { title: 'Cambiar dirección de email', description: 'Se enviará un código de verificación a la nueva dirección.', newEmailLabel: 'Nueva dirección', codeLabel: 'Código recibido por email', sendCode: 'Enviar código', confirm: 'Confirmar el cambio', cancel: 'Cancelar' };
_v488_extras.pt.changeEmail = { title: 'Alterar endereço de email', description: 'Um código de verificação será enviado para o novo endereço.', newEmailLabel: 'Novo endereço', codeLabel: 'Código recebido por email', sendCode: 'Enviar código', confirm: 'Confirmar alteração', cancel: 'Cancelar' };
_v488_extras.de.changeEmail = { title: 'E-Mail-Adresse ändern', description: 'Ein Bestätigungscode wird an die neue Adresse gesendet.', newEmailLabel: 'Neue Adresse', codeLabel: 'Per E-Mail erhaltener Code', sendCode: 'Code senden', confirm: 'Änderung bestätigen', cancel: 'Abbrechen' };
_v488_extras.ar.changeEmail = { title: 'تغيير عنوان البريد الإلكتروني', description: 'سيتم إرسال رمز التحقق إلى العنوان الجديد.', newEmailLabel: 'العنوان الجديد', codeLabel: 'الرمز المستلم عبر البريد', sendCode: 'إرسال الرمز', confirm: 'تأكيد التغيير', cancel: 'إلغاء' };
_v488_extras.ja.changeEmail = { title: 'メールアドレスを変更', description: '新しいアドレスに認証コードが送信されます。', newEmailLabel: '新しいアドレス', codeLabel: 'メールで受け取ったコード', sendCode: 'コードを送信', confirm: '変更を確定', cancel: 'キャンセル' };
_v488_extras.zh.changeEmail = { title: '更改邮箱地址', description: '验证码将发送至新地址。', newEmailLabel: '新地址', codeLabel: '邮件收到的验证码', sendCode: '发送验证码', confirm: '确认更改', cancel: '取消' };
_v488_extras.ht.changeEmail = { title: 'Chanje adrès imèl', description: 'Yon kòd verifikasyon ap voye sou nouvo adrès la.', newEmailLabel: 'Nouvo adrès', codeLabel: 'Kòd resevwa pa imèl', sendCode: 'Voye kòd la', confirm: 'Konfime chanjman an', cancel: 'Anile' };
// Notifications page — new namespace
_v488_extras.fr.notificationsPage = { title: 'Notifications', empty: 'Aucune notification.', markAllRead: 'Tout marquer comme lu', filterAll: 'Toutes', filterUnread: 'Non lues', deleteAll: 'Tout supprimer', deleted: 'Notification supprimée', markedRead: 'Marquée comme lue', new: 'Nouveau', message: 'Message', follow: 'Nouvel abonné', reply: 'Réponse', like: 'Nouveau j\'aime', mention: 'Mention', event: 'Événement', ticket: 'Billet', refund: 'Remboursement', promo: 'Code promo', system: 'Système' };
_v488_extras.en.notificationsPage = { title: 'Notifications', empty: 'No notifications.', markAllRead: 'Mark all as read', filterAll: 'All', filterUnread: 'Unread', deleteAll: 'Delete all', deleted: 'Notification deleted', markedRead: 'Marked as read', new: 'New', message: 'Message', follow: 'New follower', reply: 'Reply', like: 'New like', mention: 'Mention', event: 'Event', ticket: 'Ticket', refund: 'Refund', promo: 'Promo code', system: 'System' };
_v488_extras.es.notificationsPage = { title: 'Notificaciones', empty: 'Sin notificaciones.', markAllRead: 'Marcar todo como leído', filterAll: 'Todas', filterUnread: 'No leídas', deleteAll: 'Eliminar todo', deleted: 'Notificación eliminada', markedRead: 'Marcada como leída', new: 'Nuevo', message: 'Mensaje', follow: 'Nuevo seguidor', reply: 'Respuesta', like: 'Nuevo me gusta', mention: 'Mención', event: 'Evento', ticket: 'Entrada', refund: 'Reembolso', promo: 'Código promo', system: 'Sistema' };
_v488_extras.pt.notificationsPage = { title: 'Notificações', empty: 'Sem notificações.', markAllRead: 'Marcar tudo como lido', filterAll: 'Todas', filterUnread: 'Não lidas', deleteAll: 'Excluir tudo', deleted: 'Notificação excluída', markedRead: 'Marcada como lida', new: 'Nova', message: 'Mensagem', follow: 'Novo seguidor', reply: 'Resposta', like: 'Nova curtida', mention: 'Menção', event: 'Evento', ticket: 'Ingresso', refund: 'Reembolso', promo: 'Código promo', system: 'Sistema' };
_v488_extras.de.notificationsPage = { title: 'Benachrichtigungen', empty: 'Keine Benachrichtigungen.', markAllRead: 'Alle als gelesen markieren', filterAll: 'Alle', filterUnread: 'Ungelesen', deleteAll: 'Alle löschen', deleted: 'Benachrichtigung gelöscht', markedRead: 'Als gelesen markiert', new: 'Neu', message: 'Nachricht', follow: 'Neuer Follower', reply: 'Antwort', like: 'Neues Like', mention: 'Erwähnung', event: 'Event', ticket: 'Ticket', refund: 'Rückerstattung', promo: 'Promo-Code', system: 'System' };
_v488_extras.ar.notificationsPage = { title: 'الإشعارات', empty: 'لا توجد إشعارات.', markAllRead: 'تحديد الكل كمقروء', filterAll: 'الكل', filterUnread: 'غير مقروءة', deleteAll: 'حذف الكل', deleted: 'تم حذف الإشعار', markedRead: 'تم التحديد كمقروء', new: 'جديد', message: 'رسالة', follow: 'متابع جديد', reply: 'رد', like: 'إعجاب جديد', mention: 'إشارة', event: 'فعالية', ticket: 'تذكرة', refund: 'استرداد', promo: 'رمز ترويجي', system: 'النظام' };
_v488_extras.ja.notificationsPage = { title: '通知', empty: '通知はありません。', markAllRead: 'すべて既読にする', filterAll: 'すべて', filterUnread: '未読', deleteAll: 'すべて削除', deleted: '通知を削除しました', markedRead: '既読にしました', new: '新規', message: 'メッセージ', follow: '新しいフォロワー', reply: '返信', like: '新しいいいね', mention: 'メンション', event: 'イベント', ticket: 'チケット', refund: '返金', promo: 'プロモコード', system: 'システム' };
_v488_extras.zh.notificationsPage = { title: '通知', empty: '暂无通知。', markAllRead: '全部标为已读', filterAll: '全部', filterUnread: '未读', deleteAll: '全部删除', deleted: '通知已删除', markedRead: '已标为已读', new: '新', message: '消息', follow: '新粉丝', reply: '回复', like: '新赞', mention: '提及', event: '活动', ticket: '门票', refund: '退款', promo: '优惠码', system: '系统' };
_v488_extras.ht.notificationsPage = { title: 'Notifikasyon', empty: 'Pa gen notifikasyon.', markAllRead: 'Make tout kòm li', filterAll: 'Tout', filterUnread: 'Poko li', deleteAll: 'Efase tout', deleted: 'Notifikasyon efase', markedRead: 'Make kòm li', new: 'Nouvo', message: 'Mesaj', follow: 'Nouvo abòne', reply: 'Repons', like: 'Nouvo lay', mention: 'Mansyone', event: 'Evènman', ticket: 'Tikè', refund: 'Ranbousman', promo: 'Kòd pwomo', system: 'Sistèm' };
// Merge into base translations (same generic loop pattern)
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  const src = _v488_extras[lang] || _v488_extras.en;
  for (const ns of Object.keys(src)) {
    if (!translations[lang][ns]) translations[lang][ns] = {};
    Object.assign(translations[lang][ns], src[ns]);
  }
}

// =============================================================================
// WELCOME PAGE (v48 redesign) — full landing-page strings for all 13 languages.
// User requested: "S'inscrire" below "Connexion", 13-language picker under the
// signup button, new tagline, remove "Commencer maintenant", smaller hero,
// and translate every card incl. the 3 feature frames at the bottom.
// =============================================================================
const _welcome_i18n = {
  fr: {
    title: 'Tout pour réussir',
    tagline: "Destine IA est un réseau social dédié à la culture et au cinéma, avec l'une des meilleures IA vocales au monde et ses trois modèles : Déesse, GPT Guyane et GPT Africa !",
    login: 'Connexion', register: "S'inscrire", language: 'Langue', learnMore: 'En savoir plus',
    card1_title: 'Audio Narratif', card1_desc: "Le tout premier réseau social audio narratif du cinéma : faites entendre votre voix et celle des passionnés.",
    card1_i1_t: 'Gim Toli', card1_i1_d: 'vos posts audio courts',
    card1_i2_t: 'Histoires audio', card1_i2_d: 'récits longs, illustrés et téléchargeables',
    card1_i3_t: 'Podcasts', card1_i3_d: 'partagez vos émissions et trouvez votre public',
    card2_title: 'Avatars, Discussions & Actu Ciné', card2_desc: 'Une expérience sociale complète, taillée pour les amoureux du cinéma.',
    card2_i1_t: 'Avatars IA', card2_i1_d: 'créez votre double cinématographique en quelques secondes',
    card2_i2_t: 'Discussions & groupes', card2_i2_d: 'texte, vocaux, vidéos, PDF, appels voix & vidéo',
    card2_i3_t: 'Actualités cinéma', card2_i3_d: 'en temps réel',
    card2_i4_t: 'Prochaines sorties', card2_i4_d: 'au cinéma à ne pas manquer',
    card2_i5_t: 'eSIM Voyage', card2_i5_d: 'data mobile dans 200+ pays, activation instantanée',
    card2_i6_t: 'MyMouv Billetterie', card2_i6_d: 'achetez et vendez des billets d\'événements et concerts en toute sécurité',
    card3_title: 'Destine IA', card3_desc: "L'assistant intelligent intégré : discutez par texte ou voix, analyse d'émotions sur vos Gim Toli, transcription audio, recommandations cinéma et actus en temps réel.",
    mobileAvailable: 'Disponible sur mobile', downloadOn: 'Télécharger sur', availableOn: 'Disponible sur',
  },
  en: {
    title: 'Everything to succeed',
    tagline: "Destine IA is a social network dedicated to culture and cinema, with one of the best voice AIs in the world and its three models: Déesse, GPT Guyane and GPT Africa!",
    login: 'Log in', register: 'Sign up', language: 'Language', learnMore: 'Learn more',
    card1_title: 'Narrative Audio', card1_desc: "The very first narrative-audio social network for cinema: let your voice — and the voices of fans — be heard.",
    card1_i1_t: 'Gim Toli', card1_i1_d: 'your short audio posts',
    card1_i2_t: 'Audio stories', card1_i2_d: 'long, illustrated, downloadable tales',
    card1_i3_t: 'Podcasts', card1_i3_d: 'share your shows and find your audience',
    card2_title: 'Avatars, Chats & Movie News', card2_desc: 'A complete social experience, tailored for cinema lovers.',
    card2_i1_t: 'AI Avatars', card2_i1_d: 'create your cinematic alter ego in seconds',
    card2_i2_t: 'Chats & groups', card2_i2_d: 'text, voice, video, PDF, voice & video calls',
    card2_i3_t: 'Movie news', card2_i3_d: 'in real time',
    card2_i4_t: 'Upcoming releases', card2_i4_d: "movies you don't want to miss",
    card2_i5_t: 'Travel eSIM', card2_i5_d: 'mobile data in 200+ countries, instant activation',
    card2_i6_t: 'MyMouv Ticketing', card2_i6_d: 'buy and sell tickets for events and concerts securely',
    card3_title: 'Destine AI', card3_desc: 'The built-in smart assistant: chat by text or voice, emotion analysis on your Gim Toli, audio transcription, movie recommendations and live news.',
    mobileAvailable: 'Available on mobile', downloadOn: 'Download on the', availableOn: 'Get it on',
  },
  es: {
    title: 'Todo para triunfar',
    tagline: "Destine IA es una red social dedicada a la cultura y al cine, con una de las mejores IA de voz del mundo y sus tres modelos: Déesse, GPT Guyane y GPT Africa!",
    login: 'Iniciar sesión', register: 'Registrarse', language: 'Idioma', learnMore: 'Saber más',
    card1_title: 'Audio Narrativo', card1_desc: 'La primera red social de audio narrativo del cine: haz oír tu voz y la de los apasionados.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'tus publicaciones de audio breves',
    card1_i2_t: 'Historias de audio', card1_i2_d: 'relatos largos, ilustrados y descargables',
    card1_i3_t: 'Podcasts', card1_i3_d: 'comparte tus programas y encuentra tu público',
    card2_title: 'Avatares, chats y noticias de cine', card2_desc: 'Una experiencia social completa, pensada para los amantes del cine.',
    card2_i1_t: 'Avatares IA', card2_i1_d: 'crea tu doble cinematográfico en segundos',
    card2_i2_t: 'Chats y grupos', card2_i2_d: 'texto, voz, vídeo, PDF, llamadas de voz y vídeo',
    card2_i3_t: 'Noticias de cine', card2_i3_d: 'en tiempo real',
    card2_i4_t: 'Próximos estrenos', card2_i4_d: 'en cines, que no te puedes perder',
    card2_i5_t: 'eSIM de Viaje', card2_i5_d: 'datos móviles en más de 200 países, activación instantánea',
    card2_i6_t: 'Boletería MyMouv', card2_i6_d: 'compra y vende entradas para eventos y conciertos de forma segura',
    card3_title: 'Destine IA', card3_desc: 'El asistente inteligente integrado: chatea por texto o voz, análisis de emociones en tus Gim Toli, transcripción de audio, recomendaciones de cine y noticias en vivo.',
    mobileAvailable: 'Disponible en móvil', downloadOn: 'Descargar en', availableOn: 'Disponible en',
  },
  ar: {
    title: 'كل ما يلزم للنجاح',
    tagline: "Destine IA شبكة اجتماعية مخصصة للثقافة والسينما، مع أحد أفضل أنظمة الذكاء الاصطناعي الصوتية في العالم بنماذجه الثلاثة: Déesse وGPT Guyane وGPT Africa!",
    login: 'تسجيل الدخول', register: 'إنشاء حساب', language: 'اللغة', learnMore: 'اعرف المزيد',
    card1_title: 'صوت سردي', card1_desc: 'أول شبكة اجتماعية للسرد الصوتي في السينما: أَسمِع صوتك وأصوات العشاق.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'منشوراتك الصوتية القصيرة',
    card1_i2_t: 'قصص صوتية', card1_i2_d: 'حكايات طويلة، مصوّرة وقابلة للتنزيل',
    card1_i3_t: 'بودكاست', card1_i3_d: 'شارك برامجك واعثر على جمهورك',
    card2_title: 'أفاتارات ومحادثات وأخبار السينما', card2_desc: 'تجربة اجتماعية متكاملة لعشاق السينما.',
    card2_i1_t: 'أفاتار AI', card2_i1_d: 'أنشئ نسختك السينمائية في ثوانٍ',
    card2_i2_t: 'محادثات ومجموعات', card2_i2_d: 'نص، صوت، فيديو، PDF، مكالمات صوت وفيديو',
    card2_i3_t: 'أخبار السينما', card2_i3_d: 'في الوقت الحقيقي',
    card2_i4_t: 'إصدارات قادمة', card2_i4_d: 'في السينما، لا تفوّتها',
    card2_i5_t: 'شريحة eSIM للسفر', card2_i5_d: 'بيانات الجوال في أكثر من 200 دولة، تفعيل فوري',
    card2_i6_t: 'تذاكر MyMouv', card2_i6_d: 'اشترِ وبِع تذاكر الفعاليات والحفلات بأمان',
    card3_title: 'Destine AI', card3_desc: 'المساعد الذكي المدمج: دردش نصاً أو صوتاً، تحليل المشاعر، تفريغ صوتي، توصيات سينمائية وأخبار حية.',
    mobileAvailable: 'متاح على الجوال', downloadOn: 'تنزيل من', availableOn: 'متوفر على',
  },
  pt: {
    title: 'Tudo para ter sucesso',
    tagline: "Destine IA é uma rede social dedicada à cultura e ao cinema, com uma das melhores IA de voz do mundo e os seus três modelos: Déesse, GPT Guyane e GPT Africa!",
    login: 'Entrar', register: 'Inscrever-se', language: 'Idioma', learnMore: 'Saiba mais',
    card1_title: 'Áudio Narrativo', card1_desc: 'A primeira rede social de áudio narrativo do cinema: faça a sua voz e a dos apaixonados serem ouvidas.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'seus posts em áudio curtos',
    card1_i2_t: 'Histórias em áudio', card1_i2_d: 'narrativas longas, ilustradas e descarregáveis',
    card1_i3_t: 'Podcasts', card1_i3_d: 'compartilhe seus programas e encontre seu público',
    card2_title: 'Avatares, chats e notícias de cinema', card2_desc: 'Uma experiência social completa, feita para os amantes do cinema.',
    card2_i1_t: 'Avatares IA', card2_i1_d: 'crie seu duplo cinematográfico em segundos',
    card2_i2_t: 'Chats e grupos', card2_i2_d: 'texto, voz, vídeo, PDF, chamadas de voz e vídeo',
    card2_i3_t: 'Notícias de cinema', card2_i3_d: 'em tempo real',
    card2_i4_t: 'Próximos lançamentos', card2_i4_d: 'no cinema, imperdíveis',
    card2_i5_t: 'eSIM de Viagem', card2_i5_d: 'dados móveis em mais de 200 países, ativação instantânea',
    card2_i6_t: 'Bilheteria MyMouv', card2_i6_d: 'compre e venda ingressos para eventos e shows com segurança',
    card3_title: 'Destine IA', card3_desc: 'O assistente inteligente integrado: chat por texto ou voz, análise de emoções nos Gim Toli, transcrição de áudio, recomendações de cinema e notícias ao vivo.',
    mobileAvailable: 'Disponível em mobile', downloadOn: 'Baixar na', availableOn: 'Disponível no',
  },
  de: {
    title: 'Alles zum Erfolg',
    tagline: "Destine IA ist ein soziales Netzwerk für Kultur und Kino – mit einer der besten Sprach-KIs der Welt und ihren drei Modellen: Déesse, GPT Guyane und GPT Africa!",
    login: 'Anmelden', register: 'Registrieren', language: 'Sprache', learnMore: 'Mehr erfahren',
    card1_title: 'Erzählerisches Audio', card1_desc: 'Das allererste narrative Audio-Social-Network fürs Kino: lass deine Stimme und die der Fans hören.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'deine kurzen Audio-Posts',
    card1_i2_t: 'Audio-Geschichten', card1_i2_d: 'lange, illustrierte, herunterladbare Erzählungen',
    card1_i3_t: 'Podcasts', card1_i3_d: 'teile deine Sendungen und finde dein Publikum',
    card2_title: 'Avatare, Chats & Kino-News', card2_desc: 'Eine komplette Social-Erfahrung – maßgeschneidert für Kino-Fans.',
    card2_i1_t: 'KI-Avatare', card2_i1_d: 'erschaffe in Sekunden dein filmisches Alter Ego',
    card2_i2_t: 'Chats & Gruppen', card2_i2_d: 'Text, Sprache, Video, PDF, Sprach- & Videoanrufe',
    card2_i3_t: 'Kino-News', card2_i3_d: 'in Echtzeit',
    card2_i4_t: 'Kommende Kinostarts', card2_i4_d: 'die du nicht verpassen darfst',
    card2_i5_t: 'Reise-eSIM', card2_i5_d: 'mobile Daten in 200+ Ländern, sofortige Aktivierung',
    card2_i6_t: 'MyMouv Ticketing', card2_i6_d: 'kaufe und verkaufe Tickets für Veranstaltungen und Konzerte sicher',
    card3_title: 'Destine KI', card3_desc: 'Der integrierte smarte Assistent: chatte per Text oder Stimme, Emotionsanalyse auf deinen Gim Toli, Audio-Transkription, Filmempfehlungen und Live-News.',
    mobileAvailable: 'Auf dem Handy verfügbar', downloadOn: 'Laden im', availableOn: 'Jetzt bei',
  },
  ru: {
    title: 'Всё для успеха',
    tagline: "Destine IA — социальная сеть о культуре и кино с одним из лучших голосовых ИИ в мире и тремя моделями: Déesse, GPT Guyane и GPT Africa!",
    login: 'Войти', register: 'Регистрация', language: 'Язык', learnMore: 'Узнать больше',
    card1_title: 'Нарративное аудио', card1_desc: 'Первая нарративно-аудио соцсеть кино: пусть звучит ваш голос и голоса поклонников.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'ваши короткие аудиопосты',
    card1_i2_t: 'Аудио-истории', card1_i2_d: 'длинные, иллюстрированные и скачиваемые рассказы',
    card1_i3_t: 'Подкасты', card1_i3_d: 'делитесь шоу и находите свою аудиторию',
    card2_title: 'Аватары, чаты и киноновости', card2_desc: 'Полный социальный опыт для тех, кто любит кино.',
    card2_i1_t: 'ИИ-аватары', card2_i1_d: 'создайте своё киноотражение за секунды',
    card2_i2_t: 'Чаты и группы', card2_i2_d: 'текст, голос, видео, PDF, голосовые и видеозвонки',
    card2_i3_t: 'Киноновости', card2_i3_d: 'в реальном времени',
    card2_i4_t: 'Скоро в кино', card2_i4_d: 'фильмы, которые не стоит пропускать',
    card2_i5_t: 'eSIM для путешествий', card2_i5_d: 'мобильный интернет в 200+ странах, мгновенная активация',
    card2_i6_t: 'Билеты MyMouv', card2_i6_d: 'покупайте и продавайте билеты на мероприятия и концерты безопасно',
    card3_title: 'Destine ИИ', card3_desc: 'Встроенный умный помощник: чат текстом или голосом, анализ эмоций в Gim Toli, расшифровка аудио, рекомендации фильмов и живые новости.',
    mobileAvailable: 'Доступно на мобильном', downloadOn: 'Загрузить в', availableOn: 'Доступно в',
  },
  zh: {
    title: '一切为了成功',
    tagline: "Destine IA 是一个致力于文化与电影的社交网络，拥有全球最优秀的语音 AI 之一及其三大模型：Déesse、GPT Guyane 和 GPT Africa！",
    login: '登录', register: '注册', language: '语言', learnMore: '了解更多',
    card1_title: '叙事音频', card1_desc: '电影界首个叙事音频社交网络：让你和影迷的声音被听见。',
    card1_i1_t: 'Gim Toli', card1_i1_d: '你的短音频帖子',
    card1_i2_t: '音频故事', card1_i2_d: '长篇、插画、可下载',
    card1_i3_t: '播客', card1_i3_d: '分享节目，找到你的观众',
    card2_title: '头像、聊天与电影资讯', card2_desc: '为影迷量身打造的完整社交体验。',
    card2_i1_t: 'AI 头像', card2_i1_d: '几秒钟创建电影版的你',
    card2_i2_t: '聊天与群组', card2_i2_d: '文字、语音、视频、PDF、语音与视频通话',
    card2_i3_t: '电影资讯', card2_i3_d: '实时更新',
    card2_i4_t: '即将上映', card2_i4_d: '不容错过的院线大片',
    card2_i5_t: '旅行 eSIM', card2_i5_d: '覆盖 200+ 国家的移动数据，即刻激活',
    card2_i6_t: 'MyMouv 票务', card2_i6_d: '安全地购买和出售活动与音乐会门票',
    card3_title: 'Destine AI', card3_desc: '内置智能助手：文字或语音聊天、Gim Toli 情绪分析、音频转写、电影推荐和实时新闻。',
    mobileAvailable: '可在手机上使用', downloadOn: '下载于', availableOn: '获取于',
  },
  ja: {
    title: '成功のためのすべて',
    tagline: "Destine IA は文化と映画に特化した SNS。世界最高クラスの音声 AI と 3 つのモデル（Déesse、GPT Guyane、GPT Africa）を備えています！",
    login: 'ログイン', register: '登録', language: '言語', learnMore: 'もっと知る',
    card1_title: 'ナラティブ音声', card1_desc: '映画初のナラティブ音声 SNS。あなたとファンの声を響かせよう。',
    card1_i1_t: 'Gim Toli', card1_i1_d: '短い音声投稿',
    card1_i2_t: '音声ストーリー', card1_i2_d: '長編・イラスト付き・ダウンロード可',
    card1_i3_t: 'ポッドキャスト', card1_i3_d: '番組を共有して観客を見つけよう',
    card2_title: 'アバター・チャット・映画ニュース', card2_desc: '映画好きのための総合 SNS 体験。',
    card2_i1_t: 'AI アバター', card2_i1_d: '数秒で映画版の自分を作成',
    card2_i2_t: 'チャット & グループ', card2_i2_d: 'テキスト、音声、動画、PDF、音声・ビデオ通話',
    card2_i3_t: '映画ニュース', card2_i3_d: 'リアルタイム',
    card2_i4_t: '近日公開', card2_i4_d: '見逃せない映画',
    card2_i5_t: '旅行用 eSIM', card2_i5_d: '200か国以上のモバイルデータ、即時アクティベート',
    card2_i6_t: 'MyMouv チケット', card2_i6_d: 'イベントやコンサートのチケットを安全に売買',
    card3_title: 'Destine AI', card3_desc: '組み込み AI アシスタント：テキストや音声で会話、Gim Toli の感情分析、音声書き起こし、映画レコメンドとライブニュース。',
    mobileAvailable: 'モバイルで利用可', downloadOn: 'ダウンロード:', availableOn: 'で入手:',
  },
  hi: {
    title: 'सफलता के लिए सब कुछ',
    tagline: "Destine IA संस्कृति और सिनेमा को समर्पित एक सोशल नेटवर्क है, जिसमें दुनिया की सर्वश्रेष्ठ वॉयस AI में से एक और उसके तीन मॉडल हैं: Déesse, GPT Guyane और GPT Africa!",
    login: 'लॉग इन', register: 'साइन अप', language: 'भाषा', learnMore: 'और जानें',
    card1_title: 'वर्णनात्मक ऑडियो', card1_desc: 'सिनेमा का पहला वर्णनात्मक-ऑडियो सोशल नेटवर्क: अपनी और प्रशंसकों की आवाज़ सुनाइए।',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'आपकी छोटी ऑडियो पोस्ट',
    card1_i2_t: 'ऑडियो कहानियाँ', card1_i2_d: 'लंबी, सचित्र, डाउनलोड करने योग्य',
    card1_i3_t: 'पॉडकास्ट', card1_i3_d: 'अपने शो साझा करें और श्रोता पाएँ',
    card2_title: 'अवतार, चैट & सिनेमा समाचार', card2_desc: 'सिनेमा प्रेमियों के लिए संपूर्ण सोशल अनुभव।',
    card2_i1_t: 'AI अवतार', card2_i1_d: 'सेकंडों में अपना सिनेमाई रूप बनाएँ',
    card2_i2_t: 'चैट & ग्रुप', card2_i2_d: 'टेक्स्ट, वॉइस, वीडियो, PDF, वॉइस/वीडियो कॉल',
    card2_i3_t: 'सिनेमा समाचार', card2_i3_d: 'रीयल-टाइम',
    card2_i4_t: 'आगामी रिलीज़', card2_i4_d: 'सिनेमा में देखी जाने वाली फ़िल्में',
    card2_i5_t: 'यात्रा eSIM', card2_i5_d: '200+ देशों में मोबाइल डेटा, तुरंत सक्रिय',
    card2_i6_t: 'MyMouv टिकटिंग', card2_i6_d: 'इवेंट और कॉन्सर्ट के टिकट सुरक्षित रूप से खरीदें और बेचें',
    card3_title: 'Destine AI', card3_desc: 'एकीकृत स्मार्ट सहायक: टेक्स्ट/वॉइस चैट, Gim Toli पर भावनाओं का विश्लेषण, ऑडियो ट्रांसक्रिप्शन, सिनेमा सुझाव और लाइव न्यूज़।',
    mobileAvailable: 'मोबाइल पर उपलब्ध', downloadOn: 'डाउनलोड करें', availableOn: 'उपलब्ध:',
  },
  nl: {
    title: 'Alles om te slagen',
    tagline: "Destine IA is een sociaal netwerk gewijd aan cultuur en cinema, met een van de beste spraak-AI's ter wereld en zijn drie modellen: Déesse, GPT Guyane en GPT Africa!",
    login: 'Inloggen', register: 'Aanmelden', language: 'Taal', learnMore: 'Meer weten',
    card1_title: 'Narratieve audio', card1_desc: 'Het allereerste narratieve-audio sociale netwerk voor cinema: laat jouw stem en die van fans horen.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'jouw korte audio-posts',
    card1_i2_t: 'Audioverhalen', card1_i2_d: 'lange, geïllustreerde en downloadbare verhalen',
    card1_i3_t: 'Podcasts', card1_i3_d: 'deel je shows en vind je publiek',
    card2_title: 'Avatars, chats & filmnieuws', card2_desc: 'Een complete sociale ervaring, op maat voor filmliefhebbers.',
    card2_i1_t: 'AI-avatars', card2_i1_d: 'creëer in seconden jouw cinematische dubbelganger',
    card2_i2_t: 'Chats & groepen', card2_i2_d: 'tekst, spraak, video, PDF, spraak- en video-oproepen',
    card2_i3_t: 'Filmnieuws', card2_i3_d: 'in real time',
    card2_i4_t: 'Binnenkort in de bios', card2_i4_d: 'films die je niet mag missen',
    card2_i5_t: 'Reis-eSIM', card2_i5_d: 'mobiele data in 200+ landen, directe activering',
    card2_i6_t: 'MyMouv Ticketing', card2_i6_d: 'koop en verkoop tickets voor evenementen en concerten veilig',
    card3_title: 'Destine AI', card3_desc: 'De ingebouwde slimme assistent: chat via tekst of stem, emotie-analyse op je Gim Toli, audio-transcriptie, filmaanbevelingen en live nieuws.',
    mobileAvailable: 'Beschikbaar op mobiel', downloadOn: 'Download in de', availableOn: 'Verkrijgbaar via',
  },
  sw: {
    title: 'Kila kitu kwa mafanikio',
    tagline: "Destine IA ni mtandao wa kijamii wa utamaduni na sinema, wenye mojawapo ya AI bora zaidi za sauti duniani na mifano yake mitatu: Déesse, GPT Guyane na GPT Africa!",
    login: 'Ingia', register: 'Jisajili', language: 'Lugha', learnMore: 'Jifunze zaidi',
    card1_title: 'Sauti ya Hadithi', card1_desc: 'Mtandao wa kwanza wa sauti-simulizi wa sinema: acha sauti yako na ya mashabiki isikike.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'machapisho yako mafupi ya sauti',
    card1_i2_t: 'Hadithi za sauti', card1_i2_d: 'simulizi ndefu, zenye picha na zinazoweza kupakuliwa',
    card1_i3_t: 'Podikasti', card1_i3_d: 'shiriki vipindi vyako na ukutane na hadhira yako',
    card2_title: 'Avatar, mazungumzo na habari za sinema', card2_desc: 'Uzoefu kamili wa kijamii kwa wapenzi wa sinema.',
    card2_i1_t: 'Avatar za AI', card2_i1_d: 'unda nakala yako ya kisinema kwa sekunde chache',
    card2_i2_t: 'Mazungumzo & makundi', card2_i2_d: 'maandishi, sauti, video, PDF, simu za sauti na video',
    card2_i3_t: 'Habari za sinema', card2_i3_d: 'kwa wakati halisi',
    card2_i4_t: 'Filamu zinazokuja', card2_i4_d: 'filamu usizopaswa kukosa',
    card2_i5_t: 'eSIM ya Safari', card2_i5_d: 'data ya simu katika nchi 200+, uanzishaji wa papo hapo',
    card2_i6_t: 'MyMouv Tiketi', card2_i6_d: 'nunua na uza tiketi za matukio na matamasha kwa usalama',
    card3_title: 'Destine AI', card3_desc: 'Msaidizi mahiri uliojumuishwa: mazungumzo kwa maandishi/sauti, uchambuzi wa hisia kwenye Gim Toli, unukuzi wa sauti, mapendekezo ya sinema na habari za moja kwa moja.',
    mobileAvailable: 'Inapatikana kwenye simu', downloadOn: 'Pakua kwenye', availableOn: 'Inapatikana kwenye',
  },
  ht: {
    title: 'Tout sa w bezwen pou reyisi',
    tagline: "Destine IA se yon rezo sosyal dedye a kilti ak sinema, ak youn nan pi bon IA vokal nan mond lan ak twa modèl li yo: Déesse, GPT Guyane ak GPT Africa!",
    login: 'Konekte', register: 'Enskri', language: 'Lang', learnMore: 'Aprann plis',
    card1_title: 'Odyo Naratif', card1_desc: 'Premye rezo sosyal odyo-naratif sinema a : fè vwa pa w ak vwa fanatik yo tande.',
    card1_i1_t: 'Gim Toli', card1_i1_d: 'piblikasyon odyo kout ou yo',
    card1_i2_t: 'Istwa odyo', card1_i2_d: 'rakontay long, ak imaj e ki ka telechaje',
    card1_i3_t: 'Podcasts', card1_i3_d: 'pataje emisyon w yo epi jwenn odyans ou',
    card2_title: 'Avatar, Chat & Nouvèl Sinema', card2_desc: 'Yon eksperyans sosyal konplè, fèt pou moun ki renmen sinema.',
    card2_i1_t: 'Avatar AI', card2_i1_d: 'kreye doub sinematografik ou nan kèk segonn',
    card2_i2_t: 'Chat & gwoup', card2_i2_d: 'tèks, vokal, videyo, PDF, apèl vwa & videyo',
    card2_i3_t: 'Nouvèl sinema', card2_i3_d: 'an tan reyèl',
    card2_i4_t: 'Pwochen sòti', card2_i4_d: 'films nan sinema ou pa dwe rate',
    card2_i5_t: 'eSIM Vwayaj', card2_i5_d: 'done mobil nan plis pase 200 peyi, aktivasyon imedya',
    card2_i6_t: 'MyMouv Tikèt', card2_i6_d: 'achte epi vann tikè pou evènman ak konsè an tout sekirite',
    card3_title: 'Destine AI', card3_desc: 'Asistan entèlijan entegre: chat pa tèks oswa vwa, analiz emosyon sou Gim Toli ou, transkripsyon odyo, rekòmandasyon sinema ak nouvèl an dirèk.',
    mobileAvailable: 'Disponib sou mobil', downloadOn: 'Telechaje sou', availableOn: 'Disponib sou',
  },
};
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  translations[lang].welcome = _welcome_i18n[lang] || _welcome_i18n.en;
}

// =============================================================================
// ADS NAMESPACE — backfilled for all 13 languages via GPT-4o-mini
// (Emergent Universal Key). Generated by /app/backend/tools/translate_ads_i18n.py
// — only fills MISSING keys per language so existing translations stay intact.
// =============================================================================
const _ads_full_i18n = {
  es: {
    title: 'Destine Ads',
    subtitle: 'Gestiona tus anuncios y sigue tu rendimiento',
    createAd: 'Crear una publicidad',
    myAds: 'Mis publicidades',
    analytics: 'Analíticas',
    sponsorshipRequests: 'Solicitudes de patrocinio',
    myOffers: 'Mis ofertas',
    activeAds: 'Publicidades activas',
    totalImpressions: 'Impresiones totales',
    totalClicks: 'Clics totales',
    ctr: 'Tasa de clic (CTR)',
    avgCtr: 'Tasa de clic media',
    conversionRate: 'Tasa de conversión',
    adsCreated: 'Publicidades creadas',
    activeShort: 'activas',
    performanceSummary: 'Resumen del rendimiento',
    details: 'Detalles',
    perAdPerformance: 'Rendimiento por publicidad',
    myShop: 'Mi MyShop',
    sellYourProductsServices: 'Vende tus productos y servicios',
    payoutTitle: 'Datos bancarios (MyShop)',
    payoutModify: 'Modificar',
    payoutFill: 'Rellenar',
    payoutHint: 'Esta información es necesaria para recibir los pagos de tus ventas (comisión de Destine: 5 %). Solo son visibles para ti y el equipo administrador.',
    companyName: 'Razón social',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'Razón social (ej. SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'Guardar',
    saving: 'Guardando…',
    cancel: 'Cancelar',
    saved: 'Datos guardados',
    genericError: 'Error',
    noAdsYet: 'Ningún anuncio',
    noAdsHint: 'Crea tu primer anuncio para comenzar',
    statusPendingPayment: 'Pendiente de pago',
    statusApproved: 'Aprobada',
    statusActive: 'Activa',
    statusExpired: 'Caducada',
    statusPending: 'Pendiente',
    adVideo: 'Vídeo',
    adImage: 'Imagen',
    adAudio: 'Audio',
    duration: 'Duración',
    days: 'días',
    broadcastZones: 'Zonas de difusión:',
    impressions: 'Impresiones',
    clicks: 'Clics',
    delete: 'Eliminar',
    pay: 'Pagar',
    checkPayment: 'Comprobar pago',
    checking: 'Comprobando…',
    createModalTitle: 'Crear una publicidad',
    adTypeLabel: 'Tipo de publicidad',
    videoMax: 'Máx 30s, 30 MB',
    imageMax: 'Máx 5 MB',
    audioMax: 'Máx 30s, MP3',
    file: 'Archivo',
    maxDuration: 'Duración máxima: 30 segundos',
    broadcastDuration: 'Duración de difusión',
    sevenDays: '7 días',
    externalLinkOptional: 'Enlace externo (opcional)',
    sitePlaceholder: 'https://tu-sitio.com',
    externalLinkHint: 'URL hacia tu sitio, producto o servicio',
    feedVocaux: 'Feed (Vocales)',
    podcasts: 'Podcasts',
    stories: 'Historias',
    adPrice: 'Precio de la publicidad',
    videoPriceLabel: '100€ por 7 días (vídeo)',
    audioPriceLabel: '50€ por 7 días (audio)',
    imagePriceLabel: '50€ por 7 días (imagen)',
    creating: 'Creando…',
    createAndPay: 'Crear y pagar',
    selectFile: 'Por favor selecciona un archivo',
    selectAtLeastOneZone: 'Selecciona al menos una zona de difusión',
    adCreated: '¡Publicidad creada! Procede al pago.',
    createError: 'Error al crear',
    myOffersPanel: 'Mis ofertas de patrocinio',
    newOffer: 'Nueva oferta',
    noOffersYet: 'Ninguna oferta publicada. Crea una para que aparezca a los creadores al compartir.',
    offerTitleLabel: 'Título',
    offerTitlePlaceholder: 'Ej: Lanzamiento de nuestro nuevo perfume',
    offerDescLabel: 'Descripción (¿qué debe decir el creador?)',
    offerDescPlaceholder: 'Describe el producto o servicio que el creador debe mencionar…',
    offerKindsLabel: 'Tipos de contenido aceptados',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: 'Cantidad',
    offerCurrencyEUR: 'EUR',
    offerRule: 'El creador debe hablar del patrocinador durante un mínimo de 10 segundos en su Gim Toli o podcast (o simple mención en un corto). Esta regla es impuesta por Destine.',
    publishOffer: 'Publicar la oferta',
    offerTitleRequired: 'Título requerido',
    offerDescRequired: 'Descripción requerida',
    offerAmountInvalid: 'Cantidad inválida',
    offerPublished: 'Oferta publicada',
    offerDeleted: 'Oferta eliminada',
    filterAll: 'Todo',
    filterPending: 'Pendiente',
    filterAccepted: 'Aceptadas',
    filterRejected: 'Rechazadas',
    noSponsorshipRequests: 'Ninguna solicitud de patrocinio.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: 'Cortometraje',
    noCallbacks: 'Ninguna solicitud de devolución de llamada en este momento.',
    noCallbacksHint: 'Las solicitudes enviadas por los compradores sobre tus servicios aparecerán aquí.',
    client: 'Cliente',
    markCalled: 'Marcar como recordado',
    archive: 'Archivar',
    updated: 'Actualizado',
    shopAccounting: 'Contabilidad MyShop',
    detailsBtn: 'Detalles',
    gross: 'Bruto',
    commissionPct: 'Comisión',
    netReceive: 'Neto a recibir',
    salesCount: 'venta(s)',
    shopsCount: 'boutique(s)',
    netExplain: 'Neto = cifra de negocios menos la comisión de Destine.',
    back: 'Atrás',
    proOnly: 'Acceso reservado a cuentas PRO',
    loading: 'Cargando…',
    paymentChecking: 'Comprobando el pago en curso…',
    paymentConfirmed: '¡Pago confirmado!',
    paymentProcessing: 'Pago en proceso…',
    paymentCheckError: 'Error de comprobación',
    paymentCreateError: 'Error al crear el pago',
    notifications: 'Notificaciones',
    paymentCanceled: 'Pago cancelado',
    confirmDelete: '¿Realmente quieres eliminar esta publicidad?',
    adDeleted: 'Publicidad eliminada',
    deleteError: 'Error al eliminar',
    acceptedTypes: 'Tipos aceptados',
    minTalk: 'Duración mínima de hablar',
    confirmDeleteOffer: '¿Eliminar esta oferta?',
    followers: 'Seguidores',
    likes: 'Me gusta',
    plays: 'Reproducciones',
    accept: 'Aceptar',
    reject: 'Rechazar',
    sponsorAccepted: 'Patrocinio aceptado',
    sponsorRejected: 'Solicitud rechazada',
    payoutCoords: 'Datos de pago',
    holder: 'Titular',
    sponsorLinkClicks: 'Clics en enlace de patrocinador',
    publishing: 'Publicando…',
    chooseAtLeastOneKind: 'Elige al menos un tipo de contenido',
  },
  ar: {
    title: 'إعلانات Destine',
    subtitle: 'إدارة إعلاناتك وتتبع أدائك',
    createAd: 'إنشاء إعلانات',
    myAds: 'إعلاناتي',
    analytics: 'تحليل البيانات',
    sponsorshipRequests: 'طلبات الرعاية',
    myOffers: 'عروضي',
    activeAds: 'إعلانات نشطة',
    totalImpressions: 'إجمالي الظهور',
    totalClicks: 'إجمالي النقرات',
    ctr: 'نسبة النقر (CTR)',
    avgCtr: 'متوسط نسبة النقر',
    conversionRate: 'معدل التحويل',
    adsCreated: 'إعلانات تم إنشاؤها',
    activeShort: 'نشطة',
    performanceSummary: 'ملخص الأداء',
    details: 'تفاصيل',
    perAdPerformance: 'أداء كل إعلان',
    myShop: 'متجري الإلكتروني',
    sellYourProductsServices: 'بيع منتجاتك وخدماتك',
    payoutTitle: 'بيانات مصرفية (المتجر الإلكتروني)',
    payoutModify: 'تعديل',
    payoutFill: 'ملء',
    payoutHint: 'هذه المعلومات ضرورية لاستلام المدفوعات من مبيعاتك (عمولة Destine: 5%). هي مرئية فقط لك وفريق الإدارة.',
    companyName: 'الاسم التجاري',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'الاسم التجاري (مثلاً SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'حفظ',
    saving: 'جارٍ الحفظ…',
    cancel: 'إلغاء',
    saved: 'تم تسجيل البيانات',
    genericError: 'خطأ',
    noAdsYet: 'لا توجد إعلانات',
    noAdsHint: 'قم بإنشاء إعلانك الأول للبدء',
    statusPendingPayment: 'بانتظار الدفع',
    statusApproved: 'موافقة',
    statusActive: 'نشط',
    statusExpired: 'منتهي',
    statusPending: 'بانتظار',
    adVideo: 'فيديو',
    adImage: 'صورة',
    adAudio: 'صوت',
    duration: 'المدة',
    days: 'أيام',
    broadcastZones: 'مناطق البث:',
    impressions: 'الظهور',
    clicks: 'النقرات',
    delete: 'حذف',
    pay: 'ادفع',
    checkPayment: 'تحقق من الدفع',
    checking: 'جارٍ التحقق…',
    createModalTitle: 'إنشاء إعلان',
    adTypeLabel: 'نوع الإعلان',
    videoMax: 'بحد أقصى 30 ثانية، 30 ميغا بايت',
    imageMax: 'بحد أقصى 5 ميغا بايت',
    audioMax: 'بحد أقصى 30 ثانية، MP3',
    file: 'ملف',
    maxDuration: 'الحد الأقصى للمدة: 30 ثانية',
    broadcastDuration: 'مدة البث',
    sevenDays: '7 أيام',
    externalLinkOptional: 'رابط خارجي (اختياري)',
    sitePlaceholder: 'https://موقعك.com',
    externalLinkHint: 'عنوان URL لموقعك، منتجك أو خدمتك',
    feedVocaux: 'الخلاصات (المهنية)',
    podcasts: 'البودكاست',
    stories: 'القصص',
    adPrice: 'سعر الإعلان',
    videoPriceLabel: '100€ لمدة 7 أيام (فيديو)',
    audioPriceLabel: '50€ لمدة 7 أيام (صوت)',
    imagePriceLabel: '50€ لمدة 7 أيام (صورة)',
    creating: 'جارٍ الإنشاء…',
    createAndPay: 'إنشاء والدفع',
    selectFile: 'يرجى اختيار ملف',
    selectAtLeastOneZone: 'اختر منطقة بث واحدة على الأقل',
    adCreated: 'تم إنشاء الإعلان! انتقل إلى الدفع.',
    createError: 'حدث خطأ أثناء الإنشاء',
    myOffersPanel: 'عروضي للرعاية',
    newOffer: 'عرض جديد',
    noOffersYet: 'لا يوجد عروض منشورة. أنشئ واحدة لتظهر للمنشئين عند المشاركة.',
    offerTitleLabel: 'العنوان',
    offerTitlePlaceholder: 'مثال: إطلاق عطرنا الجديد',
    offerDescLabel: 'الوصف (ماذا يجب أن يقول المنشئ؟)',
    offerDescPlaceholder: 'صف المنتج أو الخدمة التي يجب على المنشئ ذكرها…',
    offerKindsLabel: 'أنواع المحتوى المقبولة',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'بودكاست',
    offerAmountPlaceholder: 'المبلغ',
    offerCurrencyEUR: 'EUR',
    offerRule: 'يجب على المنشئ التحدث عن الراعي لمدة 10 ثوانٍ على الأقل في Gim Toli الخاص به أو البودكاست (أو ذكر بسيط في الفيلم القصير). هذه القاعدة مفروضة من قبل Destine.',
    publishOffer: 'نشر العرض',
    offerTitleRequired: 'العنوان مطلوب',
    offerDescRequired: 'الوصف مطلوب',
    offerAmountInvalid: 'مبلغ غير صالح',
    offerPublished: 'تم نشر العرض',
    offerDeleted: 'تم حذف العرض',
    filterAll: 'الكل',
    filterPending: 'بانتظار',
    filterAccepted: 'مقبولة',
    filterRejected: 'مرفوضة',
    noSponsorshipRequests: 'لا توجد طلبات للرعاية.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'بودكاست',
    kindShortFilm: 'فيلم قصير',
    noCallbacks: 'لا توجد طلبات إعادة اتصال في الوقت الحالي.',
    noCallbacksHint: 'سيظهر الطلبات المرسلة من المشترين على خدماتك هنا.',
    client: 'عميل',
    markCalled: 'تحديد كتم الاتصال',
    archive: 'أرشفة',
    updated: 'تم التحديث',
    shopAccounting: 'محاسبة المتجر الإلكتروني',
    detailsBtn: 'تفاصيل',
    gross: 'إجمالي',
    commissionPct: 'العمولة',
    netReceive: 'صافي يستقبل',
    salesCount: 'عملية بيع(ات)',
    shopsCount: 'متجر(ات)',
    netExplain: 'صافي = إيرادات ناقص عمولة Destine.',
    back: 'عودة',
    proOnly: 'الوصول مقصور على حسابات PRO',
    loading: 'جارٍ التحميل…',
    paymentChecking: 'جارٍ التحقق من الدفع…',
    paymentConfirmed: 'تم تأكيد الدفع!',
    paymentProcessing: 'جارٍ معالجة الدفع…',
    paymentCheckError: 'خطأ في التحقق',
    paymentCreateError: 'خطأ أثناء إنشاء الدفع',
    notifications: 'الإشعارات',
    paymentCanceled: 'تم إلغاء الدفع',
    confirmDelete: 'هل أنت متأكد أنك تريد حذف هذا الإعلان؟',
    adDeleted: 'تم حذف الإعلان',
    deleteError: 'حدث خطأ أثناء الحذف',
    acceptedTypes: 'أنواع مقبولة',
    minTalk: 'المدة المدفوعة الأدنى',
    confirmDeleteOffer: 'هل تريد حذف هذا العرض؟',
    followers: 'المتابعون',
    likes: 'الإعجابات',
    plays: 'المرات التشغيل',
    accept: 'قبول',
    reject: 'رفض',
    sponsorAccepted: 'تم قبول الرعاية',
    sponsorRejected: 'تم رفض الطلب',
    payoutCoords: 'بيانات الدفع',
    holder: 'المالك',
    sponsorLinkClicks: 'النقرات على رابط الراعي',
    publishing: 'جارٍ النشر…',
    chooseAtLeastOneKind: 'اختر نوع محتوى واحد على الأقل',
  },
  pt: {
    title: 'Destine Ads',
    subtitle: 'Gerencie seus anúncios e acompanhe seu desempenho',
    createAd: 'Criar um anúncio',
    myAds: 'Meus anúncios',
    analytics: 'Análise',
    sponsorshipRequests: 'Solicitações de patrocínio',
    myOffers: 'Minhas ofertas',
    activeAds: 'Anúncios ativos',
    totalImpressions: 'Impressões totais',
    totalClicks: 'Cliques totais',
    ctr: 'Taxa de clique (CTR)',
    avgCtr: 'Taxa de clique média',
    conversionRate: 'Taxa de conversão',
    adsCreated: 'Anúncios criados',
    activeShort: 'ativas',
    performanceSummary: 'Resumo de desempenho',
    details: 'Detalhes',
    perAdPerformance: 'Desempenho por anúncio',
    myShop: 'Minha MyShop',
    sellYourProductsServices: 'Venda seus produtos e serviços',
    payoutTitle: 'Informações bancárias (MyShop)',
    payoutModify: 'Modificar',
    payoutFill: 'Preencher',
    payoutHint: 'Essas informações são necessárias para receber os pagamentos de suas vendas (comissão Destine: 5%). Elas são visíveis apenas para você e a equipe admin.',
    companyName: 'Razão social',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'Razão social (ex. SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    saved: 'Informações salvas',
    genericError: 'Erro',
    noAdsYet: 'Nenhum anúncio',
    noAdsHint: 'Crie seu primeiro anúncio para começar',
    statusPendingPayment: 'Aguardando pagamento',
    statusApproved: 'Aprovada',
    statusActive: 'Ativa',
    statusExpired: 'Expirada',
    statusPending: 'Aguardando',
    adVideo: 'Vídeo',
    adImage: 'Imagem',
    adAudio: 'Áudio',
    duration: 'Duração',
    days: 'dias',
    broadcastZones: 'Zonas de transmissão:',
    impressions: 'Impressões',
    clicks: 'Cliques',
    delete: 'Excluir',
    pay: 'Pagar',
    checkPayment: 'Verificar pagamento',
    checking: 'Verificando…',
    createModalTitle: 'Criar um anúncio',
    adTypeLabel: 'Tipo de anúncio',
    videoMax: 'Máx 30s, 30 MB',
    imageMax: 'Máx 5 MB',
    audioMax: 'Máx 30s, MP3',
    file: 'Arquivo',
    maxDuration: 'Duração máxima: 30 segundos',
    broadcastDuration: 'Duração de transmissão',
    sevenDays: '7 dias',
    externalLinkOptional: 'Link externo (opcional)',
    sitePlaceholder: 'https://seu-site.com',
    externalLinkHint: 'URL para seu site, produto ou serviço',
    feedVocaux: 'Feed (Vocais)',
    podcasts: 'Podcasts',
    stories: 'Stories',
    adPrice: 'Preço do anúncio',
    videoPriceLabel: '100€ por 7 dias (vídeo)',
    audioPriceLabel: '50€ por 7 dias (áudio)',
    imagePriceLabel: '50€ por 7 dias (imagem)',
    creating: 'Criando…',
    createAndPay: 'Criar e pagar',
    selectFile: 'Por favor, selecione um arquivo',
    selectAtLeastOneZone: 'Selecione pelo menos uma zona de transmissão',
    adCreated: 'Anúncio criado! Proceda ao pagamento.',
    createError: 'Erro ao criar',
    myOffersPanel: 'Minhas ofertas de patrocínio',
    newOffer: 'Nova oferta',
    noOffersYet: 'Nenhuma oferta publicada. Crie uma para que apareça aos criadores durante o compartilhamento.',
    offerTitleLabel: 'Título',
    offerTitlePlaceholder: 'Ex: Lançamento do nosso novo perfume',
    offerDescLabel: 'Descrição (o que o criador deve dizer?)',
    offerDescPlaceholder: 'Descreva o produto ou serviço que o criador deve mencionar…',
    offerKindsLabel: 'Tipos de conteúdo aceitos',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: 'Valor',
    offerCurrencyEUR: 'EUR',
    offerRule: 'O criador deve falar sobre o patrocinador por no mínimo 10 segundos em seu Gim Toli ou podcast (ou simples menção em filme curto). Esta regra é imposta pela Destine.',
    publishOffer: 'Publicar a oferta',
    offerTitleRequired: 'Título necessário',
    offerDescRequired: 'Descrição necessária',
    offerAmountInvalid: 'Valor inválido',
    offerPublished: 'Oferta publicada',
    offerDeleted: 'Oferta excluída',
    filterAll: 'Tudo',
    filterPending: 'Aguardando',
    filterAccepted: 'Aceitas',
    filterRejected: 'Recusadas',
    noSponsorshipRequests: 'Nenhuma solicitação de patrocínio.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: 'Filme curto',
    noCallbacks: 'Nenhuma solicitação de retorno no momento.',
    noCallbacksHint: 'As solicitações enviadas pelos compradores em seus serviços aparecerão aqui.',
    client: 'Cliente',
    markCalled: 'Marcar como retornado',
    archive: 'Arquivar',
    updated: 'Atualizado',
    shopAccounting: 'Contabilidade MyShop',
    detailsBtn: 'Detalhes',
    gross: 'Bruto',
    commissionPct: 'Comissão',
    netReceive: 'Líquido a receber',
    salesCount: 'venda(s)',
    shopsCount: 'boutique(s)',
    netExplain: 'Líquido = receita menos a comissão da Destine.',
    back: 'Voltar',
    proOnly: 'Acesso reservado a contas PRO',
    loading: 'Carregando…',
    paymentChecking: 'Verificação do pagamento em andamento…',
    paymentConfirmed: 'Pagamento confirmado!',
    paymentProcessing: 'Pagamento em processamento…',
    paymentCheckError: 'Erro na verificação',
    paymentCreateError: 'Erro ao criar o pagamento',
    notifications: 'Notificações',
    paymentCanceled: 'Pagamento cancelado',
    confirmDelete: 'Você realmente deseja excluir este anúncio?',
    adDeleted: 'Anúncio excluído',
    deleteError: 'Erro ao excluir',
    acceptedTypes: 'Tipos aceitos',
    minTalk: 'Duração mínima de fala',
    confirmDeleteOffer: 'Excluir esta oferta?',
    followers: 'Seguidores',
    likes: 'Likes',
    plays: 'Reproduções',
    accept: 'Aceitar',
    reject: 'Recusar',
    sponsorAccepted: 'Patrocínio aceito',
    sponsorRejected: 'Solicitação recusada',
    payoutCoords: 'Informações de pagamento',
    holder: 'Titular',
    sponsorLinkClicks: 'Cliques no link do patrocinador',
    publishing: 'Publicação…',
    chooseAtLeastOneKind: 'Escolha pelo menos um tipo de conteúdo',
  },
  de: {
    title: 'Destine Ads',
    subtitle: 'Verwalten Sie Ihre Werbung und verfolgen Sie Ihre Leistungen',
    createAd: 'Eine Werbung erstellen',
    myAds: 'Meine Werbung',
    analytics: 'Analytik',
    sponsorshipRequests: 'Sponsoring-Anfragen',
    myOffers: 'Meine Angebote',
    activeAds: 'Aktive Werbung',
    totalImpressions: 'Gesamtimpressionen',
    totalClicks: 'Gesamtanzahl der Klicks',
    ctr: 'Klickrate (CTR)',
    avgCtr: 'Durchschnittliche Klickrate',
    conversionRate: 'Konversionsrate',
    adsCreated: 'Erstellte Werbung',
    activeShort: 'aktiv',
    performanceSummary: 'Leistungszusammenfassung',
    details: 'Details',
    perAdPerformance: 'Leistung pro Werbung',
    myShop: 'Mein MyShop',
    sellYourProductsServices: 'Verkaufen Sie Ihre Produkte & Dienstleistungen',
    payoutTitle: 'Bankverbindung (MyShop)',
    payoutModify: 'Ändern',
    payoutFill: 'Ausfüllen',
    payoutHint: 'Diese Informationen sind erforderlich, um Zahlungen aus Ihren Verkäufen zu erhalten (Provision von Destine: 5 %). Sie sind nur für Sie und das Admin-Team sichtbar.',
    companyName: 'Unternehmensname',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'Unternehmensname (z.B. SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'Speichern',
    saving: 'Speichern…',
    cancel: 'Abbrechen',
    saved: 'Daten gespeichert',
    genericError: 'Fehler',
    noAdsYet: 'Keine Werbung',
    noAdsHint: 'Erstellen Sie Ihre erste Werbung, um zu beginnen',
    statusPendingPayment: 'Zahlung ausstehend',
    statusApproved: 'Genehmigt',
    statusActive: 'Aktiv',
    statusExpired: 'Abgelaufen',
    statusPending: 'Ausstehend',
    adVideo: 'Video',
    adImage: 'Bild',
    adAudio: 'Audio',
    duration: 'Dauer',
    days: 'Tage',
    broadcastZones: 'Sendegebiete:',
    impressions: 'Impressionen',
    clicks: 'Klicks',
    delete: 'Löschen',
    pay: 'Bezahlen',
    checkPayment: 'Zahlung prüfen',
    checking: 'Prüfung…',
    createModalTitle: 'Eine Werbung erstellen',
    adTypeLabel: 'Werbetyp',
    videoMax: 'Max 30s, 30 MB',
    imageMax: 'Max 5 MB',
    audioMax: 'Max 30s, MP3',
    file: 'Datei',
    maxDuration: 'Maximale Dauer: 30 Sekunden',
    broadcastDuration: 'Sendelänge',
    sevenDays: '7 Tage',
    externalLinkOptional: 'Externer Link (optional)',
    sitePlaceholder: 'https://ihre-seite.com',
    externalLinkHint: 'URL zu Ihrer Seite, Produkt oder Dienstleistung',
    feedVocaux: 'Feed (Vokale)',
    podcasts: 'Podcasts',
    stories: 'Stories',
    adPrice: 'Preis der Werbung',
    videoPriceLabel: '100€ für 7 Tage (Video)',
    audioPriceLabel: '50€ für 7 Tage (Audio)',
    imagePriceLabel: '50€ für 7 Tage (Bild)',
    creating: 'Erstellung…',
    createAndPay: 'Erstellen und bezahlen',
    selectFile: 'Bitte wählen Sie eine Datei aus',
    selectAtLeastOneZone: 'Wählen Sie mindestens ein Sendegebiet aus',
    adCreated: 'Werbung erstellt! Fahren Sie mit der Zahlung fort.',
    createError: 'Fehler bei der Erstellung',
    myOffersPanel: 'Meine Sponsoring-Angebote',
    newOffer: 'Neues Angebot',
    noOffersYet: 'Kein Angebot veröffentlicht. Erstellen Sie eines, damit es den Erstellern beim Teilen angezeigt wird.',
    offerTitleLabel: 'Titel',
    offerTitlePlaceholder: 'Z.B.: Einführung unseres neuen Parfums',
    offerDescLabel: 'Beschreibung (was soll der Ersteller sagen?)',
    offerDescPlaceholder: 'Beschreiben Sie das Produkt oder die Dienstleistung, die der Ersteller erwähnen soll…',
    offerKindsLabel: 'Akzeptierte Inhaltsarten',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: 'Betrag',
    offerCurrencyEUR: 'EUR',
    offerRule: 'Der Ersteller muss mindestens 10 Sekunden lang über den Sponsor in seinem Gim Toli oder Podcast sprechen (oder einfache Erwähnung im Kurzfilm). Diese Regel wird von Destine durchgesetzt.',
    publishOffer: 'Angebot veröffentlichen',
    offerTitleRequired: 'Titel erforderlich',
    offerDescRequired: 'Beschreibung erforderlich',
    offerAmountInvalid: 'Ungültiger Betrag',
    offerPublished: 'Angebot veröffentlicht',
    offerDeleted: 'Angebot gelöscht',
    filterAll: 'Alle',
    filterPending: 'Ausstehend',
    filterAccepted: 'Akzeptiert',
    filterRejected: 'Abgelehnt',
    noSponsorshipRequests: 'Keine Sponsoring-Anfragen.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: 'Kurzfilm',
    noCallbacks: 'Keine Rückrufanfragen im Moment.',
    noCallbacksHint: 'Anfragen von Käufern zu Ihren Dienstleistungen werden hier angezeigt.',
    client: 'Kunde',
    markCalled: 'Als zurückgerufen markieren',
    archive: 'Archivieren',
    updated: 'Aktualisiert',
    shopAccounting: 'Buchhaltung MyShop',
    detailsBtn: 'Details',
    gross: 'Brutto',
    commissionPct: 'Provision',
    netReceive: 'Netto zu erhalten',
    salesCount: 'Verkauf(e)',
    shopsCount: 'Boutique(n)',
    netExplain: 'Netto = Umsatz minus die Provision von Destine.',
    back: 'Zurück',
    proOnly: 'Zugang nur für PRO-Konten',
    loading: 'Laden…',
    paymentChecking: 'Zahlungsprüfung wird durchgeführt…',
    paymentConfirmed: 'Zahlung bestätigt!',
    paymentProcessing: 'Zahlung wird bearbeitet…',
    paymentCheckError: 'Überprüfungsfehler',
    paymentCreateError: 'Fehler bei der Erstellung der Zahlung',
    notifications: 'Benachrichtigungen',
    paymentCanceled: 'Zahlung abgebrochen',
    confirmDelete: 'Möchten Sie diese Werbung wirklich löschen?',
    adDeleted: 'Werbung gelöscht',
    deleteError: 'Fehler beim Löschen',
    acceptedTypes: 'Akzeptierte Typen',
    minTalk: 'Minimale Sprechdauer',
    confirmDeleteOffer: 'Dieses Angebot löschen?',
    followers: 'Abonnenten',
    likes: 'Likes',
    plays: 'Aufrufe',
    accept: 'Akzeptieren',
    reject: 'Ablehnen',
    sponsorAccepted: 'Sponsoring akzeptiert',
    sponsorRejected: 'Anfrage abgelehnt',
    payoutCoords: 'Zahlungsdaten',
    holder: 'Inhaber',
    sponsorLinkClicks: 'Klicks auf den Sponsor-Link',
    publishing: 'Veröffentlichung…',
    chooseAtLeastOneKind: 'Wählen Sie mindestens einen Inhaltstyp',
  },
  ru: {
    title: 'Реклама Destine',
    subtitle: 'Управляйте вашей рекламой и следите за результатами',
    createAd: 'Создать рекламу',
    myAds: 'Мои рекламы',
    analytics: 'Аналитика',
    sponsorshipRequests: 'Запросы на спонсорство',
    myOffers: 'Мои предложения',
    activeAds: 'Активные рекламы',
    totalImpressions: 'Общее количество показов',
    totalClicks: 'Общее количество кликов',
    ctr: 'Коэффициент кликабельности (CTR)',
    avgCtr: 'Средний коэффициент кликабельности',
    conversionRate: 'Коэффициент конверсии',
    adsCreated: 'Созданные рекламы',
    activeShort: 'активные',
    performanceSummary: 'Итоги производительности',
    details: 'Подробности',
    perAdPerformance: 'Производительность по рекламе',
    myShop: 'Мой MyShop',
    sellYourProductsServices: 'Продавайте свои товары и услуги',
    payoutTitle: 'Банковские реквизиты (MyShop)',
    payoutModify: 'Изменить',
    payoutFill: 'Заполнить',
    payoutHint: 'Эта информация необходима для получения платежей за ваши продажи (комиссия Destine: 5 %). Она видна только вам и команде администраторов.',
    companyName: 'Название компании',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'Название компании (например, ООО Магазин XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'Сохранить',
    saving: 'Сохранение…',
    cancel: 'Отмена',
    saved: 'Реквизиты сохранены',
    genericError: 'Ошибка',
    noAdsYet: 'Нет рекламы',
    noAdsHint: 'Создайте свою первую рекламу, чтобы начать',
    statusPendingPayment: 'Ожидает оплаты',
    statusApproved: 'Одобрено',
    statusActive: 'Активно',
    statusExpired: 'Просрочено',
    statusPending: 'В ожидании',
    adVideo: 'Видео',
    adImage: 'Изображение',
    adAudio: 'Аудио',
    duration: 'Длительность',
    days: 'дней',
    broadcastZones: 'Зоны трансляции:',
    impressions: 'Показы',
    clicks: 'Клики',
    delete: 'Удалить',
    pay: 'Оплатить',
    checkPayment: 'Проверить оплату',
    checking: 'Проверка…',
    createModalTitle: 'Создать рекламу',
    adTypeLabel: 'Тип рекламы',
    videoMax: 'Макс 30с, 30 MB',
    imageMax: 'Макс 5 MB',
    audioMax: 'Макс 30с, MP3',
    file: 'Файл',
    maxDuration: 'Максимальная длительность: 30 секунд',
    broadcastDuration: 'Длительность трансляции',
    sevenDays: '7 дней',
    externalLinkOptional: 'Внешняя ссылка (по желанию)',
    sitePlaceholder: 'https://ваш-сайт.com',
    externalLinkHint: 'URL на ваш сайт, продукт или услугу',
    feedVocaux: 'Лента (Голосовые)',
    podcasts: 'Подкасты',
    stories: 'Истории',
    adPrice: 'Цена рекламы',
    videoPriceLabel: '100€ за 7 дней (видео)',
    audioPriceLabel: '50€ за 7 дней (аудио)',
    imagePriceLabel: '50€ за 7 дней (изображение)',
    creating: 'Создание…',
    createAndPay: 'Создать и оплатить',
    selectFile: 'Пожалуйста, выберите файл',
    selectAtLeastOneZone: 'Выберите хотя бы одну зону трансляции',
    adCreated: 'Реклама создана! Перейдите к оплате.',
    createError: 'Ошибка при создании',
    myOffersPanel: 'Мои предложения спонсорства',
    newOffer: 'Новое предложение',
    noOffersYet: 'Нет опубликованных предложений. Создайте одно, чтобы оно появилось у авторов при делении.',
    offerTitleLabel: 'Заголовок',
    offerTitlePlaceholder: 'Например: Запуск нашего нового парфюма',
    offerDescLabel: 'Описание (что должен сказать автор?)',
    offerDescPlaceholder: 'Опишите продукт или услугу, которую автор должен упомянуть…',
    offerKindsLabel: 'Типы контента, допускаемые',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: 'Сумма',
    offerCurrencyEUR: 'EUR',
    offerRule: 'Автор должен говорить о спонсоре не менее 10 секунд в своем Gim Toli или подкасте (или просто упоминание в коротком фильме). Это правило установлено Destine.',
    publishOffer: 'Опубликовать предложение',
    offerTitleRequired: 'Заголовок обязателен',
    offerDescRequired: 'Описание обязательно',
    offerAmountInvalid: 'Недопустимая сумма',
    offerPublished: 'Предложение опубликовано',
    offerDeleted: 'Предложение удалено',
    filterAll: 'Все',
    filterPending: 'В ожидании',
    filterAccepted: 'Принятые',
    filterRejected: 'Отклоненные',
    noSponsorshipRequests: 'Нет запросов на спонсорство.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: 'Короткометражный фильм',
    noCallbacks: 'Нет запросов на обратный звонок в данный момент.',
    noCallbacksHint: 'Запросы, отправленные покупателями на ваши услуги, появятся здесь.',
    client: 'Клиент',
    markCalled: 'Отметить как перезвоненный',
    archive: 'Архивировать',
    updated: 'Обновлено',
    shopAccounting: 'Учет продаж в MyShop',
    detailsBtn: 'Подробности',
    gross: 'Брутто',
    commissionPct: 'Комиссия',
    netReceive: 'Чистый к получению',
    salesCount: 'продаж(и)',
    shopsCount: 'магазин(ы)',
    netExplain: 'Чистый = оборот минус комиссия Destine.',
    back: 'Назад',
    proOnly: 'Доступ только для PRO аккаунтов',
    loading: 'Загрузка…',
    paymentChecking: 'Проверка оплаты…',
    paymentConfirmed: 'Оплата подтверждена!',
    paymentProcessing: 'Обработка оплаты…',
    paymentCheckError: 'Ошибка проверки',
    paymentCreateError: 'Ошибка при создании платежа',
    notifications: 'Уведомления',
    paymentCanceled: 'Оплата отменена',
    confirmDelete: 'Вы уверены, что хотите удалить эту рекламу?',
    adDeleted: 'Реклама удалена',
    deleteError: 'Ошибка при удалении',
    acceptedTypes: 'Допустимые типы',
    minTalk: 'Минимальное время разговора',
    confirmDeleteOffer: 'Удалить это предложение?',
    followers: 'Подписчики',
    likes: 'Лайки',
    plays: 'Прослушивания',
    accept: 'Принять',
    reject: 'Отклонить',
    sponsorAccepted: 'Спонсорство принято',
    sponsorRejected: 'Запрос отклонен',
    payoutCoords: 'Реквизиты для выплаты',
    holder: 'Владелец',
    sponsorLinkClicks: 'Клики по ссылке спонсора',
    publishing: 'Публикация…',
    chooseAtLeastOneKind: 'Выберите как минимум один тип контента',
  },
  zh: {
    title: 'Destine 广告',
    subtitle: '管理您的广告并跟踪您的表现',
    createAd: '创建广告',
    myAds: '我的广告',
    analytics: '分析',
    sponsorshipRequests: '赞助请求',
    myOffers: '我的报价',
    activeAds: '激活的广告',
    totalImpressions: '总印象',
    totalClicks: '总点击',
    ctr: '点击率 (CTR)',
    avgCtr: '平均点击率',
    conversionRate: '转化率',
    adsCreated: '创建的广告',
    activeShort: '活跃',
    performanceSummary: '表现总结',
    details: '详情',
    perAdPerformance: '每个广告的表现',
    myShop: '我的 MyShop',
    sellYourProductsServices: '出售您的产品与服务',
    payoutTitle: '银行账户信息 (MyShop)',
    payoutModify: '修改',
    payoutFill: '填写',
    payoutHint: '这些信息对于接收您销售的付款是必要的（Destine 佣金：5%）。这些信息仅对您和管理员团队可见。',
    companyName: '公司名称',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: '公司名称（例如：SARL Boutique XYZ）',
    bicPlaceholder: 'BIC / SWIFT',
    save: '保存',
    saving: '保存中…',
    cancel: '取消',
    saved: '信息已保存',
    genericError: '错误',
    noAdsYet: '没有广告',
    noAdsHint: '创建您的第一条广告以开始',
    statusPendingPayment: '待付款',
    statusApproved: '已批准',
    statusActive: '活跃',
    statusExpired: '已过期',
    statusPending: '待处理',
    adVideo: '视频',
    adImage: '图片',
    adAudio: '音频',
    duration: '时长',
    days: '天',
    broadcastZones: '播出区域：',
    impressions: '印象',
    clicks: '点击',
    delete: '删除',
    pay: '支付',
    checkPayment: '检查付款',
    checking: '检查中…',
    createModalTitle: '创建广告',
    adTypeLabel: '广告类型',
    videoMax: '最大 30 秒，30 MB',
    imageMax: '最大 5 MB',
    audioMax: '最大 30 秒，MP3',
    file: '文件',
    maxDuration: '最大时长：30 秒',
    broadcastDuration: '播出时长',
    sevenDays: '7 天',
    externalLinkOptional: '外部链接（可选）',
    sitePlaceholder: 'https://您的网站.com',
    externalLinkHint: '指向您的网站、产品或服务的 URL',
    feedVocaux: 'Feed (语音)',
    podcasts: '播客',
    stories: '故事',
    adPrice: '广告价格',
    videoPriceLabel: '100€ 为期 7 天（视频）',
    audioPriceLabel: '50€ 为期 7 天（音频）',
    imagePriceLabel: '50€ 为期 7 天（图片）',
    creating: '创建中…',
    createAndPay: '创建并支付',
    selectFile: '请选择一个文件',
    selectAtLeastOneZone: '请选择至少一个播出区域',
    adCreated: '广告已创建！请进行支付。',
    createError: '创建时错误',
    myOffersPanel: '我的赞助报价',
    newOffer: '新报价',
    noOffersYet: '没有发布的报价。创建一个以便其在分享时出现在创作者那里。',
    offerTitleLabel: '标题',
    offerTitlePlaceholder: '例如：推出我们的新香水',
    offerDescLabel: '描述（创作者需要说什么？）',
    offerDescPlaceholder: '描述创作者需要提到的产品或服务…',
    offerKindsLabel: '接受的内容类型',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: '播客',
    offerAmountPlaceholder: '金额',
    offerCurrencyEUR: 'EUR',
    offerRule: '创作者必须在其 Gim Toli 或播客中至少讲述赞助商 10 秒（或在短片中简单提及）。此规则由 Destine 强制执行。',
    publishOffer: '发布报价',
    offerTitleRequired: '标题必填',
    offerDescRequired: '描述必填',
    offerAmountInvalid: '金额无效',
    offerPublished: '报价已发布',
    offerDeleted: '报价已删除',
    filterAll: '所有',
    filterPending: '待处理',
    filterAccepted: '已接受',
    filterRejected: '已拒绝',
    noSponsorshipRequests: '没有赞助请求。',
    kindGimToli: 'Gim Toli',
    kindPodcast: '播客',
    kindShortFilm: '短片',
    noCallbacks: '当前没有回调请求。',
    noCallbacksHint: '买家对您的服务发送的请求将在这里显示。',
    client: '客户',
    markCalled: '标记为已回拨',
    archive: '归档',
    updated: '已更新',
    shopAccounting: 'MyShop 会计',
    detailsBtn: '详情',
    gross: '毛收入',
    commissionPct: '佣金',
    netReceive: '净收入',
    salesCount: '销售',
    shopsCount: '商店',
    netExplain: '净收入 = 营业额减去 Destine 佣金。',
    back: '返回',
    proOnly: '仅限 PRO 账户访问',
    loading: '加载中…',
    paymentChecking: '付款检查中…',
    paymentConfirmed: '付款已确认！',
    paymentProcessing: '付款处理中…',
    paymentCheckError: '检查错误',
    paymentCreateError: '创建付款时错误',
    notifications: '通知',
    paymentCanceled: '付款已取消',
    confirmDelete: '您真的要删除此广告吗？',
    adDeleted: '广告已删除',
    deleteError: '删除时错误',
    acceptedTypes: '接受的类型',
    minTalk: '最少谈话时长',
    confirmDeleteOffer: '删除此报价？',
    followers: '关注者',
    likes: '点赞',
    plays: '播放',
    accept: '接受',
    reject: '拒绝',
    sponsorAccepted: '赞助已接受',
    sponsorRejected: '请求已拒绝',
    payoutCoords: '付款信息',
    holder: '持有人',
    sponsorLinkClicks: '点击赞助链接',
    publishing: '发布中…',
    chooseAtLeastOneKind: '请选择至少一种内容类型',
  },
  ja: {
    title: 'Destine 広告',
    subtitle: '広告を管理し、パフォーマンスを追跡する',
    createAd: '広告を作成する',
    myAds: '私の広告',
    analytics: 'アナリティクス',
    sponsorshipRequests: 'スポンサーシップリクエスト',
    myOffers: '私のオファー',
    activeAds: 'アクティブな広告',
    totalImpressions: '合計インプレッション',
    totalClicks: '合計クリック',
    ctr: 'クリック率 (CTR)',
    avgCtr: '平均クリック率',
    conversionRate: 'コンバージョン率',
    adsCreated: '作成された広告',
    activeShort: 'アクティブ',
    performanceSummary: 'パフォーマンス概要',
    details: '詳細',
    perAdPerformance: '広告ごとのパフォーマンス',
    myShop: '私の MyShop',
    sellYourProductsServices: 'あなたの商品とサービスを販売する',
    payoutTitle: '銀行口座情報 (MyShop)',
    payoutModify: '変更する',
    payoutFill: '情報を入力する',
    payoutHint: 'これらの情報は、あなたの販売からの支払いを受け取るために必要です (Destine の手数料：5%)。あなたと管理チームだけが見ることができます。',
    companyName: '法人名',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: '法人名 (例：SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: '保存する',
    saving: '保存中…',
    cancel: 'キャンセル',
    saved: '情報が保存されました',
    genericError: 'エラー',
    noAdsYet: '広告はありません',
    noAdsHint: '最初の広告を作成して開始してください',
    statusPendingPayment: '支払い待ち',
    statusApproved: '承認済み',
    statusActive: 'アクティブ',
    statusExpired: '期限切れ',
    statusPending: '保留中',
    adVideo: '動画',
    adImage: '画像',
    adAudio: 'オーディオ',
    duration: '期間',
    days: '日',
    broadcastZones: '放送ゾーン：',
    impressions: 'インプレッション',
    clicks: 'クリック',
    delete: '削除',
    pay: '支払う',
    checkPayment: '支払いを確認する',
    checking: '確認中…',
    createModalTitle: '広告を作成する',
    adTypeLabel: '広告タイプ',
    videoMax: '最大 30s、30 MB',
    imageMax: '最大 5 MB',
    audioMax: '最大 30s、MP3',
    file: 'ファイル',
    maxDuration: '最大期間：30秒',
    broadcastDuration: '放送期間',
    sevenDays: '7日',
    externalLinkOptional: '外部リンク (任意)',
    sitePlaceholder: 'https://あなたのサイト.com',
    externalLinkHint: 'あなたのサイト、商品、またはサービスへの URL',
    feedVocaux: 'フィード (音声)',
    podcasts: 'ポッドキャスト',
    stories: 'ストーリー',
    adPrice: '広告の価格',
    videoPriceLabel: '100€で7日間 (動画)',
    audioPriceLabel: '50€で7日間 (オーディオ)',
    imagePriceLabel: '50€で7日間 (画像)',
    creating: '作成中…',
    createAndPay: '作成して支払う',
    selectFile: 'ファイルを選択してください',
    selectAtLeastOneZone: '少なくとも1つの放送ゾーンを選択してください',
    adCreated: '広告が作成されました！支払いに進んでください。',
    createError: '作成中にエラーが発生しました',
    myOffersPanel: '私のスポンサーシップオファー',
    newOffer: '新しいオファー',
    noOffersYet: '公開されたオファーはありません。共有時にクリエイターに表示されるように作成してください。',
    offerTitleLabel: 'タイトル',
    offerTitlePlaceholder: '例：新しい香水の発売',
    offerDescLabel: '説明 (クリエイターは何を言うべきか？)',
    offerDescPlaceholder: 'クリエイターが言及するべき商品やサービスを説明してください…',
    offerKindsLabel: '受け入れられるコンテンツの種類',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: '金額',
    offerCurrencyEUR: 'EUR',
    offerRule: 'クリエイターは、Gim Toli またはポッドキャストの中でスポンサーについて最低10秒間話す必要があります（短編映画での単純な言及も可）。このルールは Destine によって課せられています。',
    publishOffer: 'オファーを公開する',
    offerTitleRequired: 'タイトルは必須です',
    offerDescRequired: '説明は必須です',
    offerAmountInvalid: '無効な金額',
    offerPublished: 'オファーが公開されました',
    offerDeleted: 'オファーが削除されました',
    filterAll: 'すべて',
    filterPending: '保留中',
    filterAccepted: '承認済み',
    filterRejected: '拒否',
    noSponsorshipRequests: 'スポンサーシップリクエストはありません。',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: '短編映画',
    noCallbacks: '現在、リクエストはありません。',
    noCallbacksHint: '購入者があなたのサービスに送信したリクエストはここに表示されます。',
    client: 'クライアント',
    markCalled: 'コール済みとしてマーク',
    archive: 'アーカイブ',
    updated: '更新されました',
    shopAccounting: 'MyShop 会計',
    detailsBtn: '詳細',
    gross: '総額',
    commissionPct: '手数料',
    netReceive: '受取額',
    salesCount: '売上',
    shopsCount: '店舗',
    netExplain: 'ネット = 売上高 - Destine の手数料。',
    back: '戻る',
    proOnly: 'PRO アカウント専用アクセス',
    loading: '読み込み中…',
    paymentChecking: '支払い確認中…',
    paymentConfirmed: '支払いが確認されました！',
    paymentProcessing: '支払い処理中…',
    paymentCheckError: '確認エラー',
    paymentCreateError: '支払い作成中にエラーが発生しました',
    notifications: '通知',
    paymentCanceled: '支払いがキャンセルされました',
    confirmDelete: '本当にこの広告を削除しますか？',
    adDeleted: '広告が削除されました',
    deleteError: '削除中にエラーが発生しました',
    acceptedTypes: '受け入れられるタイプ',
    minTalk: '最低談話時間',
    confirmDeleteOffer: 'このオファーを削除しますか？',
    followers: 'フォロワー',
    likes: 'いいね',
    plays: '再生',
    accept: '承認する',
    reject: '拒否する',
    sponsorAccepted: 'スポンサーシップが承認されました',
    sponsorRejected: 'リクエストが拒否されました',
    payoutCoords: '支払い情報',
    holder: '口座名義人',
    sponsorLinkClicks: 'スポンサーリンククリック数',
    publishing: '公開中…',
    chooseAtLeastOneKind: '少なくとも1つのコンテンツタイプを選択してください',
  },
  hi: {
    title: 'Destine विज्ञापन',
    subtitle: 'अपने विज्ञापनों को प्रबंधित करें और अपने प्रदर्शन को ट्रैक करें',
    createAd: 'विज्ञापन बनाना',
    myAds: 'मेरे विज्ञापन',
    analytics: 'विश्लेषण',
    sponsorshipRequests: 'स्पॉन्सरशिप अनुरोध',
    myOffers: 'मेरे ऑफ़र',
    activeAds: 'सक्रिय विज्ञापन',
    totalImpressions: 'कुल इम्प्रेशन',
    totalClicks: 'कुल क्लिक',
    ctr: 'क्लिक दर (CTR)',
    avgCtr: 'औसत क्लिक दर',
    conversionRate: 'रूपांतरण दर',
    adsCreated: 'बनाए गए विज्ञापन',
    activeShort: 'सक्रिय',
    performanceSummary: 'प्रदर्शन का सारांश',
    details: 'विवरण',
    perAdPerformance: 'प्रत्येक विज्ञापन का प्रदर्शन',
    myShop: 'मेरी e-बुटीक',
    sellYourProductsServices: 'अपने उत्पाद और सेवाएं बेचें',
    payoutTitle: 'बैंक विवरण (e-बुटीक)',
    payoutModify: 'संशोधित करें',
    payoutFill: 'पूर्ण करें',
    payoutHint: 'ये जानकारी आपके बिक्री से होने वाले भुगतान प्राप्त करने के लिए आवश्यक हैं (Destine कमीशन: 5 %)। इन्हें केवल आप और प्रशासन टीम देख सकते हैं।',
    companyName: 'कंपनी का नाम',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'कंपनी का नाम (उदा. SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'सहेजें',
    saving: 'सहेजना…',
    cancel: 'रद्द करें',
    saved: 'विवरण सहेजे गए',
    genericError: 'त्रुटि',
    noAdsYet: 'कोई विज्ञापन नहीं',
    noAdsHint: 'आरंभ करने के लिए अपना पहला विज्ञापन बनाएं',
    statusPendingPayment: 'भुगतान की प्रतीक्षा में',
    statusApproved: 'स्वीकृत',
    statusActive: 'सक्रिय',
    statusExpired: 'समाप्त',
    statusPending: 'प्रतीक्षा में',
    adVideo: 'वीडियो',
    adImage: 'छवि',
    adAudio: 'ऑडियो',
    duration: 'अवधि',
    days: 'दिन',
    broadcastZones: 'प्रसारण क्षेत्र:',
    impressions: 'इम्प्रेशन',
    clicks: 'क्लिक्स',
    delete: 'हटाएं',
    pay: 'भुगतान करें',
    checkPayment: 'भुगतान की जाँच करें',
    checking: 'जाँच हो रही है…',
    createModalTitle: 'विज्ञापन बनाएं',
    adTypeLabel: 'विज्ञापन का प्रकार',
    videoMax: 'अधिकतम 30s, 30 MB',
    imageMax: 'अधिकतम 5 MB',
    audioMax: 'अधिकतम 30s, MP3',
    file: 'फाइल',
    maxDuration: 'अधिकतम अवधि: 30 सेकंड',
    broadcastDuration: 'प्रसारण की अवधि',
    sevenDays: '7 दिन',
    externalLinkOptional: 'बाहरी लिंक (वैकल्पिक)',
    sitePlaceholder: 'https://आपकी-साइट.com',
    externalLinkHint: 'आपकी साइट, उत्पाद या सेवा का यूआरएल',
    feedVocaux: 'फीड (वोकल)',
    podcasts: 'पॉडकास्ट',
    stories: 'किस्से',
    adPrice: 'विज्ञापन की कीमत',
    videoPriceLabel: '100€ के लिए 7 दिन (वीडियो)',
    audioPriceLabel: '50€ के लिए 7 दिन (ऑडियो)',
    imagePriceLabel: '50€ के लिए 7 दिन (छवि)',
    creating: 'बनाना…',
    createAndPay: 'बनाएं और भुगतान करें',
    selectFile: 'कृपया एक फ़ाइल चुनें',
    selectAtLeastOneZone: 'कम से कम एक प्रसारण क्षेत्र चुनें',
    adCreated: 'विज्ञापन बनाया गया! भुगतान करें।',
    createError: 'बनाने में त्रुटि',
    myOffersPanel: 'मेरे स्पॉन्सरशिप ऑफर',
    newOffer: 'नया ऑफर',
    noOffersYet: 'कोई ऑफर प्रकाशित नहीं हुआ है। इसे शेयर करने पर क्रिएटर्स को दिखाने के लिए एक बनाएं।',
    offerTitleLabel: 'शीर्षक',
    offerTitlePlaceholder: 'उदा: हमारे नए इत्र का विमोचन',
    offerDescLabel: 'विवरण (क्रिएटर को क्या कहना चाहिए?)',
    offerDescPlaceholder: 'उत्पाद या सेवा का वर्णन करें जिसे क्रिएटर को उल्लेख करना है…',
    offerKindsLabel: 'स्वीकृत सामग्री के प्रकार',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'पॉडकास्ट',
    offerAmountPlaceholder: 'राशि',
    offerCurrencyEUR: 'EUR',
    offerRule: 'क्रिएटर को अपने Gim Toli या पॉडकास्ट में स्पॉन्सर के बारे में न्यूनतम 10 सेकंड तक बात करनी होगी (या संक्षिप्त फिल्मों में साधारण उल्लेख)। यह नियम Destine द्वारा लगाया गया है।',
    publishOffer: 'ऑफर प्रकाशित करें',
    offerTitleRequired: 'शीर्षक आवश्यक है',
    offerDescRequired: 'विवरण आवश्यक है',
    offerAmountInvalid: 'अमान्य राशि',
    offerPublished: 'ऑफर प्रकाशित किया गया',
    offerDeleted: 'ऑफर हटाया गया',
    filterAll: 'सभी',
    filterPending: 'प्रतीक्षा में',
    filterAccepted: 'स्वीकृत',
    filterRejected: 'अस्वीकृत',
    noSponsorshipRequests: 'कोई स्पॉन्सरशिप अनुरोध नहीं।',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'पॉडकास्ट',
    kindShortFilm: 'संक्षिप्त फिल्म',
    noCallbacks: 'फिलहाल कोई कॉलबैक अनुरोध नहीं हैं।',
    noCallbacksHint: 'आपकी सेवाओं पर खरीदारों द्वारा भेजे गए अनुरोध यहां दिखाई देंगे।',
    client: 'क्लाइंट',
    markCalled: 'कॉल किया हुआ चिह्नित करें',
    archive: 'आर्काइव करें',
    updated: 'अपडेट किया गया',
    shopAccounting: 'e-बुटीक लेखांकन',
    detailsBtn: 'विवरण',
    gross: 'सकल',
    commissionPct: 'कमीशन',
    netReceive: 'प्राप्त करने के लिए शुद्ध',
    salesCount: 'विक्रय(यों)',
    shopsCount: 'दुकान(ों)',
    netExplain: 'शुद्ध = राजस्व में से Destine की कमीशन घटाएं।',
    back: 'वापस',
    proOnly: 'सिर्फ PRO खातों के लिए विशेष पहुंच',
    loading: 'लोड हो रहा है…',
    paymentChecking: 'भुगतान की जाँच प्रक्रिया में…',
    paymentConfirmed: 'भुगतान की पुष्टि हो गई!',
    paymentProcessing: 'भुगतान प्रक्रिया में…',
    paymentCheckError: 'जाँच में त्रुटि',
    paymentCreateError: 'भुगतान बनाने में त्रुटि',
    notifications: 'सूचनाएँ',
    paymentCanceled: 'भुगतान रद्द',
    confirmDelete: 'क्या आप वास्तव में इस विज्ञापन को हटाना चाहते हैं?',
    adDeleted: 'विज्ञापन हटाया गया',
    deleteError: 'हटाने में त्रुटि',
    acceptedTypes: 'स्वीकृत प्रकार',
    minTalk: 'न्यूनतम बोलने की अवधि',
    confirmDeleteOffer: 'इस ऑफर को हटाएं?',
    followers: 'अनुयायी',
    likes: 'पसंद',
    plays: 'चलन',
    accept: 'स्वीकृत करें',
    reject: 'अस्वीकृत करें',
    sponsorAccepted: 'स्पॉन्सरशिप स्वीकृत',
    sponsorRejected: 'अनुरोध अस्वीकृत',
    payoutCoords: 'भुगतान विवरण',
    holder: 'धारक',
    sponsorLinkClicks: 'स्पॉन्सर लिंक पर क्लिक',
    publishing: 'प्रकाशन…',
    chooseAtLeastOneKind: 'कम से कम एक सामग्री प्रकार चुनें',
  },
  sw: {
    title: 'Matangazo ya Destine',
    subtitle: 'Simamia matangazo yako na fuatilia utendaji wako',
    createAd: 'Unda tangazo',
    myAds: 'Matangazo yangu',
    analytics: 'Analytics',
    sponsorshipRequests: 'Maombi ya udhamini',
    myOffers: 'Ofa zangu',
    activeAds: 'Matangazo yaliyopo',
    totalImpressions: 'Mawasilisho yote',
    totalClicks: 'Mabofyo yote',
    ctr: 'Kiwango cha bofya (CTR)',
    avgCtr: 'Kiwango cha bofya wastani',
    conversionRate: 'Kiwango cha ubadilishaji',
    adsCreated: 'Matangazo yaliyoundwa',
    activeShort: 'yaliyopo',
    performanceSummary: 'Muhtasari wa utendaji',
    details: 'Maelezo',
    perAdPerformance: 'Utendaji kwa tangazo',
    myShop: 'Duka langu la MyShop',
    sellYourProductsServices: 'Uza bidhaa na huduma zako',
    payoutTitle: 'Maelezo ya benki (MyShop)',
    payoutModify: 'Badilisha',
    payoutFill: 'Jaza',
    payoutHint: 'Habari hizi ni muhimu ili kupokea malipo ya mauzo yako (tuzo ya Destine: 5%). Zitaonekana tu kwako na timu ya admin.',
    companyName: 'Jina la kampuni',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'Jina la kampuni (mfano: SARL Duka XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'Hifadhi',
    saving: 'Ikihifadhi…',
    cancel: 'Batilisha',
    saved: 'Maelezo yamehifadhiwa',
    genericError: 'Kosa',
    noAdsYet: 'Hakuna tangazo',
    noAdsHint: 'Unda tangazo lako la kwanza ili kuanza',
    statusPendingPayment: 'Inasubiri malipo',
    statusApproved: 'Imeidhinishwa',
    statusActive: 'Ipo',
    statusExpired: 'Imeisha',
    statusPending: 'Inasubiri',
    adVideo: 'Video',
    adImage: 'Picha',
    adAudio: 'Sauti',
    duration: 'Muda',
    days: 'siku',
    broadcastZones: 'Maeneo ya matangazo:',
    impressions: 'Mawasilisho',
    clicks: 'Mabofyo',
    delete: 'Futa',
    pay: 'Lipa',
    checkPayment: 'Angalia malipo',
    checking: 'Kuangalia…',
    createModalTitle: 'Unda tangazo',
    adTypeLabel: 'Aina ya tangazo',
    videoMax: 'Max 30s, 30 MB',
    imageMax: 'Max 5 MB',
    audioMax: 'Max 30s, MP3',
    file: 'Faili',
    maxDuration: 'Muda wa juu: sekunde 30',
    broadcastDuration: 'Muda wa matangazo',
    sevenDays: 'siku 7',
    externalLinkOptional: 'Kiungo cha nje (hiari)',
    sitePlaceholder: 'https://tovuti-yako.com',
    externalLinkHint: 'URL kuelekea tovuti yako, bidhaa au huduma',
    feedVocaux: 'Feed (Sauti)',
    podcasts: 'Podcasts',
    stories: 'Hadithi',
    adPrice: 'Bei ya tangazo',
    videoPriceLabel: '100€ kwa siku 7 (video)',
    audioPriceLabel: '50€ kwa siku 7 (sauti)',
    imagePriceLabel: '50€ kwa siku 7 (picha)',
    creating: 'Ikisajili…',
    createAndPay: 'Unda na lipa',
    selectFile: 'Tafadhali chagua faili',
    selectAtLeastOneZone: 'Chagua angalau eneo moja la matangazo',
    adCreated: 'Tangazo limeundwa! Endelea na malipo.',
    createError: 'Kosa wakati wa kuunda',
    myOffersPanel: 'Ofa zangu za udhamini',
    newOffer: 'Ofa mpya',
    noOffersYet: 'Hakuna ofa zilizochapishwa. Unda moja ili ionekane kwa waumbaji wakati wa kushiriki.',
    offerTitleLabel: 'Kichwa',
    offerTitlePlaceholder: 'Mfano: Uzinduzi wa naftali yetu mpya',
    offerDescLabel: 'Maelezo (mwandishi anapaswa kusema nini?)',
    offerDescPlaceholder: 'Eleza bidhaa au huduma ambayo mwandishi anapaswa kutaja…',
    offerKindsLabel: 'Aina za maudhui zinazokubalika',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: 'Kiasi',
    offerCurrencyEUR: 'EUR',
    offerRule: 'Mwandishi anapaswa kusema kuhusu mdhamini kwa sekunde 10 angalau katika Gim Toli yake au podcast (au kutaja tu kwenye filamu fupi). Kanuni hii inatekelezwa na Destine.',
    publishOffer: 'Chapisha ofa',
    offerTitleRequired: 'Kichwa kinahitajika',
    offerDescRequired: 'Maelezo yanahitajika',
    offerAmountInvalid: 'Kiasi kisicho halali',
    offerPublished: 'Ofa imechapishwa',
    offerDeleted: 'Ofa imefutwa',
    filterAll: 'Yote',
    filterPending: 'Inasubiri',
    filterAccepted: 'Imepokelewa',
    filterRejected: 'Imekataliwa',
    noSponsorshipRequests: 'Hakuna maombi ya udhamini.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: 'Filamu fupi',
    noCallbacks: 'Hakuna maombi ya kurudi kwa sasa.',
    noCallbacksHint: 'Maombi yaliyotumwa na wanunuzi kwa huduma zako yataonekana hapa.',
    client: 'Mteja',
    markCalled: 'Alama kama iliyokolewa',
    archive: 'Hifadhi',
    updated: 'Imesasishwa',
    shopAccounting: 'Uhasibu wa MyShop',
    detailsBtn: 'Maelezo',
    gross: 'Brut',
    commissionPct: 'Tuzo',
    netReceive: 'Neti ya kupokea',
    salesCount: 'mauzo',
    shopsCount: 'duka',
    netExplain: 'Neti = mapato ya mauzo - taji ya Destine.',
    back: 'Rudi',
    proOnly: 'Ufikiaji umewekewa akiba kwa akaunti za PRO',
    loading: 'Ikitoload…',
    paymentChecking: 'Kuangalia malipo kwa sasa…',
    paymentConfirmed: 'Malipo yamehakikishwa!',
    paymentProcessing: 'Malipo yanaendelea kushughulikiwa…',
    paymentCheckError: 'Kosa la kuangalia',
    paymentCreateError: 'Kosa wakati wa kuunda malipo',
    notifications: 'Ilani',
    paymentCanceled: 'Malipo yamebatilishwa',
    confirmDelete: 'Je, unataka kufuta tangazo hili kwa kweli?',
    adDeleted: 'Tangazo limetolewa',
    deleteError: 'Kosa wakati wa kufuta',
    acceptedTypes: 'Aina zinazokubalika',
    minTalk: 'Muda wa kuzungumza wa chini',
    confirmDeleteOffer: 'Futa ofa hii?',
    followers: 'Wafuasi',
    likes: 'Penda',
    plays: 'Zilizochezwa',
    accept: 'Kubaliana',
    reject: 'Kataa',
    sponsorAccepted: 'Udhamini umeidhinishwa',
    sponsorRejected: 'Ombi limekataliwa',
    payoutCoords: 'Maelezo ya malipo',
    holder: 'Miliki',
    sponsorLinkClicks: 'Mabofyo kwenye kiungo cha mdhamini',
    publishing: 'Chapisho…',
    chooseAtLeastOneKind: 'Chagua angalau aina moja ya maudhui',
  },
  ht: {
    title: 'Destine Anons',
    subtitle: 'Gestione anons ou yo ak swiv pèfòmans ou',
    createAd: 'Kreye yon anons',
    myAds: 'Anons mwen',
    analytics: 'Analiz',
    sponsorshipRequests: 'Demandes pou sponsor',
    myOffers: 'Ofri mwen yo',
    activeAds: 'Anons aktif',
    totalImpressions: 'Impresyon total',
    totalClicks: 'Klik total',
    ctr: 'Taux de klik (CTR)',
    avgCtr: 'Taux de klik mwayen',
    conversionRate: 'Taux de konvèsyon',
    adsCreated: 'Anons kreye',
    activeShort: 'aktif',
    performanceSummary: 'Rezime pèfòmans',
    details: 'Detay',
    perAdPerformance: 'Pèfòmans pa anons',
    myShop: 'Mwen MyShop',
    sellYourProductsServices: 'Vann pwodwi ak sèvis ou',
    payoutTitle: 'Kondisyon bankè (MyShop)',
    payoutModify: 'Modifye',
    payoutFill: 'Ranpli',
    payoutHint: 'Enfòmasyon sa yo nesesè pou resevwa peman pou vant ou yo (komisyon Destine: 5 %). Yo se sèlman vizib pou ou ak ekip administrasyon an.',
    companyName: 'Raison sociale',
    iban: 'IBAN',
    bic: 'BIC',
    companyPlaceholder: 'Raison sociale (ex. SARL Boutique XYZ)',
    bicPlaceholder: 'BIC / SWIFT',
    save: 'Sove',
    saving: 'Sove…',
    cancel: 'Anile',
    saved: 'Kondisyon sove',
    genericError: 'Erè',
    noAdsYet: 'Okenn anons',
    noAdsHint: 'Kreye premye anons ou pou kòmanse',
    statusPendingPayment: 'An atant peman',
    statusApproved: 'Apwouve',
    statusActive: 'Aktif',
    statusExpired: 'Ekspire',
    statusPending: 'An atant',
    adVideo: 'Videyo',
    adImage: 'Imaj',
    adAudio: 'Odyo',
    duration: 'Dire',
    days: 'jou',
    broadcastZones: 'Zòn difizyon :',
    impressions: 'Impresyon',
    clicks: 'Klike',
    delete: 'Efase',
    pay: 'Peye',
    checkPayment: 'Verifye peman',
    checking: 'Verifikasyon…',
    createModalTitle: 'Kreye yon anons',
    adTypeLabel: 'Kalite anons',
    videoMax: 'Max 30s, 30 MB',
    imageMax: 'Max 5 MB',
    audioMax: 'Max 30s, MP3',
    file: 'Fichye',
    maxDuration: 'Dire maksimòm: 30 segond',
    broadcastDuration: 'Dire difizyon',
    sevenDays: '7 jou',
    externalLinkOptional: 'Lyen extèn (opsyonèl)',
    sitePlaceholder: 'https://votre-site.com',
    externalLinkHint: 'URL pou sit ou, pwodwi ou oswa sèvis ou',
    feedVocaux: 'Feed (Vokaux)',
    podcasts: 'Podcasts',
    stories: 'Istwa',
    adPrice: 'Pri anons la',
    videoPriceLabel: '100€ pou 7 jou (videyo)',
    audioPriceLabel: '50€ pou 7 jou (odyo)',
    imagePriceLabel: '50€ pou 7 jou (imaj)',
    creating: 'Kreye…',
    createAndPay: 'Kreye ak peye',
    selectFile: 'Tanpri chwazi yon fichye',
    selectAtLeastOneZone: 'Chwazi omwen yon zòn difizyon',
    adCreated: 'Anons kreye ! Pase lajan.',
    createError: 'Erè pandan kreye',
    myOffersPanel: 'Ofri mwen yo pou sponsor',
    newOffer: 'Nouvo ofri',
    noOffersYet: 'Okenn ofri pibliye. Kreye youn pou li parèt pou kreyatè yo pandan yo ap pataje.',
    offerTitleLabel: 'Tit',
    offerTitlePlaceholder: 'Ex: Lanse nouvo parfum nou an',
    offerDescLabel: 'Deskripsyon (kisa kreyatè a dwe di ?)',
    offerDescPlaceholder: 'Dekri pwodwi oswa sèvis kreyatè a dwe mansyone…',
    offerKindsLabel: 'Kalite kontni aksepte',
    offerKindGimToli: 'Gim Toli',
    offerKindPodcast: 'Podcast',
    offerAmountPlaceholder: 'Montan',
    offerCurrencyEUR: 'EUR',
    offerRule: 'Kreyatè a dwe pale sou sponsor a pandan omwen 10 segond nan Gim Toli li oswa podcast (oswa senp mansyon nan kout fim). Règleman sa a se imposé pa Destine.',
    publishOffer: 'Pibliye ofri a',
    offerTitleRequired: 'Tit obligatwa',
    offerDescRequired: 'Deskripsyon obligatwa',
    offerAmountInvalid: 'Montant envalide',
    offerPublished: 'Ofri pibliye',
    offerDeleted: 'Ofri efase',
    filterAll: 'Tout',
    filterPending: 'An atant',
    filterAccepted: 'Aksepte',
    filterRejected: 'Refize',
    noSponsorshipRequests: 'Okenn demann pou sponsor.',
    kindGimToli: 'Gim Toli',
    kindPodcast: 'Podcast',
    kindShortFilm: 'Fim kout',
    noCallbacks: 'Okenn demann pou rapèl pou kounye a.',
    noCallbacksHint: 'Demann yo voye pa achtè sou sèvis ou yo ap parèt isit la.',
    client: 'Kliyan',
    markCalled: 'Mennen kòm raple',
    archive: 'Achiv',
    updated: 'Mizajou',
    shopAccounting: 'Komen MyShop',
    detailsBtn: 'Detay',
    gross: 'Brit',
    commissionPct: 'Komisyon',
    netReceive: 'Net pou resevwa',
    salesCount: 'vant',
    shopsCount: 'boutik',
    netExplain: 'Net = chif biznis mwens komisyon Destine.',
    back: 'Retounen',
    proOnly: 'Aksè rezève pou kont PRO',
    loading: 'Chajman…',
    paymentChecking: 'Verifikasyon peman an kouran…',
    paymentConfirmed: 'Peman konfime !',
    paymentProcessing: 'Peman an kouran de tretman…',
    paymentCheckError: 'Erè verifikasyon',
    paymentCreateError: 'Erè pandan kreye peman',
    notifications: 'Notifikasyon',
    paymentCanceled: 'Peman anile',
    confirmDelete: 'Eske ou sèten ou vle efase anons sa a ?',
    adDeleted: 'Anons efase',
    deleteError: 'Erè pandan efase',
    acceptedTypes: 'Kalite aksepte',
    minTalk: 'Minimòm dire pale',
    confirmDeleteOffer: 'Efase ofri sa a ?',
    followers: 'Abòne',
    likes: 'Mwen renmen sa',
    plays: 'Egzèsis',
    accept: 'Aksepte',
    reject: 'Refize',
    sponsorAccepted: 'Sponsoring aksepte',
    sponsorRejected: 'Demann refize',
    payoutCoords: 'Kondisyon peman',
    holder: 'Titulaire',
    sponsorLinkClicks: 'Klike sou lyen sponsor',
    publishing: 'Piblikasyon…',
    chooseAtLeastOneKind: 'Chwazi omwen yon kalite kontni',
  },
  en: {
    feedVocaux: 'Feed (Vocaux)',
  },
  fr: {
    feedVocaux: 'Feed (Vocaux)',
  },
  nl: {
    feedVocaux: 'Feed (Vocaux)',
  },
};

// Backfill every language's `ads` namespace — only fills missing keys,
// never overwrites existing translations.
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  const src = _ads_full_i18n[lang];
  if (!src) continue;
  if (!translations[lang].ads) translations[lang].ads = {};
  for (const k of Object.keys(src)) {
    if (translations[lang].ads[k] === undefined) {
      translations[lang].ads[k] = src[k];
    }
  }
}

// ============================================================================
// eSIM namespace — Airalo Partner API V2 integration (Feb 2026)
// Provides the in-app eSIM marketplace, user "My eSIMs" panel and admin
// dashboard. Backfilled across all 13 supported languages.
// ============================================================================
const _esim_i18n = {
  en: {
    sectionTitle: 'Travel eSIM',
    sectionSubtitle: 'Stay online anywhere · instant activation',
    seeAll: 'See all',
    poweredBy: 'Powered by Airalo · Official partnership',
    browseTitle: 'Pick your eSIM',
    browseSubtitle: 'Mobile data in 200+ destinations',
    searchDestination: 'Search a destination…',
    filterCountry: 'Country',
    filterData: 'Data',
    filterDays: 'Duration',
    filterPrice: 'Price',
    filterAll: 'All',
    days: 'days',
    day: 'day',
    unlimited: 'Unlimited',
    from: 'from',
    buy: 'Buy',
    buyNow: 'Buy now',
    loading: 'Loading…',
    empty: 'No eSIM available for this filter',
    countriesEmpty: 'No destinations available',
    operator: 'Operator',
    coverage: 'Coverage',
    perGB: 'per GB',
    validity: 'Validity',
    paying: 'Redirecting to payment…',
    paymentSuccess: 'Payment successful! Provisioning your eSIM…',
    paymentCancelled: 'Payment cancelled',
    paymentFailed: 'Payment failed',
    activating: 'Activating eSIM…',
    activated: 'Your eSIM is ready!',
    installTitle: 'Install your eSIM',
    installScan: 'Scan this QR code from your phone settings to install',
    installManualTitle: 'Manual installation',
    smdpAddress: 'SM-DP+ Address',
    activationCode: 'Activation code',
    confirmationCode: 'Confirmation code',
    copyCode: 'Copy',
    copied: 'Copied!',
    directInstallIos: 'Install on iPhone (iOS 17.4+)',
    instructionsHeader: 'How to install',
    mySectionTitle: 'My eSIMs',
    noEsims: 'You don\'t have any eSIM yet',
    statusActive: 'Active',
    statusExpired: 'Expired',
    statusCancelled: 'Cancelled',
    statusPending: 'Activating…',
    statusFailed: 'Failed',
    statusPaymentPending: 'Awaiting payment',
    dataRemaining: 'Data remaining',
    dataUsed: 'Used',
    expiresIn: 'Expires in',
    expiresOn: 'Expires on',
    iccid: 'ICCID',
    refresh: 'Refresh',
    refreshing: 'Refreshing…',
    topup: 'Top up',
    topupTitle: 'Top up your eSIM',
    topupEmpty: 'No top-up available for this eSIM',
    install: 'Install',
    installAgain: 'Show installation',
    details: 'Details',
    countryFlag: 'Destination',
    purchasedOn: 'Purchased on',
    confirm: 'Confirm',
    close: 'Close',
    cancel: 'Cancel',
    // Admin
    adminTitle: 'eSIM Dashboard',
    adminSubtitle: 'Airalo Partner integration · monitoring & support',
    kpiTotalOrders: 'Total orders',
    kpiActive: 'Active',
    kpiCancelled: 'Cancelled',
    kpiRefunded: 'Refunded',
    kpiRevenue: 'Gross revenue',
    kpiMargin: 'Margin',
    kpiARPU: 'ARPU',
    kpiTopups: 'Top-ups',
    kpiFailed: 'Failed',
    byLanguage: 'Sales by language',
    byCountry: 'Sales by destination',
    byStatus: 'Orders by status',
    syncNow: 'Resync catalog',
    syncing: 'Syncing…',
    syncSuccess: 'Catalog synced',
    ordersTable: 'Orders',
    user: 'User',
    package: 'Package',
    price: 'Price',
    status: 'Status',
    actions: 'Actions',
    forceCancel: 'Force cancel & refund',
    cancelConfirm: 'Cancel this eSIM and refund the user?',
    cancelDone: 'eSIM cancelled and refunded',
    environment: 'Environment',
    markup: 'Markup',
  },
  fr: {
    sectionTitle: 'eSIM Voyage',
    sectionSubtitle: 'Restez connecté partout · activation instantanée',
    seeAll: 'Voir tout',
    poweredBy: 'Propulsé par Airalo · Partenariat officiel',
    browseTitle: 'Choisis ton eSIM',
    browseSubtitle: 'Data mobile dans 200+ destinations',
    searchDestination: 'Rechercher une destination…',
    filterCountry: 'Pays',
    filterData: 'Data',
    filterDays: 'Durée',
    filterPrice: 'Prix',
    filterAll: 'Tous',
    days: 'jours',
    day: 'jour',
    unlimited: 'Illimité',
    from: 'à partir de',
    buy: 'Acheter',
    buyNow: 'Acheter maintenant',
    loading: 'Chargement…',
    empty: 'Aucun eSIM pour ce filtre',
    countriesEmpty: 'Aucune destination disponible',
    operator: 'Opérateur',
    coverage: 'Couverture',
    perGB: 'par Go',
    validity: 'Validité',
    paying: 'Redirection vers le paiement…',
    paymentSuccess: 'Paiement réussi ! Provisionnement de votre eSIM…',
    paymentCancelled: 'Paiement annulé',
    paymentFailed: 'Échec du paiement',
    activating: 'Activation de l\'eSIM…',
    activated: 'Votre eSIM est prête !',
    installTitle: 'Installer votre eSIM',
    installScan: 'Scannez ce QR code depuis les réglages de votre téléphone',
    installManualTitle: 'Installation manuelle',
    smdpAddress: 'Adresse SM-DP+',
    activationCode: 'Code d\'activation',
    confirmationCode: 'Code de confirmation',
    copyCode: 'Copier',
    copied: 'Copié !',
    directInstallIos: 'Installer sur iPhone (iOS 17.4+)',
    instructionsHeader: 'Comment installer',
    mySectionTitle: 'Mes eSIM',
    noEsims: 'Vous n\'avez pas encore d\'eSIM',
    statusActive: 'Active',
    statusExpired: 'Expirée',
    statusCancelled: 'Résiliée',
    statusPending: 'Activation…',
    statusFailed: 'Échec',
    statusPaymentPending: 'En attente de paiement',
    dataRemaining: 'Data restante',
    dataUsed: 'Utilisé',
    expiresIn: 'Expire dans',
    expiresOn: 'Expire le',
    iccid: 'ICCID',
    refresh: 'Actualiser',
    refreshing: 'Actualisation…',
    topup: 'Recharger',
    topupTitle: 'Recharger votre eSIM',
    topupEmpty: 'Aucune recharge disponible pour cet eSIM',
    install: 'Installer',
    installAgain: 'Voir l\'installation',
    details: 'Détails',
    countryFlag: 'Destination',
    purchasedOn: 'Acheté le',
    confirm: 'Confirmer',
    close: 'Fermer',
    cancel: 'Annuler',
    adminTitle: 'Tableau de bord eSIM',
    adminSubtitle: 'Intégration Airalo Partner · monitoring & support',
    kpiTotalOrders: 'Commandes totales',
    kpiActive: 'Actives',
    kpiCancelled: 'Résiliées',
    kpiRefunded: 'Remboursées',
    kpiRevenue: 'CA brut',
    kpiMargin: 'Marge',
    kpiARPU: 'ARPU',
    kpiTopups: 'Recharges',
    kpiFailed: 'Échecs',
    byLanguage: 'Ventes par langue',
    byCountry: 'Ventes par destination',
    byStatus: 'Commandes par statut',
    syncNow: 'Resynchroniser le catalogue',
    syncing: 'Synchronisation…',
    syncSuccess: 'Catalogue synchronisé',
    ordersTable: 'Commandes',
    user: 'Utilisateur',
    package: 'Forfait',
    price: 'Prix',
    status: 'Statut',
    actions: 'Actions',
    forceCancel: 'Forcer résiliation & remboursement',
    cancelConfirm: 'Résilier cet eSIM et rembourser l\'utilisateur ?',
    cancelDone: 'eSIM résilié et remboursé',
    environment: 'Environnement',
    markup: 'Marge',
  },
  es: {
    sectionTitle: 'eSIM de Viaje',
    sectionSubtitle: 'Conéctate en cualquier lugar · activación instantánea',
    seeAll: 'Ver todo', poweredBy: 'Con tecnología Airalo · Alianza oficial',
    browseTitle: 'Elige tu eSIM', browseSubtitle: 'Datos móviles en 200+ destinos',
    searchDestination: 'Buscar un destino…', filterCountry: 'País', filterData: 'Datos',
    filterDays: 'Duración', filterPrice: 'Precio', filterAll: 'Todos',
    days: 'días', day: 'día', unlimited: 'Ilimitado', from: 'desde',
    buy: 'Comprar', buyNow: 'Comprar ahora', loading: 'Cargando…',
    empty: 'No hay eSIM para este filtro', countriesEmpty: 'Sin destinos disponibles',
    operator: 'Operador', coverage: 'Cobertura', perGB: 'por GB', validity: 'Validez',
    paying: 'Redirigiendo al pago…', paymentSuccess: '¡Pago exitoso! Activando tu eSIM…',
    paymentCancelled: 'Pago cancelado', paymentFailed: 'Pago fallido',
    activating: 'Activando eSIM…', activated: '¡Tu eSIM está lista!',
    installTitle: 'Instalar tu eSIM', installScan: 'Escanea este QR desde los ajustes de tu teléfono',
    installManualTitle: 'Instalación manual', smdpAddress: 'Dirección SM-DP+',
    activationCode: 'Código de activación', confirmationCode: 'Código de confirmación',
    copyCode: 'Copiar', copied: '¡Copiado!', directInstallIos: 'Instalar en iPhone (iOS 17.4+)',
    instructionsHeader: 'Cómo instalar', mySectionTitle: 'Mis eSIM',
    noEsims: 'Aún no tienes ningún eSIM', statusActive: 'Activa', statusExpired: 'Expirada',
    statusCancelled: 'Cancelada', statusPending: 'Activando…', statusFailed: 'Fallo',
    statusPaymentPending: 'Esperando pago', dataRemaining: 'Datos restantes',
    dataUsed: 'Usado', expiresIn: 'Expira en', expiresOn: 'Expira el', iccid: 'ICCID',
    refresh: 'Actualizar', refreshing: 'Actualizando…', topup: 'Recargar',
    topupTitle: 'Recargar tu eSIM', topupEmpty: 'Sin recargas disponibles',
    install: 'Instalar', installAgain: 'Ver instalación', details: 'Detalles',
    countryFlag: 'Destino', purchasedOn: 'Comprado el', confirm: 'Confirmar',
    close: 'Cerrar', cancel: 'Cancelar',
    adminTitle: 'Panel eSIM', adminSubtitle: 'Integración Airalo · monitoreo & soporte',
    kpiTotalOrders: 'Pedidos totales', kpiActive: 'Activas', kpiCancelled: 'Canceladas',
    kpiRefunded: 'Reembolsadas', kpiRevenue: 'Ingresos brutos', kpiMargin: 'Margen',
    kpiARPU: 'ARPU', kpiTopups: 'Recargas', kpiFailed: 'Fallos',
    byLanguage: 'Ventas por idioma', byCountry: 'Ventas por destino',
    byStatus: 'Pedidos por estado', syncNow: 'Resincronizar catálogo',
    syncing: 'Sincronizando…', syncSuccess: 'Catálogo sincronizado',
    ordersTable: 'Pedidos', user: 'Usuario', package: 'Plan', price: 'Precio',
    status: 'Estado', actions: 'Acciones', forceCancel: 'Forzar cancelación y reembolso',
    cancelConfirm: '¿Cancelar este eSIM y reembolsar?', cancelDone: 'eSIM cancelada y reembolsada',
    environment: 'Entorno', markup: 'Margen',
  },
  ar: {
    sectionTitle: 'شريحة eSIM للسفر',
    sectionSubtitle: 'ابق متصلاً في أي مكان · تفعيل فوري',
    seeAll: 'عرض الكل', poweredBy: 'مدعوم من Airalo · شراكة رسمية',
    browseTitle: 'اختر شريحة eSIM', browseSubtitle: 'بيانات الجوال في أكثر من 200 وجهة',
    searchDestination: 'ابحث عن وجهة…', filterCountry: 'الدولة', filterData: 'البيانات',
    filterDays: 'المدة', filterPrice: 'السعر', filterAll: 'الكل',
    days: 'أيام', day: 'يوم', unlimited: 'غير محدود', from: 'من',
    buy: 'شراء', buyNow: 'اشتر الآن', loading: 'تحميل…',
    empty: 'لا توجد شرائح eSIM لهذا الفلتر', countriesEmpty: 'لا توجد وجهات متاحة',
    operator: 'المشغل', coverage: 'التغطية', perGB: 'لكل غيغابايت', validity: 'الصلاحية',
    paying: 'إعادة التوجيه إلى الدفع…', paymentSuccess: 'تم الدفع! جارٍ تفعيل eSIM…',
    paymentCancelled: 'تم إلغاء الدفع', paymentFailed: 'فشل الدفع',
    activating: 'جارٍ التفعيل…', activated: 'شريحة eSIM جاهزة!',
    installTitle: 'تثبيت eSIM', installScan: 'امسح رمز QR من إعدادات هاتفك',
    installManualTitle: 'التثبيت اليدوي', smdpAddress: 'عنوان SM-DP+',
    activationCode: 'رمز التفعيل', confirmationCode: 'رمز التأكيد',
    copyCode: 'نسخ', copied: 'تم النسخ!', directInstallIos: 'التثبيت على iPhone (iOS 17.4+)',
    instructionsHeader: 'كيفية التثبيت', mySectionTitle: 'شرائحي eSIM',
    noEsims: 'لا توجد لديك شريحة eSIM بعد', statusActive: 'نشطة', statusExpired: 'منتهية',
    statusCancelled: 'ملغاة', statusPending: 'جارٍ التفعيل…', statusFailed: 'فشل',
    statusPaymentPending: 'بانتظار الدفع', dataRemaining: 'البيانات المتبقية',
    dataUsed: 'المستخدم', expiresIn: 'تنتهي خلال', expiresOn: 'تنتهي في', iccid: 'ICCID',
    refresh: 'تحديث', refreshing: 'تحديث…', topup: 'إعادة شحن',
    topupTitle: 'إعادة شحن eSIM', topupEmpty: 'لا توجد عمليات شحن متاحة',
    install: 'تثبيت', installAgain: 'عرض التثبيت', details: 'التفاصيل',
    countryFlag: 'الوجهة', purchasedOn: 'تم الشراء في', confirm: 'تأكيد',
    close: 'إغلاق', cancel: 'إلغاء',
    adminTitle: 'لوحة eSIM', adminSubtitle: 'تكامل Airalo · مراقبة ودعم',
    kpiTotalOrders: 'إجمالي الطلبات', kpiActive: 'نشطة', kpiCancelled: 'ملغاة',
    kpiRefunded: 'مستردة', kpiRevenue: 'الإيرادات', kpiMargin: 'الهامش',
    kpiARPU: 'ARPU', kpiTopups: 'الشحنات', kpiFailed: 'إخفاقات',
    byLanguage: 'المبيعات حسب اللغة', byCountry: 'المبيعات حسب الوجهة',
    byStatus: 'الطلبات حسب الحالة', syncNow: 'إعادة مزامنة الكتالوج',
    syncing: 'مزامنة…', syncSuccess: 'تمت المزامنة', ordersTable: 'الطلبات',
    user: 'المستخدم', package: 'الباقة', price: 'السعر', status: 'الحالة',
    actions: 'إجراءات', forceCancel: 'إلغاء قسري ورد', cancelConfirm: 'إلغاء eSIM ورد المبلغ؟',
    cancelDone: 'تم الإلغاء والرد', environment: 'البيئة', markup: 'الهامش',
  },
  pt: {
    sectionTitle: 'eSIM de Viagem',
    sectionSubtitle: 'Fique online em qualquer lugar · ativação instantânea',
    seeAll: 'Ver tudo', poweredBy: 'Tecnologia Airalo · Parceria oficial',
    browseTitle: 'Escolha seu eSIM', browseSubtitle: 'Dados móveis em mais de 200 destinos',
    searchDestination: 'Buscar destino…', filterCountry: 'País', filterData: 'Dados',
    filterDays: 'Duração', filterPrice: 'Preço', filterAll: 'Todos',
    days: 'dias', day: 'dia', unlimited: 'Ilimitado', from: 'a partir de',
    buy: 'Comprar', buyNow: 'Comprar agora', loading: 'A carregar…',
    empty: 'Sem eSIM para este filtro', countriesEmpty: 'Sem destinos disponíveis',
    operator: 'Operador', coverage: 'Cobertura', perGB: 'por GB', validity: 'Validade',
    paying: 'A redirecionar para pagamento…', paymentSuccess: 'Pagamento OK! Ativando o eSIM…',
    paymentCancelled: 'Pagamento cancelado', paymentFailed: 'Falha no pagamento',
    activating: 'Ativando eSIM…', activated: 'O seu eSIM está pronto!',
    installTitle: 'Instalar o eSIM', installScan: 'Leia este QR nas definições do telemóvel',
    installManualTitle: 'Instalação manual', smdpAddress: 'Endereço SM-DP+',
    activationCode: 'Código de ativação', confirmationCode: 'Código de confirmação',
    copyCode: 'Copiar', copied: 'Copiado!', directInstallIos: 'Instalar no iPhone (iOS 17.4+)',
    instructionsHeader: 'Como instalar', mySectionTitle: 'Meus eSIM',
    noEsims: 'Ainda não tem nenhum eSIM', statusActive: 'Ativa', statusExpired: 'Expirada',
    statusCancelled: 'Cancelada', statusPending: 'Ativando…', statusFailed: 'Falha',
    statusPaymentPending: 'Aguardando pagamento', dataRemaining: 'Dados restantes',
    dataUsed: 'Usado', expiresIn: 'Expira em', expiresOn: 'Expira em', iccid: 'ICCID',
    refresh: 'Atualizar', refreshing: 'A atualizar…', topup: 'Carregar',
    topupTitle: 'Carregar o eSIM', topupEmpty: 'Sem recargas disponíveis',
    install: 'Instalar', installAgain: 'Ver instalação', details: 'Detalhes',
    countryFlag: 'Destino', purchasedOn: 'Comprado em', confirm: 'Confirmar',
    close: 'Fechar', cancel: 'Cancelar',
    adminTitle: 'Painel eSIM', adminSubtitle: 'Integração Airalo · monitoramento & suporte',
    kpiTotalOrders: 'Pedidos totais', kpiActive: 'Ativas', kpiCancelled: 'Canceladas',
    kpiRefunded: 'Reembolsadas', kpiRevenue: 'Receita bruta', kpiMargin: 'Margem',
    kpiARPU: 'ARPU', kpiTopups: 'Recargas', kpiFailed: 'Falhas',
    byLanguage: 'Vendas por idioma', byCountry: 'Vendas por destino',
    byStatus: 'Pedidos por status', syncNow: 'Re-sincronizar catálogo',
    syncing: 'Sincronizando…', syncSuccess: 'Catálogo sincronizado', ordersTable: 'Pedidos',
    user: 'Utilizador', package: 'Plano', price: 'Preço', status: 'Estado',
    actions: 'Ações', forceCancel: 'Cancelar e reembolsar', cancelConfirm: 'Cancelar este eSIM e reembolsar?',
    cancelDone: 'eSIM cancelado e reembolsado', environment: 'Ambiente', markup: 'Margem',
  },
  de: {
    sectionTitle: 'Reise-eSIM', sectionSubtitle: 'Überall online · sofortige Aktivierung',
    seeAll: 'Alle ansehen', poweredBy: 'Mit Airalo · Offizielle Partnerschaft', browseTitle: 'Wähle deine eSIM',
    browseSubtitle: 'Mobile Daten in 200+ Ländern', searchDestination: 'Ziel suchen…',
    filterCountry: 'Land', filterData: 'Daten', filterDays: 'Dauer', filterPrice: 'Preis',
    filterAll: 'Alle', days: 'Tage', day: 'Tag', unlimited: 'Unbegrenzt', from: 'ab',
    buy: 'Kaufen', buyNow: 'Jetzt kaufen', loading: 'Lädt…',
    empty: 'Keine eSIM für diesen Filter', countriesEmpty: 'Keine Ziele verfügbar',
    operator: 'Anbieter', coverage: 'Abdeckung', perGB: 'pro GB', validity: 'Gültigkeit',
    paying: 'Weiterleitung zur Zahlung…', paymentSuccess: 'Bezahlt! eSIM wird aktiviert…',
    paymentCancelled: 'Zahlung abgebrochen', paymentFailed: 'Zahlung fehlgeschlagen',
    activating: 'eSIM wird aktiviert…', activated: 'Ihre eSIM ist bereit!',
    installTitle: 'eSIM installieren', installScan: 'QR-Code in den Einstellungen scannen',
    installManualTitle: 'Manuelle Installation', smdpAddress: 'SM-DP+ Adresse',
    activationCode: 'Aktivierungscode', confirmationCode: 'Bestätigungscode',
    copyCode: 'Kopieren', copied: 'Kopiert!', directInstallIos: 'Auf iPhone installieren (iOS 17.4+)',
    instructionsHeader: 'Installationsanleitung', mySectionTitle: 'Meine eSIMs',
    noEsims: 'Sie haben noch keine eSIM', statusActive: 'Aktiv', statusExpired: 'Abgelaufen',
    statusCancelled: 'Storniert', statusPending: 'Aktivierung…', statusFailed: 'Fehler',
    statusPaymentPending: 'Wartet auf Zahlung', dataRemaining: 'Verbleibende Daten',
    dataUsed: 'Verbraucht', expiresIn: 'Läuft ab in', expiresOn: 'Läuft ab am', iccid: 'ICCID',
    refresh: 'Aktualisieren', refreshing: 'Wird aktualisiert…', topup: 'Aufladen',
    topupTitle: 'eSIM aufladen', topupEmpty: 'Keine Aufladung verfügbar',
    install: 'Installieren', installAgain: 'Installation anzeigen', details: 'Details',
    countryFlag: 'Ziel', purchasedOn: 'Gekauft am', confirm: 'Bestätigen',
    close: 'Schließen', cancel: 'Abbrechen',
    adminTitle: 'eSIM Dashboard', adminSubtitle: 'Airalo Partner · Monitoring',
    kpiTotalOrders: 'Bestellungen', kpiActive: 'Aktiv', kpiCancelled: 'Storniert',
    kpiRefunded: 'Erstattet', kpiRevenue: 'Bruttoumsatz', kpiMargin: 'Marge',
    kpiARPU: 'ARPU', kpiTopups: 'Aufladungen', kpiFailed: 'Fehler',
    byLanguage: 'Verkäufe nach Sprache', byCountry: 'Verkäufe nach Ziel',
    byStatus: 'Bestellungen nach Status', syncNow: 'Katalog neu synchronisieren',
    syncing: 'Synchronisierung…', syncSuccess: 'Katalog synchronisiert',
    ordersTable: 'Bestellungen', user: 'Benutzer', package: 'Paket', price: 'Preis',
    status: 'Status', actions: 'Aktionen', forceCancel: 'Stornieren & erstatten',
    cancelConfirm: 'Diese eSIM stornieren und erstatten?', cancelDone: 'eSIM storniert und erstattet',
    environment: 'Umgebung', markup: 'Marge',
  },
  ru: {
    sectionTitle: 'eSIM для путешествий', sectionSubtitle: 'В сети где угодно · мгновенная активация',
    seeAll: 'Все', poweredBy: 'На базе Airalo · Официальное партнёрство', browseTitle: 'Выберите eSIM',
    browseSubtitle: 'Мобильный интернет в 200+ странах', searchDestination: 'Поиск страны…',
    filterCountry: 'Страна', filterData: 'Данные', filterDays: 'Срок', filterPrice: 'Цена',
    filterAll: 'Все', days: 'дней', day: 'день', unlimited: 'Безлимит', from: 'от',
    buy: 'Купить', buyNow: 'Купить сейчас', loading: 'Загрузка…',
    empty: 'Нет eSIM по этому фильтру', countriesEmpty: 'Нет доступных стран',
    operator: 'Оператор', coverage: 'Покрытие', perGB: 'за ГБ', validity: 'Действует',
    paying: 'Перенаправление на оплату…', paymentSuccess: 'Оплата прошла! Активация eSIM…',
    paymentCancelled: 'Оплата отменена', paymentFailed: 'Ошибка оплаты',
    activating: 'Активация eSIM…', activated: 'Ваша eSIM готова!',
    installTitle: 'Установить eSIM', installScan: 'Отсканируйте QR-код в настройках телефона',
    installManualTitle: 'Ручная установка', smdpAddress: 'Адрес SM-DP+',
    activationCode: 'Код активации', confirmationCode: 'Код подтверждения',
    copyCode: 'Копировать', copied: 'Скопировано!', directInstallIos: 'Установить на iPhone (iOS 17.4+)',
    instructionsHeader: 'Как установить', mySectionTitle: 'Мои eSIM',
    noEsims: 'У вас пока нет eSIM', statusActive: 'Активна', statusExpired: 'Истекла',
    statusCancelled: 'Отменена', statusPending: 'Активация…', statusFailed: 'Ошибка',
    statusPaymentPending: 'Ожидает оплаты', dataRemaining: 'Осталось данных',
    dataUsed: 'Использовано', expiresIn: 'Истекает через', expiresOn: 'Истекает', iccid: 'ICCID',
    refresh: 'Обновить', refreshing: 'Обновление…', topup: 'Пополнить',
    topupTitle: 'Пополнить eSIM', topupEmpty: 'Пополнения недоступны',
    install: 'Установить', installAgain: 'Показать установку', details: 'Детали',
    countryFlag: 'Направление', purchasedOn: 'Куплено', confirm: 'Подтвердить',
    close: 'Закрыть', cancel: 'Отмена',
    adminTitle: 'Панель eSIM', adminSubtitle: 'Интеграция Airalo · мониторинг',
    kpiTotalOrders: 'Всего заказов', kpiActive: 'Активные', kpiCancelled: 'Отменённые',
    kpiRefunded: 'Возвращено', kpiRevenue: 'Валовой доход', kpiMargin: 'Маржа',
    kpiARPU: 'ARPU', kpiTopups: 'Пополнения', kpiFailed: 'Ошибки',
    byLanguage: 'Продажи по языкам', byCountry: 'Продажи по направлениям',
    byStatus: 'Заказы по статусу', syncNow: 'Синхронизировать каталог',
    syncing: 'Синхронизация…', syncSuccess: 'Каталог синхронизирован', ordersTable: 'Заказы',
    user: 'Пользователь', package: 'Тариф', price: 'Цена', status: 'Статус',
    actions: 'Действия', forceCancel: 'Отменить и вернуть деньги',
    cancelConfirm: 'Отменить эту eSIM и вернуть деньги?', cancelDone: 'eSIM отменена и возвращена',
    environment: 'Среда', markup: 'Наценка',
  },
  zh: {
    sectionTitle: '旅行 eSIM', sectionSubtitle: '随时随地保持在线 · 即刻激活',
    seeAll: '查看全部', poweredBy: '由 Airalo 提供 · 官方合作伙伴', browseTitle: '选择您的 eSIM',
    browseSubtitle: '覆盖 200+ 目的地的移动数据', searchDestination: '搜索目的地…',
    filterCountry: '国家', filterData: '流量', filterDays: '时长', filterPrice: '价格',
    filterAll: '全部', days: '天', day: '天', unlimited: '不限量', from: '起',
    buy: '购买', buyNow: '立即购买', loading: '加载中…',
    empty: '此筛选条件下没有 eSIM', countriesEmpty: '暂无可用目的地',
    operator: '运营商', coverage: '覆盖范围', perGB: '每 GB', validity: '有效期',
    paying: '正在跳转支付…', paymentSuccess: '支付成功！正在激活 eSIM…',
    paymentCancelled: '支付已取消', paymentFailed: '支付失败',
    activating: '激活中…', activated: '您的 eSIM 已就绪！',
    installTitle: '安装您的 eSIM', installScan: '在手机设置中扫描此二维码',
    installManualTitle: '手动安装', smdpAddress: 'SM-DP+ 地址',
    activationCode: '激活码', confirmationCode: '确认码', copyCode: '复制',
    copied: '已复制！', directInstallIos: '在 iPhone 上安装 (iOS 17.4+)',
    instructionsHeader: '安装指南', mySectionTitle: '我的 eSIM',
    noEsims: '您还没有 eSIM', statusActive: '已激活', statusExpired: '已过期',
    statusCancelled: '已取消', statusPending: '激活中…', statusFailed: '失败',
    statusPaymentPending: '等待支付', dataRemaining: '剩余流量',
    dataUsed: '已使用', expiresIn: '剩余', expiresOn: '到期日', iccid: 'ICCID',
    refresh: '刷新', refreshing: '刷新中…', topup: '充值', topupTitle: '为 eSIM 充值',
    topupEmpty: '暂无可用充值', install: '安装', installAgain: '查看安装',
    details: '详情', countryFlag: '目的地', purchasedOn: '购买于',
    confirm: '确认', close: '关闭', cancel: '取消',
    adminTitle: 'eSIM 控制台', adminSubtitle: 'Airalo 合作伙伴 · 监控与支持',
    kpiTotalOrders: '总订单', kpiActive: '激活', kpiCancelled: '已取消',
    kpiRefunded: '已退款', kpiRevenue: '总收入', kpiMargin: '毛利',
    kpiARPU: 'ARPU', kpiTopups: '充值', kpiFailed: '失败',
    byLanguage: '按语言销售', byCountry: '按目的地销售', byStatus: '按状态分类',
    syncNow: '重新同步目录', syncing: '同步中…', syncSuccess: '目录已同步',
    ordersTable: '订单', user: '用户', package: '套餐', price: '价格',
    status: '状态', actions: '操作', forceCancel: '强制取消并退款',
    cancelConfirm: '取消此 eSIM 并退款？', cancelDone: 'eSIM 已取消并退款',
    environment: '环境', markup: '加价',
  },
  ja: {
    sectionTitle: '旅行用 eSIM', sectionSubtitle: 'どこでもオンライン · 即時アクティベート',
    seeAll: 'すべて見る', poweredBy: 'Airalo 提供 · 公式パートナーシップ', browseTitle: 'eSIM を選ぶ',
    browseSubtitle: '200以上の国でモバイルデータ', searchDestination: '目的地を検索…',
    filterCountry: '国', filterData: 'データ', filterDays: '期間', filterPrice: '価格',
    filterAll: 'すべて', days: '日', day: '日', unlimited: '無制限', from: 'から',
    buy: '購入', buyNow: '今すぐ購入', loading: '読み込み中…',
    empty: 'このフィルターに該当する eSIM はありません', countriesEmpty: '利用可能な目的地なし',
    operator: '通信事業者', coverage: 'カバー範囲', perGB: 'GB あたり', validity: '有効期間',
    paying: '支払いへリダイレクト中…', paymentSuccess: '支払い完了！eSIM を準備中…',
    paymentCancelled: '支払いがキャンセルされました', paymentFailed: '支払いに失敗しました',
    activating: 'アクティベート中…', activated: 'eSIM の準備ができました！',
    installTitle: 'eSIM をインストール', installScan: '電話の設定から QR コードをスキャン',
    installManualTitle: '手動インストール', smdpAddress: 'SM-DP+ アドレス',
    activationCode: 'アクティベーションコード', confirmationCode: '確認コード',
    copyCode: 'コピー', copied: 'コピーしました！', directInstallIos: 'iPhone にインストール (iOS 17.4+)',
    instructionsHeader: 'インストール方法', mySectionTitle: 'マイ eSIM',
    noEsims: 'まだ eSIM がありません', statusActive: 'アクティブ', statusExpired: '期限切れ',
    statusCancelled: 'キャンセル済み', statusPending: 'アクティベート中…', statusFailed: '失敗',
    statusPaymentPending: '支払い待ち', dataRemaining: '残りデータ',
    dataUsed: '使用済み', expiresIn: '残り', expiresOn: '有効期限', iccid: 'ICCID',
    refresh: '更新', refreshing: '更新中…', topup: 'チャージ', topupTitle: 'eSIM をチャージ',
    topupEmpty: '利用可能なチャージはありません', install: 'インストール', installAgain: 'インストールを表示',
    details: '詳細', countryFlag: '目的地', purchasedOn: '購入日', confirm: '確認',
    close: '閉じる', cancel: 'キャンセル',
    adminTitle: 'eSIM ダッシュボード', adminSubtitle: 'Airalo パートナー · 監視',
    kpiTotalOrders: '注文合計', kpiActive: 'アクティブ', kpiCancelled: 'キャンセル',
    kpiRefunded: '返金済み', kpiRevenue: '総売上', kpiMargin: 'マージン',
    kpiARPU: 'ARPU', kpiTopups: 'チャージ', kpiFailed: '失敗',
    byLanguage: '言語別売上', byCountry: '目的地別売上', byStatus: 'ステータス別注文',
    syncNow: 'カタログを再同期', syncing: '同期中…', syncSuccess: 'カタログを同期しました',
    ordersTable: '注文', user: 'ユーザー', package: 'プラン', price: '価格',
    status: 'ステータス', actions: 'アクション', forceCancel: '強制キャンセルと返金',
    cancelConfirm: 'この eSIM をキャンセルして返金しますか？', cancelDone: 'eSIM をキャンセル・返金しました',
    environment: '環境', markup: 'マージン',
  },
  hi: {
    sectionTitle: 'यात्रा eSIM', sectionSubtitle: 'कहीं भी ऑनलाइन रहें · तुरंत सक्रिय',
    seeAll: 'सभी देखें', poweredBy: 'Airalo द्वारा संचालित · आधिकारिक साझेदारी', browseTitle: 'अपना eSIM चुनें',
    browseSubtitle: '200+ देशों में मोबाइल डेटा', searchDestination: 'गंतव्य खोजें…',
    filterCountry: 'देश', filterData: 'डेटा', filterDays: 'अवधि', filterPrice: 'कीमत',
    filterAll: 'सभी', days: 'दिन', day: 'दिन', unlimited: 'असीमित', from: 'से',
    buy: 'खरीदें', buyNow: 'अभी खरीदें', loading: 'लोड हो रहा है…',
    empty: 'इस फ़िल्टर के लिए कोई eSIM नहीं', countriesEmpty: 'कोई गंतव्य उपलब्ध नहीं',
    operator: 'ऑपरेटर', coverage: 'कवरेज', perGB: 'प्रति GB', validity: 'वैधता',
    paying: 'भुगतान पर रीडायरेक्ट…', paymentSuccess: 'भुगतान सफल! eSIM सक्रिय किया जा रहा है…',
    paymentCancelled: 'भुगतान रद्द', paymentFailed: 'भुगतान विफल',
    activating: 'सक्रिय कर रहे हैं…', activated: 'आपका eSIM तैयार है!',
    installTitle: 'अपना eSIM इंस्टॉल करें', installScan: 'फोन सेटिंग्स से QR कोड स्कैन करें',
    installManualTitle: 'मैनुअल इंस्टॉल', smdpAddress: 'SM-DP+ पता',
    activationCode: 'सक्रियण कोड', confirmationCode: 'पुष्टि कोड',
    copyCode: 'कॉपी', copied: 'कॉपी हो गया!', directInstallIos: 'iPhone पर इंस्टॉल करें (iOS 17.4+)',
    instructionsHeader: 'इंस्टॉल कैसे करें', mySectionTitle: 'मेरे eSIM',
    noEsims: 'आपके पास अभी कोई eSIM नहीं', statusActive: 'सक्रिय', statusExpired: 'समाप्त',
    statusCancelled: 'रद्द', statusPending: 'सक्रिय हो रहा है…', statusFailed: 'विफल',
    statusPaymentPending: 'भुगतान प्रतीक्षित', dataRemaining: 'शेष डेटा',
    dataUsed: 'उपयोग', expiresIn: 'समाप्ति', expiresOn: 'समाप्ति', iccid: 'ICCID',
    refresh: 'रीफ्रेश', refreshing: 'रीफ्रेश हो रहा है…', topup: 'टॉप-अप',
    topupTitle: 'eSIM टॉप-अप', topupEmpty: 'कोई टॉप-अप उपलब्ध नहीं',
    install: 'इंस्टॉल', installAgain: 'इंस्टॉल देखें', details: 'विवरण',
    countryFlag: 'गंतव्य', purchasedOn: 'खरीदा गया', confirm: 'पुष्टि',
    close: 'बंद', cancel: 'रद्द',
    adminTitle: 'eSIM डैशबोर्ड', adminSubtitle: 'Airalo पार्टनर · निगरानी',
    kpiTotalOrders: 'कुल ऑर्डर', kpiActive: 'सक्रिय', kpiCancelled: 'रद्द',
    kpiRefunded: 'रिफंड', kpiRevenue: 'कुल राजस्व', kpiMargin: 'मार्जिन',
    kpiARPU: 'ARPU', kpiTopups: 'टॉप-अप', kpiFailed: 'विफल',
    byLanguage: 'भाषा अनुसार बिक्री', byCountry: 'गंतव्य अनुसार बिक्री',
    byStatus: 'स्थिति अनुसार ऑर्डर', syncNow: 'कैटलॉग पुनः सिंक करें',
    syncing: 'सिंक हो रहा है…', syncSuccess: 'कैटलॉग सिंक हो गया', ordersTable: 'ऑर्डर',
    user: 'उपयोगकर्ता', package: 'पैकेज', price: 'कीमत', status: 'स्थिति',
    actions: 'क्रियाएं', forceCancel: 'जबरन रद्द और रिफंड',
    cancelConfirm: 'इस eSIM को रद्द कर रिफंड करें?', cancelDone: 'eSIM रद्द और रिफंड हो गया',
    environment: 'पर्यावरण', markup: 'मार्जिन',
  },
  nl: {
    sectionTitle: 'Reis-eSIM', sectionSubtitle: 'Overal online · directe activering',
    seeAll: 'Alles bekijken', poweredBy: 'Mogelijk gemaakt door Airalo · Officieel partnerschap',
    browseTitle: 'Kies je eSIM', browseSubtitle: 'Mobiele data in 200+ landen',
    searchDestination: 'Zoek een bestemming…', filterCountry: 'Land', filterData: 'Data',
    filterDays: 'Duur', filterPrice: 'Prijs', filterAll: 'Alle',
    days: 'dagen', day: 'dag', unlimited: 'Onbeperkt', from: 'vanaf',
    buy: 'Kopen', buyNow: 'Nu kopen', loading: 'Laden…',
    empty: 'Geen eSIM voor dit filter', countriesEmpty: 'Geen bestemmingen beschikbaar',
    operator: 'Operator', coverage: 'Dekking', perGB: 'per GB', validity: 'Geldigheid',
    paying: 'Doorsturen naar betaling…', paymentSuccess: 'Betaling gelukt! eSIM activeren…',
    paymentCancelled: 'Betaling geannuleerd', paymentFailed: 'Betaling mislukt',
    activating: 'eSIM activeren…', activated: 'Je eSIM is klaar!',
    installTitle: 'Installeer je eSIM', installScan: 'Scan deze QR-code via de instellingen',
    installManualTitle: 'Handmatige installatie', smdpAddress: 'SM-DP+ adres',
    activationCode: 'Activeringscode', confirmationCode: 'Bevestigingscode',
    copyCode: 'Kopieer', copied: 'Gekopieerd!', directInstallIos: 'Installeren op iPhone (iOS 17.4+)',
    instructionsHeader: 'Installatie-instructies', mySectionTitle: 'Mijn eSIMs',
    noEsims: 'Je hebt nog geen eSIM', statusActive: 'Actief', statusExpired: 'Verlopen',
    statusCancelled: 'Geannuleerd', statusPending: 'Activeren…', statusFailed: 'Mislukt',
    statusPaymentPending: 'Wacht op betaling', dataRemaining: 'Resterende data',
    dataUsed: 'Gebruikt', expiresIn: 'Verloopt in', expiresOn: 'Verloopt op', iccid: 'ICCID',
    refresh: 'Vernieuwen', refreshing: 'Vernieuwen…', topup: 'Bijladen',
    topupTitle: 'eSIM bijladen', topupEmpty: 'Geen oplaadopties beschikbaar',
    install: 'Installeren', installAgain: 'Installatie tonen', details: 'Details',
    countryFlag: 'Bestemming', purchasedOn: 'Gekocht op', confirm: 'Bevestigen',
    close: 'Sluiten', cancel: 'Annuleren',
    adminTitle: 'eSIM Dashboard', adminSubtitle: 'Airalo Partner · monitoring',
    kpiTotalOrders: 'Totaal bestellingen', kpiActive: 'Actief', kpiCancelled: 'Geannuleerd',
    kpiRefunded: 'Terugbetaald', kpiRevenue: 'Bruto omzet', kpiMargin: 'Marge',
    kpiARPU: 'ARPU', kpiTopups: 'Bijladen', kpiFailed: 'Mislukt',
    byLanguage: 'Verkoop per taal', byCountry: 'Verkoop per bestemming',
    byStatus: 'Bestellingen per status', syncNow: 'Catalogus opnieuw synchroniseren',
    syncing: 'Synchroniseren…', syncSuccess: 'Catalogus gesynchroniseerd',
    ordersTable: 'Bestellingen', user: 'Gebruiker', package: 'Pakket', price: 'Prijs',
    status: 'Status', actions: 'Acties', forceCancel: 'Annuleren & terugbetalen',
    cancelConfirm: 'Deze eSIM annuleren en terugbetalen?', cancelDone: 'eSIM geannuleerd en terugbetaald',
    environment: 'Omgeving', markup: 'Marge',
  },
  sw: {
    sectionTitle: 'eSIM ya Safari', sectionSubtitle: 'Endelea mtandaoni popote · uanzishaji wa papo hapo',
    seeAll: 'Angalia zote', poweredBy: 'Inawezeshwa na Airalo · Ushirikiano rasmi',
    browseTitle: 'Chagua eSIM yako', browseSubtitle: 'Data ya simu katika nchi 200+',
    searchDestination: 'Tafuta unakoenda…', filterCountry: 'Nchi', filterData: 'Data',
    filterDays: 'Muda', filterPrice: 'Bei', filterAll: 'Zote',
    days: 'siku', day: 'siku', unlimited: 'Isiyo na kikomo', from: 'kuanzia',
    buy: 'Nunua', buyNow: 'Nunua sasa', loading: 'Inapakia…',
    empty: 'Hakuna eSIM kwa kichujio hiki', countriesEmpty: 'Hakuna marudio yanayopatikana',
    operator: 'Mtoa huduma', coverage: 'Eneo', perGB: 'kwa GB', validity: 'Uhalali',
    paying: 'Inaelekeza kwenye malipo…', paymentSuccess: 'Malipo yamefanikiwa! eSIM yako inaandaliwa…',
    paymentCancelled: 'Malipo yamesitishwa', paymentFailed: 'Malipo yameshindikana',
    activating: 'Inawasha eSIM…', activated: 'eSIM yako iko tayari!',
    installTitle: 'Sakinisha eSIM yako', installScan: 'Skani msimbo huu wa QR kutoka kwenye mipangilio',
    installManualTitle: 'Usakinishaji wa mkono', smdpAddress: 'Anwani ya SM-DP+',
    activationCode: 'Msimbo wa uanzishaji', confirmationCode: 'Msimbo wa uthibitisho',
    copyCode: 'Nakili', copied: 'Imenakiliwa!', directInstallIos: 'Sakinisha kwenye iPhone (iOS 17.4+)',
    instructionsHeader: 'Jinsi ya kusakinisha', mySectionTitle: 'eSIM zangu',
    noEsims: 'Bado huna eSIM yoyote', statusActive: 'Inafanya kazi', statusExpired: 'Imeisha',
    statusCancelled: 'Imeghairiwa', statusPending: 'Inawasha…', statusFailed: 'Imeshindikana',
    statusPaymentPending: 'Inasubiri malipo', dataRemaining: 'Data iliyobaki',
    dataUsed: 'Iliyotumika', expiresIn: 'Itaisha baada ya', expiresOn: 'Itaisha tarehe', iccid: 'ICCID',
    refresh: 'Onyesha upya', refreshing: 'Inaonyesha upya…', topup: 'Ongeza',
    topupTitle: 'Ongeza eSIM yako', topupEmpty: 'Hakuna nyongeza inayopatikana',
    install: 'Sakinisha', installAgain: 'Onyesha usakinishaji', details: 'Maelezo',
    countryFlag: 'Mahali', purchasedOn: 'Ilinunuliwa', confirm: 'Thibitisha',
    close: 'Funga', cancel: 'Ghairi',
    adminTitle: 'Dashibodi ya eSIM', adminSubtitle: 'Ushirikiano wa Airalo · ufuatiliaji',
    kpiTotalOrders: 'Maagizo yote', kpiActive: 'Hai', kpiCancelled: 'Yameghairiwa',
    kpiRefunded: 'Yamerejeshwa', kpiRevenue: 'Mapato ghafi', kpiMargin: 'Faida',
    kpiARPU: 'ARPU', kpiTopups: 'Nyongeza', kpiFailed: 'Yameshindikana',
    byLanguage: 'Mauzo kwa lugha', byCountry: 'Mauzo kwa eneo',
    byStatus: 'Maagizo kwa hali', syncNow: 'Sawazisha katalogi',
    syncing: 'Inasawazisha…', syncSuccess: 'Katalogi imesawazishwa', ordersTable: 'Maagizo',
    user: 'Mtumiaji', package: 'Kifurushi', price: 'Bei', status: 'Hali',
    actions: 'Vitendo', forceCancel: 'Lazimisha kughairi & kurudisha',
    cancelConfirm: 'Ghairi eSIM hii na rudisha pesa?', cancelDone: 'eSIM imeghairiwa na pesa zimerejeshwa',
    environment: 'Mazingira', markup: 'Faida',
  },
  ht: {
    sectionTitle: 'eSIM Vwayaj', sectionSubtitle: 'Rete sou entènèt nenpòt kote · aktivasyon imedya',
    seeAll: 'Wè tout', poweredBy: 'Pwopilse pa Airalo · Patenarya ofisyèl',
    browseTitle: 'Chwazi eSIM ou', browseSubtitle: 'Done mobil nan plis pase 200 peyi',
    searchDestination: 'Chèche yon destinasyon…', filterCountry: 'Peyi', filterData: 'Done',
    filterDays: 'Dire', filterPrice: 'Pri', filterAll: 'Tout',
    days: 'jou', day: 'jou', unlimited: 'San limit', from: 'soti nan',
    buy: 'Achte', buyNow: 'Achte kounye a', loading: 'Chajman…',
    empty: 'Pa gen eSIM pou filtè sa a', countriesEmpty: 'Pa gen destinasyon disponib',
    operator: 'Operatè', coverage: 'Kouvèti', perGB: 'pa GB', validity: 'Valitite',
    paying: 'Redireksyon pou peman…', paymentSuccess: 'Peman reyisi! eSIM ou ap aktive…',
    paymentCancelled: 'Peman anile', paymentFailed: 'Peman echwe',
    activating: 'Aktive eSIM…', activated: 'eSIM ou pare!',
    installTitle: 'Enstale eSIM ou', installScan: 'Eskane kòd QR sa nan paramèt telefòn ou',
    installManualTitle: 'Enstalasyon manyèl', smdpAddress: 'Adrès SM-DP+',
    activationCode: 'Kòd aktivasyon', confirmationCode: 'Kòd konfimasyon',
    copyCode: 'Kopye', copied: 'Kopye!', directInstallIos: 'Enstale sou iPhone (iOS 17.4+)',
    instructionsHeader: 'Kijan pou enstale', mySectionTitle: 'eSIM mwen yo',
    noEsims: 'Ou poko gen okenn eSIM', statusActive: 'Aktif', statusExpired: 'Ekspire',
    statusCancelled: 'Anile', statusPending: 'Aktive…', statusFailed: 'Echwe',
    statusPaymentPending: 'An atant peman', dataRemaining: 'Done ki rete',
    dataUsed: 'Itilize', expiresIn: 'Ekspire nan', expiresOn: 'Ekspire le', iccid: 'ICCID',
    refresh: 'Rafrechi', refreshing: 'Rafrechi…', topup: 'Rechaje',
    topupTitle: 'Rechaje eSIM ou', topupEmpty: 'Pa gen rechaje disponib',
    install: 'Enstale', installAgain: 'Wè enstalasyon', details: 'Detay',
    countryFlag: 'Destinasyon', purchasedOn: 'Achte le', confirm: 'Konfime',
    close: 'Fèmen', cancel: 'Anile',
    adminTitle: 'Dashbòd eSIM', adminSubtitle: 'Patnè Airalo · siveyans',
    kpiTotalOrders: 'Total kòmand', kpiActive: 'Aktif', kpiCancelled: 'Anile',
    kpiRefunded: 'Ranbouse', kpiRevenue: 'Revni brit', kpiMargin: 'Maj',
    kpiARPU: 'ARPU', kpiTopups: 'Rechaje', kpiFailed: 'Echèk',
    byLanguage: 'Vant pa lang', byCountry: 'Vant pa destinasyon',
    byStatus: 'Kòmand pa estati', syncNow: 'Resenkronize katalòg',
    syncing: 'Senkronize…', syncSuccess: 'Katalòg senkronize', ordersTable: 'Kòmand',
    user: 'Itilizatè', package: 'Plan', price: 'Pri', status: 'Estati',
    actions: 'Aksyon', forceCancel: 'Fòse anile & ranbouse',
    cancelConfirm: 'Anile eSIM sa a epi ranbouse?', cancelDone: 'eSIM anile epi ranbouse',
    environment: 'Anviwònman', markup: 'Maj',
  },
};

for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  const src = _esim_i18n[lang] || _esim_i18n.en;
  if (!translations[lang].esim) translations[lang].esim = {};
  for (const k of Object.keys(src)) {
    if (translations[lang].esim[k] === undefined) {
      translations[lang].esim[k] = src[k];
    }
  }
}

// ============================================================================
// franchises namespace — Franchises, Studios & Streaming section
// ============================================================================
const _franchises_i18n = {
  en: { sectionTitle: 'Franchises, Studios & Streaming', type_franchise: 'Franchises', type_studio: 'Studios', type_streaming: 'Streaming', visit: 'Visit', wikipedia: 'Wikipedia', free: 'Free', empty: 'Nothing here yet' },
  fr: { sectionTitle: 'Franchises, Studios & Streaming', type_franchise: 'Franchises', type_studio: 'Studios', type_streaming: 'Streaming', visit: 'Visiter', wikipedia: 'Wikipédia', free: 'Gratuit', empty: 'Rien pour le moment' },
  es: { sectionTitle: 'Franquicias, Estudios & Streaming', type_franchise: 'Franquicias', type_studio: 'Estudios', type_streaming: 'Streaming', visit: 'Visitar', wikipedia: 'Wikipedia', free: 'Gratis', empty: 'Nada aún' },
  ar: { sectionTitle: 'الامتيازات والاستوديوهات والبث', type_franchise: 'امتيازات', type_studio: 'استوديوهات', type_streaming: 'بث', visit: 'زيارة', wikipedia: 'ويكيبيديا', free: 'مجاني', empty: 'لا شيء بعد' },
  pt: { sectionTitle: 'Franquias, Estúdios & Streaming', type_franchise: 'Franquias', type_studio: 'Estúdios', type_streaming: 'Streaming', visit: 'Visitar', wikipedia: 'Wikipédia', free: 'Grátis', empty: 'Nada por enquanto' },
  de: { sectionTitle: 'Franchises, Studios & Streaming', type_franchise: 'Franchises', type_studio: 'Studios', type_streaming: 'Streaming', visit: 'Besuchen', wikipedia: 'Wikipedia', free: 'Kostenlos', empty: 'Noch nichts' },
  ru: { sectionTitle: 'Франшизы, студии и стриминг', type_franchise: 'Франшизы', type_studio: 'Студии', type_streaming: 'Стриминг', visit: 'Открыть', wikipedia: 'Википедия', free: 'Бесплатно', empty: 'Пока пусто' },
  zh: { sectionTitle: '系列、制片厂与流媒体', type_franchise: '系列', type_studio: '制片厂', type_streaming: '流媒体', visit: '访问', wikipedia: '维基百科', free: '免费', empty: '暂无' },
  ja: { sectionTitle: 'フランチャイズ、スタジオ & ストリーミング', type_franchise: 'フランチャイズ', type_studio: 'スタジオ', type_streaming: 'ストリーミング', visit: '訪問', wikipedia: 'ウィキペディア', free: '無料', empty: 'まだありません' },
  hi: { sectionTitle: 'फ्रेंचाइज़ी, स्टूडियो और स्ट्रीमिंग', type_franchise: 'फ्रेंचाइज़ी', type_studio: 'स्टूडियो', type_streaming: 'स्ट्रीमिंग', visit: 'खोलें', wikipedia: 'विकिपीडिया', free: 'मुफ्त', empty: 'अभी कुछ नहीं' },
  nl: { sectionTitle: 'Franchises, Studios & Streaming', type_franchise: 'Franchises', type_studio: 'Studios', type_streaming: 'Streaming', visit: 'Bezoek', wikipedia: 'Wikipedia', free: 'Gratis', empty: 'Nog niets' },
  sw: { sectionTitle: 'Franchaisi, Studio na Mtiririko', type_franchise: 'Franchaisi', type_studio: 'Studio', type_streaming: 'Mtiririko', visit: 'Tembelea', wikipedia: 'Wikipedia', free: 'Bure', empty: 'Hakuna chochote' },
  ht: { sectionTitle: 'Franchiz, Estidyo & Streaming', type_franchise: 'Franchiz', type_studio: 'Estidyo', type_streaming: 'Streaming', visit: 'Vizite', wikipedia: 'Wikipedya', free: 'Gratis', empty: 'Pa gen anyen ankò' },
};
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  const src = _franchises_i18n[lang] || _franchises_i18n.en;
  if (!translations[lang].franchises) translations[lang].franchises = {};
  for (const k of Object.keys(src)) {
    if (translations[lang].franchises[k] === undefined) {
      translations[lang].franchises[k] = src[k];
    }
  }
}

// ============================================================================
// emailVerif namespace — Email verification UI strings
// ============================================================================
const _emailVerif_i18n = {
  en: { verified: 'Email verified', unverified: 'Email not verified yet', helper: 'Paste here the 6-digit code received by email. Code valid 48h.', validate: 'Validate', resend: 'Resend the code', sentToast: 'Code sent by email!', sentManualNeeded: 'Code generated, automatic send failed.', verifiedToast: 'Email verified ✓', codeFormat: '6-digit code required', alreadyVerified: 'Email already verified', blocked: "Your account is blocked because your email was not verified within 90 days of signup. Verify your email to reactivate it." },
  fr: { verified: 'Email vérifié', unverified: 'Email non vérifié', helper: "Collez ici le code à 6 chiffres reçu par email pour valider votre adresse. Code valable 48 h.", validate: 'Valider', resend: 'Renvoyer le code', sentToast: 'Code envoyé par email !', sentManualNeeded: "Code généré, mais l'envoi automatique a échoué.", verifiedToast: 'Email vérifié ✓', codeFormat: 'Code à 6 chiffres requis', alreadyVerified: 'Email déjà vérifié', blocked: "Votre compte est bloqué car votre email n'a pas été vérifié dans les 90 jours suivant l'inscription. Vérifiez votre email pour le réactiver." },
  es: { verified: 'Email verificado', unverified: 'Email no verificado', helper: 'Pega aquí el código de 6 dígitos recibido por email. Válido 48 h.', validate: 'Validar', resend: 'Reenviar el código', sentToast: '¡Código enviado por email!', verifiedToast: 'Email verificado ✓', codeFormat: 'Código de 6 dígitos', alreadyVerified: 'Email ya verificado', blocked: 'Su cuenta está bloqueada porque su email no fue verificado en 90 días. Verifíquelo para reactivar.' },
  ar: { verified: 'تم التحقق من البريد', unverified: 'لم يتم التحقق بعد', helper: 'الصق هنا الرمز المكوّن من 6 أرقام. صالح 48 ساعة.', validate: 'تحقّق', resend: 'إعادة الإرسال', sentToast: 'تم إرسال الرمز!', verifiedToast: 'تم التحقق ✓', codeFormat: 'الرمز 6 أرقام', alreadyVerified: 'تم التحقق مسبقًا', blocked: 'حسابك محظور لأن بريدك لم يُتحقق منه خلال 90 يومًا.' },
  pt: { verified: 'Email verificado', unverified: 'Email não verificado', helper: 'Cole aqui o código de 6 dígitos recebido por email. Válido 48 h.', validate: 'Validar', resend: 'Reenviar o código', sentToast: 'Código enviado por email!', verifiedToast: 'Email verificado ✓', codeFormat: 'Código de 6 dígitos', alreadyVerified: 'Email já verificado', blocked: 'Sua conta está bloqueada por falta de verificação em 90 dias.' },
  de: { verified: 'E-Mail bestätigt', unverified: 'E-Mail nicht bestätigt', helper: 'Fügen Sie hier den 6-stelligen Code aus der E-Mail ein. 48 h gültig.', validate: 'Bestätigen', resend: 'Code erneut senden', sentToast: 'Code per E-Mail gesendet!', verifiedToast: 'E-Mail bestätigt ✓', codeFormat: '6-stelliger Code', alreadyVerified: 'Bereits bestätigt', blocked: 'Konto gesperrt — E-Mail nicht innerhalb von 90 Tagen bestätigt.' },
  ru: { verified: 'Email подтверждён', unverified: 'Email не подтверждён', helper: 'Вставьте сюда 6-значный код из письма. Действителен 48 ч.', validate: 'Подтвердить', resend: 'Отправить код заново', sentToast: 'Код отправлен!', verifiedToast: 'Email подтверждён ✓', codeFormat: '6-значный код', alreadyVerified: 'Email уже подтверждён', blocked: 'Аккаунт заблокирован: email не подтверждён за 90 дней.' },
  zh: { verified: '邮箱已验证', unverified: '邮箱未验证', helper: '在此粘贴邮件收到的 6 位代码，48 小时有效。', validate: '验证', resend: '重新发送代码', sentToast: '代码已发送！', verifiedToast: '邮箱已验证 ✓', codeFormat: '需要 6 位代码', alreadyVerified: '邮箱已验证', blocked: '账号已封锁 — 邮箱未在 90 天内验证。' },
  ja: { verified: 'メール認証済み', unverified: 'メール未認証', helper: 'メールで受け取った6桁のコードをここに貼り付け。48時間有効。', validate: '確認', resend: 'コードを再送', sentToast: 'コードを送信しました！', verifiedToast: 'メール認証済み ✓', codeFormat: '6桁のコードが必要', alreadyVerified: '既に認証済み', blocked: 'アカウントは90日以内に認証されなかったためロックされました。' },
  hi: { verified: 'ईमेल सत्यापित', unverified: 'ईमेल सत्यापित नहीं', helper: 'ईमेल में मिला 6 अंकों का कोड यहाँ चिपकाएं। 48 घंटे मान्य।', validate: 'सत्यापित करें', resend: 'कोड पुनः भेजें', sentToast: 'कोड भेजा गया!', verifiedToast: 'ईमेल सत्यापित ✓', codeFormat: '6 अंकों का कोड', alreadyVerified: 'पहले से सत्यापित', blocked: 'खाता ब्लॉक — 90 दिन में ईमेल सत्यापित नहीं हुआ।' },
  nl: { verified: 'E-mail geverifieerd', unverified: 'E-mail niet geverifieerd', helper: 'Plak hier de 6-cijferige code uit de e-mail. 48 uur geldig.', validate: 'Valideer', resend: 'Code opnieuw verzenden', sentToast: 'Code verzonden per e-mail!', verifiedToast: 'E-mail geverifieerd ✓', codeFormat: '6-cijferige code vereist', alreadyVerified: 'Reeds geverifieerd', blocked: 'Account geblokkeerd — e-mail niet binnen 90 dagen geverifieerd.' },
  sw: { verified: 'Barua pepe imethibitishwa', unverified: 'Barua pepe haijathibitishwa', helper: 'Bandika hapa msimbo wa tarakimu 6 uliopokea. Ni halali kwa saa 48.', validate: 'Thibitisha', resend: 'Tuma msimbo tena', sentToast: 'Msimbo umetumwa!', verifiedToast: 'Barua pepe imethibitishwa ✓', codeFormat: 'Msimbo wa tarakimu 6 unahitajika', alreadyVerified: 'Tayari imethibitishwa', blocked: 'Akaunti imezuiliwa — barua pepe haijathibitishwa kwa siku 90.' },
  ht: { verified: 'Imèl verifye', unverified: 'Imèl pa verifye', helper: 'Kole isit la kòd 6 chif ou resevwa nan imèl. Valab 48 èdtan.', validate: 'Valide', resend: 'Voye kòd la ankò', sentToast: 'Kòd voye pa imèl!', verifiedToast: 'Imèl verifye ✓', codeFormat: 'Kòd 6 chif obligatwa', alreadyVerified: 'Imèl deja verifye', blocked: 'Kont bloke — imèl pa verifye nan 90 jou.' },
};
for (const lang of supportedLanguages) {
  if (!translations[lang]) continue;
  const src = _emailVerif_i18n[lang] || _emailVerif_i18n.en;
  if (!translations[lang].emailVerif) translations[lang].emailVerif = {};
  for (const k of Object.keys(src)) {
    if (translations[lang].emailVerif[k] === undefined) {
      translations[lang].emailVerif[k] = src[k];
    }
  }
}

// ============================================================================
// apia namespace — Destine AP-IA (developer key requests)
// ============================================================================
const _apia_i18n = {
  en: {
    tabTitle: 'AP-IA',
    panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Integrate Destine AI (with GPT Guyane and GPT Africa regional languages) into your own apps.',
    docLink: 'Read the AP-IA documentation',
    requestTitle: 'Request an AP-IA key',
    projectName: 'Project name',
    projectNamePh: 'e.g. Cayenne Guide',
    purpose: 'What will you build with the API?',
    purposePh: 'Describe your app / feature (min. 10 characters)',
    reason: 'Why do you need Destine AI in particular?',
    reasonPh: 'Explain the reason for your request (min. 10 characters)',
    submit: 'Submit request',
    submitting: 'Submitting…',
    submitted: 'Request submitted — an admin will review it shortly',
    myRequests: 'My requests',
    statusPending: 'Pending review',
    statusApproved: 'Approved',
    statusRefused: 'Refused',
    yourKey: 'Your AP-IA key',
    keyOnceWarning: 'Copy this key now — you will not be able to see it again.',
    copy: 'Copy',
    copied: 'Key copied',
    revoked: 'Revoked',
    usage: 'Usage',
    quotaInfo: 'Free tier: 60 req/min · 1000 req/day',
    refusedBy: 'Refused by admin',
    refuseReason: 'Reason',
    adminNote: 'Admin note',
    empty: 'No request yet.',
    freeInfo: 'AP-IA is currently free. Please use it fairly.',
    alreadyPending: 'You already have a request being reviewed.',
    proOnly: 'AP-IA is reserved for PRO accounts.',
  },
  fr: {
    tabTitle: 'AP-IA',
    panelTitle: 'Destine AP-IA',
    panelSubtitle: "Intègre l'IA Destine (avec les langues régionales GPT Guyane et GPT Africa) dans tes propres apps.",
    docLink: 'Consulter la documentation AP-IA',
    requestTitle: 'Demander une clé AP-IA',
    projectName: 'Nom du projet',
    projectNamePh: 'ex : Guide Cayenne',
    purpose: 'Que vas-tu construire avec l\'API ?',
    purposePh: 'Décris ton app / fonctionnalité (10 caractères min.)',
    reason: 'Pourquoi as-tu besoin de Destine IA en particulier ?',
    reasonPh: 'Explique le motif de ta demande (10 caractères min.)',
    submit: 'Envoyer la demande',
    submitting: 'Envoi…',
    submitted: 'Demande envoyée — un administrateur va l\'examiner',
    myRequests: 'Mes demandes',
    statusPending: 'En attente',
    statusApproved: 'Approuvée',
    statusRefused: 'Refusée',
    yourKey: 'Ta clé AP-IA',
    keyOnceWarning: 'Copie cette clé maintenant — elle ne sera plus jamais affichée en clair.',
    copy: 'Copier',
    copied: 'Clé copiée',
    revoked: 'Révoquée',
    usage: 'Utilisations',
    quotaInfo: 'Offre gratuite : 60 req/min · 1000 req/jour',
    refusedBy: 'Refusée par l\'administrateur',
    refuseReason: 'Motif',
    adminNote: 'Note admin',
    empty: 'Aucune demande pour l\'instant.',
    freeInfo: 'AP-IA est actuellement gratuit. Merci d\'en faire un usage raisonnable.',
    alreadyPending: 'Tu as déjà une demande en cours de traitement.',
    proOnly: 'AP-IA est réservée aux comptes PRO.',
  },
  es: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Integra la IA de Destine (con las lenguas regionales GPT Guyane y GPT Africa) en tus apps.',
    docLink: 'Consultar la documentación AP-IA',
    requestTitle: 'Solicitar una clave AP-IA', projectName: 'Nombre del proyecto', projectNamePh: 'ej. Guía Cayena',
    purpose: '¿Qué vas a construir con la API?', purposePh: 'Describe tu app (mín. 10 caracteres)',
    reason: '¿Por qué necesitas Destine IA?', reasonPh: 'Explica el motivo (mín. 10 caracteres)',
    submit: 'Enviar solicitud', submitting: 'Enviando…', submitted: 'Solicitud enviada — un admin la revisará',
    myRequests: 'Mis solicitudes', statusPending: 'Pendiente', statusApproved: 'Aprobada', statusRefused: 'Rechazada',
    yourKey: 'Tu clave AP-IA', keyOnceWarning: 'Copia esta clave ahora — no volverá a mostrarse.',
    copy: 'Copiar', copied: 'Clave copiada', revoked: 'Revocada', usage: 'Usos',
    quotaInfo: 'Nivel gratuito: 60 req/min · 1000 req/día',
    refusedBy: 'Rechazada por el administrador', refuseReason: 'Motivo', adminNote: 'Nota del admin',
    empty: 'Sin solicitudes por el momento.', freeInfo: 'AP-IA es gratis por ahora. Úsala con moderación.',
    alreadyPending: 'Ya tienes una solicitud en revisión.', proOnly: 'AP-IA es solo para cuentas PRO.',
  },
  ar: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'ادمج ذكاء Destine (مع اللغات الإقليمية GPT Guyane وGPT Africa) في تطبيقاتك.',
    docLink: 'قراءة توثيق AP-IA',
    requestTitle: 'طلب مفتاح AP-IA', projectName: 'اسم المشروع', projectNamePh: 'مثال: دليل كايين',
    purpose: 'ماذا ستبني باستخدام الواجهة؟', purposePh: 'صف تطبيقك (10 أحرف على الأقل)',
    reason: 'لماذا تحتاج ذكاء Destine؟', reasonPh: 'اشرح السبب (10 أحرف على الأقل)',
    submit: 'إرسال الطلب', submitting: 'جارٍ الإرسال…', submitted: 'تم إرسال الطلب — سيراجعه المسؤول',
    myRequests: 'طلباتي', statusPending: 'قيد المراجعة', statusApproved: 'مقبول', statusRefused: 'مرفوض',
    yourKey: 'مفتاحك AP-IA', keyOnceWarning: 'انسخ هذا المفتاح الآن — لن يُعرض مرة أخرى.',
    copy: 'نسخ', copied: 'تم نسخ المفتاح', revoked: 'ملغى', usage: 'الاستخدام',
    quotaInfo: 'مجاني: 60 طلب/دقيقة · 1000 طلب/يوم',
    refusedBy: 'رفضه المسؤول', refuseReason: 'السبب', adminNote: 'ملاحظة المسؤول',
    empty: 'لا توجد طلبات بعد.', freeInfo: 'AP-IA مجاني حاليًا. الرجاء الاستخدام المعقول.',
    alreadyPending: 'لديك طلب قيد المراجعة بالفعل.', proOnly: 'AP-IA للحسابات PRO فقط.',
  },
  pt: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Integre a IA da Destine (com as línguas regionais GPT Guyane e GPT Africa) nos seus apps.',
    docLink: 'Ver a documentação AP-IA',
    requestTitle: 'Solicitar uma chave AP-IA', projectName: 'Nome do projeto', projectNamePh: 'ex.: Guia Caiena',
    purpose: 'O que vai construir com a API?', purposePh: 'Descreva seu app (mín. 10 caracteres)',
    reason: 'Por que precisa da Destine IA?', reasonPh: 'Explique o motivo (mín. 10 caracteres)',
    submit: 'Enviar pedido', submitting: 'Enviando…', submitted: 'Pedido enviado — um admin vai analisar',
    myRequests: 'Meus pedidos', statusPending: 'Em análise', statusApproved: 'Aprovado', statusRefused: 'Recusado',
    yourKey: 'Sua chave AP-IA', keyOnceWarning: 'Copie esta chave agora — ela não será mais exibida.',
    copy: 'Copiar', copied: 'Chave copiada', revoked: 'Revogada', usage: 'Usos',
    quotaInfo: 'Grátis: 60 req/min · 1000 req/dia',
    refusedBy: 'Recusado pelo administrador', refuseReason: 'Motivo', adminNote: 'Nota do admin',
    empty: 'Nenhum pedido ainda.', freeInfo: 'AP-IA é gratuito por ora. Use com moderação.',
    alreadyPending: 'Você já tem um pedido em análise.', proOnly: 'AP-IA é exclusivo para contas PRO.',
  },
  de: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Integriere die Destine KI (mit den Regionalsprachen GPT Guyane und GPT Africa) in deine Apps.',
    docLink: 'AP-IA-Dokumentation ansehen',
    requestTitle: 'AP-IA-Schlüssel anfragen', projectName: 'Projektname', projectNamePh: 'z. B. Cayenne Guide',
    purpose: 'Was baust du mit der API?', purposePh: 'Beschreibe deine App (mind. 10 Zeichen)',
    reason: 'Warum brauchst du Destine KI?', reasonPh: 'Begründe deine Anfrage (mind. 10 Zeichen)',
    submit: 'Anfrage senden', submitting: 'Senden…', submitted: 'Anfrage gesendet — ein Admin prüft sie',
    myRequests: 'Meine Anfragen', statusPending: 'In Prüfung', statusApproved: 'Genehmigt', statusRefused: 'Abgelehnt',
    yourKey: 'Dein AP-IA-Schlüssel', keyOnceWarning: 'Kopiere den Schlüssel jetzt — er wird nie wieder angezeigt.',
    copy: 'Kopieren', copied: 'Schlüssel kopiert', revoked: 'Widerrufen', usage: 'Nutzung',
    quotaInfo: 'Kostenlos: 60 Anfragen/Min · 1000 Anfragen/Tag',
    refusedBy: 'Vom Admin abgelehnt', refuseReason: 'Grund', adminNote: 'Admin-Hinweis',
    empty: 'Noch keine Anfrage.', freeInfo: 'AP-IA ist derzeit gratis. Bitte fair nutzen.',
    alreadyPending: 'Du hast bereits eine offene Anfrage.', proOnly: 'AP-IA ist nur für PRO-Konten.',
  },
  ru: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Интегрируйте ИИ Destine (с региональными языками GPT Guyane и GPT Africa) в свои приложения.',
    docLink: 'Открыть документацию AP-IA',
    requestTitle: 'Запросить ключ AP-IA', projectName: 'Название проекта', projectNamePh: 'напр., Cayenne Guide',
    purpose: 'Что вы построите с API?', purposePh: 'Опишите ваше приложение (мин. 10 символов)',
    reason: 'Почему именно Destine ИИ?', reasonPh: 'Объясните причину (мин. 10 символов)',
    submit: 'Отправить запрос', submitting: 'Отправка…', submitted: 'Запрос отправлен — админ рассмотрит',
    myRequests: 'Мои запросы', statusPending: 'На рассмотрении', statusApproved: 'Одобрено', statusRefused: 'Отклонено',
    yourKey: 'Ваш ключ AP-IA', keyOnceWarning: 'Скопируйте ключ сейчас — он больше не будет показан.',
    copy: 'Копировать', copied: 'Ключ скопирован', revoked: 'Отозван', usage: 'Использований',
    quotaInfo: 'Бесплатно: 60 req/min · 1000 req/сутки',
    refusedBy: 'Отклонено администратором', refuseReason: 'Причина', adminNote: 'Заметка админа',
    empty: 'Пока запросов нет.', freeInfo: 'AP-IA бесплатен. Используйте разумно.',
    alreadyPending: 'У вас уже есть запрос на рассмотрении.', proOnly: 'AP-IA только для PRO-аккаунтов.',
  },
  zh: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: '将 Destine AI（含 GPT Guyane 与 GPT Africa 地区语言）集成到您的应用中。',
    docLink: '查看 AP-IA 文档',
    requestTitle: '申请 AP-IA 密钥', projectName: '项目名称', projectNamePh: '例如：卡宴指南',
    purpose: '您将用 API 做什么？', purposePh: '描述您的应用（至少 10 个字符）',
    reason: '为什么需要 Destine AI？', reasonPh: '说明申请理由（至少 10 个字符）',
    submit: '提交申请', submitting: '提交中…', submitted: '已提交 — 管理员将审核',
    myRequests: '我的申请', statusPending: '待审核', statusApproved: '已通过', statusRefused: '已拒绝',
    yourKey: '您的 AP-IA 密钥', keyOnceWarning: '请立即复制此密钥 — 将不再显示。',
    copy: '复制', copied: '密钥已复制', revoked: '已吊销', usage: '使用次数',
    quotaInfo: '免费额度：60 次/分钟 · 1000 次/天',
    refusedBy: '被管理员拒绝', refuseReason: '原因', adminNote: '管理员备注',
    empty: '暂无申请。', freeInfo: 'AP-IA 目前免费，请合理使用。',
    alreadyPending: '您已有申请正在审核中。', proOnly: 'AP-IA 仅限 PRO 账户。',
  },
  ja: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Destine AI（GPT Guyane・GPT Africa の地域言語対応）をあなたのアプリに組み込めます。',
    docLink: 'AP-IA ドキュメントを読む',
    requestTitle: 'AP-IA キーを申請', projectName: 'プロジェクト名', projectNamePh: '例：カイエンヌガイド',
    purpose: 'API で何を作りますか？', purposePh: 'アプリを説明（10文字以上）',
    reason: 'なぜ Destine AI が必要ですか？', reasonPh: '理由を記入（10文字以上）',
    submit: '申請を送信', submitting: '送信中…', submitted: '申請を送信しました — 管理者が確認します',
    myRequests: '申請履歴', statusPending: '審査中', statusApproved: '承認済み', statusRefused: '却下',
    yourKey: 'あなたの AP-IA キー', keyOnceWarning: '今すぐキーをコピーしてください — 再表示されません。',
    copy: 'コピー', copied: 'キーをコピー', revoked: '取消済み', usage: '使用回数',
    quotaInfo: '無料枠：60req/分 · 1000req/日',
    refusedBy: '管理者により却下', refuseReason: '理由', adminNote: '管理者メモ',
    empty: '申請はまだありません。', freeInfo: 'AP-IA は現在無料です。適切にご利用ください。',
    alreadyPending: 'すでに審査中の申請があります。', proOnly: 'AP-IA は PRO アカウント専用です。',
  },
  hi: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Destine AI (GPT Guyane और GPT Africa की क्षेत्रीय भाषाओं सहित) को अपने ऐप में एकीकृत करें।',
    docLink: 'AP-IA दस्तावेज़ पढ़ें',
    requestTitle: 'AP-IA कुंजी का अनुरोध करें', projectName: 'प्रोजेक्ट नाम', projectNamePh: 'उदा. Cayenne गाइड',
    purpose: 'API से क्या बनाएँगे?', purposePh: 'ऐप का विवरण (कम से कम 10 अक्षर)',
    reason: 'Destine AI क्यों?', reasonPh: 'कारण बताएँ (कम से कम 10 अक्षर)',
    submit: 'अनुरोध भेजें', submitting: 'भेज रहे हैं…', submitted: 'अनुरोध भेजा गया — व्यवस्थापक समीक्षा करेगा',
    myRequests: 'मेरे अनुरोध', statusPending: 'लंबित', statusApproved: 'स्वीकृत', statusRefused: 'अस्वीकृत',
    yourKey: 'आपकी AP-IA कुंजी', keyOnceWarning: 'यह कुंजी अभी कॉपी करें — दोबारा नहीं दिखेगी।',
    copy: 'कॉपी', copied: 'कुंजी कॉपी हो गई', revoked: 'निरस्त', usage: 'उपयोग',
    quotaInfo: 'मुफ्त: 60 req/min · 1000 req/day',
    refusedBy: 'व्यवस्थापक द्वारा अस्वीकृत', refuseReason: 'कारण', adminNote: 'व्यवस्थापक टिप्पणी',
    empty: 'अभी तक कोई अनुरोध नहीं।', freeInfo: 'AP-IA अभी मुफ्त है। कृपया उचित उपयोग करें।',
    alreadyPending: 'आपका पहले से एक अनुरोध समीक्षाधीन है।', proOnly: 'AP-IA केवल PRO खातों के लिए है।',
  },
  nl: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Integreer Destine AI (met de regionale talen GPT Guyane en GPT Africa) in je eigen apps.',
    docLink: 'AP-IA-documentatie openen',
    requestTitle: 'AP-IA-sleutel aanvragen', projectName: 'Projectnaam', projectNamePh: 'bijv. Cayenne Guide',
    purpose: 'Wat ga je bouwen met de API?', purposePh: 'Beschrijf je app (min. 10 tekens)',
    reason: 'Waarom Destine AI?', reasonPh: 'Leg uit (min. 10 tekens)',
    submit: 'Aanvraag versturen', submitting: 'Verzenden…', submitted: 'Aanvraag verzonden — een admin bekijkt hem',
    myRequests: 'Mijn aanvragen', statusPending: 'In afwachting', statusApproved: 'Goedgekeurd', statusRefused: 'Geweigerd',
    yourKey: 'Jouw AP-IA-sleutel', keyOnceWarning: 'Kopieer deze sleutel nu — je ziet hem niet meer.',
    copy: 'Kopiëren', copied: 'Sleutel gekopieerd', revoked: 'Ingetrokken', usage: 'Gebruik',
    quotaInfo: 'Gratis: 60 req/min · 1000 req/dag',
    refusedBy: 'Geweigerd door admin', refuseReason: 'Reden', adminNote: 'Admin-notitie',
    empty: 'Nog geen aanvraag.', freeInfo: 'AP-IA is momenteel gratis. Gebruik het eerlijk.',
    alreadyPending: 'Je hebt al een aanvraag in behandeling.', proOnly: 'AP-IA is alleen voor PRO-accounts.',
  },
  sw: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Unganisha Destine AI (pamoja na lugha za kikanda GPT Guyane na GPT Africa) katika programu zako.',
    docLink: 'Fungua nyaraka za AP-IA',
    requestTitle: 'Omba ufunguo wa AP-IA', projectName: 'Jina la mradi', projectNamePh: 'k.m. Cayenne Guide',
    purpose: 'Utaijenga nini kwa API?', purposePh: 'Eleza programu yako (angalau herufi 10)',
    reason: 'Kwa nini Destine AI?', reasonPh: 'Eleza sababu (angalau herufi 10)',
    submit: 'Tuma ombi', submitting: 'Inatuma…', submitted: 'Ombi limetumwa — msimamizi atapitia',
    myRequests: 'Maombi yangu', statusPending: 'Inasubiri', statusApproved: 'Imeidhinishwa', statusRefused: 'Imekataliwa',
    yourKey: 'Ufunguo wako wa AP-IA', keyOnceWarning: 'Nakili ufunguo huu sasa — hautaonyeshwa tena.',
    copy: 'Nakili', copied: 'Ufunguo umenakiliwa', revoked: 'Umetenguliwa', usage: 'Matumizi',
    quotaInfo: 'Bure: 60 req/dak · 1000 req/siku',
    refusedBy: 'Imekataliwa na msimamizi', refuseReason: 'Sababu', adminNote: 'Kumbuka ya msimamizi',
    empty: 'Bado hakuna ombi.', freeInfo: 'AP-IA ni bure kwa sasa. Tafadhali tumia kwa haki.',
    alreadyPending: 'Tayari una ombi linalopitiwa.', proOnly: 'AP-IA ni kwa akaunti za PRO tu.',
  },
  ht: {
    tabTitle: 'AP-IA', panelTitle: 'Destine AP-IA',
    panelSubtitle: 'Entegre Destine AI (ak lang rejyonal GPT Guyane ak GPT Africa) nan pwòp aplikasyon w yo.',
    docLink: 'Ouvri dokimantasyon AP-IA',
    requestTitle: 'Mande yon kle AP-IA', projectName: 'Non pwojè a', projectNamePh: 'pa egzanp Cayenne Guide',
    purpose: 'Kisa w ap konstwi ak API a ?', purposePh: 'Dekri app ou (omwen 10 karaktè)',
    reason: 'Poukisa Destine AI ?', reasonPh: 'Bay rezon an (omwen 10 karaktè)',
    submit: 'Voye demann lan', submitting: 'Ap voye…', submitted: 'Demann voye — yon admin ap gade li',
    myRequests: 'Demann mwen yo', statusPending: 'Ap tann', statusApproved: 'Apwouve', statusRefused: 'Refize',
    yourKey: 'Kle AP-IA ou a', keyOnceWarning: 'Kopye kle sa a kounye a — ou p ap wè l ankò.',
    copy: 'Kopye', copied: 'Kle kopye', revoked: 'Revoke', usage: 'Itilizasyon',
    quotaInfo: 'Gratis : 60 req/min · 1000 req/jou',
    refusedBy: 'Refize pa admin', refuseReason: 'Rezon', adminNote: 'Nòt admin',
    empty: 'Poko gen okenn demann.', freeInfo: 'AP-IA gratis kounye a. Tanpri sèvi avè l avèk respè.',
    alreadyPending: 'Ou deja gen yon demann k ap egzamine.', proOnly: 'AP-IA se pou kont PRO sèlman.',
  },
};

// Apply the AP-IA translations to the language dictionary (idempotent).
try {
  for (const [lng, obj] of Object.entries(_apia_i18n)) {
    if (translations[lng]) {
      translations[lng].apia = obj;
    }
  }
} catch (_e) { /* ignore */ }

// -----------------------------------------------------------------------------
// v50.14 — Ratings block (used in Films.jsx DetailModal for box office +
// upcoming). Kept in a separate dictionary so we can extend it without
// hunting through 9k lines of top-level translations.
// -----------------------------------------------------------------------------
const _ratings_i18n = {
  fr: { communityTitle: 'Avis de la communauté', reviewsShort: 'avis', yourRating: 'Votre note :', commentPlaceholder: 'Votre commentaire (optionnel)…', beFirst: 'Aucun avis pour le moment. Soyez le premier !', anonUser: 'Utilisateur' },
  en: { communityTitle: 'Community reviews', reviewsShort: 'reviews', yourRating: 'Your rating:', commentPlaceholder: 'Your comment (optional)…', beFirst: 'No review yet. Be the first!', anonUser: 'User' },
  es: { communityTitle: 'Opiniones de la comunidad', reviewsShort: 'opiniones', yourRating: 'Tu nota:', commentPlaceholder: 'Tu comentario (opcional)…', beFirst: 'Aún no hay opiniones. ¡Sé el primero!', anonUser: 'Usuario' },
  de: { communityTitle: 'Community-Bewertungen', reviewsShort: 'Bewertungen', yourRating: 'Deine Bewertung:', commentPlaceholder: 'Dein Kommentar (optional)…', beFirst: 'Noch keine Bewertung — sei die/der Erste!', anonUser: 'Benutzer' },
  it: { communityTitle: 'Recensioni della community', reviewsShort: 'recensioni', yourRating: 'Il tuo voto:', commentPlaceholder: 'Il tuo commento (opzionale)…', beFirst: 'Nessuna recensione — sii il primo!', anonUser: 'Utente' },
  pt: { communityTitle: 'Avaliações da comunidade', reviewsShort: 'avaliações', yourRating: 'A sua nota:', commentPlaceholder: 'O seu comentário (opcional)…', beFirst: 'Sem avaliações — seja o primeiro!', anonUser: 'Utilizador' },
  nl: { communityTitle: 'Community-beoordelingen', reviewsShort: 'beoordelingen', yourRating: 'Jouw beoordeling:', commentPlaceholder: 'Jouw commentaar (optioneel)…', beFirst: 'Nog geen beoordelingen — wees de eerste!', anonUser: 'Gebruiker' },
  ar: { communityTitle: 'آراء المجتمع', reviewsShort: 'آراء', yourRating: 'تقييمك:', commentPlaceholder: 'تعليقك (اختياري)…', beFirst: 'لا توجد آراء بعد. كن الأول!', anonUser: 'مستخدم' },
  ru: { communityTitle: 'Отзывы сообщества', reviewsShort: 'отзывов', yourRating: 'Ваша оценка:', commentPlaceholder: 'Ваш комментарий (опционально)…', beFirst: 'Пока нет отзывов. Будьте первым!', anonUser: 'Пользователь' },
  zh: { communityTitle: '社区评价', reviewsShort: '条评价', yourRating: '您的评分：', commentPlaceholder: '您的评论（可选）…', beFirst: '暂无评价 — 快来抢先！', anonUser: '用户' },
  ja: { communityTitle: 'コミュニティレビュー', reviewsShort: 'レビュー', yourRating: 'あなたの評価：', commentPlaceholder: 'コメント（任意）…', beFirst: 'まだレビューはありません。最初のレビューを！', anonUser: 'ユーザー' },
  hi: { communityTitle: 'समुदाय की समीक्षा', reviewsShort: 'समीक्षाएँ', yourRating: 'आपकी रेटिंग:', commentPlaceholder: 'आपकी टिप्पणी (वैकल्पिक)…', beFirst: 'अभी कोई समीक्षा नहीं — पहले बनें!', anonUser: 'उपयोगकर्ता' },
  sw: { communityTitle: 'Maoni ya jamii', reviewsShort: 'maoni', yourRating: 'Ukadiriaji wako:', commentPlaceholder: 'Maoni yako (hiari)…', beFirst: 'Hakuna maoni bado — kuwa wa kwanza!', anonUser: 'Mtumiaji' },
  ht: { communityTitle: 'Opinyon kominote a', reviewsShort: 'opinyon', yourRating: 'Nòt ou :', commentPlaceholder: 'Kòmantè ou (opsyonèl)…', beFirst: 'Poko gen opinyon. Se ou premye !', anonUser: 'Itilizatè' },
};
try {
  for (const [lng, obj] of Object.entries(_ratings_i18n)) {
    if (translations[lng]) {
      translations[lng].ratings = obj;
    }
  }
} catch (_e) { /* ignore */ }
